var vo = Object.defineProperty;
var No = (n, e, t) => e in n ? vo(n, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : n[e] = t;
var _n = (n, e, t) => (No(n, typeof e != "symbol" ? e + "" : e, t), t);
import { reactive as an, onActivated as Rt, watch as hn, defineComponent as le, createElementBlock as L, openBlock as P, createCommentVNode as ge, createElementVNode as k, unref as R, toDisplayString as G, Fragment as Ue, renderList as Tn, normalizeClass as Ie, renderSlot as Re, computed as be, resolveComponent as Co, createVNode as W, withCtx as fe, ref as ne, onMounted as $n, onUnmounted as Or, createTextVNode as Fe, nextTick as Vt, withDirectives as zt, vModelText as bo, vShow as wo, onBeforeUnmount as Eo, render as Kt, createBlock as qt, KeepAlive as Ao, resolveDynamicComponent as Oo, createApp as So } from "vue";
import { createI18n as To, useI18n as Sr } from "vue-i18n";
import { LoginUIComponentDelegateEvent as Qt } from "@xbase/login-ui";
import { VerificationUsages as Wt } from "@xbase/sdk";
import { LoginEvent as Tr } from "@xbase/login";
const ze = Symbol.for("@ts-pattern/matcher"), ko = Symbol.for("@ts-pattern/isVariadic"), Hn = "@ts-pattern/anonymous-select-key", ft = (n) => !!(n && typeof n == "object"), Fn = (n) => n && !!n[ze], De = (n, e, t) => {
  if (Fn(n)) {
    const r = n[ze](), { matched: o, selections: a } = r.match(e);
    return o && a && Object.keys(a).forEach((d) => t(d, a[d])), o;
  }
  if (ft(n)) {
    if (!ft(e))
      return !1;
    if (Array.isArray(n)) {
      if (!Array.isArray(e))
        return !1;
      let r = [], o = [], a = [];
      for (const d of n.keys()) {
        const s = n[d];
        Fn(s) && s[ko] ? a.push(s) : a.length ? o.push(s) : r.push(s);
      }
      if (a.length) {
        if (a.length > 1)
          throw new Error("Pattern error: Using `...P.array(...)` several times in a single pattern is not allowed.");
        if (e.length < r.length + o.length)
          return !1;
        const d = e.slice(0, r.length), s = o.length === 0 ? [] : e.slice(-o.length), l = e.slice(r.length, o.length === 0 ? 1 / 0 : -o.length);
        return r.every((f, p) => De(f, d[p], t)) && o.every((f, p) => De(f, s[p], t)) && (a.length === 0 || De(a[0], l, t));
      }
      return n.length === e.length && n.every((d, s) => De(d, e[s], t));
    }
    return Reflect.ownKeys(n).every((r) => {
      const o = n[r];
      return (r in e || Fn(a = o) && a[ze]().matcherType === "optional") && De(o, e[r], t);
      var a;
    });
  }
  return Object.is(e, n);
}, tn = (n) => {
  var e, t, r;
  return ft(n) ? Fn(n) ? (e = (t = (r = n[ze]()).getSelectionKeys) == null ? void 0 : t.call(r)) != null ? e : [] : Array.isArray(n) ? En(n, tn) : En(Object.values(n), tn) : [];
}, En = (n, e) => n.reduce((t, r) => t.concat(e(r)), []);
function Se(n) {
  return Object.assign(n, { optional: () => Io(n), and: (e) => ce(n, e), or: (e) => Ro(n, e), select: (e) => e === void 0 ? Zt(n) : Zt(e, n) });
}
function Io(n) {
  return Se({ [ze]: () => ({ match: (e) => {
    let t = {};
    const r = (o, a) => {
      t[o] = a;
    };
    return e === void 0 ? (tn(n).forEach((o) => r(o, void 0)), { matched: !0, selections: t }) : { matched: De(n, e, r), selections: t };
  }, getSelectionKeys: () => tn(n), matcherType: "optional" }) });
}
function ce(...n) {
  return Se({ [ze]: () => ({ match: (e) => {
    let t = {};
    const r = (o, a) => {
      t[o] = a;
    };
    return { matched: n.every((o) => De(o, e, r)), selections: t };
  }, getSelectionKeys: () => En(n, tn), matcherType: "and" }) });
}
function Ro(...n) {
  return Se({ [ze]: () => ({ match: (e) => {
    let t = {};
    const r = (o, a) => {
      t[o] = a;
    };
    return En(n, tn).forEach((o) => r(o, void 0)), { matched: n.some((o) => De(o, e, r)), selections: t };
  }, getSelectionKeys: () => En(n, tn), matcherType: "or" }) });
}
function Z(n) {
  return { [ze]: () => ({ match: (e) => ({ matched: !!n(e) }) }) };
}
function Zt(...n) {
  const e = typeof n[0] == "string" ? n[0] : void 0, t = n.length === 2 ? n[1] : typeof n[0] == "string" ? void 0 : n[0];
  return Se({ [ze]: () => ({ match: (r) => {
    let o = { [e ?? Hn]: r };
    return { matched: t === void 0 || De(t, r, (a, d) => {
      o[a] = d;
    }), selections: o };
  }, getSelectionKeys: () => [e ?? Hn].concat(t === void 0 ? [] : tn(t)) }) });
}
function Le(n) {
  return typeof n == "number";
}
function Ze(n) {
  return typeof n == "string";
}
function Je(n) {
  return typeof n == "bigint";
}
Se(Z(function(n) {
  return !0;
}));
const Ye = (n) => Object.assign(Se(n), { startsWith: (e) => {
  return Ye(ce(n, (t = e, Z((r) => Ze(r) && r.startsWith(t)))));
  var t;
}, endsWith: (e) => {
  return Ye(ce(n, (t = e, Z((r) => Ze(r) && r.endsWith(t)))));
  var t;
}, minLength: (e) => Ye(ce(n, ((t) => Z((r) => Ze(r) && r.length >= t))(e))), length: (e) => Ye(ce(n, ((t) => Z((r) => Ze(r) && r.length === t))(e))), maxLength: (e) => Ye(ce(n, ((t) => Z((r) => Ze(r) && r.length <= t))(e))), includes: (e) => {
  return Ye(ce(n, (t = e, Z((r) => Ze(r) && r.includes(t)))));
  var t;
}, regex: (e) => {
  return Ye(ce(n, (t = e, Z((r) => Ze(r) && !!r.match(t)))));
  var t;
} });
Ye(Z(Ze));
const xe = (n) => Object.assign(Se(n), { between: (e, t) => xe(ce(n, ((r, o) => Z((a) => Le(a) && r <= a && o >= a))(e, t))), lt: (e) => xe(ce(n, ((t) => Z((r) => Le(r) && r < t))(e))), gt: (e) => xe(ce(n, ((t) => Z((r) => Le(r) && r > t))(e))), lte: (e) => xe(ce(n, ((t) => Z((r) => Le(r) && r <= t))(e))), gte: (e) => xe(ce(n, ((t) => Z((r) => Le(r) && r >= t))(e))), int: () => xe(ce(n, Z((e) => Le(e) && Number.isInteger(e)))), finite: () => xe(ce(n, Z((e) => Le(e) && Number.isFinite(e)))), positive: () => xe(ce(n, Z((e) => Le(e) && e > 0))), negative: () => xe(ce(n, Z((e) => Le(e) && e < 0))) });
xe(Z(Le));
const Xe = (n) => Object.assign(Se(n), { between: (e, t) => Xe(ce(n, ((r, o) => Z((a) => Je(a) && r <= a && o >= a))(e, t))), lt: (e) => Xe(ce(n, ((t) => Z((r) => Je(r) && r < t))(e))), gt: (e) => Xe(ce(n, ((t) => Z((r) => Je(r) && r > t))(e))), lte: (e) => Xe(ce(n, ((t) => Z((r) => Je(r) && r <= t))(e))), gte: (e) => Xe(ce(n, ((t) => Z((r) => Je(r) && r >= t))(e))), positive: () => Xe(ce(n, Z((e) => Je(e) && e > 0))), negative: () => Xe(ce(n, Z((e) => Je(e) && e < 0))) });
Xe(Z(Je));
Se(Z(function(n) {
  return typeof n == "boolean";
}));
Se(Z(function(n) {
  return typeof n == "symbol";
}));
Se(Z(function(n) {
  return n == null;
}));
Se(Z(function(n) {
  return n != null;
}));
class Po extends Error {
  constructor(e) {
    let t;
    try {
      t = JSON.stringify(e);
    } catch {
      t = e;
    }
    super(`Pattern matching error: no pattern matches value ${t}`), this.input = void 0, this.input = e;
  }
}
const mt = { matched: !1, value: void 0 };
function Lo(n) {
  return new Vn(n, mt);
}
class Vn {
  constructor(e, t) {
    this.input = void 0, this.state = void 0, this.input = e, this.state = t;
  }
  with(...e) {
    if (this.state.matched)
      return this;
    const t = e[e.length - 1], r = [e[0]];
    let o;
    e.length === 3 && typeof e[1] == "function" ? o = e[1] : e.length > 2 && r.push(...e.slice(1, e.length - 1));
    let a = !1, d = {};
    const s = (f, p) => {
      a = !0, d[f] = p;
    }, l = !r.some((f) => De(f, this.input, s)) || o && !o(this.input) ? mt : { matched: !0, value: t(a ? Hn in d ? d[Hn] : d : this.input, this.input) };
    return new Vn(this.input, l);
  }
  when(e, t) {
    if (this.state.matched)
      return this;
    const r = !!e(this.input);
    return new Vn(this.input, r ? { matched: !0, value: t(this.input, this.input) } : mt);
  }
  otherwise(e) {
    return this.state.matched ? this.state.value : e(this.input);
  }
  exhaustive() {
    if (this.state.matched)
      return this.state.value;
    throw new Po(this.input);
  }
  run() {
    return this.exhaustive();
  }
  returnType() {
    return this;
  }
}
var D = /* @__PURE__ */ ((n) => (n.SET_X_BASE_ERROR_TEXT = "SET_X_BASE_ERROR_TEXT", n.SET_OAUTH_ERROR_MESSAGE = "SET_OAUTH_ERROR_MESSAGE", n.CLEAR_X_BASE_ERROR_TEXT = "CLEAR_X_BASE_ERROR_TEXT", n.GOTO_OAUTH_LOGIN = "GOTO_OAUTH_LOGIN", n.GOTO_AUTH_LOGIN = "GOTO_AUTH_LOGIN", n.GOTO_PHONE_LOGIN = "GOTO_PHONE_LOGIN", n.GOTO_PASSWORD_LOGIN = "GOTO_PASSWORD_LOGIN", n.GOTO_FORGET_PASSWORD = "GOTO_FORGET_PASSWORD", n.GOTO_EMAIL_LOGIN = "GOTO_EMAIL_LOGIN", n.GOTO_QR_CODE_LOGIN = "GOTO_QR_CODE_LOGIN", n.GOTO_EMAIL_REGISTER = "GOTO_EMAIL_REGISTER", n.GOTO_ROUTER_BACK = "GOTO_ROUTER_BACK", n.HANDLE_SEND_PHONE_MESSAGE = "HANDLE_SEND_PHONE_MESSAGE", n.HANDLE_LOGIN_BY_PHONE_NUMBER = "HANDLE_LOGIN_BY_PHONE_NUMBER", n.HANDLE_LOGIN_BY_PASSWORD = "HANDLE_LOGIN_BY_PASSWORD", n.HANDLE_LOGIN_BY_EMAIL = "HANDLE_LOGIN_BY_EMAIL", n.HANDLE_LOGIN_BY_AUTH_CODE = "HANDLE_LOGIN_BY_AUTH_CODE", n.HANDLE_SEND_EMAIL_MESSAGE = "HANDLE_SEND_EMAIL_MESSAGE", n.HANDLE_REGISTER_BY_EMAIL = "HANDLE_REGISTER_BY_EMAIL", n.HANDLE_OAUTH_FROM_GOOGLE = "HANDLE_OAUTH_FROM_GOOGLE", n.HANDLE_OAUTH_FROM_FACEBOOK = "HANDLE_OAUTH_FROM_FACEBOOK", n))(D || {}), He = /* @__PURE__ */ ((n) => (n[n.QUICK_GOOGLE = 0] = "QUICK_GOOGLE", n[n.QUICK_FACEBOOK = 1] = "QUICK_FACEBOOK", n[n.QUICK_PHONE = 2] = "QUICK_PHONE", n[n.QUICK_EMAIL = 3] = "QUICK_EMAIL", n[n.QUICK_QRCODE = 4] = "QUICK_QRCODE", n))(He || {});
const xo = [
  {
    type: 0,
    iconClass: "icon-google",
    action: "HANDLE_OAUTH_FROM_GOOGLE"
    /* HANDLE_OAUTH_FROM_GOOGLE */
  },
  {
    type: 1,
    iconClass: "icon-facebook",
    action: "HANDLE_OAUTH_FROM_FACEBOOK"
    /* HANDLE_OAUTH_FROM_FACEBOOK */
  },
  {
    type: 2,
    iconClass: "icon-phone",
    action: "GOTO_PHONE_LOGIN"
    /* GOTO_PHONE_LOGIN */
  },
  {
    type: 3,
    iconClass: "icon-email",
    action: "GOTO_EMAIL_LOGIN"
    /* GOTO_EMAIL_LOGIN */
  },
  {
    type: 4,
    iconClass: "icon-qrcode",
    action: "GOTO_QR_CODE_LOGIN"
    /* GOTO_QR_CODE_LOGIN */
  }
], pt = "+65", Jt = "SG";
var kr = /* @__PURE__ */ ((n) => (n.GET_AUTH_LOGIN_INFO = "GET_AUTH_LOGIN_INFO", n))(kr || {});
const Ir = ["mypikpak.com", "pikpakdrive.com", "mypikpak.net", "pikpak.me"], Yt = Ir[0], ie = an({
  history: [],
  email: "",
  phoneNumber: "",
  phoneCode: "",
  // 获取当前登录方式(用于上报)
  emphasizeMode: "oauth"
}), Yn = (n, e) => {
  Rt(() => {
    const t = ie[e];
    t !== void 0 && (n[e] = t);
  }), hn(n, () => {
    ie[e] !== void 0 && (ie[e] = n[e]);
  });
}, Mo = { class: "login-header" }, Do = { class: "login-header-title" }, Fo = { class: "subtitle-box" }, Uo = ["onClick"], Go = /* @__PURE__ */ le({
  __name: "ActionBar",
  props: {
    title: { type: Function },
    subtitle: {}
  },
  emits: ["command"],
  setup(n, { emit: e }) {
    const t = e, r = () => {
      t("command", { type: D.GOTO_ROUTER_BACK });
    };
    return (o, a) => (P(), L("div", Mo, [
      R(ie).history.length > 1 ? (P(), L("div", {
        key: 0,
        class: "login-header-icon",
        onClick: r
      })) : ge("", !0),
      k("span", Do, G(o.title()), 1),
      k("div", Fo, [
        (P(!0), L(Ue, null, Tn(o.subtitle, (d, s) => (P(), L("span", {
          class: Ie({ "login-header-subtitle": !0, link: d.action }),
          key: s,
          onClick: () => d.action && t("command", d.action)
        }, G(d.text()), 11, Uo))), 128))
      ])
    ]));
  }
}), ue = (n, e) => {
  const t = n.__vccOpts || n;
  for (const [r, o] of e)
    t[r] = o;
  return t;
}, Bo = /* @__PURE__ */ ue(Go, [["__scopeId", "data-v-5671aac1"]]), jo = /* @__PURE__ */ le({
  __name: "PPButton",
  props: {
    disabled: { type: Boolean }
  },
  emits: ["click"],
  setup(n, { emit: e }) {
    const t = e;
    return (r, o) => (P(), L("button", {
      class: Ie({
        "pp-button": !0,
        disabled: r.disabled
      }),
      role: "button",
      onClick: o[0] || (o[0] = (a) => t("click", a))
    }, [
      Re(r.$slots, "default", {}, void 0, !0)
    ], 2));
  }
}), kn = /* @__PURE__ */ ue(jo, [["__scopeId", "data-v-ca33e41c"]]), Ho = { class: "auth-login-pane" }, Vo = { class: "user-info" }, zo = ["src"], Ko = ["title"], qo = ["title"], Qo = { class: "error-message" }, Wo = { class: "dynamic-name" }, Zo = { class: "left-part" }, Jo = { class: "right-part" }, Yo = /* @__PURE__ */ le({
  __name: "AuthLogin",
  props: {
    client: {},
    authInfo: {}
  },
  emits: ["command"],
  setup(n, { emit: e }) {
    const t = n, r = e, o = be(
      () => [t.authInfo.email, t.authInfo.phone].filter((s) => s).join(" | ")
    ), a = be(() => {
      const s = t.authInfo.username.length, l = Math.floor(s / 3 * 2);
      return {
        leftPart: t.authInfo.username.slice(0, l),
        rightPart: t.authInfo.username.slice(l)
      };
    }), d = () => {
      r("command", {
        type: D.HANDLE_LOGIN_BY_AUTH_CODE,
        loginInfo: t.authInfo
      });
    };
    return (s, l) => {
      const f = Co("i18n-t");
      return P(), L("div", Ho, [
        k("div", Vo, [
          k("img", {
            src: s.authInfo.avatar,
            alt: "avatar",
            class: "avatar"
          }, null, 8, zo),
          k("div", {
            class: "username",
            title: s.authInfo.username
          }, G(s.authInfo.username), 9, Ko),
          k("div", {
            class: "contact",
            title: o.value
          }, G(o.value), 9, qo)
        ]),
        k("div", Qo, [
          Re(s.$slots, "auth-login-error", {}, void 0, !0)
        ]),
        W(kn, { onClick: d }, {
          default: fe(() => [
            W(f, { keypath: "cpQsRbAexGlsskux4Awu" }, {
              default: fe(() => [
                k("div", Wo, [
                  k("span", Zo, G(a.value.leftPart), 1),
                  k("span", Jo, G(a.value.rightPart), 1)
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        k("span", {
          class: "other-login-methods",
          role: "button",
          onClick: l[0] || (l[0] = (p) => r("command", { type: R(D).GOTO_ROUTER_BACK }))
        }, G(s.$t("hFQzsBwmWj3ZyY5xwiffn")), 1)
      ]);
    };
  }
}), Xo = /* @__PURE__ */ ue(Yo, [["__scopeId", "data-v-663b7d18"]]), ed = { class: "split-line-box" }, nd = {
  key: 0,
  class: "text"
}, td = /* @__PURE__ */ le({
  __name: "SplitLine",
  props: {
    text: {}
  },
  setup(n) {
    return (e, t) => (P(), L("div", ed, [
      t[0] || (t[0] = k("div", { class: "split-line" }, null, -1)),
      e.text !== "" ? (P(), L("div", nd, G(e.text), 1)) : ge("", !0)
    ]));
  }
}), rd = /* @__PURE__ */ ue(td, [["__scopeId", "data-v-ac930bd6"]]), od = "Privacy Policy", dd = " and ", ad = "User Agreement", id = "By continuing you agree to PikPak's ", sd = "Forgot password?", cd = "Please enter the password", ld = "Enter your email", ud = "Confirm password", hd = "6-16 digits, two or more characters", gd = "Send code", fd = "Verification code", md = "Registration", pd = "The new number will be registered and logged in", $d = "Sign up now", _d = "No account? ", yd = "Login now", vd = "Have an account?", Nd = "Verification code", Cd = "Please enter phone number", bd = "Login with phone", wd = "The two passwords don't match", Ed = "Via SMS", Ad = "Via Password", Od = "Sign Up or Login", Sd = "Login with Google", Td = "Login with Facebook", kd = "Resend {0}s", Id = "Please click on the top", Rd = 'Select "Open in Safari', Pd = 'Select "Open in Browser', Ld = "Continue in an external browser", xd = "Login", Md = "QR Code Login", Dd = "Please Confirm Login on Your Mobile Device", Fd = "Scan Successful", Ud = "Open the PikPak App and Scan to login", Gd = "Failed to Retrieve QR Code", Bd = 'Login as "{0}"', jd = "Other login methods", Hd = "Complete Login in Browser", Vd = "We will refresh this page after you login", zd = "Cancel", Kd = "Connection Timed Out", qd = "Sorry, connection to the server timed out. The server may be temporarily unavailable or too busy. Please go back and retry.", Qd = "Back", Wd = {
  i7t4qmC3l0Qrx1f3Vhhh4: od,
  lyNVvA9ZvxGiyb7W_8Mz0: dd,
  tWlnmAbJ1f4Tv3Iuoht8: ad,
  guAsn6e2xbK3Raw9gokY: id,
  "1ZpdIhCgVugfCbRIp6oj": "Login With Email",
  jEVoi8AbtDyqmxg0uI9: sd,
  nIlLdBnvEaFymQzCZwYbe: cd,
  rjaGoUfPmGl6TaS463Cn: ld,
  s7TOj9RzdgxEmLc0iQ1G: ud,
  n67Zbeckh9qf0VZFqd2x: hd,
  vtKgvl4yJauSnsTy3ORf: gd,
  c9uyPndv2WrqZpw74hdTm: fd,
  ufUkrBGbv4Xt457vFOa4D: md,
  eaK82n7hjR623PupHmVhj: pd,
  cFufuxQyNg0q1a1dVWgD1: $d,
  hA5VzRxKiolLxIDSOzu: _d,
  gyJwCCpTd35n7xsGpxnE: yd,
  inpUrHefXWalKjs9ufoT: vd,
  pqc4Olt4lfdLp_8y6ZSuA: Nd,
  uunm9VjxdmUucFse2Qjs: Cd,
  "6IsOzjcj00s5HGgImQx2v": "No result",
  zcOSHAfjmkBuxiFzogJx: bd,
  b4Myg4xCv2PdFdp4T7Yf9: wd,
  nWs2QjRZeS8UwDtTggyJ: Ed,
  bGh4Ajs0J5MafoKrPkJy: Ad,
  xNuOXxnZbXmpgKbAqfKGz: Od,
  gxDXMpGqhyO1a6PMa4B: Sd,
  e1SdxwZgTfRd7HlSyegK: Td,
  scMOylJrrhNLlrFu6VTki: kd,
  kkv6uGohTOyATz9IDzOdr: Id,
  eYnpkZMyeXCFgjyMfaTh: Rd,
  fFdV8SvrG9_5ZuRy5GVd: Pd,
  jxXRc1FxLoCdUtSsyzOf: Ld,
  mLlnoecfSMuJxTrxodqMt: xd,
  "or-you-can": "Or you can",
  aJ1drF3Sll9NPkTU0Ro6: Md,
  as230x12lSDF02LSD1dw: Dd,
  gJaP_0qRfiU9zNb2Hs2y: Fd,
  "2Grb84h1MnUjxpxr7IQi": "Please Click",
  "6MhbexHdGc37PjQ7Tp15": "Refresh",
  mOAooQeZeCWt2a0swZlQ9: Ud,
  vJvlwMy1A7SGoS1JggM9: Gd,
  cpQsRbAexGlsskux4Awu: Bd,
  hFQzsBwmWj3ZyY5xwiffn: jd,
  "3cSGnE4amksZ8nYggFqYh": "Login failed, please try again later",
  i0qzQnQhDvQTuSYzEvHd: Hd,
  yyHu3EkYTxXy2aMczGocn: Vd,
  bbyavRuUbj025YpODbm1S: zd,
  vkN9TkHnIgJlFrVsw7bq: Kd,
  juspWzUyy57Ij3Oxe5Hyb: qd,
  rKg0YrFdCcho96B04NnK: Qd
}, Zd = "Kebijakan Privasi", Jd = " dan ", Yd = "Perjanjian Pengguna", Xd = "Jika Anda melanjutkan, Anda setuju dengan PikPak ", e0 = "Lupa kata sandi?", n0 = "Silakan masukkan kata sandi", t0 = "Silakan masukan email Anda", r0 = "Konfirmasi kata sandi", o0 = "6-16 digit, dua atau lebih karakter", d0 = "Hantar kod", a0 = "Kode verifikasi email", i0 = "Registrasi", s0 = "Nomor baru akan didaftarkan dan login", c0 = "Pendaftaran", l0 = "Tiada akaun?", u0 = "Log masuk", h0 = "Ada akaun?", g0 = "Kode verifikasi", f0 = "Sila masukkan nombor telefon", m0 = "Masuk dengan telepon", p0 = "Kedua kata sandi tidak cocok", $0 = "Masuk kode SMS", _0 = "Masuk Kata Sandi", y0 = "Daftar atau masuk", v0 = "Masuk dengan Google", N0 = "Masuk dengan Facebook", C0 = "Kirim ulang {0}s", b0 = "Please click on the top", w0 = 'Select "Open in Safari', E0 = 'Select "Open in Browser', A0 = "Continue in an external browser", O0 = "Gabung", S0 = "Login dengan Kode QR", T0 = "Silakan Konfirmasi Masuk pada Perangkat Seluler Anda", k0 = "Scan Berhasil", I0 = "Buka Aplikasi PikPak dan Pindai untuk Masuk", R0 = "Gagal Mengambil Kode QR", P0 = 'Login sebagai "{0}"', L0 = "Metode login lainnya", x0 = "Selesaikan Masuk di Peramban", M0 = "Kami akan memuat ulang halaman ini setelah Anda masuk", D0 = "Batal", F0 = "Koneksi Berakhir Waktu", U0 = "Maaf, koneksi ke server telah habis waktu. Server mungkin sementara tidak tersedia atau terlalu sibuk. Silakan kembali dan coba lagi.", G0 = "Kembali", B0 = {
  i7t4qmC3l0Qrx1f3Vhhh4: Zd,
  lyNVvA9ZvxGiyb7W_8Mz0: Jd,
  tWlnmAbJ1f4Tv3Iuoht8: Yd,
  guAsn6e2xbK3Raw9gokY: Xd,
  "1ZpdIhCgVugfCbRIp6oj": "Masuk Dengan Email",
  jEVoi8AbtDyqmxg0uI9: e0,
  nIlLdBnvEaFymQzCZwYbe: n0,
  rjaGoUfPmGl6TaS463Cn: t0,
  s7TOj9RzdgxEmLc0iQ1G: r0,
  n67Zbeckh9qf0VZFqd2x: o0,
  vtKgvl4yJauSnsTy3ORf: d0,
  c9uyPndv2WrqZpw74hdTm: a0,
  ufUkrBGbv4Xt457vFOa4D: i0,
  eaK82n7hjR623PupHmVhj: s0,
  cFufuxQyNg0q1a1dVWgD1: c0,
  hA5VzRxKiolLxIDSOzu: l0,
  gyJwCCpTd35n7xsGpxnE: u0,
  inpUrHefXWalKjs9ufoT: h0,
  pqc4Olt4lfdLp_8y6ZSuA: g0,
  uunm9VjxdmUucFse2Qjs: f0,
  "6IsOzjcj00s5HGgImQx2v": "Tiada keputusan",
  zcOSHAfjmkBuxiFzogJx: m0,
  b4Myg4xCv2PdFdp4T7Yf9: p0,
  nWs2QjRZeS8UwDtTggyJ: $0,
  bGh4Ajs0J5MafoKrPkJy: _0,
  xNuOXxnZbXmpgKbAqfKGz: y0,
  gxDXMpGqhyO1a6PMa4B: v0,
  e1SdxwZgTfRd7HlSyegK: N0,
  scMOylJrrhNLlrFu6VTki: C0,
  kkv6uGohTOyATz9IDzOdr: b0,
  eYnpkZMyeXCFgjyMfaTh: w0,
  fFdV8SvrG9_5ZuRy5GVd: E0,
  jxXRc1FxLoCdUtSsyzOf: A0,
  mLlnoecfSMuJxTrxodqMt: O0,
  "or-you-can": "Atau kamu bisa",
  aJ1drF3Sll9NPkTU0Ro6: S0,
  as230x12lSDF02LSD1dw: T0,
  gJaP_0qRfiU9zNb2Hs2y: k0,
  "2Grb84h1MnUjxpxr7IQi": "Silakan Klik",
  "6MhbexHdGc37PjQ7Tp15": "Segarkan",
  mOAooQeZeCWt2a0swZlQ9: I0,
  vJvlwMy1A7SGoS1JggM9: R0,
  cpQsRbAexGlsskux4Awu: P0,
  hFQzsBwmWj3ZyY5xwiffn: L0,
  "3cSGnE4amksZ8nYggFqYh": "Gagal login, silakan coba lagi nanti",
  i0qzQnQhDvQTuSYzEvHd: x0,
  yyHu3EkYTxXy2aMczGocn: M0,
  bbyavRuUbj025YpODbm1S: D0,
  vkN9TkHnIgJlFrVsw7bq: F0,
  juspWzUyy57Ij3Oxe5Hyb: U0,
  rKg0YrFdCcho96B04NnK: G0
}, j0 = "Kebijakan Privasi", H0 = " dan ", V0 = "Perjanjian Pengguna", z0 = "Jika Anda melanjutkan, Anda setuju dengan PikPak ", K0 = "Lupa kata sandi?", q0 = "Silakan masukkan kata sandi", Q0 = "Silakan masukan email Anda", W0 = "Konfirmasi kata sandi", Z0 = "6-16 digit, dua atau lebih aksara", J0 = "Hantar kod", Y0 = "Kode verifikasi email", X0 = "Pendaftaran", ea = "Nomor baru akan didaftarkan dan masuk", na = "Pendaftaran", ta = "Tiada akaun?", ra = "Log masuk", oa = "Ada akaun?", da = "Kod pengesahan", aa = "Sila masukkan nombor telefon", ia = "Log masuk dengan telefon", sa = "Kedua kata sandi tidak cocok", ca = "Log masuk kod SMS", la = "Log Masuk Kata Laluan", ua = "Daftar atau log masuk", ha = "Log masuk melalui Google", ga = "Log masuk melalui Facebook", fa = "Hantar semula {0}s", ma = "Please click on the top", pa = 'Select "Open in Safari', $a = 'Select "Open in Browser', _a = "Continue in an external browser", ya = "Log masuk", va = "Log Masuk dengan Kod QR", Na = "Sila Sahkan Log Masuk pada Peranti Mudah Alih Anda", Ca = "Imbas Berjaya", ba = "Buka Aplikasi PikPak dan Imbas untuk Log Masuk", wa = "Gagal Dapatkan Kod QR", Ea = 'Log masuk sebagai "{0}"', Aa = "Cara login lain", Oa = "Lengkapkan Log Masuk di Pelayar", Sa = "Kami akan memuat semula halaman ini selepas anda log masuk", Ta = "Batal", ka = "Sambungan Tamat Tempoh", Ia = "Maaf, sambungan ke pelayan telah tamat. Pelayan mungkin sementara tidak tersedia atau terlalu sibuk. Sila kembali dan cuba lagi.", Ra = "Kembali", Pa = {
  i7t4qmC3l0Qrx1f3Vhhh4: j0,
  lyNVvA9ZvxGiyb7W_8Mz0: H0,
  tWlnmAbJ1f4Tv3Iuoht8: V0,
  guAsn6e2xbK3Raw9gokY: z0,
  "1ZpdIhCgVugfCbRIp6oj": "Log Masuk Dengan E-mel",
  jEVoi8AbtDyqmxg0uI9: K0,
  nIlLdBnvEaFymQzCZwYbe: q0,
  rjaGoUfPmGl6TaS463Cn: Q0,
  s7TOj9RzdgxEmLc0iQ1G: W0,
  n67Zbeckh9qf0VZFqd2x: Z0,
  vtKgvl4yJauSnsTy3ORf: J0,
  c9uyPndv2WrqZpw74hdTm: Y0,
  ufUkrBGbv4Xt457vFOa4D: X0,
  eaK82n7hjR623PupHmVhj: ea,
  cFufuxQyNg0q1a1dVWgD1: na,
  hA5VzRxKiolLxIDSOzu: ta,
  gyJwCCpTd35n7xsGpxnE: ra,
  inpUrHefXWalKjs9ufoT: oa,
  pqc4Olt4lfdLp_8y6ZSuA: da,
  uunm9VjxdmUucFse2Qjs: aa,
  "6IsOzjcj00s5HGgImQx2v": "Tiada keputusan",
  zcOSHAfjmkBuxiFzogJx: ia,
  b4Myg4xCv2PdFdp4T7Yf9: sa,
  nWs2QjRZeS8UwDtTggyJ: ca,
  bGh4Ajs0J5MafoKrPkJy: la,
  xNuOXxnZbXmpgKbAqfKGz: ua,
  gxDXMpGqhyO1a6PMa4B: ha,
  e1SdxwZgTfRd7HlSyegK: ga,
  scMOylJrrhNLlrFu6VTki: fa,
  kkv6uGohTOyATz9IDzOdr: ma,
  eYnpkZMyeXCFgjyMfaTh: pa,
  fFdV8SvrG9_5ZuRy5GVd: $a,
  jxXRc1FxLoCdUtSsyzOf: _a,
  mLlnoecfSMuJxTrxodqMt: ya,
  "or-you-can": "Atau anda boleh",
  aJ1drF3Sll9NPkTU0Ro6: va,
  as230x12lSDF02LSD1dw: Na,
  gJaP_0qRfiU9zNb2Hs2y: Ca,
  "2Grb84h1MnUjxpxr7IQi": "Sila Klik",
  "6MhbexHdGc37PjQ7Tp15": "Segarkan semula",
  mOAooQeZeCWt2a0swZlQ9: ba,
  vJvlwMy1A7SGoS1JggM9: wa,
  cpQsRbAexGlsskux4Awu: Ea,
  hFQzsBwmWj3ZyY5xwiffn: Aa,
  "3cSGnE4amksZ8nYggFqYh": "Gagal log masuk, sila cuba lagi nanti",
  i0qzQnQhDvQTuSYzEvHd: Oa,
  yyHu3EkYTxXy2aMczGocn: Sa,
  bbyavRuUbj025YpODbm1S: Ta,
  vkN9TkHnIgJlFrVsw7bq: ka,
  juspWzUyy57Ij3Oxe5Hyb: Ia,
  rKg0YrFdCcho96B04NnK: Ra
}, La = "隐私政策", xa = "和", Ma = "用户协议", Da = "如果继续，则表示您同意PikPak的", Fa = "忘记密码?", Ua = "请输入密码", Ga = "请输入邮箱", Ba = "确认密码", ja = "6-16位密码，使用字母、数字和符号混合", Ha = "发送验证码", Va = "邮箱验证码", za = "注册", Ka = "未注册号码会自动注册登录", qa = "去注册", Qa = "没有账号？", Wa = "去登录", Za = "已有账号？", Ja = "验证码", Ya = "请输入手机号", Xa = "手机登录", ei = "两次密码不一致", ni = "短信验证码登录", ti = "密码登录", ri = "注册或登录", oi = "使用 Google 登录", di = "使用 Facebook 登录", ai = "重新发送 {0}s", ii = "Please click on the top", si = 'Select "Open in Safari', ci = 'Select "Open in Browser', li = "Continue in an external browser", ui = "登录", hi = "二维码登录", gi = "请在手机端确认登录", fi = "扫描成功", mi = "打开 PikPak App 扫码登录", pi = "获取二维码失败", $i = '以 "{0}" 的身份登录', _i = "其他登录方式", yi = "在浏览器中完成登录", vi = "您登录后，我们将刷新此页", Ni = "取消", Ci = "连接超时", bi = "对不起，连接服务器请求超时。网络服务器可能暂时不可用或过于繁忙，请返回重试。", wi = "后退", Ei = {
  i7t4qmC3l0Qrx1f3Vhhh4: La,
  lyNVvA9ZvxGiyb7W_8Mz0: xa,
  tWlnmAbJ1f4Tv3Iuoht8: Ma,
  guAsn6e2xbK3Raw9gokY: Da,
  "1ZpdIhCgVugfCbRIp6oj": "邮箱登录",
  jEVoi8AbtDyqmxg0uI9: Fa,
  nIlLdBnvEaFymQzCZwYbe: Ua,
  rjaGoUfPmGl6TaS463Cn: Ga,
  s7TOj9RzdgxEmLc0iQ1G: Ba,
  n67Zbeckh9qf0VZFqd2x: ja,
  vtKgvl4yJauSnsTy3ORf: Ha,
  c9uyPndv2WrqZpw74hdTm: Va,
  ufUkrBGbv4Xt457vFOa4D: za,
  eaK82n7hjR623PupHmVhj: Ka,
  cFufuxQyNg0q1a1dVWgD1: qa,
  hA5VzRxKiolLxIDSOzu: Qa,
  gyJwCCpTd35n7xsGpxnE: Wa,
  inpUrHefXWalKjs9ufoT: Za,
  pqc4Olt4lfdLp_8y6ZSuA: Ja,
  uunm9VjxdmUucFse2Qjs: Ya,
  "6IsOzjcj00s5HGgImQx2v": "无结果",
  zcOSHAfjmkBuxiFzogJx: Xa,
  b4Myg4xCv2PdFdp4T7Yf9: ei,
  nWs2QjRZeS8UwDtTggyJ: ni,
  bGh4Ajs0J5MafoKrPkJy: ti,
  xNuOXxnZbXmpgKbAqfKGz: ri,
  gxDXMpGqhyO1a6PMa4B: oi,
  e1SdxwZgTfRd7HlSyegK: di,
  scMOylJrrhNLlrFu6VTki: ai,
  kkv6uGohTOyATz9IDzOdr: ii,
  eYnpkZMyeXCFgjyMfaTh: si,
  fFdV8SvrG9_5ZuRy5GVd: ci,
  jxXRc1FxLoCdUtSsyzOf: li,
  mLlnoecfSMuJxTrxodqMt: ui,
  "or-you-can": "或者",
  aJ1drF3Sll9NPkTU0Ro6: hi,
  as230x12lSDF02LSD1dw: gi,
  gJaP_0qRfiU9zNb2Hs2y: fi,
  "2Grb84h1MnUjxpxr7IQi": "请点击",
  "6MhbexHdGc37PjQ7Tp15": "刷新",
  mOAooQeZeCWt2a0swZlQ9: mi,
  vJvlwMy1A7SGoS1JggM9: pi,
  cpQsRbAexGlsskux4Awu: $i,
  hFQzsBwmWj3ZyY5xwiffn: _i,
  "3cSGnE4amksZ8nYggFqYh": "登录失败，请稍后重试",
  i0qzQnQhDvQTuSYzEvHd: yi,
  yyHu3EkYTxXy2aMczGocn: vi,
  bbyavRuUbj025YpODbm1S: Ni,
  vkN9TkHnIgJlFrVsw7bq: Ci,
  juspWzUyy57Ij3Oxe5Hyb: bi,
  rKg0YrFdCcho96B04NnK: wi
}, Ai = "隱私政策", Oi = "和", Si = "用戶協議", Ti = "如果繼續，則表示您同意PikPak的", ki = "忘記密碼？", Ii = "請輸入密碼", Ri = "請輸入郵箱", Pi = "確認密碼", Li = "6-16位密碼，使用字母、數字和符號混合", xi = "發送驗證碼", Mi = "郵箱驗證碼", Di = "註冊", Fi = "未註冊號碼會自動註冊登入", Ui = "去註冊", Gi = "沒有賬號？", Bi = "去登錄", ji = "已有賬號？", Hi = "驗證碼", Vi = "請輸入手機號", zi = "手機登錄", Ki = "兩次密碼不一致", qi = "短信驗證碼登錄", Qi = "密碼登錄", Wi = "註冊或登錄", Zi = "使用 Google 登錄", Ji = "使用 Facebook 登錄", Yi = "重新發送 {0}s", Xi = "Please click on the top", e1 = 'Select "Open in Safari', n1 = 'Select "Open in Browser', t1 = "Continue in an external browser", r1 = "登錄", o1 = "二維碼登入", d1 = "請在手機端確認登入", a1 = "掃描成功", i1 = "打開 PikPak App 掃碼登入", s1 = "獲取二維碼失敗", c1 = "以 「{0}」 的身份登錄", l1 = "其他登錄方式", u1 = "在瀏覽器中完成登入", h1 = "您登入後，我們將刷新此頁", g1 = "取消", f1 = "連線逾時", m1 = "很抱歉，連線伺服器請求逾時。網路伺服器可能暫時不可用或過於繁忙，請返回重試。", p1 = "後退", $1 = {
  i7t4qmC3l0Qrx1f3Vhhh4: Ai,
  lyNVvA9ZvxGiyb7W_8Mz0: Oi,
  tWlnmAbJ1f4Tv3Iuoht8: Si,
  guAsn6e2xbK3Raw9gokY: Ti,
  "1ZpdIhCgVugfCbRIp6oj": "郵箱登錄",
  jEVoi8AbtDyqmxg0uI9: ki,
  nIlLdBnvEaFymQzCZwYbe: Ii,
  rjaGoUfPmGl6TaS463Cn: Ri,
  s7TOj9RzdgxEmLc0iQ1G: Pi,
  n67Zbeckh9qf0VZFqd2x: Li,
  vtKgvl4yJauSnsTy3ORf: xi,
  c9uyPndv2WrqZpw74hdTm: Mi,
  ufUkrBGbv4Xt457vFOa4D: Di,
  eaK82n7hjR623PupHmVhj: Fi,
  cFufuxQyNg0q1a1dVWgD1: Ui,
  hA5VzRxKiolLxIDSOzu: Gi,
  gyJwCCpTd35n7xsGpxnE: Bi,
  inpUrHefXWalKjs9ufoT: ji,
  pqc4Olt4lfdLp_8y6ZSuA: Hi,
  uunm9VjxdmUucFse2Qjs: Vi,
  "6IsOzjcj00s5HGgImQx2v": "無結果",
  zcOSHAfjmkBuxiFzogJx: zi,
  b4Myg4xCv2PdFdp4T7Yf9: Ki,
  nWs2QjRZeS8UwDtTggyJ: qi,
  bGh4Ajs0J5MafoKrPkJy: Qi,
  xNuOXxnZbXmpgKbAqfKGz: Wi,
  gxDXMpGqhyO1a6PMa4B: Zi,
  e1SdxwZgTfRd7HlSyegK: Ji,
  scMOylJrrhNLlrFu6VTki: Yi,
  kkv6uGohTOyATz9IDzOdr: Xi,
  eYnpkZMyeXCFgjyMfaTh: e1,
  fFdV8SvrG9_5ZuRy5GVd: n1,
  jxXRc1FxLoCdUtSsyzOf: t1,
  mLlnoecfSMuJxTrxodqMt: r1,
  "or-you-can": "或者",
  aJ1drF3Sll9NPkTU0Ro6: o1,
  as230x12lSDF02LSD1dw: d1,
  gJaP_0qRfiU9zNb2Hs2y: a1,
  "2Grb84h1MnUjxpxr7IQi": "請點擊",
  "6MhbexHdGc37PjQ7Tp15": "刷新",
  mOAooQeZeCWt2a0swZlQ9: i1,
  vJvlwMy1A7SGoS1JggM9: s1,
  cpQsRbAexGlsskux4Awu: c1,
  hFQzsBwmWj3ZyY5xwiffn: l1,
  "3cSGnE4amksZ8nYggFqYh": "登入失敗，請稍後再試",
  i0qzQnQhDvQTuSYzEvHd: u1,
  yyHu3EkYTxXy2aMczGocn: h1,
  bbyavRuUbj025YpODbm1S: g1,
  vkN9TkHnIgJlFrVsw7bq: f1,
  juspWzUyy57Ij3Oxe5Hyb: m1,
  rKg0YrFdCcho96B04NnK: p1
}, _1 = "개인 정보 정책", y1 = "사용자 약관", v1 = "이메일 주소를 입력하세요", N1 = "비밀번호를 확인", C1 = "인증 코드 보내기", b1 = "이메일 인증 코드", w1 = "가입하기", E1 = "가입하려 가기", A1 = "계정 없습니까?", O1 = "로그인하려 가기", S1 = "인증 코드", T1 = "전화번호를 입력하세요", k1 = "두 비밀번호가 일치하지 않습니다", I1 = "SMS 인증 코드 로그인", R1 = "비밀번호 로그인", P1 = "구글로 로그인", L1 = "페이스북으로 로그인", x1 = "{0}s 재전송", M1 = "과", D1 = "계속하려면, 다음과 같은 픽팍의 정책을 동의합니다.", F1 = "비밀번호를 잊으셨나요?", U1 = "비밀번호를 입력하세요", G1 = "문자, 숫자 및 기호를 혼합한 6-16자리", B1 = "미 가입 번호는 자동적으로 가입됩니다.", j1 = "회원가입 또는 로그인", H1 = "계정이 있습니까?", V1 = "휴대전화로 로그인", z1 = "상단을 클릭하여", K1 = '"Safari에서 열기" 를 선택한 후', q1 = '"브라우저에서 열기" 를 선택한 후', Q1 = "외부 브라우저에서 계속하시기 바랍니다.", W1 = "로그인", Z1 = "QR코드로 로그인", J1 = "휴대폰으로 로그인 확인을 하세요.", Y1 = "스캔 성공", X1 = "픽팍 앱을 열고 QR코드로 로그인하세요.", e2 = "QR코드 불러오기에 실패했습니다.", n2 = ' "{0}" 신분으로 등록하기', t2 = "다른 방식으로 등록하기", r2 = "브라우저에서 로그인 완료", o2 = "로그인 후 이 페이지를 새로 고침합니다.", d2 = "취소", a2 = "연결 시간 초과", i2 = "죄송합니다. 연결 서버 요청이 시간 초과되었습니다. 네트워크 서버가 일시적으로 사용할 수 없거나 과도하게 사용 중일 수 있으므로 나중에 다시 시도하십시오.", s2 = "뒤로", c2 = {
  i7t4qmC3l0Qrx1f3Vhhh4: _1,
  tWlnmAbJ1f4Tv3Iuoht8: y1,
  "1ZpdIhCgVugfCbRIp6oj": "이메일 로그인",
  rjaGoUfPmGl6TaS463Cn: v1,
  s7TOj9RzdgxEmLc0iQ1G: N1,
  vtKgvl4yJauSnsTy3ORf: C1,
  c9uyPndv2WrqZpw74hdTm: b1,
  ufUkrBGbv4Xt457vFOa4D: w1,
  cFufuxQyNg0q1a1dVWgD1: E1,
  hA5VzRxKiolLxIDSOzu: A1,
  gyJwCCpTd35n7xsGpxnE: O1,
  pqc4Olt4lfdLp_8y6ZSuA: S1,
  uunm9VjxdmUucFse2Qjs: T1,
  b4Myg4xCv2PdFdp4T7Yf9: k1,
  nWs2QjRZeS8UwDtTggyJ: I1,
  bGh4Ajs0J5MafoKrPkJy: R1,
  gxDXMpGqhyO1a6PMa4B: P1,
  e1SdxwZgTfRd7HlSyegK: L1,
  scMOylJrrhNLlrFu6VTki: x1,
  lyNVvA9ZvxGiyb7W_8Mz0: M1,
  guAsn6e2xbK3Raw9gokY: D1,
  jEVoi8AbtDyqmxg0uI9: F1,
  nIlLdBnvEaFymQzCZwYbe: U1,
  n67Zbeckh9qf0VZFqd2x: G1,
  eaK82n7hjR623PupHmVhj: B1,
  xNuOXxnZbXmpgKbAqfKGz: j1,
  inpUrHefXWalKjs9ufoT: H1,
  "6IsOzjcj00s5HGgImQx2v": "결과 없음",
  zcOSHAfjmkBuxiFzogJx: V1,
  kkv6uGohTOyATz9IDzOdr: z1,
  eYnpkZMyeXCFgjyMfaTh: K1,
  fFdV8SvrG9_5ZuRy5GVd: q1,
  jxXRc1FxLoCdUtSsyzOf: Q1,
  mLlnoecfSMuJxTrxodqMt: W1,
  "or-you-can": "혹은",
  aJ1drF3Sll9NPkTU0Ro6: Z1,
  as230x12lSDF02LSD1dw: J1,
  gJaP_0qRfiU9zNb2Hs2y: Y1,
  "2Grb84h1MnUjxpxr7IQi": "클릭하세요",
  "6MhbexHdGc37PjQ7Tp15": "새로고침",
  mOAooQeZeCWt2a0swZlQ9: X1,
  vJvlwMy1A7SGoS1JggM9: e2,
  cpQsRbAexGlsskux4Awu: n2,
  hFQzsBwmWj3ZyY5xwiffn: t2,
  "3cSGnE4amksZ8nYggFqYh": "로그인 실패했습니다.잠시후 다시 시도하십시오.",
  i0qzQnQhDvQTuSYzEvHd: r2,
  yyHu3EkYTxXy2aMczGocn: o2,
  bbyavRuUbj025YpODbm1S: d2,
  vkN9TkHnIgJlFrVsw7bq: a2,
  juspWzUyy57Ij3Oxe5Hyb: i2,
  rKg0YrFdCcho96B04NnK: s2
}, l2 = "プライバシーポリシー", u2 = "と", h2 = "ユーザー規約", g2 = "続行すると、PikPak の", f2 = "パスワードをお忘れですか", m2 = "パスワードを入力してください", p2 = "メールアドレスを入力してください", $2 = "パスワードを認証する", _2 = "文字、数字、記号を組み合わせた 6 ～ 16 桁のパスワード", y2 = "確認コードを送信する", v2 = "メール認証コード", N2 = "登録", C2 = "未登録の番号は自動的に登録され、ログインされます", b2 = "登録するために", w2 = "アカウントがありませんか？", E2 = "ログインします", A2 = "すでにアカウントをお持ちですか？", O2 = "認証コード", S2 = "電話番号を入力してください", T2 = "電話でログイン", k2 = "2 つのパスワードが一致しません", I2 = "SMSコードログイン", R2 = "パスワードログイン", P2 = "サインアップまたはログイン", L2 = "Google でログイン", x2 = "Facebookでログイン", M2 = "{0}秒再送信", D2 = "Please click on the top", F2 = 'Select "Open in Safari', U2 = 'Select "Open in Browser', G2 = "Continue in an external browser", B2 = "ログイン", j2 = "QRコードでログイン", H2 = "スマートフォンでログインの確認をお願いします", V2 = "スキャンが成功しました", z2 = "PikPak アプリを開いて、QR コードでログインしてください", K2 = "QRコードの取得に失敗しました", q2 = `
 "{0}" の身分で登録する`, Q2 = "別の方法で登録する", W2 = "ブラウザでログインを完了する", Z2 = "ログイン後、このページを更新します。", J2 = "キャンセル", Y2 = "接続タイムアウト", X2 = "申し訳ありませんが、接続サーバーへのリクエストがタイムアウトしました。ネットワークサーバーが一時的に使用できないか、過負荷になっている可能性があります。後ほど再試行してください。", es = "戻る", ns = {
  i7t4qmC3l0Qrx1f3Vhhh4: l2,
  lyNVvA9ZvxGiyb7W_8Mz0: u2,
  tWlnmAbJ1f4Tv3Iuoht8: h2,
  guAsn6e2xbK3Raw9gokY: g2,
  "1ZpdIhCgVugfCbRIp6oj": "メールログイン",
  jEVoi8AbtDyqmxg0uI9: f2,
  nIlLdBnvEaFymQzCZwYbe: m2,
  rjaGoUfPmGl6TaS463Cn: p2,
  s7TOj9RzdgxEmLc0iQ1G: $2,
  n67Zbeckh9qf0VZFqd2x: _2,
  vtKgvl4yJauSnsTy3ORf: y2,
  c9uyPndv2WrqZpw74hdTm: v2,
  ufUkrBGbv4Xt457vFOa4D: N2,
  eaK82n7hjR623PupHmVhj: C2,
  cFufuxQyNg0q1a1dVWgD1: b2,
  hA5VzRxKiolLxIDSOzu: w2,
  gyJwCCpTd35n7xsGpxnE: E2,
  inpUrHefXWalKjs9ufoT: A2,
  pqc4Olt4lfdLp_8y6ZSuA: O2,
  uunm9VjxdmUucFse2Qjs: S2,
  "6IsOzjcj00s5HGgImQx2v": "検索結果はありません",
  zcOSHAfjmkBuxiFzogJx: T2,
  b4Myg4xCv2PdFdp4T7Yf9: k2,
  nWs2QjRZeS8UwDtTggyJ: I2,
  bGh4Ajs0J5MafoKrPkJy: R2,
  xNuOXxnZbXmpgKbAqfKGz: P2,
  gxDXMpGqhyO1a6PMa4B: L2,
  e1SdxwZgTfRd7HlSyegK: x2,
  scMOylJrrhNLlrFu6VTki: M2,
  kkv6uGohTOyATz9IDzOdr: D2,
  eYnpkZMyeXCFgjyMfaTh: F2,
  fFdV8SvrG9_5ZuRy5GVd: U2,
  jxXRc1FxLoCdUtSsyzOf: G2,
  mLlnoecfSMuJxTrxodqMt: B2,
  "or-you-can": "または",
  aJ1drF3Sll9NPkTU0Ro6: j2,
  as230x12lSDF02LSD1dw: H2,
  gJaP_0qRfiU9zNb2Hs2y: V2,
  "2Grb84h1MnUjxpxr7IQi": "クリックしてください",
  "6MhbexHdGc37PjQ7Tp15": "リフレッシュ",
  mOAooQeZeCWt2a0swZlQ9: z2,
  vJvlwMy1A7SGoS1JggM9: K2,
  cpQsRbAexGlsskux4Awu: q2,
  hFQzsBwmWj3ZyY5xwiffn: Q2,
  "3cSGnE4amksZ8nYggFqYh": "ログインに失敗しました、後ほど再試行してください",
  i0qzQnQhDvQTuSYzEvHd: W2,
  yyHu3EkYTxXy2aMczGocn: Z2,
  bbyavRuUbj025YpODbm1S: J2,
  vkN9TkHnIgJlFrVsw7bq: Y2,
  juspWzUyy57Ij3Oxe5Hyb: X2,
  rKg0YrFdCcho96B04NnK: es
}, ts = {
  "en-US": Wd,
  id: B0,
  ms: Pa,
  "zh-CN": Ei,
  "zh-TW": $1,
  ko: c2,
  ja: ns
}, me = To({
  legacy: !1,
  // locale: 'zh-CN',
  // locale: 'zh-TW',
  locale: "en-US",
  // set locale
  // locale: 'id',
  // locale: 'ms',
  fallbackLocale: "en-US",
  // set fallback locale
  messages: ts
  // set locale messages
}), ln = (n, ...e) => () => me.global.t(n, e), rs = { class: "oAuth-box" }, os = ["onClick"], ds = { class: "title" }, as = /* @__PURE__ */ le({
  __name: "OAuthLogin",
  props: {
    client: {},
    authInfo: {}
  },
  emits: ["command"],
  setup(n, { emit: e }) {
    const t = me.global.t, r = e, o = an([
      {
        iconClass: "icon-google",
        className: "google-button",
        title: () => t("gxDXMpGqhyO1a6PMa4B"),
        command: D.HANDLE_OAUTH_FROM_GOOGLE
      },
      {
        iconClass: "icon-facebook",
        className: "facebook-button",
        title: () => t("e1SdxwZgTfRd7HlSyegK"),
        command: D.HANDLE_OAUTH_FROM_FACEBOOK
      }
    ]);
    return (a, d) => (P(), L("div", rs, [
      (P(!0), L(Ue, null, Tn(o, (s, l) => (P(), L("div", {
        key: s.command + l,
        class: Ie(["oAuth-button", s.className]),
        role: "button",
        onClick: (f) => r("command", { type: s.command })
      }, [
        k("div", {
          class: Ie(["oAuth-icon", s.iconClass])
        }, null, 2),
        k("div", ds, G(s.title()), 1)
      ], 10, os))), 128)),
      W(rd, {
        text: R(t)("or-you-can")
      }, null, 8, ["text"])
    ]));
  }
}), is = /* @__PURE__ */ ue(as, [["__scopeId", "data-v-069a950b"]]), ss = ["type", "value", "placeholder", "autocomplete"], cs = /* @__PURE__ */ le({
  __name: "PPBasicInput",
  props: {
    type: {},
    placeholder: {},
    clearable: { type: Boolean },
    eye: { type: Boolean },
    modelValue: {},
    showBorder: { type: Boolean, default: !0 },
    autocomplete: {},
    inputFilter: {}
  },
  emits: ["update:modelValue", "focus", "blur", "keyup"],
  setup(n, { emit: e }) {
    const t = n, r = e, o = ne(!1);
    hn(o, () => r(o.value ? "focus" : "blur"));
    const a = () => r("update:modelValue", ""), d = (f) => {
      var _;
      const p = f.target;
      p.value = (_ = p.value) == null ? void 0 : _.trim(), t.inputFilter && (p.value = t.inputFilter(p.value)), r("update:modelValue", p.value);
    }, s = ne(!1), l = () => {
      s.value = !s.value;
    };
    return (f, p) => (P(), L("div", {
      class: Ie(["pp-basic-input", f.showBorder && o.value && "show-border"])
    }, [
      k("input", {
        type: s.value ? "text" : f.type,
        role: "input",
        class: "inner-input",
        value: f.modelValue,
        placeholder: f.placeholder,
        autocomplete: f.autocomplete || "new-password",
        onInput: d,
        onFocus: p[0] || (p[0] = () => o.value = !0),
        onBlur: p[1] || (p[1] = () => o.value = !1),
        onKeyup: p[2] || (p[2] = (_) => r("keyup", _))
      }, null, 40, ss),
      f.clearable && f.modelValue.length > 0 ? (P(), L("div", {
        key: 0,
        class: "icon-clearable",
        onClick: a
      })) : ge("", !0),
      f.eye ? (P(), L("div", {
        key: 1,
        class: Ie(["icon-eye", s.value ? "icon-open-eye" : "icon-close-eye"]),
        onClick: l
      }, null, 2)) : ge("", !0),
      Re(f.$slots, "email-suffix", {}, void 0, !0)
    ], 2));
  }
}), dn = /* @__PURE__ */ ue(cs, [["__scopeId", "data-v-a0941e04"]]), Rr = (n) => {
  var e;
  return ((e = n.match(/^\d{0,11}/)) == null ? void 0 : e[0]) || "";
}, Pr = (n) => {
  var e;
  return ((e = n.match(/^[0-9a-z]{0,6}/i)) == null ? void 0 : e[0]) || "";
}, Lr = (n) => n.slice(0, 256), $t = (n) => n.slice(0, 36), ls = ["onClick"], us = ["innerHTML"], yn = 48, hs = /* @__PURE__ */ le({
  __name: "EmailSuffix",
  props: {
    value: {}
  },
  emits: ["click"],
  setup(n, { expose: e, emit: t }) {
    const r = t, o = n, a = [
      "aol.com",
      "gmail.com",
      "hotmail.com",
      "icloud.com",
      "live.com",
      "outlook.com",
      "protonmail.com",
      "yandex.com",
      "yahoo.com"
    ], d = ne([]), s = ne(!1), l = ne(), f = ne(0), p = ne(""), _ = () => {
      f.value = 0, p.value = "";
      const $ = o.value;
      if (!$) {
        d.value = [];
        return;
      }
      const v = $.lastIndexOf("@");
      if (v === -1) {
        d.value = [];
        return;
      }
      if (/@$/.test($))
        return d.value = [...a], [];
      const N = $.slice(v + 1);
      d.value = a.filter(
        (C) => C.startsWith(N) && C !== N
      ), d.value.length && (p.value = N);
    }, y = ($) => p.value ? `<span style="color: #306EFF;">${p.value}</span><span>${$.slice(p.value.length)}</span>` : $, u = () => {
      _(), d.value.length > 0 && (s.value = !0);
    }, g = () => {
      s.value = !1;
    }, h = ($) => {
      if (!l.value)
        return;
      const { height: v } = l.value.getBoundingClientRect(), N = l.value.scrollTop, C = Math.floor(v / yn), w = N + v, A = ($ + 1) * yn;
      A > w ? l.value.scrollTo(
        0,
        Math.max(0, ($ + 1) * yn - C * yn)
      ) : N >= A && l.value.scrollTo(0, $ * yn);
    };
    hn(
      () => o.value,
      () => {
        if (_(), !d.value.length)
          return g();
        s.value || (s.value = !0);
      }
    );
    const c = ($) => {
      o.value && (r("click", $), g());
    }, i = ($) => {
      if (!s.value)
        return;
      const v = $.target;
      l.value && l.value.contains(v) || g();
    }, m = ($) => {
      if (!s.value)
        return;
      const v = $.key;
      let N = "";
      switch (v) {
        case "Enter":
          $.preventDefault(), N = d.value[f.value], N && c(N);
          break;
        case "ArrowDown":
          $.preventDefault(), f.value < d.value.length - 1 && (f.value = f.value + 1, h(f.value));
          break;
        case "ArrowUp":
          $.preventDefault(), f.value > 0 && (f.value = f.value - 1, h(f.value));
          break;
        case "Tab":
        case "Escape":
          g();
          break;
      }
    };
    return $n(() => {
      document.addEventListener("click", i), document.addEventListener("keydown", m);
    }), Or(() => {
      document.removeEventListener("click", i), document.removeEventListener("keydown", m);
    }), e({ show: u, hide: g }), ($, v) => s.value && d.value.length > 0 ? (P(), L("div", {
      key: 0,
      class: "email-suffix-box",
      ref_key: "boxRef",
      ref: l
    }, [
      (P(!0), L(Ue, null, Tn(d.value, (N, C) => (P(), L("div", {
        class: Ie(["email-suffix-item", f.value === C ? "active" : ""]),
        key: N,
        onClick: (w) => c(N)
      }, [
        k("span", {
          innerHTML: y(N)
        }, null, 8, us)
      ], 10, ls))), 128))
    ], 512)) : ge("", !0);
  }
}), xr = /* @__PURE__ */ ue(hs, [["__scopeId", "data-v-bd8f5513"]]), gs = /* @__PURE__ */ le({
  __name: "EmailLogin",
  props: {
    client: {},
    authInfo: {}
  },
  emits: ["command"],
  setup(n, { emit: e }) {
    const t = me.global.t, r = e, o = an({
      email: "",
      password: ""
    });
    Yn(o, "email");
    const a = (l) => {
      o.email = [o.email.split("@")[0], l].join("@");
    }, d = be(() => {
      const { email: l, password: f } = o;
      return /@.*\..*/.test(l) ? l.trim() !== "" && f.trim() !== "" : !1;
    }), s = () => {
      d.value && r("command", { type: D.HANDLE_LOGIN_BY_EMAIL, loginInfo: o });
    };
    return (l, f) => (P(), L(Ue, null, [
      W(dn, {
        ref: "ppBasicInputRef",
        class: "pp-basic-input",
        modelValue: o.email,
        "onUpdate:modelValue": f[0] || (f[0] = (p) => o.email = p),
        clearable: "",
        name: "username",
        "input-filter": R(Lr),
        placeholder: R(t)("rjaGoUfPmGl6TaS463Cn"),
        autocomplete: "email"
      }, {
        "email-suffix": fe(() => [
          W(xr, {
            class: "email-suffix",
            value: o.email,
            onClick: a
          }, null, 8, ["value"])
        ]),
        _: 1
      }, 8, ["modelValue", "input-filter", "placeholder"]),
      W(dn, {
        class: "pp-basic-input",
        modelValue: o.password,
        "onUpdate:modelValue": f[1] || (f[1] = (p) => o.password = p),
        type: "password",
        eye: "",
        clearable: "",
        "input-filter": R($t),
        placeholder: R(t)("nIlLdBnvEaFymQzCZwYbe"),
        autocomplete: "current-password"
      }, null, 8, ["modelValue", "input-filter", "placeholder"]),
      Re(l.$slots, "x-base-error", {}, void 0, !0),
      W(kn, {
        onClick: s,
        disabled: !d.value
      }, {
        default: fe(() => [
          Fe(G(R(t)("mLlnoecfSMuJxTrxodqMt")), 1)
        ]),
        _: 1
      }, 8, ["disabled"]),
      k("div", {
        class: "forget-password",
        onClick: f[2] || (f[2] = () => r("command", {
          type: R(D).GOTO_FORGET_PASSWORD,
          data: "email"
        }))
      }, G(R(t)("jEVoi8AbtDyqmxg0uI9")), 1)
    ], 64));
  }
}), fs = /* @__PURE__ */ ue(gs, [["__scopeId", "data-v-3a2b818e"]]), ms = {
  key: 0,
  class: "input-split"
}, ps = /* @__PURE__ */ le({
  __name: "PPMultipleInput",
  props: {
    type: {},
    placeholder: {},
    clearable: { type: Boolean },
    modelValue: {},
    autocomplete: {},
    inputFilter: {}
  },
  emits: ["update:modelValue", "keyup"],
  setup(n, { emit: e }) {
    const t = e, r = ne(!1), o = (a) => t("update:modelValue", a);
    return (a, d) => (P(), L("div", {
      class: Ie({ "pp-multiple-input": !0, focus: r.value })
    }, [
      Re(a.$slots, "prefix", {}, void 0, !0),
      a.$slots.prefix ? (P(), L("div", ms)) : ge("", !0),
      W(dn, {
        type: a.type,
        placeholder: a.placeholder,
        clearable: a.clearable,
        "model-value": a.modelValue,
        "input-filter": a.inputFilter,
        "show-border": !1,
        autocomplete: a.autocomplete,
        "onUpdate:modelValue": o,
        onFocus: d[0] || (d[0] = () => r.value = !0),
        onBlur: d[1] || (d[1] = () => r.value = !1),
        onKeyup: d[2] || (d[2] = (s) => t("keyup", s))
      }, null, 8, ["type", "placeholder", "clearable", "model-value", "input-filter", "autocomplete"]),
      Re(a.$slots, "suffix", {}, void 0, !0)
    ], 2));
  }
}), zn = /* @__PURE__ */ ue(ps, [["__scopeId", "data-v-780ee154"]]), $s = /* @__PURE__ */ le({
  __name: "CountDownButton",
  props: {
    disabled: { type: Boolean }
  },
  emits: ["click"],
  setup(n) {
    return (e, t) => (P(), L("div", {
      class: Ie({ "count-down-button": !0, disabled: e.disabled }),
      role: "button",
      onClick: t[0] || (t[0] = (r) => e.$emit("click", r))
    }, [
      Re(e.$slots, "default", {}, void 0, !0)
    ], 2));
  }
}), Mr = /* @__PURE__ */ ue($s, [["__scopeId", "data-v-4261cd63"]]), _s = { version: 4, country_calling_codes: { 1: ["US", "AG", "AI", "AS", "BB", "BM", "BS", "CA", "DM", "DO", "GD", "GU", "JM", "KN", "KY", "LC", "MP", "MS", "PR", "SX", "TC", "TT", "VC", "VG", "VI"], 7: ["RU", "KZ"], 20: ["EG"], 27: ["ZA"], 30: ["GR"], 31: ["NL"], 32: ["BE"], 33: ["FR"], 34: ["ES"], 36: ["HU"], 39: ["IT", "VA"], 40: ["RO"], 41: ["CH"], 43: ["AT"], 44: ["GB", "GG", "IM", "JE"], 45: ["DK"], 46: ["SE"], 47: ["NO", "SJ"], 48: ["PL"], 49: ["DE"], 51: ["PE"], 52: ["MX"], 53: ["CU"], 54: ["AR"], 55: ["BR"], 56: ["CL"], 57: ["CO"], 58: ["VE"], 60: ["MY"], 61: ["AU", "CC", "CX"], 62: ["ID"], 63: ["PH"], 64: ["NZ"], 65: ["SG"], 66: ["TH"], 81: ["JP"], 82: ["KR"], 84: ["VN"], 86: ["CN"], 90: ["TR"], 91: ["IN"], 92: ["PK"], 93: ["AF"], 94: ["LK"], 95: ["MM"], 98: ["IR"], 211: ["SS"], 212: ["MA", "EH"], 213: ["DZ"], 216: ["TN"], 218: ["LY"], 220: ["GM"], 221: ["SN"], 222: ["MR"], 223: ["ML"], 224: ["GN"], 225: ["CI"], 226: ["BF"], 227: ["NE"], 228: ["TG"], 229: ["BJ"], 230: ["MU"], 231: ["LR"], 232: ["SL"], 233: ["GH"], 234: ["NG"], 235: ["TD"], 236: ["CF"], 237: ["CM"], 238: ["CV"], 239: ["ST"], 240: ["GQ"], 241: ["GA"], 242: ["CG"], 243: ["CD"], 244: ["AO"], 245: ["GW"], 246: ["IO"], 247: ["AC"], 248: ["SC"], 249: ["SD"], 250: ["RW"], 251: ["ET"], 252: ["SO"], 253: ["DJ"], 254: ["KE"], 255: ["TZ"], 256: ["UG"], 257: ["BI"], 258: ["MZ"], 260: ["ZM"], 261: ["MG"], 262: ["RE", "YT"], 263: ["ZW"], 264: ["NA"], 265: ["MW"], 266: ["LS"], 267: ["BW"], 268: ["SZ"], 269: ["KM"], 290: ["SH", "TA"], 291: ["ER"], 297: ["AW"], 298: ["FO"], 299: ["GL"], 350: ["GI"], 351: ["PT"], 352: ["LU"], 353: ["IE"], 354: ["IS"], 355: ["AL"], 356: ["MT"], 357: ["CY"], 358: ["FI", "AX"], 359: ["BG"], 370: ["LT"], 371: ["LV"], 372: ["EE"], 373: ["MD"], 374: ["AM"], 375: ["BY"], 376: ["AD"], 377: ["MC"], 378: ["SM"], 380: ["UA"], 381: ["RS"], 382: ["ME"], 383: ["XK"], 385: ["HR"], 386: ["SI"], 387: ["BA"], 389: ["MK"], 420: ["CZ"], 421: ["SK"], 423: ["LI"], 500: ["FK"], 501: ["BZ"], 502: ["GT"], 503: ["SV"], 504: ["HN"], 505: ["NI"], 506: ["CR"], 507: ["PA"], 508: ["PM"], 509: ["HT"], 590: ["GP", "BL", "MF"], 591: ["BO"], 592: ["GY"], 593: ["EC"], 594: ["GF"], 595: ["PY"], 596: ["MQ"], 597: ["SR"], 598: ["UY"], 599: ["CW", "BQ"], 670: ["TL"], 672: ["NF"], 673: ["BN"], 674: ["NR"], 675: ["PG"], 676: ["TO"], 677: ["SB"], 678: ["VU"], 679: ["FJ"], 680: ["PW"], 681: ["WF"], 682: ["CK"], 683: ["NU"], 685: ["WS"], 686: ["KI"], 687: ["NC"], 688: ["TV"], 689: ["PF"], 690: ["TK"], 691: ["FM"], 692: ["MH"], 850: ["KP"], 852: ["HK"], 853: ["MO"], 855: ["KH"], 856: ["LA"], 880: ["BD"], 886: ["TW"], 960: ["MV"], 961: ["LB"], 962: ["JO"], 963: ["SY"], 964: ["IQ"], 965: ["KW"], 966: ["SA"], 967: ["YE"], 968: ["OM"], 970: ["PS"], 971: ["AE"], 972: ["IL"], 973: ["BH"], 974: ["QA"], 975: ["BT"], 976: ["MN"], 977: ["NP"], 992: ["TJ"], 993: ["TM"], 994: ["AZ"], 995: ["GE"], 996: ["KG"], 998: ["UZ"] }, countries: { AC: ["247", "00", "(?:[01589]\\d|[46])\\d{4}", [5, 6], 0, 0, 0, 0, 0, 0, 0, [["6[2-467]\\d{3}", [5]], ["4\\d{4}", [5]], 0, 0, 0, 0, ["(?:0[1-9]|[1589]\\d)\\d{4}", [6]]]], AD: ["376", "00", "(?:1|6\\d)\\d{7}|[135-9]\\d{5}", [6, 8, 9], [["(\\d{3})(\\d{3})", "$1 $2", ["[135-9]"]], ["(\\d{4})(\\d{4})", "$1 $2", ["1"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"]]], 0, 0, 0, 0, 0, 0, [["[78]\\d{5}", [6]], ["690\\d{6}|[356]\\d{5}", [6, 9]], ["180[02]\\d{4}", [8]], ["[19]\\d{5}", [6]]]], AE: ["971", "00", "(?:[4-7]\\d|9[0-689])\\d{7}|800\\d{2,9}|[2-4679]\\d{7}", [5, 6, 7, 8, 9, 10, 11, 12], [["(\\d{3})(\\d{2,9})", "$1 $2", ["60|8"]], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[236]|[479][2-8]"], "0$1"], ["(\\d{3})(\\d)(\\d{5})", "$1 $2 $3", ["[479]"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["5"], "0$1"]], "0", 0, 0, 0, 0, 0, [["[2-4679][2-8]\\d{6}", [8]], ["5[024-68]\\d{7}", [9]], ["400\\d{6}|800\\d{2,9}"], ["900[02]\\d{5}", [9]], 0, 0, ["600[25]\\d{5}", [9]], 0, 0, ["700[05]\\d{5}", [9]]]], AF: ["93", "00", "[2-7]\\d{8}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-7]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:[25][0-8]|[34][0-4]|6[0-5])[2-9]\\d{6}"], ["7\\d{8}"]]], AG: ["1", "011", "(?:268|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([457]\\d{6})$|1", "268$1", 0, "268", [["268(?:4(?:6[0-38]|84)|56[0-2])\\d{4}"], ["268(?:464|7(?:1[3-9]|[28]\\d|3[0246]|64|7[0-689]))\\d{4}"], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"], 0, 0, ["26840[69]\\d{4}"], ["26848[01]\\d{4}"]]], AI: ["1", "011", "(?:264|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2457]\\d{6})$|1", "264$1", 0, "264", [["264(?:292|4(?:6[12]|9[78]))\\d{4}"], ["264(?:235|4(?:69|76)|5(?:3[6-9]|8[1-4])|7(?:29|72))\\d{4}"], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"], 0, 0, ["264724\\d{4}"]]], AL: ["355", "00", "(?:700\\d\\d|900)\\d{3}|8\\d{5,7}|(?:[2-5]|6\\d)\\d{7}", [6, 7, 8, 9], [["(\\d{3})(\\d{3,4})", "$1 $2", ["80|9"], "0$1"], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["4[2-6]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2358][2-5]|4"], "0$1"], ["(\\d{3})(\\d{5})", "$1 $2", ["[23578]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["6"], "0$1"]], "0", 0, 0, 0, 0, 0, [["4505[0-2]\\d{3}|(?:[2358][16-9]\\d[2-9]|4410)\\d{4}|(?:[2358][2-5][2-9]|4(?:[2-57-9][2-9]|6\\d))\\d{5}", [8]], ["6(?:[78][2-9]|9\\d)\\d{6}", [9]], ["800\\d{4}", [7]], ["900[1-9]\\d\\d", [6]], ["700[2-9]\\d{4}", [8]], 0, 0, 0, 0, ["808[1-9]\\d\\d", [6]]]], AM: ["374", "00", "(?:[1-489]\\d|55|60|77)\\d{6}", [8], [["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[89]0"], "0 $1"], ["(\\d{3})(\\d{5})", "$1 $2", ["2|3[12]"], "(0$1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["1|47"], "(0$1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["[3-9]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:(?:1[0-25]|47)\\d|2(?:2[2-46]|3[1-8]|4[2-69]|5[2-7]|6[1-9]|8[1-7])|3[12]2)\\d{5}"], ["(?:33|4[1349]|55|77|88|9[13-9])\\d{6}"], ["800\\d{5}"], ["90[016]\\d{5}"], 0, 0, 0, 0, ["60(?:2[78]|3[5-9]|4[02-9]|5[0-46-9]|[6-8]\\d|9[0-2])\\d{4}"], ["80[1-4]\\d{5}"]]], AO: ["244", "00", "[29]\\d{8}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[29]"]]], 0, 0, 0, 0, 0, 0, [["2\\d(?:[0134][25-9]|[25-9]\\d)\\d{5}"], ["9[1-79]\\d{7}"]]], AR: ["54", "00", "(?:11|[89]\\d\\d)\\d{8}|[2368]\\d{9}", [10, 11], [["(\\d{4})(\\d{2})(\\d{4})", "$1 $2-$3", ["2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9])", "2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8]))|2(?:2[24-9]|3[1-59]|47)", "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5[56][46]|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]", "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|58|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|54(?:4|5[13-7]|6[89])|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:454|85[56])[46]|3(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"], "0$1", 1], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2-$3", ["1"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["[68]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2-$3", ["[23]"], "0$1", 1], ["(\\d)(\\d{4})(\\d{2})(\\d{4})", "$2 15-$3-$4", ["9(?:2[2-469]|3[3-578])", "9(?:2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9]))", "9(?:2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8])))|92(?:2[24-9]|3[1-59]|47)", "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5(?:[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]", "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|5(?:4(?:4|5[13-7]|6[89])|[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"], "0$1", 0, "$1 $2 $3-$4"], ["(\\d)(\\d{2})(\\d{4})(\\d{4})", "$2 15-$3-$4", ["91"], "0$1", 0, "$1 $2 $3-$4"], ["(\\d{3})(\\d{3})(\\d{5})", "$1-$2-$3", ["8"], "0$1"], ["(\\d)(\\d{3})(\\d{3})(\\d{4})", "$2 15-$3-$4", ["9"], "0$1", 0, "$1 $2 $3-$4"]], "0", 0, "0?(?:(11|2(?:2(?:02?|[13]|2[13-79]|4[1-6]|5[2457]|6[124-8]|7[1-4]|8[13-6]|9[1267])|3(?:02?|1[467]|2[03-6]|3[13-8]|[49][2-6]|5[2-8]|[67])|4(?:7[3-578]|9)|6(?:[0136]|2[24-6]|4[6-8]?|5[15-8])|80|9(?:0[1-3]|[19]|2\\d|3[1-6]|4[02568]?|5[2-4]|6[2-46]|72?|8[23]?))|3(?:3(?:2[79]|6|8[2578])|4(?:0[0-24-9]|[12]|3[5-8]?|4[24-7]|5[4-68]?|6[02-9]|7[126]|8[2379]?|9[1-36-8])|5(?:1|2[1245]|3[237]?|4[1-46-9]|6[2-4]|7[1-6]|8[2-5]?)|6[24]|7(?:[069]|1[1568]|2[15]|3[145]|4[13]|5[14-8]|7[2-57]|8[126])|8(?:[01]|2[15-7]|3[2578]?|4[13-6]|5[4-8]?|6[1-357-9]|7[36-8]?|8[5-8]?|9[124])))15)?", "9$1", 0, 0, [["3(?:7(?:1[15]|81)|8(?:21|4[16]|69|9[12]))[46]\\d{5}|(?:(?:11[1-8]|670)\\d|2(?:21[2-6]|(?:3[06]|49)4|6(?:04|1[2-8])|9[17][4-6])|3(?:(?:36|64)4|4(?:1[2-8]|[25][4-6]|84)|5(?:1[2-9]|[38][4-6])|8(?:[17][2-6]|3[4-6]|8[3-68])))\\d{6}|(?:2(?:23|64|99)|3(?:43|85))[3-6]\\d{6}|(?:2(?:657|9(?:54|66))|3(?:487|7(?:55|77)|865))[2-8]\\d{5}|(?:2(?:[28]0|37|6[36]|9[48])|3(?:62|7[069]|80))[45]\\d{6}|(?:2(?:2(?:2[59]|44|52)|3(?:26|44)|47[35]|9(?:[07]2|2[26]|34|46))|3327)[45]\\d{5}|(?:2(?:2(?:62|81)|320|622|9(?:42|83))|3(?:329|4(?:62|76|89)|564))[2-6]\\d{5}|(?:2(?:284|3(?:02|23)|477|920)|3(?:4(?:46|[89]2)|541|878))[2-7]\\d{5}|2(?:2(?:21|4[23]|6[145]|7[1-4]|8[356]|9[267])|3(?:16|3[13-8]|43|5[346-8]|9[3-5])|6(?:2[46]|4[78]|5[1568])|9(?:03|2[1457-9]|3[1356]|4[08]|[56][23]|82))4\\d{5}|(?:2(?:257|3(?:24|46|92)|9(?:01|23|64))|3(?:4(?:42|64|71)|5(?:25|37|4[347]|71)|7(?:18|35|5[17])))[3-6]\\d{5}|(?:2(?:2(?:02|2[3467]|4[156]|5[45]|6[6-8]|91)|3(?:1[47]|25|[45][25]|96)|47[48]|625|932)|3(?:38[2578]|4(?:0[0-24-9]|3[78]|4[457]|58|6[035-9]|72|83|9[136-8])|5(?:2[124]|[368][23]|4[2689]|7[2-6])|7(?:16|2[15]|3[14]|4[13]|5[468]|7[2-5]|8[26])|8(?:2[5-7]|3[278]|4[3-5]|5[78]|6[1-378]|[78]7|94)))[4-6]\\d{5}", [10]], ["93(?:7(?:1[15]|81)|8(?:21|4[16]|69|9[12]))[46]\\d{5}|(?:675\\d|9(?:11[1-8]\\d|2(?:21[2-6]|(?:3[06]|49)4|6(?:04|1[2-8])|9[17][4-6])|3(?:(?:36|64)4|4(?:1[2-8]|[25][4-6]|84)|5(?:1[2-9]|[38][4-6])|8(?:[17][2-6]|3[4-6]|8[3-68]))))\\d{6}|9(?:2(?:23|64|99)|3(?:43|85))[3-6]\\d{6}|9(?:2(?:657|9(?:54|66))|3(?:487|7(?:55|77)|865))[2-8]\\d{5}|9(?:2(?:[28]0|37|6[36]|9[48])|3(?:62|7[069]|80))[45]\\d{6}|9(?:2(?:2(?:2[59]|44|52)|3(?:26|44)|47[35]|9(?:[07]2|2[26]|34|46))|3327)[45]\\d{5}|9(?:2(?:2(?:62|81)|320|622|9(?:42|83))|3(?:329|4(?:62|76|89)|564))[2-6]\\d{5}|9(?:2(?:284|3(?:02|23)|477|920)|3(?:4(?:46|[89]2)|541|878))[2-7]\\d{5}|92(?:2(?:21|4[23]|6[145]|7[1-4]|8[356]|9[267])|3(?:16|3[13-8]|43|5[346-8]|9[3-5])|6(?:2[46]|4[78]|5[1568])|9(?:03|2[1457-9]|3[1356]|4[08]|[56][23]|82))4\\d{5}|9(?:2(?:257|3(?:24|46|92)|9(?:01|23|64))|3(?:4(?:42|64|71)|5(?:25|37|4[347]|71)|7(?:18|35|5[17])))[3-6]\\d{5}|9(?:2(?:2(?:02|2[3467]|4[156]|5[45]|6[6-8]|91)|3(?:1[47]|25|[45][25]|96)|47[48]|625|932)|3(?:38[2578]|4(?:0[0-24-9]|3[78]|4[457]|58|6[035-9]|72|83|9[136-8])|5(?:2[124]|[368][23]|4[2689]|7[2-6])|7(?:16|2[15]|3[14]|4[13]|5[468]|7[2-5]|8[26])|8(?:2[5-7]|3[278]|4[3-5]|5[78]|6[1-378]|[78]7|94)))[4-6]\\d{5}"], ["800\\d{7,8}"], ["60[04579]\\d{7}", [10]], 0, 0, ["810\\d{7}", [10]]]], AS: ["1", "011", "(?:[58]\\d\\d|684|900)\\d{7}", [10], 0, "1", 0, "([267]\\d{6})$|1", "684$1", 0, "684", [["6846(?:22|33|44|55|77|88|9[19])\\d{4}"], ["684(?:2(?:48|5[2468]|7[26])|7(?:3[13]|70|82))\\d{4}"], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"]]], AT: ["43", "00", "1\\d{3,12}|2\\d{6,12}|43(?:(?:0\\d|5[02-9])\\d{3,9}|2\\d{4,5}|[3467]\\d{4}|8\\d{4,6}|9\\d{4,7})|5\\d{4,12}|8\\d{7,12}|9\\d{8,12}|(?:[367]\\d|4[0-24-9])\\d{4,11}", [4, 5, 6, 7, 8, 9, 10, 11, 12, 13], [["(\\d)(\\d{3,12})", "$1 $2", ["1(?:11|[2-9])"], "0$1"], ["(\\d{3})(\\d{2})", "$1 $2", ["517"], "0$1"], ["(\\d{2})(\\d{3,5})", "$1 $2", ["5[079]"], "0$1"], ["(\\d{3})(\\d{3,10})", "$1 $2", ["(?:31|4)6|51|6(?:5[0-3579]|[6-9])|7(?:20|32|8)|[89]"], "0$1"], ["(\\d{4})(\\d{3,9})", "$1 $2", ["[2-467]|5[2-6]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["5"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4,7})", "$1 $2 $3", ["5"], "0$1"]], "0", 0, 0, 0, 0, 0, [["1(?:11\\d|[2-9]\\d{3,11})|(?:316|463|(?:51|66|73)2)\\d{3,10}|(?:2(?:1[467]|2[13-8]|5[2357]|6[1-46-8]|7[1-8]|8[124-7]|9[1458])|3(?:1[1-578]|3[23568]|4[5-7]|5[1378]|6[1-38]|8[3-68])|4(?:2[1-8]|35|7[1368]|8[2457])|5(?:2[1-8]|3[357]|4[147]|5[12578]|6[37])|6(?:13|2[1-47]|4[135-8]|5[468])|7(?:2[1-8]|35|4[13478]|5[68]|6[16-8]|7[1-6]|9[45]))\\d{4,10}"], ["6(?:5[0-3579]|6[013-9]|[7-9]\\d)\\d{4,10}", [7, 8, 9, 10, 11, 12, 13]], ["800\\d{6,10}", [9, 10, 11, 12, 13]], ["(?:8[69][2-68]|9(?:0[01]|3[019]))\\d{6,10}", [9, 10, 11, 12, 13]], 0, 0, 0, 0, ["5(?:0[1-9]|17|[79]\\d)\\d{2,10}|7[28]0\\d{6,10}", [5, 6, 7, 8, 9, 10, 11, 12, 13]], ["8(?:10|2[018])\\d{6,10}|828\\d{5}", [8, 9, 10, 11, 12, 13]]]], AU: ["61", "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011", "1(?:[0-79]\\d{7}(?:\\d(?:\\d{2})?)?|8[0-24-9]\\d{7})|[2-478]\\d{8}|1\\d{4,7}", [5, 6, 7, 8, 9, 10, 12], [["(\\d{2})(\\d{3,4})", "$1 $2", ["16"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2,4})", "$1 $2 $3", ["16"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["14|4"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["[2378]"], "(0$1)"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1(?:30|[89])"]]], "0", 0, "(183[12])|0", 0, 0, 0, [["(?:(?:(?:2(?:[0-26-9]\\d|3[0-8]|4[02-9]|5[0135-9])|7(?:[013-57-9]\\d|2[0-8]))\\d|3(?:(?:[0-3589]\\d|6[1-9]|7[0-35-9])\\d|4(?:[0-578]\\d|90)))\\d\\d|8(?:51(?:0(?:0[03-9]|[12479]\\d|3[2-9]|5[0-8]|6[1-9]|8[0-7])|1(?:[0235689]\\d|1[0-69]|4[0-589]|7[0-47-9])|2(?:0[0-79]|[18][13579]|2[14-9]|3[0-46-9]|[4-6]\\d|7[89]|9[0-4])|3\\d\\d)|(?:6[0-8]|[78]\\d)\\d{3}|9(?:[02-9]\\d{3}|1(?:(?:[0-58]\\d|6[0135-9])\\d|7(?:0[0-24-9]|[1-9]\\d)|9(?:[0-46-9]\\d|5[0-79])))))\\d{3}", [9]], ["4(?:79[01]|83[0-389]|94[0-4])\\d{5}|4(?:[0-36]\\d|4[047-9]|5[0-25-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}", [9]], ["180(?:0\\d{3}|2)\\d{3}", [7, 10]], ["190[0-26]\\d{6}", [10]], 0, 0, 0, ["163\\d{2,6}", [5, 6, 7, 8, 9]], ["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}", [9]], ["13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}", [6, 8, 10, 12]]], "0011"], AW: ["297", "00", "(?:[25-79]\\d\\d|800)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[25-9]"]]], 0, 0, 0, 0, 0, 0, [["5(?:2\\d|8[1-9])\\d{4}"], ["(?:290|5[69]\\d|6(?:[03]0|22|4[0-2]|[69]\\d)|7(?:[34]\\d|7[07])|9(?:6[45]|9[4-8]))\\d{4}"], ["800\\d{4}"], ["900\\d{4}"], 0, 0, 0, 0, ["(?:28\\d|501)\\d{4}"]]], AX: ["358", "00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))", "2\\d{4,9}|35\\d{4,5}|(?:60\\d\\d|800)\\d{4,6}|7\\d{5,11}|(?:[14]\\d|3[0-46-9]|50)\\d{4,8}", [5, 6, 7, 8, 9, 10, 11, 12], 0, "0", 0, 0, 0, 0, "18", [["18[1-8]\\d{3,6}", [6, 7, 8, 9]], ["4946\\d{2,6}|(?:4[0-8]|50)\\d{4,8}", [6, 7, 8, 9, 10]], ["800\\d{4,6}", [7, 8, 9]], ["[67]00\\d{5,6}", [8, 9]], 0, 0, ["20\\d{4,8}|60[12]\\d{5,6}|7(?:099\\d{4,5}|5[03-9]\\d{3,7})|20[2-59]\\d\\d|(?:606|7(?:0[78]|1|3\\d))\\d{7}|(?:10|29|3[09]|70[1-5]\\d)\\d{4,8}"]], "00"], AZ: ["994", "00", "365\\d{6}|(?:[124579]\\d|60|88)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["90"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[28]|2|365|46", "1[28]|2|365[45]|46", "1[28]|2|365(?:4|5[02])|46"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[13-9]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:2[12]428|3655[02])\\d{4}|(?:2(?:22[0-79]|63[0-28])|3654)\\d{5}|(?:(?:1[28]|46)\\d|2(?:[014-6]2|[23]3))\\d{6}"], ["36554\\d{4}|(?:[16]0|4[04]|5[015]|7[07]|99)\\d{7}"], ["88\\d{7}"], ["900200\\d{3}"]]], BA: ["387", "00", "6\\d{8}|(?:[35689]\\d|49|70)\\d{6}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["6[1-3]|[7-9]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2-$3", ["[3-5]|6[56]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["6"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:3(?:[05-79][2-9]|1[4579]|[23][24-9]|4[2-4689]|8[2457-9])|49[2-579]|5(?:0[2-49]|[13][2-9]|[268][2-4679]|4[4689]|5[2-79]|7[2-69]|9[2-4689]))\\d{5}", [8]], ["6040\\d{5}|6(?:03|[1-356]|44|7\\d)\\d{6}"], ["8[08]\\d{6}", [8]], ["9[0246]\\d{6}", [8]], 0, 0, ["703[235]0\\d{3}|70(?:2[0-5]|3[0146]|[56]0)\\d{4}", [8]], 0, 0, ["8[12]\\d{6}", [8]]]], BB: ["1", "011", "(?:246|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "246$1", 0, "246", [["246521[0369]\\d{3}|246(?:2(?:2[78]|7[0-4])|4(?:1[024-6]|2\\d|3[2-9])|5(?:20|[34]\\d|54|7[1-3])|6(?:2\\d|38)|7[35]7|9(?:1[89]|63))\\d{4}"], ["246(?:(?:2(?:[3568]\\d|4[0-57-9])|3(?:5[2-9]|6[0-6])|4(?:46|5\\d)|69[5-7]|8(?:[2-5]\\d|83))\\d|52(?:1[147]|20))\\d{3}"], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["(?:246976|900[2-9]\\d\\d)\\d{4}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"], 0, ["246(?:292|367|4(?:1[7-9]|3[01]|4[47-9]|67)|7(?:1[2-9]|2\\d|3[016]|53))\\d{4}"], 0, ["24631\\d{5}"]]], BD: ["880", "00", "[1-469]\\d{9}|8[0-79]\\d{7,8}|[2-79]\\d{8}|[2-9]\\d{7}|[3-9]\\d{6}|[57-9]\\d{5}", [6, 7, 8, 9, 10], [["(\\d{2})(\\d{4,6})", "$1-$2", ["31[5-8]|[459]1"], "0$1"], ["(\\d{3})(\\d{3,7})", "$1-$2", ["3(?:[67]|8[013-9])|4(?:6[168]|7|[89][18])|5(?:6[128]|9)|6(?:[15]|28|4[14])|7[2-589]|8(?:0[014-9]|[12])|9[358]|(?:3[2-5]|4[235]|5[2-578]|6[0389]|76|8[3-7]|9[24])1|(?:44|66)[01346-9]"], "0$1"], ["(\\d{4})(\\d{3,6})", "$1-$2", ["[13-9]|2[23]"], "0$1"], ["(\\d)(\\d{7,8})", "$1-$2", ["2"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:4(?:31\\d\\d|423)|5222)\\d{3}(?:\\d{2})?|8332[6-9]\\d\\d|(?:3(?:03[56]|224)|4(?:22[25]|653))\\d{3,4}|(?:3(?:42[47]|529|823)|4(?:027|525|65(?:28|8))|562|6257|7(?:1(?:5[3-5]|6[12]|7[156]|89)|22[589]56|32|42675|52(?:[25689](?:56|8)|[347]8)|71(?:6[1267]|75|89)|92374)|82(?:2[59]|32)56|9(?:03[23]56|23(?:256|373)|31|5(?:1|2[4589]56)))\\d{3}|(?:3(?:02[348]|22[35]|324|422)|4(?:22[67]|32[236-9]|6(?:2[46]|5[57])|953)|5526|6(?:024|6655)|81)\\d{4,5}|(?:2(?:7(?:1[0-267]|2[0-289]|3[0-29]|4[01]|5[1-3]|6[013]|7[0178]|91)|8(?:0[125]|1[1-6]|2[0157-9]|3[1-69]|41|6[1-35]|7[1-5]|8[1-8]|9[0-6])|9(?:0[0-2]|1[0-4]|2[568]|3[3-6]|5[5-7]|6[0136-9]|7[0-7]|8[014-9]))|3(?:0(?:2[025-79]|3[2-4])|181|22[12]|32[2356]|824)|4(?:02[09]|22[348]|32[045]|523|6(?:27|54))|666(?:22|53)|7(?:22[57-9]|42[56]|82[35])8|8(?:0[124-9]|2(?:181|2[02-4679]8)|4[12]|[5-7]2)|9(?:[04]2|2(?:2|328)|81))\\d{4}|(?:2(?:[23]\\d|[45])\\d\\d|3(?:1(?:2[5-7]|[5-7])|425|822)|4(?:033|1\\d|[257]1|332|4(?:2[246]|5[25])|6(?:2[35]|56|62)|8(?:23|54)|92[2-5])|5(?:02[03489]|22[457]|32[35-79]|42[46]|6(?:[18]|53)|724|826)|6(?:023|2(?:2[2-5]|5[3-5]|8)|32[3478]|42[34]|52[47]|6(?:[18]|6(?:2[34]|5[24]))|[78]2[2-5]|92[2-6])|7(?:02|21\\d|[3-589]1|6[12]|72[24])|8(?:217|3[12]|[5-7]1)|9[24]1)\\d{5}|(?:(?:3[2-8]|5[2-57-9]|6[03-589])1|4[4689][18])\\d{5}|[59]1\\d{5}"], ["(?:1[13-9]\\d|644)\\d{7}|(?:3[78]|44|66)[02-9]\\d{7}", [10]], ["80[03]\\d{7}", [10]], 0, 0, 0, 0, 0, ["96(?:0[469]|1[0-47]|3[389]|43|6[69]|7[78])\\d{6}", [10]]]], BE: ["32", "00", "4\\d{8}|[1-9]\\d{7}", [8, 9], [["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:80|9)0"], "0$1"], ["(\\d)(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[239]|4[23]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[15-8]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["4"], "0$1"]], "0", 0, 0, 0, 0, 0, [["80[2-8]\\d{5}|(?:1[0-69]|[23][2-8]|4[23]|5\\d|6[013-57-9]|71|8[1-79]|9[2-4])\\d{6}", [8]], ["4[5-9]\\d{7}", [9]], ["800[1-9]\\d{4}", [8]], ["(?:70(?:2[0-57]|3[04-7]|44|6[04-69]|7[0579])|90\\d\\d)\\d{4}", [8]], 0, 0, ["78(?:0[578]|1[014-8]|2[25]|3[15-8]|48|5[05]|60|7[06-8]|9\\d)\\d{4}", [8]], 0, 0, ["7879\\d{4}", [8]]]], BF: ["226", "00", "[025-7]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[025-7]"]]], 0, 0, 0, 0, 0, 0, [["2(?:0(?:49|5[23]|6[5-7]|9[016-9])|4(?:4[569]|5[4-6]|6[5-7]|7[0179])|5(?:[34]\\d|50|6[5-7]))\\d{4}"], ["(?:0[1-7]|5[0-8]|[67]\\d)\\d{6}"]]], BG: ["359", "00", "00800\\d{7}|[2-7]\\d{6,7}|[89]\\d{6,8}|2\\d{5}", [6, 7, 8, 9, 12], [["(\\d)(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["2"], "0$1"], ["(\\d{3})(\\d{4})", "$1 $2", ["43[1-6]|70[1-9]"], "0$1"], ["(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["[356]|4[124-7]|7[1-9]|8[1-6]|9[1-7]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:70|8)0"], "0$1"], ["(\\d{3})(\\d{3})(\\d{2})", "$1 $2 $3", ["43[1-7]|7"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[48]|9[08]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"], "0$1"]], "0", 0, 0, 0, 0, 0, [["2\\d{5,7}|(?:43[1-6]|70[1-9])\\d{4,5}|(?:[36]\\d|4[124-7]|[57][1-9]|8[1-6]|9[1-7])\\d{5,6}", [6, 7, 8]], ["(?:43[07-9]|99[69]\\d)\\d{5}|(?:8[7-9]|98)\\d{7}", [8, 9]], ["(?:00800\\d\\d|800)\\d{5}", [8, 12]], ["90\\d{6}", [8]], 0, 0, 0, 0, 0, ["700\\d{5}", [8]]]], BH: ["973", "00", "[136-9]\\d{7}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[13679]|8[02-4679]"]]], 0, 0, 0, 0, 0, 0, [["(?:1(?:3[1356]|6[0156]|7\\d)\\d|6(?:1[16]\\d|500|6(?:0\\d|3[12]|44|55|7[7-9]|88)|9[69][69])|7(?:[07]\\d\\d|1(?:11|78)))\\d{4}"], ["(?:3(?:[0-79]\\d|8[0-57-9])\\d|6(?:3(?:00|33|6[16])|441|6(?:3[03-9]|[69]\\d|7[0-689])))\\d{4}"], ["8[02369]\\d{6}"], ["(?:87|9[0-8])\\d{6}"], 0, 0, 0, 0, 0, ["84\\d{6}"]]], BI: ["257", "00", "(?:[267]\\d|31)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2367]"]]], 0, 0, 0, 0, 0, 0, [["(?:22|31)\\d{6}"], ["(?:29|[67][125-9])\\d{6}"]]], BJ: ["229", "00", "(?:01\\d|[24-689])\\d{7}", [8, 10], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24-689]"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["0"]]], 0, 0, 0, 0, 0, 0, [["2090\\d{4}|(?:012\\d\\d|2(?:02|1[037]|2[45]|3[68]|4\\d))\\d{5}"], ["(?:01(?:2[5-9]|[4-69]\\d)|4[0-8]|[56]\\d|9[013-9])\\d{6}"], 0, 0, 0, 0, ["81\\d{6}", [8]], 0, ["857[58]\\d{4}", [8]]]], BL: ["590", "00", "(?:590\\d|7090)\\d{5}|(?:69|80|9\\d)\\d{7}", [9], 0, "0", 0, 0, 0, 0, 0, [["590(?:2[7-9]|3[3-7]|5[12]|87)\\d{4}"], ["(?:69(?:0\\d\\d|1(?:2[2-9]|3[0-5])|4(?:0[89]|1[2-6]|9\\d)|6(?:1[016-9]|5[0-4]|[67]\\d))|7090[0-4])\\d{4}"], ["80[0-5]\\d{6}"], 0, 0, 0, 0, 0, ["9(?:(?:39[5-7]|76[018])\\d|475[0-6])\\d{4}"]]], BM: ["1", "011", "(?:441|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "441$1", 0, "441", [["441(?:[46]\\d\\d|5(?:4\\d|60|89))\\d{4}"], ["441(?:[2378]\\d|5[0-39]|9[02])\\d{5}"], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"]]], BN: ["673", "00", "[2-578]\\d{6}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-578]"]]], 0, 0, 0, 0, 0, 0, [["22[0-7]\\d{4}|(?:2[013-9]|[34]\\d|5[0-25-9])\\d{5}"], ["(?:22[89]|[78]\\d\\d)\\d{4}"], 0, 0, 0, 0, 0, 0, ["5[34]\\d{5}"]]], BO: ["591", "00(?:1\\d)?", "8001\\d{5}|(?:[2-467]\\d|50)\\d{6}", [8, 9], [["(\\d)(\\d{7})", "$1 $2", ["[235]|4[46]"]], ["(\\d{8})", "$1", ["[67]"]], ["(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["8"]]], "0", 0, "0(1\\d)?", 0, 0, 0, [["(?:2(?:2\\d\\d|5(?:11|[258]\\d|9[67])|6(?:12|2\\d|9[34])|8(?:2[34]|39|62))|3(?:3\\d\\d|4(?:6\\d|8[24])|8(?:25|42|5[257]|86|9[25])|9(?:[27]\\d|3[2-4]|4[248]|5[24]|6[2-6]))|4(?:4\\d\\d|6(?:11|[24689]\\d|72)))\\d{4}", [8]], ["[67]\\d{7}", [8]], ["8001[07]\\d{4}", [9]], 0, 0, 0, 0, 0, ["50\\d{6}", [8]]]], BQ: ["599", "00", "(?:[34]1|7\\d)\\d{5}", [7], 0, 0, 0, 0, 0, 0, "[347]", [["(?:318[023]|41(?:6[023]|70)|7(?:1[578]|2[05]|50)\\d)\\d{3}"], ["(?:31(?:8[14-8]|9[14578])|416[14-9]|7(?:0[01]|7[07]|8\\d|9[056])\\d)\\d{3}"]]], BR: ["55", "00(?:1[245]|2[1-35]|31|4[13]|[56]5|99)", "(?:[1-46-9]\\d\\d|5(?:[0-46-9]\\d|5[0-46-9]))\\d{8}|[1-9]\\d{9}|[3589]\\d{8}|[34]\\d{7}", [8, 9, 10, 11], [["(\\d{4})(\\d{4})", "$1-$2", ["300|4(?:0[02]|37)", "4(?:02|37)0|[34]00"]], ["(\\d{3})(\\d{2,3})(\\d{4})", "$1 $2 $3", ["(?:[358]|90)0"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2-$3", ["(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])[2-57]"], "($1)"], ["(\\d{2})(\\d{5})(\\d{4})", "$1 $2-$3", ["[16][1-9]|[2-57-9]"], "($1)"]], "0", 0, "(?:0|90)(?:(1[245]|2[1-35]|31|4[13]|[56]5|99)(\\d{10,11}))?", "$2", 0, 0, [["(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])[2-5]\\d{7}", [10]], ["(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])(?:7|9\\d)\\d{7}", [10, 11]], ["800\\d{6,7}", [9, 10]], ["300\\d{6}|[59]00\\d{6,7}", [9, 10]], 0, 0, 0, 0, 0, ["(?:30[03]\\d{3}|4(?:0(?:0\\d|20)|370))\\d{4}|300\\d{5}", [8, 10]]]], BS: ["1", "011", "(?:242|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([3-8]\\d{6})$|1", "242$1", 0, "242", [["242(?:3(?:02|[236][1-9]|4[0-24-9]|5[0-68]|7[347]|8[0-4]|9[2-467])|461|502|6(?:0[1-5]|12|2[013]|[45]0|7[67]|8[78]|9[89])|7(?:02|88))\\d{4}"], ["242(?:3(?:5[79]|7[56]|95)|4(?:[23][1-9]|4[1-35-9]|5[1-8]|6[2-8]|7\\d|81)|5(?:2[45]|3[35]|44|5[1-46-9]|65|77)|6[34]6|7(?:27|38)|8(?:0[1-9]|1[02-9]|2\\d|3[0-4]|[89]9))\\d{4}"], ["242300\\d{4}|8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"], 0, ["242225\\d{4}"]]], BT: ["975", "00", "[17]\\d{7}|[2-8]\\d{6}", [7, 8], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-68]|7[246]"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[67]|7"]]], 0, 0, 0, 0, 0, 0, [["(?:2[3-6]|[34][5-7]|5[236]|6[2-46]|7[246]|8[2-4])\\d{5}", [7]], ["(?:1[67]|77)\\d{6}", [8]]]], BW: ["267", "00", "(?:0800|(?:[37]|800)\\d)\\d{6}|(?:[2-6]\\d|90)\\d{5}", [7, 8, 10], [["(\\d{2})(\\d{5})", "$1 $2", ["90"]], ["(\\d{3})(\\d{4})", "$1 $2", ["[24-6]|3[15-9]"]], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[37]"]], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["0"]], ["(\\d{3})(\\d{4})(\\d{3})", "$1 $2 $3", ["8"]]], 0, 0, 0, 0, 0, 0, [["(?:2(?:4[0-48]|6[0-24]|9[0578])|3(?:1[0-35-9]|55|[69]\\d|7[013]|81)|4(?:6[03]|7[1267]|9[0-5])|5(?:3[03489]|4[0489]|7[1-47]|88|9[0-49])|6(?:2[1-35]|5[149]|8[013467]))\\d{4}", [7]], ["(?:321|7[1-8]\\d)\\d{5}", [8]], ["(?:0800|800\\d)\\d{6}", [10]], ["90\\d{5}", [7]], 0, 0, 0, 0, ["79(?:1(?:[0-2]\\d|3[0-3])|2[0-7]\\d)\\d{3}", [8]]]], BY: ["375", "810", "(?:[12]\\d|33|44|902)\\d{7}|8(?:0[0-79]\\d{5,7}|[1-7]\\d{9})|8(?:1[0-489]|[5-79]\\d)\\d{7}|8[1-79]\\d{6,7}|8[0-79]\\d{5}|8\\d{5}", [6, 7, 8, 9, 10, 11], [["(\\d{3})(\\d{3})", "$1 $2", ["800"], "8 $1"], ["(\\d{3})(\\d{2})(\\d{2,4})", "$1 $2 $3", ["800"], "8 $1"], ["(\\d{4})(\\d{2})(\\d{3})", "$1 $2-$3", ["1(?:5[169]|6[3-5]|7[179])|2(?:1[35]|2[34]|3[3-5])", "1(?:5[169]|6(?:3[1-3]|4|5[125])|7(?:1[3-9]|7[0-24-6]|9[2-7]))|2(?:1[35]|2[34]|3[3-5])"], "8 0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["1(?:[56]|7[467])|2[1-3]"], "8 0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[1-4]"], "8 0$1"], ["(\\d{3})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["[89]"], "8 $1"]], "8", 0, "0|80?", 0, 0, 0, [["(?:1(?:5(?:1[1-5]|[24]\\d|6[2-4]|9[1-7])|6(?:[235]\\d|4[1-7])|7\\d\\d)|2(?:1(?:[246]\\d|3[0-35-9]|5[1-9])|2(?:[235]\\d|4[0-8])|3(?:[26]\\d|3[02-79]|4[024-7]|5[03-7])))\\d{5}", [9]], ["(?:2(?:5[5-79]|9[1-9])|(?:33|44)\\d)\\d{6}", [9]], ["800\\d{3,7}|8(?:0[13]|20\\d)\\d{7}"], ["(?:810|902)\\d{7}", [10]], 0, 0, 0, 0, ["249\\d{6}", [9]]], "8~10"], BZ: ["501", "00", "(?:0800\\d|[2-8])\\d{6}", [7, 11], [["(\\d{3})(\\d{4})", "$1-$2", ["[2-8]"]], ["(\\d)(\\d{3})(\\d{4})(\\d{3})", "$1-$2-$3-$4", ["0"]]], 0, 0, 0, 0, 0, 0, [["(?:2(?:[02]\\d|36|[68]0)|[3-58](?:[02]\\d|[68]0)|7(?:[02]\\d|32|[68]0))\\d{4}", [7]], ["6[0-35-7]\\d{5}", [7]], ["0800\\d{7}", [11]]]], CA: ["1", "011", "[2-9]\\d{9}|3\\d{6}", [7, 10], 0, "1", 0, 0, 0, 0, 0, [["(?:2(?:04|[23]6|[48]9|50|63)|3(?:06|43|54|6[578]|82)|4(?:03|1[68]|[26]8|3[178]|50|74)|5(?:06|1[49]|48|79|8[147])|6(?:04|[18]3|39|47|72)|7(?:0[59]|42|53|78|8[02])|8(?:[06]7|19|25|7[39])|9(?:0[25]|42))[2-9]\\d{6}", [10]], ["", [10]], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", [10]], ["900[2-9]\\d{6}", [10]], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|(?:5(?:2[125-9]|33|44|66|77|88)|6(?:22|33))[2-9]\\d{6}", [10]], 0, ["310\\d{4}", [7]], 0, ["600[2-9]\\d{6}", [10]]]], CC: ["61", "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011", "1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}", [6, 7, 8, 9, 10, 12], 0, "0", 0, "([59]\\d{7})$|0", "8$1", 0, 0, [["8(?:51(?:0(?:02|31|60|89)|1(?:18|76)|223)|91(?:0(?:1[0-2]|29)|1(?:[28]2|50|79)|2(?:10|64)|3(?:[06]8|22)|4[29]8|62\\d|70[23]|959))\\d{3}", [9]], ["4(?:79[01]|83[0-389]|94[0-4])\\d{5}|4(?:[0-36]\\d|4[047-9]|5[0-25-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}", [9]], ["180(?:0\\d{3}|2)\\d{3}", [7, 10]], ["190[0-26]\\d{6}", [10]], 0, 0, 0, 0, ["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}", [9]], ["13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}", [6, 8, 10, 12]]], "0011"], CD: ["243", "00", "(?:(?:[189]|5\\d)\\d|2)\\d{7}|[1-68]\\d{6}", [7, 8, 9, 10], [["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["88"], "0$1"], ["(\\d{2})(\\d{5})", "$1 $2", ["[1-6]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[89]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["5"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:(?:12|573)\\d\\d|276)\\d{5}|[1-6]\\d{6}"], ["88\\d{5}|(?:8[0-69]|9[017-9])\\d{7}", [7, 9]]]], CF: ["236", "00", "(?:[27]\\d{3}|8776)\\d{4}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[278]"]]], 0, 0, 0, 0, 0, 0, [["2[12]\\d{6}"], ["7[024-7]\\d{6}"], 0, ["8776\\d{4}"]]], CG: ["242", "00", "222\\d{6}|(?:0\\d|80)\\d{7}", [9], [["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["8"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[02]"]]], 0, 0, 0, 0, 0, 0, [["222[1-589]\\d{5}"], ["026(?:1[0-5]|6[6-9])\\d{4}|0(?:[14-6]\\d\\d|2(?:40|5[5-8]|6[07-9]))\\d{5}"], 0, ["80[0-2]\\d{6}"]]], CH: ["41", "00", "8\\d{11}|[2-9]\\d{8}", [9, 12], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8[047]|90"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-79]|81"], "0$1"], ["(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["8"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:2[12467]|3[1-4]|4[134]|5[256]|6[12]|[7-9]1)\\d{7}", [9]], ["(?:6[89]|7[235-9])\\d{7}", [9]], ["800\\d{6}", [9]], ["90[016]\\d{6}", [9]], ["878\\d{6}", [9]], ["860\\d{9}", [12]], ["5[18]\\d{7}", [9]], ["74[0248]\\d{6}", [9]], 0, ["84[0248]\\d{6}", [9]]]], CI: ["225", "00", "[02]\\d{9}", [10], [["(\\d{2})(\\d{2})(\\d)(\\d{5})", "$1 $2 $3 $4", ["2"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3 $4", ["0"]]], 0, 0, 0, 0, 0, 0, [["2(?:[15]\\d{3}|7(?:2(?:0[23]|1[2357]|2[245]|3[45]|4[3-5])|3(?:06|1[69]|[2-6]7)))\\d{5}"], ["0[157]\\d{8}"]]], CK: ["682", "00", "[2-578]\\d{4}", [5], [["(\\d{2})(\\d{3})", "$1 $2", ["[2-578]"]]], 0, 0, 0, 0, 0, 0, [["(?:2\\d|3[13-7]|4[1-5])\\d{3}"], ["[578]\\d{4}"]]], CL: ["56", "(?:0|1(?:1[0-69]|2[02-5]|5[13-58]|69|7[0167]|8[018]))0", "12300\\d{6}|6\\d{9,10}|[2-9]\\d{8}", [9, 10, 11], [["(\\d{5})(\\d{4})", "$1 $2", ["219", "2196"], "($1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["44"]], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2[1-36]"], "($1)"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["9[2-9]"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["3[2-5]|[47]|5[1-3578]|6[13-57]|8(?:0[1-9]|[1-9])"], "($1)"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["60|8"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]], ["(\\d{3})(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["60"]]], 0, 0, 0, 0, 0, 0, [["2(?:1982[0-6]|3314[05-9])\\d{3}|(?:2(?:1(?:160|962)|3(?:2\\d\\d|3(?:[03467]\\d|1[0-35-9]|2[1-9]|5[0-24-9]|8[0-3])|600)|646[59])|80[1-9]\\d\\d|9(?:3(?:[0-57-9]\\d\\d|6(?:0[02-9]|[1-9]\\d))|6(?:[0-8]\\d\\d|9(?:[02-79]\\d|1[05-9]))|7[1-9]\\d\\d|9(?:[03-9]\\d\\d|1(?:[0235-9]\\d|4[0-24-9])|2(?:[0-79]\\d|8[0-46-9]))))\\d{4}|(?:22|3[2-5]|[47][1-35]|5[1-3578]|6[13-57]|8[1-9]|9[2458])\\d{7}", [9]], ["", [9]], ["(?:123|8)00\\d{6}", [9, 11]], 0, 0, 0, 0, 0, ["44\\d{7}", [9]], ["600\\d{7,8}", [10, 11]]]], CM: ["237", "00", "[26]\\d{8}|88\\d{6,7}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["88"]], ["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["[26]|88"]]], 0, 0, 0, 0, 0, 0, [["2(?:22|33)\\d{6}", [9]], ["(?:24[23]|6(?:[25-9]\\d|40))\\d{6}", [9]], ["88\\d{6,7}"]]], CN: ["86", "00|1(?:[12]\\d|79)\\d\\d00", "(?:(?:1[03-689]|2\\d)\\d\\d|6)\\d{8}|1\\d{10}|[126]\\d{6}(?:\\d(?:\\d{2})?)?|86\\d{5,6}|(?:[3-579]\\d|8[0-57-9])\\d{5,9}", [7, 8, 9, 10, 11, 12], [["(\\d{2})(\\d{5,6})", "$1 $2", ["(?:10|2[0-57-9])[19]|3(?:[157]|35|49|9[1-68])|4(?:1[124-9]|2[179]|6[47-9]|7|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:07|1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3|4[13]|5[1-5]|7[0-79]|9[0-35-9])|(?:4[35]|59|85)[1-9]", "(?:10|2[0-57-9])(?:1[02]|9[56])|8078|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))1", "10(?:1(?:0|23)|9[56])|2[0-57-9](?:1(?:00|23)|9[56])|80781|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))12", "10(?:1(?:0|23)|9[56])|2[0-57-9](?:1(?:00|23)|9[56])|807812|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))123", "10(?:1(?:0|23)|9[56])|2[0-57-9](?:1(?:00|23)|9[56])|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:078|1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))123"], "0$1"], ["(\\d{3})(\\d{5,6})", "$1 $2", ["3(?:[157]|35|49|9[1-68])|4(?:[17]|2[179]|6[47-9]|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]|4[13]|5[1-5])|(?:4[35]|59|85)[1-9]", "(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))[19]", "85[23](?:10|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:10|9[56])", "85[23](?:100|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:100|9[56])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["(?:4|80)0"]], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["10|2(?:[02-57-9]|1[1-9])", "10|2(?:[02-57-9]|1[1-9])", "10[0-79]|2(?:[02-57-9]|1[1-79])|(?:10|21)8(?:0[1-9]|[1-9])"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["3(?:[3-59]|7[02-68])|4(?:[26-8]|3[3-9]|5[2-9])|5(?:3[03-9]|[468]|7[028]|9[2-46-9])|6|7(?:[0-247]|3[04-9]|5[0-4689]|6[2368])|8(?:[1-358]|9[1-7])|9(?:[013479]|5[1-5])|(?:[34]1|55|79|87)[02-9]"], "0$1", 1], ["(\\d{3})(\\d{7,8})", "$1 $2", ["9"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["80"], "0$1", 1], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["[3-578]"], "0$1", 1], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["1[3-9]"]], ["(\\d{2})(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["[12]"], "0$1", 1]], "0", 0, "(1(?:[12]\\d|79)\\d\\d)|0", 0, 0, 0, [["(?:10(?:[02-79]\\d\\d|[18](?:0[1-9]|[1-9]\\d))|2(?:[02-57-9]\\d{3}|1(?:[18](?:0[1-9]|[1-9]\\d)|[2-79]\\d\\d))|(?:41[03]|8078|9(?:78|94))\\d\\d)\\d{5}|(?:10|2[0-57-9])(?:1(?:00|23)\\d\\d|95\\d{3,4})|(?:41[03]|9(?:78|94))(?:100\\d\\d|95\\d{3,4})|8078123|(?:43[35]|754|851)\\d{7,8}|(?:43[35]|754|851)(?:1(?:00\\d|23)\\d|95\\d{3,4})|(?:3(?:11|7[179])|4(?:[15]1|3[12])|5(?:1\\d|2[37]|3[12]|51|7[13-79]|9[15])|7(?:[39]1|5[57]|6[09])|8(?:71|98))(?:[02-8]\\d{7}|1(?:0(?:0\\d\\d(?:\\d{3})?|[1-9]\\d{5})|[13-9]\\d{6}|2(?:[0-24-9]\\d{5}|3\\d(?:\\d{4})?))|9(?:[0-46-9]\\d{6}|5\\d{3}(?:\\d(?:\\d{2})?)?))|(?:3(?:1[02-9]|35|49|5\\d|7[02-68]|9[1-68])|4(?:1[24-9]|2[179]|3[46-9]|5[2-9]|6[47-9]|7\\d|8[23])|5(?:3[03-9]|4[36]|5[02-9]|6[1-46]|7[028]|80|9[2-46-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[17]\\d|2[248]|3[04-9]|4[3-6]|5[0-3689]|6[2368]|9[02-9])|8(?:1[236-8]|2[5-7]|3\\d|5[2-9]|7[02-9]|8[36-8]|9[1-7])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))(?:[02-8]\\d{6}|1(?:0(?:0\\d\\d(?:\\d{2})?|[1-9]\\d{4})|[13-9]\\d{5}|2(?:[0-24-9]\\d{4}|3\\d(?:\\d{3})?))|9(?:[0-46-9]\\d{5}|5\\d{3,5}))", [7, 8, 9, 10, 11]], ["1740[0-5]\\d{6}|1(?:[38]\\d|4[57]|[59][0-35-9]|6[25-7]|7[0-35-8])\\d{8}", [11]], ["(?:(?:10|21)8|8)00\\d{7}", [10, 12]], ["16[08]\\d{5}", [8]], 0, 0, 0, 0, 0, ["10(?:10\\d{4}|96\\d{3,4})|400\\d{7}|950\\d{7,8}|(?:2[0-57-9]|3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))96\\d{3,4}", [7, 8, 9, 10, 11]]], "00"], CO: ["57", "00(?:4(?:[14]4|56)|[579])", "(?:46|60\\d\\d)\\d{6}|(?:1\\d|[39])\\d{9}", [8, 10, 11], [["(\\d{4})(\\d{4})", "$1 $2", ["46"]], ["(\\d{3})(\\d{7})", "$1 $2", ["6|90"], "($1)"], ["(\\d{3})(\\d{7})", "$1 $2", ["3[0-357]|91"]], ["(\\d)(\\d{3})(\\d{7})", "$1-$2-$3", ["1"], "0$1", 0, "$1 $2 $3"]], "0", 0, "0([3579]|4(?:[14]4|56))?", 0, 0, 0, [["601055(?:[0-4]\\d|50)\\d\\d|6010(?:[0-4]\\d|5[0-4])\\d{4}|(?:46|60(?:[124-7][2-9]|8[1-9]))\\d{6}", [8, 10]], ["333301[0-5]\\d{3}|3333(?:00|2[5-9]|[3-9]\\d)\\d{4}|(?:3(?:24[1-9]|3(?:00|3[0-24-9]))|9101)\\d{6}|3(?:0[0-5]|1\\d|2[0-3]|5[01]|70)\\d{7}", [10]], ["1800\\d{7}", [11]], ["(?:19(?:0[01]|4[78])|901)\\d{7}", [10, 11]]]], CR: ["506", "00", "(?:8\\d|90)\\d{8}|(?:[24-8]\\d{3}|3005)\\d{4}", [8, 10], [["(\\d{4})(\\d{4})", "$1 $2", ["[2-7]|8[3-9]"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["[89]"]]], 0, 0, "(19(?:0[0-2468]|1[09]|20|66|77|99))", 0, 0, 0, [["210[7-9]\\d{4}|2(?:[024-7]\\d|1[1-9])\\d{5}", [8]], ["(?:3005\\d|6500[01])\\d{3}|(?:5[07]|6[0-4]|7[0-3]|8[3-9])\\d{6}", [8]], ["800\\d{7}", [10]], ["90[059]\\d{7}", [10]], 0, 0, 0, 0, ["(?:210[0-6]|4\\d{3}|5100)\\d{4}", [8]]]], CU: ["53", "119", "(?:[2-7]|8\\d\\d)\\d{7}|[2-47]\\d{6}|[34]\\d{5}", [6, 7, 8, 10], [["(\\d{2})(\\d{4,6})", "$1 $2", ["2[1-4]|[34]"], "(0$1)"], ["(\\d)(\\d{6,7})", "$1 $2", ["7"], "(0$1)"], ["(\\d)(\\d{7})", "$1 $2", ["[56]"], "0$1"], ["(\\d{3})(\\d{7})", "$1 $2", ["8"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:3[23]|4[89])\\d{4,6}|(?:31|4[36]|8(?:0[25]|78)\\d)\\d{6}|(?:2[1-4]|4[1257]|7\\d)\\d{5,6}"], ["(?:5\\d|6[2-4])\\d{6}", [8]], ["800\\d{7}", [10]], 0, 0, 0, 0, 0, 0, ["807\\d{7}", [10]]]], CV: ["238", "0", "(?:[2-59]\\d\\d|800)\\d{4}", [7], [["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[2-589]"]]], 0, 0, 0, 0, 0, 0, [["2(?:2[1-7]|3[0-8]|4[12]|5[1256]|6\\d|7[1-3]|8[1-5])\\d{4}"], ["(?:36|5[1-389]|9\\d)\\d{5}"], ["800\\d{4}"], 0, 0, 0, 0, 0, ["(?:3[3-5]|4[356])\\d{5}"]]], CW: ["599", "00", "(?:[34]1|60|(?:7|9\\d)\\d)\\d{5}", [7, 8], [["(\\d{3})(\\d{4})", "$1 $2", ["[3467]"]], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["9[4-8]"]]], 0, 0, 0, 0, 0, "[69]", [["9(?:4(?:3[0-5]|4[14]|6\\d)|50\\d|7(?:2[014]|3[02-9]|4[4-9]|6[357]|77|8[7-9])|8(?:3[39]|[46]\\d|7[01]|8[57-9]))\\d{4}"], ["953[01]\\d{4}|9(?:5[12467]|6[5-9])\\d{5}"], 0, 0, 0, 0, 0, ["955\\d{5}", [8]], 0, ["60[0-2]\\d{4}", [7]]]], CX: ["61", "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011", "1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}", [6, 7, 8, 9, 10, 12], 0, "0", 0, "([59]\\d{7})$|0", "8$1", 0, 0, [["8(?:51(?:0(?:01|30|59|88)|1(?:17|46|75)|2(?:22|35))|91(?:00[6-9]|1(?:[28]1|49|78)|2(?:09|63)|3(?:12|26|75)|4(?:56|97)|64\\d|7(?:0[01]|1[0-2])|958))\\d{3}", [9]], ["4(?:79[01]|83[0-389]|94[0-4])\\d{5}|4(?:[0-36]\\d|4[047-9]|5[0-25-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}", [9]], ["180(?:0\\d{3}|2)\\d{3}", [7, 10]], ["190[0-26]\\d{6}", [10]], 0, 0, 0, 0, ["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}", [9]], ["13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}", [6, 8, 10, 12]]], "0011"], CY: ["357", "00", "(?:[279]\\d|[58]0)\\d{6}", [8], [["(\\d{2})(\\d{6})", "$1 $2", ["[257-9]"]]], 0, 0, 0, 0, 0, 0, [["2[2-6]\\d{6}"], ["9(?:10|[4-79]\\d)\\d{5}"], ["800\\d{5}"], ["90[09]\\d{5}"], ["700\\d{5}"], 0, ["(?:50|77)\\d{6}"], 0, 0, ["80[1-9]\\d{5}"]]], CZ: ["420", "00", "(?:[2-578]\\d|60)\\d{7}|9\\d{8,11}", [9, 10, 11, 12], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-8]|9[015-7]"]], ["(\\d{2})(\\d{3})(\\d{3})(\\d{2})", "$1 $2 $3 $4", ["96"]], ["(\\d{2})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9"]], ["(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9"]]], 0, 0, 0, 0, 0, 0, [["(?:2\\d|3[1257-9]|4[16-9]|5[13-9])\\d{7}", [9]], ["(?:60[1-8]\\d|7(?:0(?:[2-5]\\d|60)|19[0-2]|[2379]\\d\\d))\\d{5}", [9]], ["800\\d{6}", [9]], ["9(?:0[05689]|76)\\d{6}", [9]], ["70[01]\\d{6}", [9]], ["9(?:3\\d{9}|6\\d{7,10})"], ["9(?:5\\d|7[2-4])\\d{6}", [9]], 0, ["9[17]0\\d{6}", [9]], ["8[134]\\d{7}", [9]]]], DE: ["49", "00", "[2579]\\d{5,14}|49(?:[34]0|69|8\\d)\\d\\d?|49(?:37|49|60|7[089]|9\\d)\\d{1,3}|49(?:2[024-9]|3[2-689]|7[1-7])\\d{1,8}|(?:1|[368]\\d|4[0-8])\\d{3,13}|49(?:[015]\\d|2[13]|31|[46][1-8])\\d{1,9}", [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15], [["(\\d{2})(\\d{3,13})", "$1 $2", ["3[02]|40|[68]9"], "0$1"], ["(\\d{3})(\\d{3,12})", "$1 $2", ["2(?:0[1-389]|1[124]|2[18]|3[14])|3(?:[35-9][15]|4[015])|906|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1", "2(?:0[1-389]|12[0-8])|3(?:[35-9][15]|4[015])|906|2(?:[13][14]|2[18])|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1"], "0$1"], ["(\\d{4})(\\d{2,11})", "$1 $2", ["[24-6]|3(?:[3569][02-46-9]|4[2-4679]|7[2-467]|8[2-46-8])|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]", "[24-6]|3(?:3(?:0[1-467]|2[127-9]|3[124578]|7[1257-9]|8[1256]|9[145])|4(?:2[135]|4[13578]|9[1346])|5(?:0[14]|2[1-3589]|6[1-4]|7[13468]|8[13568])|6(?:2[1-489]|3[124-6]|6[13]|7[12579]|8[1-356]|9[135])|7(?:2[1-7]|4[145]|6[1-5]|7[1-4])|8(?:21|3[1468]|6|7[1467]|8[136])|9(?:0[12479]|2[1358]|4[134679]|6[1-9]|7[136]|8[147]|9[1468]))|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]|3[68]4[1347]|3(?:47|60)[1356]|3(?:3[46]|46|5[49])[1246]|3[4579]3[1357]"], "0$1"], ["(\\d{3})(\\d{4})", "$1 $2", ["138"], "0$1"], ["(\\d{5})(\\d{2,10})", "$1 $2", ["3"], "0$1"], ["(\\d{3})(\\d{5,11})", "$1 $2", ["181"], "0$1"], ["(\\d{3})(\\d)(\\d{4,10})", "$1 $2 $3", ["1(?:3|80)|9"], "0$1"], ["(\\d{3})(\\d{7,8})", "$1 $2", ["1[67]"], "0$1"], ["(\\d{3})(\\d{7,12})", "$1 $2", ["8"], "0$1"], ["(\\d{5})(\\d{6})", "$1 $2", ["185", "1850", "18500"], "0$1"], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["7"], "0$1"], ["(\\d{4})(\\d{7})", "$1 $2", ["18[68]"], "0$1"], ["(\\d{4})(\\d{7})", "$1 $2", ["15[1279]"], "0$1"], ["(\\d{5})(\\d{6})", "$1 $2", ["15[03568]", "15(?:[0568]|31)"], "0$1"], ["(\\d{3})(\\d{8})", "$1 $2", ["18"], "0$1"], ["(\\d{3})(\\d{2})(\\d{7,8})", "$1 $2 $3", ["1(?:6[023]|7)"], "0$1"], ["(\\d{4})(\\d{2})(\\d{7})", "$1 $2 $3", ["15[279]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{8})", "$1 $2 $3", ["15"], "0$1"]], "0", 0, 0, 0, 0, 0, [["32\\d{9,11}|49[1-6]\\d{10}|322\\d{6}|49[0-7]\\d{3,9}|(?:[34]0|[68]9)\\d{3,13}|(?:2(?:0[1-689]|[1-3569]\\d|4[0-8]|7[1-7]|8[0-7])|3(?:[3569]\\d|4[0-79]|7[1-7]|8[1-8])|4(?:1[02-9]|[2-48]\\d|5[0-6]|6[0-8]|7[0-79])|5(?:0[2-8]|[124-6]\\d|[38][0-8]|[79][0-7])|6(?:0[02-9]|[1-358]\\d|[47][0-8]|6[1-9])|7(?:0[2-8]|1[1-9]|[27][0-7]|3\\d|[4-6][0-8]|8[0-5]|9[013-7])|8(?:0[2-9]|1[0-79]|2\\d|3[0-46-9]|4[0-6]|5[013-9]|6[1-8]|7[0-8]|8[0-24-6])|9(?:0[6-9]|[1-4]\\d|[589][0-7]|6[0-8]|7[0-467]))\\d{3,12}", [5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15]], ["1(?:(?:5(?:[0-25-9]\\d\\d|310)|76\\d\\d)\\d{6}|6[023]\\d{7,8})|17\\d{8}", [10, 11]], ["800\\d{7,12}", [10, 11, 12, 13, 14, 15]], ["(?:137[7-9]|900(?:[135]|9\\d))\\d{6}", [10, 11]], ["700\\d{8}", [11]], ["1(?:6(?:013|255|399)|7(?:(?:[015]1|[69]3)3|[2-4]55|[78]99))\\d{7,8}|15(?:(?:[03-68]00|113)\\d|2\\d55|7\\d99|9\\d33)\\d{7}", [12, 13]], ["18(?:1\\d{5,11}|[2-9]\\d{8})", [8, 9, 10, 11, 12, 13, 14]], ["16(?:4\\d{1,10}|[89]\\d{1,11})", [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14]], 0, ["180\\d{5,11}|13(?:7[1-6]\\d\\d|8)\\d{4}", [7, 8, 9, 10, 11, 12, 13, 14]]]], DJ: ["253", "00", "(?:2\\d|77)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[27]"]]], 0, 0, 0, 0, 0, 0, [["2(?:1[2-5]|7[45])\\d{5}"], ["77\\d{6}"]]], DK: ["45", "00", "[2-9]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-9]"]]], 0, 0, 0, 0, 0, 0, [["(?:2(?:[0-59][1-9]|[6-8]\\d)|3(?:[0-3][1-9]|4[13]|5[1-58]|6[1347-9]|7\\d|8[1-8]|9[1-79])|4(?:[0-25][1-9]|[34][2-9]|6[13-579]|7[13579]|8[1-47]|9[127])|5(?:[0-36][1-9]|4[146-9]|5[3-57-9]|7[568]|8[1-358]|9[1-69])|6(?:[0135][1-9]|2[1-68]|4[2-8]|6[1689]|[78]\\d|9[15689])|7(?:[0-69][1-9]|7[3-9]|8[147])|8(?:[16-9][1-9]|2[1-58])|9(?:[1-47-9][1-9]|6\\d))\\d{5}"], ["(?:2[6-8]|37|6[78]|96)\\d{6}|(?:2[0-59]|3[0-689]|[457]\\d|6[0-69]|8[126-9]|9[1-47-9])[1-9]\\d{5}"], ["80\\d{6}"], ["90\\d{6}"]]], DM: ["1", "011", "(?:[58]\\d\\d|767|900)\\d{7}", [10], 0, "1", 0, "([2-7]\\d{6})$|1", "767$1", 0, "767", [["767(?:2(?:55|66)|4(?:2[01]|4[0-25-9])|50[0-4])\\d{4}"], ["767(?:2(?:[2-4689]5|7[5-7])|31[5-7]|61[1-8]|70[1-6])\\d{4}"], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"]]], DO: ["1", "011", "(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, 0, 0, 0, "8001|8[024]9", [["8(?:[04]9[2-9]\\d\\d|29(?:2(?:[0-59]\\d|6[04-9]|7[0-27]|8[0237-9])|3(?:[0-35-9]\\d|4[7-9])|[45]\\d\\d|6(?:[0-27-9]\\d|[3-5][1-9]|6[0135-8])|7(?:0[013-9]|[1-37]\\d|4[1-35689]|5[1-4689]|6[1-57-9]|8[1-79]|9[1-8])|8(?:0[146-9]|1[0-48]|[248]\\d|3[1-79]|5[01589]|6[013-68]|7[124-8]|9[0-8])|9(?:[0-24]\\d|3[02-46-9]|5[0-79]|60|7[0169]|8[57-9]|9[02-9])))\\d{4}"], ["8[024]9[2-9]\\d{6}"], ["8(?:00(?:14|[2-9]\\d)|(?:33|44|55|66|77|88)[2-9]\\d)\\d{5}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"]]], DZ: ["213", "00", "(?:[1-4]|[5-79]\\d|80)\\d{7}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[1-4]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["9"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-8]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["9619\\d{5}|(?:1\\d|2[013-79]|3[0-8]|4[013-689])\\d{6}"], ["(?:5(?:4[0-29]|5\\d|6[0-3])|6(?:[569]\\d|7[0-6])|7[7-9]\\d)\\d{6}", [9]], ["800\\d{6}", [9]], ["80[3-689]1\\d{5}", [9]], 0, 0, 0, 0, ["98[23]\\d{6}", [9]], ["80[12]1\\d{5}", [9]]]], EC: ["593", "00", "1\\d{9,10}|(?:[2-7]|9\\d)\\d{7}", [8, 9, 10, 11], [["(\\d)(\\d{3})(\\d{4})", "$1 $2-$3", ["[2-7]"], "(0$1)", 0, "$1-$2-$3"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["1"]]], "0", 0, 0, 0, 0, 0, [["[2-7][2-7]\\d{6}", [8]], ["964[0-2]\\d{5}|9(?:39|[57][89]|6[0-36-9]|[89]\\d)\\d{6}", [9]], ["1800\\d{7}|1[78]00\\d{6}", [10, 11]], 0, 0, 0, 0, 0, ["[2-7]890\\d{4}", [8]]]], EE: ["372", "00", "8\\d{9}|[4578]\\d{7}|(?:[3-8]\\d|90)\\d{5}", [7, 8, 10], [["(\\d{3})(\\d{4})", "$1 $2", ["[369]|4[3-8]|5(?:[0-2]|5[0-478]|6[45])|7[1-9]|88", "[369]|4[3-8]|5(?:[02]|1(?:[0-8]|95)|5[0-478]|6(?:4[0-4]|5[1-589]))|7[1-9]|88"]], ["(\\d{4})(\\d{3,4})", "$1 $2", ["[45]|8(?:00|[1-49])", "[45]|8(?:00[1-9]|[1-49])"]], ["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["7"]], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]]], 0, 0, 0, 0, 0, 0, [["(?:3[23589]|4[3-8]|6\\d|7[1-9]|88)\\d{5}", [7]], ["(?:5\\d{5}|8(?:1(?:0(?:0(?:00|[178]\\d)|[3-9]\\d\\d)|(?:1(?:0[2-6]|1\\d)|(?:2[0-59]|[3-79]\\d)\\d)\\d)|2(?:0(?:0(?:00|4\\d)|(?:19|[2-7]\\d)\\d)|(?:(?:[124-69]\\d|3[5-9])\\d|7(?:[0-79]\\d|8[13-9])|8(?:[2-6]\\d|7[01]))\\d)|[349]\\d{4}))\\d\\d|5(?:(?:[02]\\d|5[0-478])\\d|1(?:[0-8]\\d|95)|6(?:4[0-4]|5[1-589]))\\d{3}", [7, 8]], ["800(?:(?:0\\d\\d|1)\\d|[2-9])\\d{3}"], ["(?:40\\d\\d|900)\\d{4}", [7, 8]], ["70[0-2]\\d{5}", [8]]]], EG: ["20", "00", "[189]\\d{8,9}|[24-6]\\d{8}|[135]\\d{7}", [8, 9, 10], [["(\\d)(\\d{7,8})", "$1 $2", ["[23]"], "0$1"], ["(\\d{2})(\\d{6,7})", "$1 $2", ["1[35]|[4-6]|8[2468]|9[235-7]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[89]"], "0$1"], ["(\\d{2})(\\d{8})", "$1 $2", ["1"], "0$1"]], "0", 0, 0, 0, 0, 0, [["13[23]\\d{6}|(?:15|57)\\d{6,7}|(?:2\\d|3|4[05-8]|5[05]|6[24-689]|8[2468]|9[235-7])\\d{7}", [8, 9]], ["1[0-25]\\d{8}", [10]], ["800\\d{7}", [10]], ["900\\d{7}", [10]]]], EH: ["212", "00", "[5-8]\\d{8}", [9], 0, "0", 0, 0, 0, 0, "528[89]", [["528[89]\\d{5}"], ["(?:6(?:[0-79]\\d|8[0-247-9])|7(?:[0167]\\d|2[0-467]|5[0-3]|8[0-5]))\\d{6}"], ["80[0-7]\\d{6}"], ["89\\d{7}"], 0, 0, 0, 0, ["(?:592(?:4[0-2]|93)|80[89]\\d\\d)\\d{4}"]]], ER: ["291", "00", "[178]\\d{6}", [7], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[178]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:1(?:1[12568]|[24]0|55|6[146])|8\\d\\d)\\d{4}"], ["(?:17[1-3]|7\\d\\d)\\d{4}"]]], ES: ["34", "00", "[5-9]\\d{8}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[89]00"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-9]"]]], 0, 0, 0, 0, 0, 0, [["96906(?:0[0-8]|1[1-9]|[2-9]\\d)\\d\\d|9(?:69(?:0[0-57-9]|[1-9]\\d)|73(?:[0-8]\\d|9[1-9]))\\d{4}|(?:8(?:[1356]\\d|[28][0-8]|[47][1-9])|9(?:[135]\\d|[268][0-8]|4[1-9]|7[124-9]))\\d{6}"], ["(?:590[16]00\\d|9(?:6906(?:09|10)|7390\\d\\d))\\d\\d|(?:6\\d|7[1-48])\\d{7}"], ["[89]00\\d{6}"], ["80[367]\\d{6}"], ["70\\d{7}"], 0, ["51\\d{7}"], 0, 0, ["90[12]\\d{6}"]]], ET: ["251", "00", "(?:11|[2-579]\\d)\\d{7}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-579]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["11667[01]\\d{3}|(?:11(?:1(?:1[124]|2[2-7]|3[1-5]|5[5-8]|8[6-8])|2(?:13|3[6-8]|5[89]|7[05-9]|8[2-6])|3(?:2[01]|3[0-289]|4[1289]|7[1-4]|87)|4(?:1[69]|3[2-49]|4[0-3]|6[5-8]|7\\d)|5(?:1[578]|44|5[0-4])|6(?:1[578]|2[69]|39|4[5-7]|5[0-5]|6[0-59]|8[015-8]))|2(?:2(?:11[1-9]|22[0-7]|33\\d|44[1467]|66[1-68])|5(?:11[124-6]|33[2-8]|44[1467]|55[14]|66[1-3679]|77[124-79]|880))|3(?:3(?:11[0-46-8]|(?:22|55)[0-6]|33[0134689]|44[04]|66[01467])|4(?:44[0-8]|55[0-69]|66[0-3]|77[1-5]))|4(?:6(?:119|22[0-24-7]|33[1-5]|44[13-69]|55[14-689]|660|88[1-4])|7(?:(?:11|22)[1-9]|33[13-7]|44[13-6]|55[1-689]))|5(?:7(?:227|55[05]|(?:66|77)[14-8])|8(?:11[149]|22[013-79]|33[0-68]|44[013-8]|550|66[1-5]|77\\d)))\\d{4}"], ["700[1-9]\\d{5}|(?:7(?:0[1-9]|1[0-8]|22|77|86|99)|9\\d\\d)\\d{6}"]]], FI: ["358", "00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))", "[1-35689]\\d{4}|7\\d{10,11}|(?:[124-7]\\d|3[0-46-9])\\d{8}|[1-9]\\d{5,8}", [5, 6, 7, 8, 9, 10, 11, 12], [["(\\d{5})", "$1", ["20[2-59]"], "0$1"], ["(\\d{3})(\\d{3,7})", "$1 $2", ["(?:[1-3]0|[68])0|70[07-9]"], "0$1"], ["(\\d{2})(\\d{4,8})", "$1 $2", ["[14]|2[09]|50|7[135]"], "0$1"], ["(\\d{2})(\\d{6,10})", "$1 $2", ["7"], "0$1"], ["(\\d)(\\d{4,9})", "$1 $2", ["(?:19|[2568])[1-8]|3(?:0[1-9]|[1-9])|9"], "0$1"]], "0", 0, 0, 0, 0, "1[03-79]|[2-9]", [["1[3-7][1-8]\\d{3,6}|(?:19[1-8]|[23568][1-8]\\d|9(?:00|[1-8]\\d))\\d{2,6}", [5, 6, 7, 8, 9]], ["4946\\d{2,6}|(?:4[0-8]|50)\\d{4,8}", [6, 7, 8, 9, 10]], ["800\\d{4,6}", [7, 8, 9]], ["[67]00\\d{5,6}", [8, 9]], 0, 0, ["20\\d{4,8}|60[12]\\d{5,6}|7(?:099\\d{4,5}|5[03-9]\\d{3,7})|20[2-59]\\d\\d|(?:606|7(?:0[78]|1|3\\d))\\d{7}|(?:10|29|3[09]|70[1-5]\\d)\\d{4,8}"]], "00"], FJ: ["679", "0(?:0|52)", "45\\d{5}|(?:0800\\d|[235-9])\\d{6}", [7, 11], [["(\\d{3})(\\d{4})", "$1 $2", ["[235-9]|45"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["0"]]], 0, 0, 0, 0, 0, 0, [["603\\d{4}|(?:3[0-5]|6[25-7]|8[58])\\d{5}", [7]], ["(?:[279]\\d|45|5[01568]|8[034679])\\d{5}", [7]], ["0800\\d{7}", [11]]], "00"], FK: ["500", "00", "[2-7]\\d{4}", [5], 0, 0, 0, 0, 0, 0, 0, [["[2-47]\\d{4}"], ["[56]\\d{4}"]]], FM: ["691", "00", "(?:[39]\\d\\d|820)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[389]"]]], 0, 0, 0, 0, 0, 0, [["31(?:00[67]|208|309)\\d\\d|(?:3(?:[2357]0[1-9]|602|804|905)|(?:820|9[2-6]\\d)\\d)\\d{3}"], ["31(?:00[67]|208|309)\\d\\d|(?:3(?:[2357]0[1-9]|602|804|905)|(?:820|9[2-7]\\d)\\d)\\d{3}"]]], FO: ["298", "00", "[2-9]\\d{5}", [6], [["(\\d{6})", "$1", ["[2-9]"]]], 0, 0, "(10(?:01|[12]0|88))", 0, 0, 0, [["(?:20|[34]\\d|8[19])\\d{4}"], ["(?:[27][1-9]|5\\d|9[16])\\d{4}"], ["80[257-9]\\d{3}"], ["90(?:[13-5][15-7]|2[125-7]|9\\d)\\d\\d"], 0, 0, 0, 0, ["(?:6[0-36]|88)\\d{4}"]]], FR: ["33", "00", "[1-9]\\d{8}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0 $1"], ["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["[1-79]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:26[013-9]|59[1-35-9])\\d{6}|(?:[13]\\d|2[0-57-9]|4[1-9]|5[0-8])\\d{7}"], ["(?:6(?:[0-24-8]\\d|3[0-8]|9[589])|7[3-9]\\d)\\d{6}"], ["80[0-5]\\d{6}"], ["836(?:0[0-36-9]|[1-9]\\d)\\d{4}|8(?:1[2-9]|2[2-47-9]|3[0-57-9]|[569]\\d|8[0-35-9])\\d{6}"], 0, 0, ["80[6-9]\\d{6}"], 0, ["9\\d{8}"], ["8(?:1[01]|2[0156]|4[024]|84)\\d{6}"]]], GA: ["241", "00", "(?:[067]\\d|11)\\d{6}|[2-7]\\d{6}", [7, 8], [["(\\d)(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-7]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["0"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["11|[67]"], "0$1"]], 0, 0, "0(11\\d{6}|60\\d{6}|61\\d{6}|6[256]\\d{6}|7[467]\\d{6})", "$1", 0, 0, [["[01]1\\d{6}", [8]], ["(?:(?:0[2-7]|7[467])\\d|6(?:0[0-4]|10|[256]\\d))\\d{5}|[2-7]\\d{6}"]]], GB: ["44", "00", "[1-357-9]\\d{9}|[18]\\d{8}|8\\d{6}", [7, 9, 10], [["(\\d{3})(\\d{4})", "$1 $2", ["800", "8001", "80011", "800111", "8001111"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["845", "8454", "84546", "845464"], "0$1"], ["(\\d{3})(\\d{6})", "$1 $2", ["800"], "0$1"], ["(\\d{5})(\\d{4,5})", "$1 $2", ["1(?:38|5[23]|69|76|94)", "1(?:(?:38|69)7|5(?:24|39)|768|946)", "1(?:3873|5(?:242|39[4-6])|(?:697|768)[347]|9467)"], "0$1"], ["(\\d{4})(\\d{5,6})", "$1 $2", ["1(?:[2-69][02-9]|[78])"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["[25]|7(?:0|6[02-9])", "[25]|7(?:0|6(?:[03-9]|2[356]))"], "0$1"], ["(\\d{4})(\\d{6})", "$1 $2", ["7"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1389]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:1(?:1(?:3(?:[0-58]\\d\\d|73[0-35])|4(?:(?:[0-5]\\d|70)\\d|69[7-9])|(?:(?:5[0-26-9]|[78][0-49])\\d|6(?:[0-4]\\d|50))\\d)|(?:2(?:(?:0[024-9]|2[3-9]|3[3-79]|4[1-689]|[58][02-9]|6[0-47-9]|7[013-9]|9\\d)\\d|1(?:[0-7]\\d|8[0-3]))|(?:3(?:0\\d|1[0-8]|[25][02-9]|3[02-579]|[468][0-46-9]|7[1-35-79]|9[2-578])|4(?:0[03-9]|[137]\\d|[28][02-57-9]|4[02-69]|5[0-8]|[69][0-79])|5(?:0[1-35-9]|[16]\\d|2[024-9]|3[015689]|4[02-9]|5[03-9]|7[0-35-9]|8[0-468]|9[0-57-9])|6(?:0[034689]|1\\d|2[0-35689]|[38][013-9]|4[1-467]|5[0-69]|6[13-9]|7[0-8]|9[0-24578])|7(?:0[0246-9]|2\\d|3[0236-8]|4[03-9]|5[0-46-9]|6[013-9]|7[0-35-9]|8[024-9]|9[02-9])|8(?:0[35-9]|2[1-57-9]|3[02-578]|4[0-578]|5[124-9]|6[2-69]|7\\d|8[02-9]|9[02569])|9(?:0[02-589]|[18]\\d|2[02-689]|3[1-57-9]|4[2-9]|5[0-579]|6[2-47-9]|7[0-24578]|9[2-57]))\\d)\\d)|2(?:0[013478]|3[0189]|4[017]|8[0-46-9]|9[0-2])\\d{3})\\d{4}|1(?:2(?:0(?:46[1-4]|87[2-9])|545[1-79]|76(?:2\\d|3[1-8]|6[1-6])|9(?:7(?:2[0-4]|3[2-5])|8(?:2[2-8]|7[0-47-9]|8[3-5])))|3(?:6(?:38[2-5]|47[23])|8(?:47[04-9]|64[0157-9]))|4(?:044[1-7]|20(?:2[23]|8\\d)|6(?:0(?:30|5[2-57]|6[1-8]|7[2-8])|140)|8(?:052|87[1-3]))|5(?:2(?:4(?:3[2-79]|6\\d)|76\\d)|6(?:26[06-9]|686))|6(?:06(?:4\\d|7[4-79])|295[5-7]|35[34]\\d|47(?:24|61)|59(?:5[08]|6[67]|74)|9(?:55[0-4]|77[23]))|7(?:26(?:6[13-9]|7[0-7])|(?:442|688)\\d|50(?:2[0-3]|[3-68]2|76))|8(?:27[56]\\d|37(?:5[2-5]|8[239])|843[2-58])|9(?:0(?:0(?:6[1-8]|85)|52\\d)|3583|4(?:66[1-8]|9(?:2[01]|81))|63(?:23|3[1-4])|9561))\\d{3}", [9, 10]], ["7(?:457[0-57-9]|700[01]|911[028])\\d{5}|7(?:[1-3]\\d\\d|4(?:[0-46-9]\\d|5[0-689])|5(?:0[0-8]|[13-9]\\d|2[0-35-9])|7(?:0[1-9]|[1-7]\\d|8[02-9]|9[0-689])|8(?:[014-9]\\d|[23][0-8])|9(?:[024-9]\\d|1[02-9]|3[0-689]))\\d{6}", [10]], ["80[08]\\d{7}|800\\d{6}|8001111"], ["(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[2-49]))\\d{7}|845464\\d", [7, 10]], ["70\\d{8}", [10]], 0, ["(?:3[0347]|55)\\d{8}", [10]], ["76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}", [10]], ["56\\d{8}", [10]]], 0, " x"], GD: ["1", "011", "(?:473|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "473$1", 0, "473", [["473(?:2(?:3[0-2]|69)|3(?:2[89]|86)|4(?:[06]8|3[5-9]|4[0-4]|5[579]|73|90)|63[68]|7(?:58|84)|800|938)\\d{4}"], ["473(?:4(?:0[2-79]|1[04-9]|2[0-5]|49|5[68])|5(?:2[01]|3[3-8])|901)\\d{4}"], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"]]], GE: ["995", "00", "(?:[3-57]\\d\\d|800)\\d{6}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["70"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["32"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[57]"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[348]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:3(?:[256]\\d|4[124-9]|7[0-4])|4(?:1\\d|2[2-7]|3[1-79]|4[2-8]|7[239]|9[1-7]))\\d{6}"], ["5(?:(?:(?:0555|1(?:[17]77|555))[5-9]|757(?:7[7-9]|8[01]))\\d|22252[0-4])\\d\\d|5(?:0(?:0[17]0|505)|1(?:0[01]0|1(?:07|33|51))|2(?:0[02]0|2[25]2)|3(?:0[03]0|3[35]3)|(?:40[04]|900)0|5222)[0-4]\\d{3}|(?:5(?:0(?:0(?:0\\d|11|22|3[0-6]|44|5[05]|77|88|9[09])|(?:[14]\\d|77)\\d|22[02])|1(?:1(?:[03][01]|[124]\\d|5[2-6]|7[0-4])|4\\d\\d)|[23]555|4(?:4\\d\\d|555)|5(?:[0157-9]\\d\\d|200|333|444)|6[89]\\d\\d|7(?:[0147-9]\\d\\d|5(?:00|[57]5))|8(?:0(?:[018]\\d|2[0-4])|5(?:55|8[89])|8(?:55|88))|9(?:090|[1-35-9]\\d\\d))|790\\d\\d)\\d{4}"], ["800\\d{6}"], 0, 0, 0, 0, 0, ["70[67]\\d{6}"]]], GF: ["594", "00", "(?:[56]94\\d|7093)\\d{5}|(?:80|9\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-7]|9[47]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[89]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["594(?:[02-49]\\d|1[0-5]|5[6-9]|6[0-3]|80)\\d{4}"], ["(?:694(?:[0-249]\\d|3[0-8])|7093[0-3])\\d{4}"], ["80[0-5]\\d{6}"], 0, 0, 0, 0, 0, ["9(?:(?:396|76\\d)\\d|476[0-6])\\d{4}"]]], GG: ["44", "00", "(?:1481|[357-9]\\d{3})\\d{6}|8\\d{6}(?:\\d{2})?", [7, 9, 10], 0, "0", 0, "([25-9]\\d{5})$|0", "1481$1", 0, 0, [["1481[25-9]\\d{5}", [10]], ["7(?:(?:781|839)\\d|911[17])\\d{5}", [10]], ["80[08]\\d{7}|800\\d{6}|8001111"], ["(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[0-3]))\\d{7}|845464\\d", [7, 10]], ["70\\d{8}", [10]], 0, ["(?:3[0347]|55)\\d{8}", [10]], ["76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}", [10]], ["56\\d{8}", [10]]]], GH: ["233", "00", "(?:[235]\\d{3}|800)\\d{5}", [8, 9], [["(\\d{3})(\\d{5})", "$1 $2", ["8"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[235]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["3082[0-5]\\d{4}|3(?:0(?:[237]\\d|8[01])|[167](?:2[0-6]|7\\d|80)|2(?:2[0-5]|7\\d|80)|3(?:2[0-3]|7\\d|80)|4(?:2[013-9]|3[01]|7\\d|80)|5(?:2[0-7]|7\\d|80)|8(?:2[0-2]|7\\d|80)|9(?:[28]0|7\\d))\\d{5}", [9]], ["(?:2(?:[0346-9]\\d|5[67])|5(?:[03-7]\\d|9[1-9]))\\d{6}", [9]], ["800\\d{5}", [8]]]], GI: ["350", "00", "(?:[25]\\d|60)\\d{6}", [8], [["(\\d{3})(\\d{5})", "$1 $2", ["2"]]], 0, 0, 0, 0, 0, 0, [["2190[0-2]\\d{3}|2(?:0(?:[02]\\d|3[01])|16[24-9]|2[2-5]\\d)\\d{4}"], ["5251[0-4]\\d{3}|(?:5(?:[146-8]\\d\\d|250)|60(?:1[01]|6\\d))\\d{4}"]]], GL: ["299", "00", "(?:19|[2-689]\\d|70)\\d{4}", [6], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["19|[2-9]"]]], 0, 0, 0, 0, 0, 0, [["(?:19|3[1-7]|[68][1-9]|70|9\\d)\\d{4}"], ["[245]\\d{5}"], ["80\\d{4}"], 0, 0, 0, 0, 0, ["3[89]\\d{4}"]]], GM: ["220", "00", "[2-9]\\d{6}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-9]"]]], 0, 0, 0, 0, 0, 0, [["(?:4(?:[23]\\d\\d|4(?:1[024679]|[6-9]\\d))|5(?:5(?:3\\d|4[0-7])|6[67]\\d|7(?:1[04]|2[035]|3[58]|48))|8\\d{3})\\d{3}"], ["(?:[23679]\\d|4[015]|5[0-489])\\d{5}"]]], GN: ["224", "00", "722\\d{6}|(?:3|6\\d)\\d{7}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["3"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[67]"]]], 0, 0, 0, 0, 0, 0, [["3(?:0(?:24|3[12]|4[1-35-7]|5[13]|6[189]|[78]1|9[1478])|1\\d\\d)\\d{4}", [8]], ["6[0-356]\\d{7}", [9]], 0, 0, 0, 0, 0, 0, ["722\\d{6}", [9]]]], GP: ["590", "00", "(?:590\\d|7090)\\d{5}|(?:69|80|9\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-79]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0$1"]], "0", 0, 0, 0, 0, 0, [["590(?:0[1-68]|[14][0-24-9]|2[0-68]|3[1-9]|5[3-579]|[68][0-689]|7[08]|9\\d)\\d{4}"], ["(?:69(?:0\\d\\d|1(?:2[2-9]|3[0-5])|4(?:0[89]|1[2-6]|9\\d)|6(?:1[016-9]|5[0-4]|[67]\\d))|7090[0-4])\\d{4}"], ["80[0-5]\\d{6}"], 0, 0, 0, 0, 0, ["9(?:(?:39[5-7]|76[018])\\d|475[0-6])\\d{4}"]]], GQ: ["240", "00", "222\\d{6}|(?:3\\d|55|[89]0)\\d{7}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[235]"]], ["(\\d{3})(\\d{6})", "$1 $2", ["[89]"]]], 0, 0, 0, 0, 0, 0, [["33[0-24-9]\\d[46]\\d{4}|3(?:33|5\\d)\\d[7-9]\\d{4}"], ["(?:222|55\\d)\\d{6}"], ["80\\d[1-9]\\d{5}"], ["90\\d[1-9]\\d{5}"]]], GR: ["30", "00", "5005000\\d{3}|8\\d{9,11}|(?:[269]\\d|70)\\d{8}", [10, 11, 12], [["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["21|7"]], ["(\\d{4})(\\d{6})", "$1 $2", ["2(?:2|3[2-57-9]|4[2-469]|5[2-59]|6[2-9]|7[2-69]|8[2-49])|5"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2689]"]], ["(\\d{3})(\\d{3,4})(\\d{5})", "$1 $2 $3", ["8"]]], 0, 0, 0, 0, 0, 0, [["2(?:1\\d\\d|2(?:2[1-46-9]|[36][1-8]|4[1-7]|5[1-4]|7[1-5]|[89][1-9])|3(?:1\\d|2[1-57]|[35][1-3]|4[13]|7[1-7]|8[124-6]|9[1-79])|4(?:1\\d|2[1-8]|3[1-4]|4[13-5]|6[1-578]|9[1-5])|5(?:1\\d|[29][1-4]|3[1-5]|4[124]|5[1-6])|6(?:1\\d|[269][1-6]|3[1245]|4[1-7]|5[13-9]|7[14]|8[1-5])|7(?:1\\d|2[1-5]|3[1-6]|4[1-7]|5[1-57]|6[135]|9[125-7])|8(?:1\\d|2[1-5]|[34][1-4]|9[1-57]))\\d{6}", [10]], ["68[57-9]\\d{7}|(?:69|94)\\d{8}", [10]], ["800\\d{7,9}"], ["90[19]\\d{7}", [10]], ["70\\d{8}", [10]], 0, ["5005000\\d{3}", [10]], 0, 0, ["8(?:0[16]|12|[27]5|50)\\d{7}", [10]]]], GT: ["502", "00", "80\\d{6}|(?:1\\d{3}|[2-7])\\d{7}", [8, 11], [["(\\d{4})(\\d{4})", "$1 $2", ["[2-8]"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]]], 0, 0, 0, 0, 0, 0, [["[267][2-9]\\d{6}", [8]], ["(?:[3-5]\\d\\d|80[0-4])\\d{5}", [8]], ["18[01]\\d{8}", [11]], ["19\\d{9}", [11]]]], GU: ["1", "011", "(?:[58]\\d\\d|671|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "671$1", 0, "671", [["671(?:2\\d\\d|3(?:00|3[39]|4[349]|55|6[26])|4(?:00|56|7[1-9]|8[02-9])|5(?:55|6[2-5]|88)|6(?:3[2-578]|4[24-9]|5[34]|78|8[235-9])|7(?:[0479]7|2[0167]|3[45]|8[7-9])|8(?:[2-57-9]8|6[478])|9(?:2[29]|6[79]|7[1279]|8[7-9]|9[78]))\\d{4}"], [""], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"]]], GW: ["245", "00", "[49]\\d{8}|4\\d{6}", [7, 9], [["(\\d{3})(\\d{4})", "$1 $2", ["40"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[49]"]]], 0, 0, 0, 0, 0, 0, [["443\\d{6}", [9]], ["9(?:5\\d|6[569]|77)\\d{6}", [9]], 0, 0, 0, 0, 0, 0, ["40\\d{5}", [7]]]], GY: ["592", "001", "(?:[2-8]\\d{3}|9008)\\d{3}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-9]"]]], 0, 0, 0, 0, 0, 0, [["(?:2(?:1[6-9]|2[0-35-9]|3[1-4]|5[3-9]|6\\d|7[0-79])|3(?:2[25-9]|3\\d)|4(?:4[0-24]|5[56])|50[0-6]|77[1-57])\\d{4}"], ["(?:510|6\\d\\d|7(?:[0-5]\\d|6[01]))\\d{4}"], ["(?:289|8(?:00|6[28]|88|99))\\d{4}"], ["9008\\d{3}"], 0, 0, 0, 0, ["515\\d{4}"]]], HK: ["852", "00(?:30|5[09]|[126-9]?)", "8[0-46-9]\\d{6,7}|9\\d{4,7}|(?:[2-7]|9\\d{3})\\d{7}", [5, 6, 7, 8, 9, 11], [["(\\d{3})(\\d{2,5})", "$1 $2", ["900", "9003"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[2-7]|8[1-4]|9(?:0[1-9]|[1-8])"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]], ["(\\d{3})(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9"]]], 0, 0, 0, 0, 0, 0, [["(?:2(?:[13-9]\\d|2[013-9])\\d|3(?:(?:[1569][0-24-9]|4[0-246-9]|7[0-24-69])\\d|8(?:4[0-8]|[579]\\d|6[0-2]))|58(?:0[1-9]|1[2-9]))\\d{4}", [8]], ["(?:4(?:44[0-35-9]|6(?:1[0-79]|4[0-57-9]|6[0-4])|7(?:4[0-28]|6[0-5]))|5(?:73[0-6]|95[0-8])|6(?:26[013-8]|66[0-3])|70(?:7[1-8]|8[0-4])|84(?:4[0-2]|8[0-35-9])|9(?:29[013-9]|39[014-9]|59[0-4]|899))\\d{4}|(?:4(?:4[0-35-9]|6[02357-9]|7[015])|5(?:[1-59][0-46-9]|6[0-4689]|7[0-246-9])|6(?:0[1-9]|[13-59]\\d|[268][0-57-9]|7[0-79])|70[1-59]|84[0-39]|9(?:0[1-9]|1[02-9]|[2358][0-8]|[467]\\d))\\d{5}", [8]], ["800\\d{6}", [9]], ["900(?:[0-24-9]\\d{7}|3\\d{1,4})", [5, 6, 7, 8, 11]], ["8(?:1[0-4679]\\d|2(?:[0-36]\\d|7[0-4])|3(?:[034]\\d|2[09]|70))\\d{4}", [8]], 0, ["30(?:0[1-9]|[15-7]\\d|2[047]|89)\\d{4}", [8]], ["7(?:1(?:0[0-38]|1[0-3679]|3[013]|69|9[0136])|2(?:[02389]\\d|1[18]|7[27-9])|3(?:[0-38]\\d|7[0-369]|9[2357-9])|47\\d|5(?:[178]\\d|5[0-5])|6(?:0[0-7]|2[236-9]|[35]\\d)|7(?:[27]\\d|8[7-9])|8(?:[23689]\\d|7[1-9])|9(?:[025]\\d|6[0-246-8]|7[0-36-9]|8[238]))\\d{4}", [8]]], "00"], HN: ["504", "00", "8\\d{10}|[237-9]\\d{7}", [8, 11], [["(\\d{4})(\\d{4})", "$1-$2", ["[237-9]"]]], 0, 0, 0, 0, 0, 0, [["2(?:2(?:0[0-59]|1[1-9]|[23]\\d|4[02-7]|5[57]|6[245]|7[0135689]|8[01346-9]|9[0-2])|4(?:0[578]|2[3-59]|3[13-9]|4[0-68]|5[1-3589])|5(?:0[2357-9]|1[1-356]|4[03-5]|5\\d|6[014-69]|7[04]|80)|6(?:[056]\\d|17|2[067]|3[047]|4[0-378]|[78][0-8]|9[01])|7(?:0[5-79]|6[46-9]|7[02-9]|8[034]|91)|8(?:79|8[0-357-9]|9[1-57-9]))\\d{4}", [8]], ["[37-9]\\d{7}", [8]], ["8002\\d{7}", [11]]]], HR: ["385", "00", "(?:[24-69]\\d|3[0-79])\\d{7}|80\\d{5,7}|[1-79]\\d{7}|6\\d{5,6}", [6, 7, 8, 9], [["(\\d{2})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["6[01]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["8"], "0$1"], ["(\\d)(\\d{4})(\\d{3})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["6|7[245]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-57]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"], "0$1"]], "0", 0, 0, 0, 0, 0, [["1\\d{7}|(?:2[0-3]|3[1-5]|4[02-47-9]|5[1-3])\\d{6,7}", [8, 9]], ["9(?:(?:0[1-9]|[12589]\\d)\\d\\d|7(?:[0679]\\d\\d|5(?:[01]\\d|44|55|77|9[5-79])))\\d{4}|98\\d{6}", [8, 9]], ["80\\d{5,7}", [7, 8, 9]], ["6[01459]\\d{6}|6[01]\\d{4,5}", [6, 7, 8]], ["7[45]\\d{6}", [8]], 0, ["62\\d{6,7}|72\\d{6}", [8, 9]]]], HT: ["509", "00", "(?:[2-489]\\d|55)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["[2-589]"]]], 0, 0, 0, 0, 0, 0, [["2(?:2\\d|5[1-5]|81|9[149])\\d{5}"], ["(?:[34]\\d|55)\\d{6}"], ["8\\d{7}"], 0, 0, 0, 0, 0, ["9(?:[67][0-4]|8[0-3589]|9\\d)\\d{5}"]]], HU: ["36", "00", "[235-7]\\d{8}|[1-9]\\d{7}", [8, 9], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "(06 $1)"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[27][2-9]|3[2-7]|4[24-9]|5[2-79]|6|8[2-57-9]|9[2-69]"], "(06 $1)"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-9]"], "06 $1"]], "06", 0, 0, 0, 0, 0, [["(?:1\\d|[27][2-9]|3[2-7]|4[24-9]|5[2-79]|6[23689]|8[2-57-9]|9[2-69])\\d{6}", [8]], ["(?:[257]0|3[01])\\d{7}", [9]], ["(?:[48]0\\d|680[29])\\d{5}"], ["9[01]\\d{6}", [8]], 0, 0, ["38\\d{7}", [9]], 0, ["21\\d{7}", [9]]]], ID: ["62", "00[89]", "00[1-9]\\d{9,14}|(?:[1-36]|8\\d{5})\\d{6}|00\\d{9}|[1-9]\\d{8,10}|[2-9]\\d{7}", [7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["15"]], ["(\\d{2})(\\d{5,9})", "$1 $2", ["2[124]|[36]1"], "(0$1)"], ["(\\d{3})(\\d{5,7})", "$1 $2", ["800"], "0$1"], ["(\\d{3})(\\d{5,8})", "$1 $2", ["[2-79]"], "(0$1)"], ["(\\d{3})(\\d{3,4})(\\d{3})", "$1-$2-$3", ["8[1-35-9]"], "0$1"], ["(\\d{3})(\\d{6,8})", "$1 $2", ["1"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["804"], "0$1"], ["(\\d{3})(\\d)(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["80"], "0$1"], ["(\\d{3})(\\d{4})(\\d{4,5})", "$1-$2-$3", ["8"], "0$1"]], "0", 0, 0, 0, 0, 0, [["2[124]\\d{7,8}|619\\d{8}|2(?:1(?:14|500)|2\\d{3})\\d{3}|61\\d{5,8}|(?:2(?:[35][1-4]|6[0-8]|7[1-6]|8\\d|9[1-8])|3(?:1|[25][1-8]|3[1-68]|4[1-3]|6[1-3568]|7[0-469]|8\\d)|4(?:0[1-589]|1[01347-9]|2[0-36-8]|3[0-24-68]|43|5[1-378]|6[1-5]|7[134]|8[1245])|5(?:1[1-35-9]|2[25-8]|3[124-9]|4[1-3589]|5[1-46]|6[1-8])|6(?:[25]\\d|3[1-69]|4[1-6])|7(?:02|[125][1-9]|[36]\\d|4[1-8]|7[0-36-9])|9(?:0[12]|1[013-8]|2[0-479]|5[125-8]|6[23679]|7[159]|8[01346]))\\d{5,8}", [7, 8, 9, 10, 11]], ["8[1-35-9]\\d{7,10}", [9, 10, 11, 12]], ["00(?:1803\\d{5,11}|7803\\d{7})|(?:177\\d|800)\\d{5,7}", [8, 9, 10, 11, 12, 13, 14, 15, 16, 17]], ["809\\d{7}", [10]], 0, 0, ["(?:1500|8071\\d{3})\\d{3}", [7, 10]], 0, 0, ["804\\d{7}", [10]]]], IE: ["353", "00", "(?:1\\d|[2569])\\d{6,8}|4\\d{6,9}|7\\d{8}|8\\d{8,9}", [7, 8, 9, 10], [["(\\d{2})(\\d{5})", "$1 $2", ["2[24-9]|47|58|6[237-9]|9[35-9]"], "(0$1)"], ["(\\d{3})(\\d{5})", "$1 $2", ["[45]0"], "(0$1)"], ["(\\d)(\\d{3,4})(\\d{4})", "$1 $2 $3", ["1"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2569]|4[1-69]|7[14]"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["70"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["81"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[78]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["4"], "(0$1)"], ["(\\d{2})(\\d)(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["8"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:1\\d|21)\\d{6,7}|(?:2[24-9]|4(?:0[24]|5\\d|7)|5(?:0[45]|1\\d|8)|6(?:1\\d|[237-9])|9(?:1\\d|[35-9]))\\d{5}|(?:23|4(?:[1-469]|8\\d)|5[23679]|6[4-6]|7[14]|9[04])\\d{7}"], ["8(?:22|[35-9]\\d)\\d{6}", [9]], ["1800\\d{6}", [10]], ["15(?:1[2-8]|[2-8]0|9[089])\\d{6}", [10]], ["700\\d{6}", [9]], ["88210[1-9]\\d{4}|8(?:[35-79]5\\d\\d|8(?:[013-9]\\d\\d|2(?:[01][1-9]|[2-9]\\d)))\\d{5}", [10]], ["818\\d{6}", [9]], 0, ["76\\d{7}", [9]], ["18[59]0\\d{6}", [10]]]], IL: ["972", "0(?:0|1[2-9])", "1\\d{6}(?:\\d{3,5})?|[57]\\d{8}|[1-489]\\d{7}", [7, 8, 9, 10, 11, 12], [["(\\d{4})(\\d{3})", "$1-$2", ["125"]], ["(\\d{4})(\\d{2})(\\d{2})", "$1-$2-$3", ["121"]], ["(\\d)(\\d{3})(\\d{4})", "$1-$2-$3", ["[2-489]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["[57]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1-$2-$3", ["12"]], ["(\\d{4})(\\d{6})", "$1-$2", ["159"]], ["(\\d)(\\d{3})(\\d{3})(\\d{3})", "$1-$2-$3-$4", ["1[7-9]"]], ["(\\d{3})(\\d{1,2})(\\d{3})(\\d{4})", "$1-$2 $3-$4", ["15"]]], "0", 0, 0, 0, 0, 0, [["153\\d{8,9}|29[1-9]\\d{5}|(?:2[0-8]|[3489]\\d)\\d{6}", [8, 11, 12]], ["55(?:4(?:[01]0|5[0-2])|57[0-289])\\d{4}|5(?:(?:[0-2][02-9]|[36]\\d|[49][2-9]|8[3-7])\\d|5(?:01|2\\d|3[0-3]|4[34]|5[0-25689]|6[6-8]|7[0-267]|8[7-9]|9[1-9]))\\d{5}", [9]], ["1(?:255|80[019]\\d{3})\\d{3}", [7, 10]], ["1212\\d{4}|1(?:200|9(?:0[0-2]|19))\\d{6}", [8, 10]], 0, ["151\\d{8,9}", [11, 12]], ["1599\\d{6}", [10]], 0, ["7(?:38(?:0\\d|5[0-3569]|88)|8(?:33|55|77|81)\\d)\\d{4}|7(?:18|2[23]|3[237]|47|6[258]|7\\d|82|9[2-9])\\d{6}", [9]], ["1700\\d{6}", [10]]]], IM: ["44", "00", "1624\\d{6}|(?:[3578]\\d|90)\\d{8}", [10], 0, "0", 0, "([25-8]\\d{5})$|0", "1624$1", 0, "74576|(?:16|7[56])24", [["1624(?:230|[5-8]\\d\\d)\\d{3}"], ["76245[06]\\d{4}|7(?:4576|[59]24\\d|624[0-4689])\\d{5}"], ["808162\\d{4}"], ["8(?:440[49]06|72299\\d)\\d{3}|(?:8(?:45|70)|90[0167])624\\d{4}"], ["70\\d{8}"], 0, ["3440[49]06\\d{3}|(?:3(?:08162|3\\d{4}|45624|7(?:0624|2299))|55\\d{4})\\d{4}"], 0, ["56\\d{8}"]]], IN: ["91", "00", "(?:000800|[2-9]\\d\\d)\\d{7}|1\\d{7,12}", [8, 9, 10, 11, 12, 13], [["(\\d{8})", "$1", ["5(?:0|2[23]|3[03]|[67]1|88)", "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|888)", "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|8888)"], 0, 1], ["(\\d{4})(\\d{4,5})", "$1 $2", ["180", "1800"], 0, 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["140"], 0, 1], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["11|2[02]|33|4[04]|79[1-7]|80[2-46]", "11|2[02]|33|4[04]|79(?:[1-6]|7[19])|80(?:[2-4]|6[0-589])", "11|2[02]|33|4[04]|79(?:[124-6]|3(?:[02-9]|1[0-24-9])|7(?:1|9[1-6]))|80(?:[2-4]|6[0-589])"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["1(?:2[0-249]|3[0-25]|4[145]|[68]|7[1257])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|5[12]|[78]1)|6(?:12|[2-4]1|5[17]|6[13]|80)|7(?:12|3[134]|4[47]|61|88)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91)|(?:43|59|75)[15]|(?:1[59]|29|67|72)[14]", "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|674|7(?:(?:2[14]|3[34]|5[15])[2-6]|61[346]|88[0-8])|8(?:70[2-6]|84[235-7]|91[3-7])|(?:1(?:29|60|8[06])|261|552|6(?:12|[2-47]1|5[17]|6[13]|80)|7(?:12|31|4[47])|8(?:16|2[014]|3[126]|6[136]|7[78]|83))[2-7]", "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|6(?:12(?:[2-6]|7[0-8])|74[2-7])|7(?:(?:2[14]|5[15])[2-6]|3171|61[346]|88(?:[2-7]|82))|8(?:70[2-6]|84(?:[2356]|7[19])|91(?:[3-6]|7[19]))|73[134][2-6]|(?:74[47]|8(?:16|2[014]|3[126]|6[136]|7[78]|83))(?:[2-6]|7[19])|(?:1(?:29|60|8[06])|261|552|6(?:[2-4]1|5[17]|6[13]|7(?:1|4[0189])|80)|7(?:12|88[01]))[2-7]"], "0$1", 1], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2[2457-9]|3[2-5]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1[013-9]|28|3[129]|4[1-35689]|5[29]|6[02-5]|70)|807", "1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2(?:[2457]|84|95)|3(?:[2-4]|55)|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1(?:[013-8]|9[6-9])|28[6-8]|3(?:17|2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4|5[0-367])|70[13-7])|807[19]", "1(?:[2-479]|5(?:[0236-9]|5[013-9]))|[2-5]|6(?:2(?:84|95)|355|83)|73179|807(?:1|9[1-3])|(?:1552|6(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[124-6])\\d|7(?:1(?:[013-8]\\d|9[6-9])|28[6-8]|3(?:2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]\\d|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4\\d|5[0-367])|70[13-7]))[2-7]"], "0$1", 1], ["(\\d{5})(\\d{5})", "$1 $2", ["[6-9]"], "0$1", 1], ["(\\d{4})(\\d{2,4})(\\d{4})", "$1 $2 $3", ["1(?:6|8[06])", "1(?:6|8[06]0)"], 0, 1], ["(\\d{4})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["18"], 0, 1]], "0", 0, 0, 0, 0, 0, [["2717(?:[2-7]\\d|95)\\d{4}|(?:271[0-689]|782[0-6])[2-7]\\d{5}|(?:170[24]|2(?:(?:[02][2-79]|90)\\d|80[13468])|(?:3(?:23|80)|683|79[1-7])\\d|4(?:20[24]|72[2-8])|552[1-7])\\d{6}|(?:11|33|4[04]|80)[2-7]\\d{7}|(?:342|674|788)(?:[0189][2-7]|[2-7]\\d)\\d{5}|(?:1(?:2[0-249]|3[0-25]|4[145]|[59][14]|6[014]|7[1257]|8[01346])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568]|9[14])|3(?:26|4[13]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[014-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|6(?:12|[2-47]1|5[17]|6[13]|80)|7(?:12|2[14]|3[134]|4[47]|5[15]|[67]1)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91))[2-7]\\d{6}|(?:1(?:2[35-8]|3[346-9]|4[236-9]|[59][0235-9]|6[235-9]|7[34689]|8[257-9])|2(?:1[134689]|3[24-8]|4[2-8]|5[25689]|6[2-4679]|7[3-79]|8[2-479]|9[235-9])|3(?:01|1[79]|2[1245]|4[5-8]|5[125689]|6[235-7]|7[157-9]|8[2-46-8])|4(?:1[14578]|2[5689]|3[2-467]|5[4-7]|6[35]|73|8[2689]|9[2389])|5(?:[16][146-9]|2[14-8]|3[1346]|4[14-69]|5[46]|7[2-4]|8[2-8]|9[246])|6(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[124-6])|7(?:1[013-9]|2[0235-9]|3[2679]|4[1-35689]|5[2-46-9]|[67][02-9]|8[013-7]|9[089])|8(?:1[1357-9]|2[235-8]|3[03-57-9]|4[0-24-9]|5\\d|6[2457-9]|7[1-6]|8[1256]|9[2-4]))\\d[2-7]\\d{5}", [10]], ["(?:61279|7(?:887[02-9]|9(?:313|79[07-9]))|8(?:079[04-9]|(?:84|91)7[02-8]))\\d{5}|(?:6(?:12|[2-47]1|5[17]|6[13]|80)[0189]|7(?:1(?:2[0189]|9[0-5])|2(?:[14][017-9]|8[0-59])|3(?:2[5-8]|[34][017-9]|9[016-9])|4(?:1[015-9]|[29][89]|39|8[389])|5(?:[15][017-9]|2[04-9]|9[7-9])|6(?:0[0-47]|1[0-257-9]|2[0-4]|3[19]|5[4589])|70[0289]|88[089]|97[02-8])|8(?:0(?:6[67]|7[02-8])|70[017-9]|84[01489]|91[0-289]))\\d{6}|(?:7(?:31|4[47])|8(?:16|2[014]|3[126]|6[136]|7[78]|83))(?:[0189]\\d|7[02-8])\\d{5}|(?:6(?:[09]\\d|1[04679]|2[03689]|3[05-9]|4[0489]|50|6[069]|7[07]|8[7-9])|7(?:0\\d|2[0235-79]|3[05-8]|40|5[0346-8]|6[6-9]|7[1-9]|8[0-79]|9[089])|8(?:0[01589]|1[0-57-9]|2[235-9]|3[03-57-9]|[45]\\d|6[02457-9]|7[1-69]|8[0-25-9]|9[02-9])|9\\d\\d)\\d{7}|(?:6(?:(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|8[124-6])\\d|7(?:[235689]\\d|4[0189]))|7(?:1(?:[013-8]\\d|9[6-9])|28[6-8]|3(?:2[0-49]|9[2-5])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]\\d|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4\\d|5[0-367])|70[13-7]|881))[0189]\\d{5}", [10]], ["000800\\d{7}|1(?:600\\d{6}|80(?:0\\d{4,9}|3\\d{9}))"], ["186[12]\\d{9}", [13]], 0, 0, ["140\\d{7}", [10]], 0, 0, ["1860\\d{7}", [11]]]], IO: ["246", "00", "3\\d{6}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["3"]]], 0, 0, 0, 0, 0, 0, [["37\\d{5}"], ["38\\d{5}"]]], IQ: ["964", "00", "(?:1|7\\d\\d)\\d{7}|[2-6]\\d{7,8}", [8, 9, 10], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-6]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"]], "0", 0, 0, 0, 0, 0, [["1\\d{7}|(?:2[13-5]|3[02367]|4[023]|5[03]|6[026])\\d{6,7}", [8, 9]], ["7[3-9]\\d{8}", [10]]]], IR: ["98", "00", "[1-9]\\d{9}|(?:[1-8]\\d\\d|9)\\d{3,4}", [4, 5, 6, 7, 10], [["(\\d{4,5})", "$1", ["96"], "0$1"], ["(\\d{2})(\\d{4,5})", "$1 $2", ["(?:1[137]|2[13-68]|3[1458]|4[145]|5[1468]|6[16]|7[1467]|8[13467])[12689]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["[1-8]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:1[137]|2[13-68]|3[1458]|4[145]|5[1468]|6[16]|7[1467]|8[13467])(?:[03-57]\\d{7}|[16]\\d{3}(?:\\d{4})?|[289]\\d{3}(?:\\d(?:\\d{3})?)?)|94(?:000[09]|(?:12\\d|30[0-2])\\d|2(?:121|[2689]0\\d)|4(?:111|40\\d))\\d{4}", [6, 7, 10]], ["9(?:(?:0(?:[0-35]\\d|4[4-6])|(?:[13]\\d|2[0-3])\\d)\\d|9(?:[0-46]\\d\\d|5[15]0|8(?:[12]\\d|88)|9(?:0[0-3]|[19]\\d|21|69|77|8[7-9])))\\d{5}", [10]], 0, 0, 0, 0, ["96(?:0[12]|2[16-8]|3(?:08|[14]5|[23]|66)|4(?:0|80)|5[01]|6[89]|86|9[19])", [4, 5]]]], IS: ["354", "00|1(?:0(?:01|[12]0)|100)", "(?:38\\d|[4-9])\\d{6}", [7, 9], [["(\\d{3})(\\d{4})", "$1 $2", ["[4-9]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["3"]]], 0, 0, 0, 0, 0, 0, [["(?:4(?:1[0-24-69]|2[0-7]|[37][0-8]|4[0-24589]|5[0-68]|6\\d|8[0-36-8])|5(?:05|[156]\\d|2[02578]|3[0-579]|4[03-7]|7[0-2578]|8[0-35-9]|9[013-689])|872)\\d{4}", [7]], ["(?:38[589]\\d\\d|6(?:1[1-8]|2[0-6]|3[026-9]|4[014679]|5[0159]|6[0-69]|70|8[06-8]|9\\d)|7(?:5[057]|[6-9]\\d)|8(?:2[0-59]|[3-69]\\d|8[238]))\\d{4}"], ["80[0-8]\\d{4}", [7]], ["90(?:0\\d|1[5-79]|2[015-79]|3[135-79]|4[125-7]|5[25-79]|7[1-37]|8[0-35-7])\\d{3}", [7]], 0, ["(?:689|8(?:7[18]|80)|95[48])\\d{4}", [7]], ["809\\d{4}", [7]], 0, ["49[0-24-79]\\d{4}", [7]]], "00"], IT: ["39", "00", "0\\d{5,10}|1\\d{8,10}|3(?:[0-8]\\d{7,10}|9\\d{7,8})|(?:43|55|70)\\d{8}|8\\d{5}(?:\\d{2,4})?", [6, 7, 8, 9, 10, 11, 12], [["(\\d{2})(\\d{4,6})", "$1 $2", ["0[26]"]], ["(\\d{3})(\\d{3,6})", "$1 $2", ["0[13-57-9][0159]|8(?:03|4[17]|9[2-5])", "0[13-57-9][0159]|8(?:03|4[17]|9(?:2|3[04]|[45][0-4]))"]], ["(\\d{4})(\\d{2,6})", "$1 $2", ["0(?:[13-579][2-46-8]|8[236-8])"]], ["(\\d{4})(\\d{4})", "$1 $2", ["894"]], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["0[26]|5"]], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["1(?:44|[679])|[378]|43"]], ["(\\d{3})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["0[13-57-9][0159]|14"]], ["(\\d{2})(\\d{4})(\\d{5})", "$1 $2 $3", ["0[26]"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["0"]], ["(\\d{3})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["3"]]], 0, 0, 0, 0, 0, 0, [["0669[0-79]\\d{1,6}|0(?:1(?:[0159]\\d|[27][1-5]|31|4[1-4]|6[1356]|8[2-57])|2\\d\\d|3(?:[0159]\\d|2[1-4]|3[12]|[48][1-6]|6[2-59]|7[1-7])|4(?:[0159]\\d|[23][1-9]|4[245]|6[1-5]|7[1-4]|81)|5(?:[0159]\\d|2[1-5]|3[2-6]|4[1-79]|6[4-6]|7[1-578]|8[3-8])|6(?:[0-57-9]\\d|6[0-8])|7(?:[0159]\\d|2[12]|3[1-7]|4[2-46]|6[13569]|7[13-6]|8[1-59])|8(?:[0159]\\d|2[3-578]|3[1-356]|[6-8][1-5])|9(?:[0159]\\d|[238][1-5]|4[12]|6[1-8]|7[1-6]))\\d{2,7}", [6, 7, 8, 9, 10, 11]], ["3[2-9]\\d{7,8}|(?:31|43)\\d{8}", [9, 10]], ["80(?:0\\d{3}|3)\\d{3}", [6, 9]], ["(?:0878\\d{3}|89(?:2\\d|3[04]|4(?:[0-4]|[5-9]\\d\\d)|5[0-4]))\\d\\d|(?:1(?:44|6[346])|89(?:38|5[5-9]|9))\\d{6}", [6, 8, 9, 10]], ["1(?:78\\d|99)\\d{6}", [9, 10]], ["3[2-8]\\d{9,10}", [11, 12]], 0, 0, ["55\\d{8}", [10]], ["84(?:[08]\\d{3}|[17])\\d{3}", [6, 9]]]], JE: ["44", "00", "1534\\d{6}|(?:[3578]\\d|90)\\d{8}", [10], 0, "0", 0, "([0-24-8]\\d{5})$|0", "1534$1", 0, 0, [["1534[0-24-8]\\d{5}"], ["7(?:(?:(?:50|82)9|937)\\d|7(?:00[378]|97\\d))\\d{5}"], ["80(?:07(?:35|81)|8901)\\d{4}"], ["(?:8(?:4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|90(?:066[59]|1810|71(?:07|55)))\\d{4}"], ["701511\\d{4}"], 0, ["(?:3(?:0(?:07(?:35|81)|8901)|3\\d{4}|4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|55\\d{4})\\d{4}"], ["76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}"], ["56\\d{8}"]]], JM: ["1", "011", "(?:[58]\\d\\d|658|900)\\d{7}", [10], 0, "1", 0, 0, 0, 0, "658|876", [["8766060\\d{3}|(?:658(?:2(?:[0-8]\\d|9[0-46-9])|[3-9]\\d\\d)|876(?:52[35]|6(?:0[1-3579]|1[0235-9]|[23]\\d|40|5[06]|6[2-589]|7[0-25-9]|8[04]|9[4-9])|7(?:0[2-689]|[1-6]\\d|8[056]|9[45])|9(?:0[1-8]|1[02378]|[2-8]\\d|9[2-468])))\\d{4}"], ["(?:658295|876(?:2(?:0[1-9]|[13-9]\\d|2[013-9])|[348]\\d\\d|5(?:0[1-9]|[1-9]\\d)|6(?:4[89]|6[67])|7(?:0[07]|7\\d|8[1-47-9]|9[0-36-9])|9(?:[01]9|9[0579])))\\d{4}"], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"]]], JO: ["962", "00", "(?:(?:[2689]|7\\d)\\d|32|53)\\d{6}", [8, 9], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2356]|87"], "(0$1)"], ["(\\d{3})(\\d{5,6})", "$1 $2", ["[89]"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["70"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["7"], "0$1"]], "0", 0, 0, 0, 0, 0, [["87(?:000|90[01])\\d{3}|(?:2(?:6(?:2[0-35-9]|3[0-578]|4[24-7]|5[0-24-8]|[6-8][023]|9[0-3])|7(?:0[1-79]|10|2[014-7]|3[0-689]|4[019]|5[0-3578]))|32(?:0[1-69]|1[1-35-7]|2[024-7]|3\\d|4[0-3]|[5-7][023])|53(?:0[0-3]|[13][023]|2[0-59]|49|5[0-35-9]|6[15]|7[45]|8[1-6]|9[0-36-9])|6(?:2(?:[05]0|22)|3(?:00|33)|4(?:0[0-25]|1[2-7]|2[0569]|[38][07-9]|4[025689]|6[0-589]|7\\d|9[0-2])|5(?:[01][056]|2[034]|3[0-57-9]|4[178]|5[0-69]|6[0-35-9]|7[1-379]|8[0-68]|9[0239]))|87(?:20|7[078]|99))\\d{4}", [8]], ["7(?:[78][0-25-9]|9\\d)\\d{6}", [9]], ["80\\d{6}", [8]], ["9\\d{7}", [8]], ["70\\d{7}", [9]], 0, ["8(?:10|8\\d)\\d{5}", [8]], ["74(?:66|77)\\d{5}", [9]], 0, ["85\\d{6}", [8]]]], JP: ["81", "010", "00[1-9]\\d{6,14}|[257-9]\\d{9}|(?:00|[1-9]\\d\\d)\\d{6}", [8, 9, 10, 11, 12, 13, 14, 15, 16, 17], [["(\\d{3})(\\d{3})(\\d{3})", "$1-$2-$3", ["(?:12|57|99)0"], "0$1"], ["(\\d{4})(\\d)(\\d{4})", "$1-$2-$3", ["1(?:26|3[79]|4[56]|5[4-68]|6[3-5])|499|5(?:76|97)|746|8(?:3[89]|47|51)|9(?:80|9[16])", "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:76|97)9|7468|8(?:3(?:8[7-9]|96)|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]", "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:769|979[2-69])|7468|8(?:3(?:8[7-9]|96[2457-9])|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["60"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1-$2-$3", ["[36]|4(?:2[09]|7[01])", "[36]|4(?:2(?:0|9[02-69])|7(?:0[019]|1))"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["1(?:1|5[45]|77|88|9[69])|2(?:2[1-37]|3[0-269]|4[59]|5|6[24]|7[1-358]|8[1369]|9[0-38])|4(?:[28][1-9]|3[0-57]|[45]|6[248]|7[2-579]|9[29])|5(?:2|3[0459]|4[0-369]|5[29]|8[02389]|9[0-389])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9[2-6])|8(?:2[124589]|3[26-9]|49|51|6|7[0-468]|8[68]|9[019])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9[1-489])", "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2(?:[127]|3[014-9])|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9[19])|62|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|8[1-9]|9[29])|5(?:2|3(?:[045]|9[0-8])|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0-2469])|3(?:[29]|60)|49|51|6(?:[0-24]|36|5[0-3589]|7[23]|9[01459])|7[0-468]|8[68])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9(?:[1289]|3[34]|4[0178]))|(?:264|837)[016-9]|2(?:57|93)[015-9]|(?:25[0468]|422|838)[01]|(?:47[59]|59[89]|8(?:6[68]|9))[019]", "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2[127]|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9(?:17|99))|6(?:2|4[016-9])|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|9[29])|5(?:2|3(?:[045]|9(?:[0-58]|6[4-9]|7[0-35689]))|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0169])|3(?:[29]|60|7(?:[017-9]|6[6-8]))|49|51|6(?:[0-24]|36[2-57-9]|5(?:[0-389]|5[23])|6(?:[01]|9[178])|7(?:2[2-468]|3[78])|9[0145])|7[0-468]|8[68])|9(?:4[15]|5[138]|7[156]|8[189]|9(?:[1289]|3(?:31|4[357])|4[0178]))|(?:8294|96)[1-3]|2(?:57|93)[015-9]|(?:223|8699)[014-9]|(?:25[0468]|422|838)[01]|(?:48|8292|9[23])[1-9]|(?:47[59]|59[89]|8(?:68|9))[019]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{4})", "$1-$2-$3", ["[14]|[289][2-9]|5[3-9]|7[2-4679]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["800"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1-$2-$3", ["[257-9]"], "0$1"]], "0", 0, "(000[259]\\d{6})$|(?:(?:003768)0?)|0", "$1", 0, 0, [["(?:1(?:1[235-8]|2[3-6]|3[3-9]|4[2-6]|[58][2-8]|6[2-7]|7[2-9]|9[1-9])|(?:2[2-9]|[36][1-9])\\d|4(?:[2-578]\\d|6[02-8]|9[2-59])|5(?:[2-589]\\d|6[1-9]|7[2-8])|7(?:[25-9]\\d|3[4-9]|4[02-9])|8(?:[2679]\\d|3[2-9]|4[5-9]|5[1-9]|8[03-9])|9(?:[2-58]\\d|[679][1-9]))\\d{6}", [9]], ["[7-9]0[1-9]\\d{7}", [10]], ["00777(?:[01]|5\\d)\\d\\d|(?:00(?:7778|882[1245])|(?:120|800\\d)\\d\\d)\\d{4}|00(?:37|66|78)\\d{6,13}"], ["990\\d{6}", [9]], ["60\\d{7}", [9]], 0, ["570\\d{6}", [9]], ["20\\d{8}", [10]], ["50[1-9]\\d{7}", [10]]]], KE: ["254", "000", "(?:[17]\\d\\d|900)\\d{6}|(?:2|80)0\\d{6,7}|[4-6]\\d{6,8}", [7, 8, 9, 10], [["(\\d{2})(\\d{5,7})", "$1 $2", ["[24-6]"], "0$1"], ["(\\d{3})(\\d{6})", "$1 $2", ["[17]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[89]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:4[245]|5[1-79]|6[01457-9])\\d{5,7}|(?:4[136]|5[08]|62)\\d{7}|(?:[24]0|66)\\d{6,7}", [7, 8, 9]], ["(?:1(?:0[0-8]|1[0-7]|2[014]|30)|7\\d\\d)\\d{6}", [9]], ["800[02-8]\\d{5,6}", [9, 10]], ["900[02-9]\\d{5}", [9]]]], KG: ["996", "00", "8\\d{9}|[235-9]\\d{8}", [9, 10], [["(\\d{4})(\\d{5})", "$1 $2", ["3(?:1[346]|[24-79])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[235-79]|88"], "0$1"], ["(\\d{3})(\\d{3})(\\d)(\\d{2,3})", "$1 $2 $3 $4", ["8"], "0$1"]], "0", 0, 0, 0, 0, 0, [["312(?:5[0-79]\\d|9(?:[0-689]\\d|7[0-24-9]))\\d{3}|(?:3(?:1(?:2[0-46-8]|3[1-9]|47|[56]\\d)|2(?:22|3[0-479]|6[0-7])|4(?:22|5[6-9]|6\\d)|5(?:22|3[4-7]|59|6\\d)|6(?:22|5[35-7]|6\\d)|7(?:22|3[468]|4[1-9]|59|[67]\\d)|9(?:22|4[1-8]|6\\d))|6(?:09|12|2[2-4])\\d)\\d{5}", [9]], ["312(?:58\\d|973)\\d{3}|(?:2(?:0[0-35]|2\\d)|5[0-24-7]\\d|600|7(?:[07]\\d|55)|88[08]|9(?:12|9[05-9]))\\d{6}", [9]], ["800\\d{6,7}"]]], KH: ["855", "00[14-9]", "1\\d{9}|[1-9]\\d{7,8}", [8, 9, 10], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-9]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]]], "0", 0, 0, 0, 0, 0, [["23(?:4(?:[2-4]|[56]\\d)|[568]\\d\\d)\\d{4}|23[236-9]\\d{5}|(?:2[4-6]|3[2-6]|4[2-4]|[5-7][2-5])(?:(?:[237-9]|4[56]|5\\d)\\d{5}|6\\d{5,6})", [8, 9]], ["(?:(?:1[28]|3[18]|9[67])\\d|6[016-9]|7(?:[07-9]|[16]\\d)|8(?:[013-79]|8\\d))\\d{6}|(?:1\\d|9[0-57-9])\\d{6}|(?:2[3-6]|3[2-6]|4[2-4]|[5-7][2-5])48\\d{5}", [8, 9]], ["1800(?:1\\d|2[019])\\d{4}", [10]], ["1900(?:1\\d|2[09])\\d{4}", [10]]]], KI: ["686", "00", "(?:[37]\\d|6[0-79])\\d{6}|(?:[2-48]\\d|50)\\d{3}", [5, 8], 0, "0", 0, 0, 0, 0, 0, [["(?:[24]\\d|3[1-9]|50|65(?:02[12]|12[56]|22[89]|[3-5]00)|7(?:27\\d\\d|3100|5(?:02[12]|12[56]|22[89]|[34](?:00|81)|500))|8[0-5])\\d{3}"], ["(?:6200[01]|7(?:310[1-9]|5(?:02[03-9]|12[0-47-9]|22[0-7]|[34](?:0[1-9]|8[02-9])|50[1-9])))\\d{3}|(?:63\\d\\d|7(?:(?:[0146-9]\\d|2[0-689])\\d|3(?:[02-9]\\d|1[1-9])|5(?:[0-2][013-9]|[34][1-79]|5[1-9]|[6-9]\\d)))\\d{4}", [8]], 0, 0, 0, 0, 0, 0, ["30(?:0[01]\\d\\d|12(?:11|20))\\d\\d", [8]]]], KM: ["269", "00", "[3478]\\d{6}", [7], [["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[3478]"]]], 0, 0, 0, 0, 0, 0, [["7[4-7]\\d{5}"], ["[34]\\d{6}"], 0, ["8\\d{6}"]]], KN: ["1", "011", "(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-7]\\d{6})$|1", "869$1", 0, "869", [["869(?:2(?:29|36)|302|4(?:6[015-9]|70)|56[5-7])\\d{4}"], ["869(?:48[89]|55[6-8]|66\\d|76[02-7])\\d{4}"], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"]]], KP: ["850", "00|99", "85\\d{6}|(?:19\\d|[2-7])\\d{7}", [8, 10], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"], "0$1"], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-7]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:(?:195|2)\\d|3[19]|4[159]|5[37]|6[17]|7[39]|85)\\d{6}"], ["19[1-3]\\d{7}", [10]]]], KR: ["82", "00(?:[125689]|3(?:[46]5|91)|7(?:00|27|3|55|6[126]))", "00[1-9]\\d{8,11}|(?:[12]|5\\d{3})\\d{7}|[13-6]\\d{9}|(?:[1-6]\\d|80)\\d{7}|[3-6]\\d{4,5}|(?:00|7)0\\d{8}", [5, 6, 8, 9, 10, 11, 12, 13, 14], [["(\\d{2})(\\d{3,4})", "$1-$2", ["(?:3[1-3]|[46][1-4]|5[1-5])1"], "0$1"], ["(\\d{4})(\\d{4})", "$1-$2", ["1"]], ["(\\d)(\\d{3,4})(\\d{4})", "$1-$2-$3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["[36]0|8"], "0$1"], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1-$2-$3", ["[1346]|5[1-5]"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1-$2-$3", ["[57]"], "0$1"], ["(\\d{2})(\\d{5})(\\d{4})", "$1-$2-$3", ["5"], "0$1"]], "0", 0, "0(8(?:[1-46-8]|5\\d\\d))?", 0, 0, 0, [["(?:2|3[1-3]|[46][1-4]|5[1-5])[1-9]\\d{6,7}|(?:3[1-3]|[46][1-4]|5[1-5])1\\d{2,3}", [5, 6, 8, 9, 10]], ["1(?:05(?:[0-8]\\d|9[0-6])|22[13]\\d)\\d{4,5}|1(?:0[0-46-9]|[16-9]\\d|2[013-9])\\d{6,7}", [9, 10]], ["00(?:308\\d{6,7}|798\\d{7,9})|(?:00368|[38]0)\\d{7}", [9, 11, 12, 13, 14]], ["60[2-9]\\d{6}", [9]], ["50\\d{8,9}", [10, 11]], 0, ["1(?:5(?:22|33|44|66|77|88|99)|6(?:[07]0|44|6[0168]|88)|8(?:00|33|55|77|99))\\d{4}", [8]], ["15\\d{7,8}", [9, 10]], ["70\\d{8}", [10]]]], KW: ["965", "00", "18\\d{5}|(?:[2569]\\d|41)\\d{6}", [7, 8], [["(\\d{4})(\\d{3,4})", "$1 $2", ["[169]|2(?:[235]|4[1-35-9])|52"]], ["(\\d{3})(\\d{5})", "$1 $2", ["[245]"]]], 0, 0, 0, 0, 0, 0, [["2(?:[23]\\d\\d|4(?:[1-35-9]\\d|44)|5(?:0[034]|[2-46]\\d|5[1-3]|7[1-7]))\\d{4}", [8]], ["(?:41\\d\\d|5(?:(?:[05]\\d|1[0-7]|6[56])\\d|2(?:22|5[25])|7(?:55|77)|88[58])|6(?:(?:0[034679]|5[015-9]|6\\d)\\d|1(?:00|11|6[16])|2[26]2|3[36]3|4[46]4|7(?:0[013-9]|[67]\\d)|8[68]8|9(?:[069]\\d|3[039]))|9(?:(?:[04679]\\d|8[057-9])\\d|1(?:1[01]|99)|2(?:00|2\\d)|3(?:00|3[03])|5(?:00|5\\d)))\\d{4}", [8]], ["18\\d{5}", [7]]]], KY: ["1", "011", "(?:345|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "345$1", 0, "345", [["345(?:2(?:22|3[23]|44|66)|333|444|6(?:23|38|40)|7(?:30|4[35-79]|6[6-9]|77)|8(?:00|1[45]|4[89]|88)|9(?:14|4[035-9]))\\d{4}"], ["345(?:32[1-9]|42[0-4]|5(?:1[67]|2[5-79]|4[6-9]|50|76)|649|82[56]|9(?:1[679]|2[2-9]|3[06-9]|90))\\d{4}"], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["(?:345976|900[2-9]\\d\\d)\\d{4}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"]]], KZ: ["7", "810", "(?:33622|8\\d{8})\\d{5}|[78]\\d{9}", [10, 14], 0, "8", 0, 0, 0, 0, "33|7", [["(?:33622|7(?:1(?:0(?:[23]\\d|4[0-3]|59|63)|1(?:[23]\\d|4[0-79]|59)|2(?:[23]\\d|59)|3(?:2\\d|3[0-79]|4[0-35-9]|59)|4(?:[24]\\d|3[013-9]|5[1-9]|97)|5(?:2\\d|3[1-9]|4[0-7]|59)|6(?:[2-4]\\d|5[19]|61)|72\\d|8(?:[27]\\d|3[1-46-9]|4[0-5]|59))|2(?:1(?:[23]\\d|4[46-9]|5[3469])|2(?:2\\d|3[0679]|46|5[12679])|3(?:[2-4]\\d|5[139])|4(?:2\\d|3[1-35-9]|59)|5(?:[23]\\d|4[0-8]|59|61)|6(?:2\\d|3[1-9]|4[0-4]|59)|7(?:[2379]\\d|40|5[279])|8(?:[23]\\d|4[0-3]|59)|9(?:2\\d|3[124578]|59))))\\d{5}", [10]], ["7(?:0[0-25-8]|47|6[0-4]|7[15-8]|85)\\d{7}", [10]], ["8(?:00|108\\d{3})\\d{7}"], ["809\\d{7}", [10]], ["808\\d{7}", [10]], 0, 0, 0, ["751\\d{7}", [10]]], "8~10"], LA: ["856", "00", "[23]\\d{9}|3\\d{8}|(?:[235-8]\\d|41)\\d{6}", [8, 9, 10], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["2[13]|3[14]|[4-8]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["30[0135-9]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["[23]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:2[13]|[35-7][14]|41|8[1468])\\d{6}", [8]], ["208[78]\\d{6}|(?:20[23579]|30[24])\\d{7}", [10]], 0, 0, 0, 0, ["30[0135-9]\\d{6}", [9]]]], LB: ["961", "00", "[27-9]\\d{7}|[13-9]\\d{6}", [7, 8], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[13-69]|7(?:[2-57]|62|8[0-7]|9[04-9])|8[02-9]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[27-9]"]]], "0", 0, 0, 0, 0, 0, [["7(?:62|8[0-7]|9[04-9])\\d{4}|(?:[14-69]\\d|2(?:[14-69]\\d|[78][1-9])|7[2-57]|8[02-9])\\d{5}"], ["793(?:[01]\\d|2[0-4])\\d{3}|(?:(?:3|81)\\d|7(?:[01]\\d|6[013-9]|8[89]|9[12]))\\d{5}"], 0, ["9[01]\\d{6}", [8]], 0, 0, 0, 0, 0, ["80\\d{6}", [8]]]], LC: ["1", "011", "(?:[58]\\d\\d|758|900)\\d{7}", [10], 0, "1", 0, "([2-8]\\d{6})$|1", "758$1", 0, "758", [["758(?:234|4(?:30|5\\d|6[2-9]|8[0-2])|57[0-2]|(?:63|75)8)\\d{4}"], ["758(?:28[4-7]|384|4(?:6[01]|8[4-9])|5(?:1[89]|20|84)|7(?:1[2-9]|2\\d|3[0-3])|812)\\d{4}"], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"]]], LI: ["423", "00", "[68]\\d{8}|(?:[2378]\\d|90)\\d{5}", [7, 9], [["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[2379]|8(?:0[09]|7)", "[2379]|8(?:0(?:02|9)|7)"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["69"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"]]], "0", 0, "(1001)|0", 0, 0, 0, [["(?:2(?:01|1[27]|2[02]|3\\d|6[02-578]|96)|3(?:[24]0|33|7[0135-7]|8[048]|9[0269]))\\d{4}", [7]], ["(?:6(?:(?:4[5-9]|5[0-469])\\d|6(?:[024-6]\\d|[17]0|3[7-9]))\\d|7(?:[37-9]\\d|42|56))\\d{4}"], ["8002[28]\\d\\d|80(?:05\\d|9)\\d{4}"], ["90(?:02[258]|1(?:23|3[14])|66[136])\\d\\d", [7]], 0, ["697(?:42|56|[78]\\d)\\d{4}", [9]], ["870(?:28|87)\\d\\d", [7]]]], LK: ["94", "00", "[1-9]\\d{8}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[1-689]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:12[2-9]|602|8[12]\\d|9(?:1\\d|22|9[245]))\\d{6}|(?:11|2[13-7]|3[1-8]|4[157]|5[12457]|6[35-7])[2-57]\\d{6}"], ["7(?:[0-25-8]\\d|4[0-4])\\d{6}"], 0, 0, 0, 0, ["1973\\d{5}"]]], LR: ["231", "00", "(?:[245]\\d|33|77|88)\\d{7}|(?:2\\d|[4-6])\\d{6}", [7, 8, 9], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["4[67]|[56]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-578]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["2\\d{7}", [8]], ["(?:(?:(?:22|33)0|555|(?:77|88)\\d)\\d|4(?:240|[67]))\\d{5}|[56]\\d{6}", [7, 9]], 0, ["332(?:02|[34]\\d)\\d{4}", [9]]]], LS: ["266", "00", "(?:[256]\\d\\d|800)\\d{5}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[2568]"]]], 0, 0, 0, 0, 0, 0, [["2\\d{7}"], ["[56]\\d{7}"], ["800[1256]\\d{4}"]]], LT: ["370", "00", "(?:[3469]\\d|52|[78]0)\\d{6}", [8], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["52[0-7]"], "(0-$1)", 1], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[7-9]"], "0 $1", 1], ["(\\d{2})(\\d{6})", "$1 $2", ["37|4(?:[15]|6[1-8])"], "(0-$1)", 1], ["(\\d{3})(\\d{5})", "$1 $2", ["[3-6]"], "(0-$1)", 1]], "0", 0, "[08]", 0, 0, 0, [["(?:3[1478]|4[124-6]|52)\\d{6}"], ["6\\d{7}"], ["80[02]\\d{5}"], ["9(?:0[0239]|10)\\d{5}"], ["70[05]\\d{5}"], 0, ["70[67]\\d{5}"], 0, ["[89]01\\d{5}"], ["808\\d{5}"]]], LU: ["352", "00", "35[013-9]\\d{4,8}|6\\d{8}|35\\d{2,4}|(?:[2457-9]\\d|3[0-46-9])\\d{2,9}", [4, 5, 6, 7, 8, 9, 10, 11], [["(\\d{2})(\\d{3})", "$1 $2", ["2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"]], ["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"]], ["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["20[2-689]"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})", "$1 $2 $3 $4", ["2(?:[0367]|4[3-8])"]], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["80[01]|90[015]"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["20"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})", "$1 $2 $3 $4 $5", ["2(?:[0367]|4[3-8])"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{1,5})", "$1 $2 $3 $4", ["[3-57]|8[13-9]|9(?:0[89]|[2-579])|(?:2|80)[2-9]"]]], 0, 0, "(15(?:0[06]|1[12]|[35]5|4[04]|6[26]|77|88|99)\\d)", 0, 0, 0, [["(?:35[013-9]|80[2-9]|90[89])\\d{1,8}|(?:2[2-9]|3[0-46-9]|[457]\\d|8[13-9]|9[2-579])\\d{2,9}"], ["6(?:[269][18]|5[1568]|7[189]|81)\\d{6}", [9]], ["800\\d{5}", [8]], ["90[015]\\d{5}", [8]], 0, 0, 0, 0, ["20(?:1\\d{5}|[2-689]\\d{1,7})", [4, 5, 6, 7, 8, 9, 10]], ["801\\d{5}", [8]]]], LV: ["371", "00", "(?:[268]\\d|90)\\d{6}", [8], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[269]|8[01]"]]], 0, 0, 0, 0, 0, 0, [["6\\d{7}"], ["2333[0-8]\\d{3}|2(?:[0-24-9]\\d\\d|3(?:0[07]|[14-9]\\d|2[02-9]|3[0-24-9]))\\d{4}"], ["80\\d{6}"], ["90\\d{6}"], 0, 0, 0, 0, 0, ["81\\d{6}"]]], LY: ["218", "00", "[2-9]\\d{8}", [9], [["(\\d{2})(\\d{7})", "$1-$2", ["[2-9]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:2(?:0[56]|[1-6]\\d|7[124579]|8[124])|3(?:1\\d|2[2356])|4(?:[17]\\d|2[1-357]|5[2-4]|8[124])|5(?:[1347]\\d|2[1-469]|5[13-5]|8[1-4])|6(?:[1-479]\\d|5[2-57]|8[1-5])|7(?:[13]\\d|2[13-79])|8(?:[124]\\d|5[124]|84))\\d{6}"], ["9[1-6]\\d{7}"]]], MA: ["212", "00", "[5-8]\\d{8}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["5[45]"], "0$1"], ["(\\d{4})(\\d{5})", "$1-$2", ["5(?:2[2-46-9]|3[3-9]|9)|8(?:0[89]|92)"], "0$1"], ["(\\d{2})(\\d{7})", "$1-$2", ["8"], "0$1"], ["(\\d{3})(\\d{6})", "$1-$2", ["[5-7]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["5(?:2(?:[0-25-79]\\d|3[1-578]|4[02-46-8]|8[0235-7])|3(?:[0-47]\\d|5[02-9]|6[02-8]|8[014-9]|9[3-9])|(?:4[067]|5[03])\\d)\\d{5}"], ["(?:6(?:[0-79]\\d|8[0-247-9])|7(?:[0167]\\d|2[0-467]|5[0-3]|8[0-5]))\\d{6}"], ["80[0-7]\\d{6}"], ["89\\d{7}"], 0, 0, 0, 0, ["(?:592(?:4[0-2]|93)|80[89]\\d\\d)\\d{4}"]]], MC: ["377", "00", "(?:[3489]|6\\d)\\d{7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["4"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[389]"]], ["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["6"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:870|9[2-47-9]\\d)\\d{5}", [8]], ["4(?:[469]\\d|5[1-9])\\d{5}|(?:3|6\\d)\\d{7}"], ["(?:800|90\\d)\\d{5}", [8]]]], MD: ["373", "00", "(?:[235-7]\\d|[89]0)\\d{6}", [8], [["(\\d{3})(\\d{5})", "$1 $2", ["[89]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["22|3"], "0$1"], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[25-7]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:(?:2[1-9]|3[1-79])\\d|5(?:33|5[257]))\\d{5}"], ["562\\d{5}|(?:6\\d|7[16-9])\\d{6}"], ["800\\d{5}"], ["90[056]\\d{5}"], 0, 0, ["803\\d{5}"], 0, ["3[08]\\d{6}"], ["808\\d{5}"]]], ME: ["382", "00", "(?:20|[3-79]\\d)\\d{6}|80\\d{6,7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-9]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:20[2-8]|3(?:[0-2][2-7]|3[24-7])|4(?:0[2-467]|1[2467])|5(?:0[2467]|1[24-7]|2[2-467]))\\d{5}", [8]], ["6(?:[07-9]\\d|3[024]|6[0-25])\\d{5}", [8]], ["80(?:[0-2578]|9\\d)\\d{5}"], ["9(?:4[1568]|5[178])\\d{5}", [8]], 0, 0, ["77[1-9]\\d{5}", [8]], 0, ["78[1-49]\\d{5}", [8]]]], MF: ["590", "00", "(?:590\\d|7090)\\d{5}|(?:69|80|9\\d)\\d{7}", [9], 0, "0", 0, 0, 0, 0, 0, [["590(?:0[079]|[14]3|[27][79]|3[03-7]|5[0-268]|87)\\d{4}"], ["(?:69(?:0\\d\\d|1(?:2[2-9]|3[0-5])|4(?:0[89]|1[2-6]|9\\d)|6(?:1[016-9]|5[0-4]|[67]\\d))|7090[0-4])\\d{4}"], ["80[0-5]\\d{6}"], 0, 0, 0, 0, 0, ["9(?:(?:39[5-7]|76[018])\\d|475[0-6])\\d{4}"]]], MG: ["261", "00", "[23]\\d{8}", [9], [["(\\d{2})(\\d{2})(\\d{3})(\\d{2})", "$1 $2 $3 $4", ["[23]"], "0$1"]], "0", 0, "([24-9]\\d{6})$|0", "20$1", 0, 0, [["2072[29]\\d{4}|20(?:2\\d|4[47]|5[3467]|6[279]|7[356]|8[268]|9[2457])\\d{5}"], ["3[2-47-9]\\d{7}"], 0, 0, 0, 0, 0, 0, ["22\\d{7}"]]], MH: ["692", "011", "329\\d{4}|(?:[256]\\d|45)\\d{5}", [7], [["(\\d{3})(\\d{4})", "$1-$2", ["[2-6]"]]], "1", 0, 0, 0, 0, 0, [["(?:247|528|625)\\d{4}"], ["(?:(?:23|54)5|329|45[35-8])\\d{4}"], 0, 0, 0, 0, 0, 0, ["635\\d{4}"]]], MK: ["389", "00", "[2-578]\\d{7}", [8], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["2|34[47]|4(?:[37]7|5[47]|64)"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[347]"], "0$1"], ["(\\d{3})(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[58]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:(?:2(?:62|77)0|3444)\\d|4[56]440)\\d{3}|(?:34|4[357])700\\d{3}|(?:2(?:[0-3]\\d|5[0-578]|6[01]|82)|3(?:1[3-68]|[23][2-68]|4[23568])|4(?:[23][2-68]|4[3-68]|5[2568]|6[25-8]|7[24-68]|8[4-68]))\\d{5}"], ["7(?:3555|(?:474|9[019]7)7)\\d{3}|7(?:[0-25-8]\\d\\d|3(?:[1-478]\\d|6[01])|4(?:2\\d|60|7[01578])|9(?:[2-4]\\d|5[01]|7[015]))\\d{4}"], ["800\\d{5}"], ["5\\d{7}"], 0, 0, 0, 0, 0, ["8(?:0[1-9]|[1-9]\\d)\\d{5}"]]], ML: ["223", "00", "[24-9]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24-9]"]]], 0, 0, 0, 0, 0, 0, [["2(?:07[0-8]|12[67])\\d{4}|(?:2(?:02|1[4-689])|4(?:0[0-4]|4[1-59]))\\d{5}"], ["2(?:0(?:01|79)|17\\d)\\d{4}|(?:5[01]|[679]\\d|8[2-59])\\d{6}"], ["80\\d{6}"]]], MM: ["95", "00", "1\\d{5,7}|95\\d{6}|(?:[4-7]|9[0-46-9])\\d{6,8}|(?:2|8\\d)\\d{5,8}", [6, 7, 8, 9, 10], [["(\\d)(\\d{2})(\\d{3})", "$1 $2 $3", ["16|2"], "0$1"], ["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["4(?:[2-46]|5[3-5])|5|6(?:[1-689]|7[235-7])|7(?:[0-4]|5[2-7])|8[1-5]|(?:60|86)[23]"], "0$1"], ["(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[12]|452|678|86", "[12]|452|6788|86"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[4-7]|8[1-35]"], "0$1"], ["(\\d)(\\d{3})(\\d{4,6})", "$1 $2 $3", ["9(?:2[0-4]|[35-9]|4[137-9])"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"], "0$1"], ["(\\d)(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["92"], "0$1"], ["(\\d)(\\d{5})(\\d{4})", "$1 $2 $3", ["9"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:1(?:(?:12|[28]\\d|3[56]|7[3-6]|9[0-6])\\d|4(?:2[29]|62|7[0-2]|83)|6)|2(?:2(?:00|8[34])|4(?:0\\d|[26]2|7[0-2]|83)|51\\d\\d)|4(?:2(?:2\\d\\d|48[013])|3(?:20\\d|4(?:70|83)|56)|420\\d|5(?:2\\d|470))|6(?:0(?:[23]|88\\d)|(?:124|[56]2\\d)\\d|2472|3(?:20\\d|470)|4(?:2[04]\\d|472)|7(?:3\\d\\d|4[67]0|8(?:[01459]\\d|8))))\\d{4}|5(?:2(?:2\\d{5,6}|47[02]\\d{4})|(?:3472|4(?:2(?:1|86)|470)|522\\d|6(?:20\\d|483)|7(?:20\\d|48[01])|8(?:20\\d|47[02])|9(?:20\\d|470))\\d{4})|7(?:(?:0470|4(?:25\\d|470)|5(?:202|470|96\\d))\\d{4}|1(?:20\\d{4,5}|4(?:70|83)\\d{4}))|8(?:1(?:2\\d{5,6}|4(?:10|7[01]\\d)\\d{3})|2(?:2\\d{5,6}|(?:320|490\\d)\\d{3})|(?:3(?:2\\d\\d|470)|4[24-7]|5(?:(?:2\\d|51)\\d|4(?:[1-35-9]\\d|4[0-57-9]))|6[23])\\d{4})|(?:1[2-6]\\d|4(?:2[24-8]|3[2-7]|[46][2-6]|5[3-5])|5(?:[27][2-8]|3[2-68]|4[24-8]|5[23]|6[2-4]|8[24-7]|9[2-7])|6(?:[19]20|42[03-6]|(?:52|7[45])\\d)|7(?:[04][24-8]|[15][2-7]|22|3[2-4])|8(?:1[2-689]|2[2-8]|(?:[35]2|64)\\d))\\d{4}|25\\d{5,6}|(?:2[2-9]|6(?:1[2356]|[24][2-6]|3[24-6]|5[2-4]|6[2-8]|7[235-7]|8[245]|9[24])|8(?:3[24]|5[245]))\\d{4}", [6, 7, 8, 9]], ["(?:17[01]|9(?:2(?:[0-4]|[56]\\d\\d)|(?:3(?:[0-36]|4\\d)|(?:6\\d|8[89]|9[4-8])\\d|7(?:3|40|[5-9]\\d))\\d|4(?:(?:[0245]\\d|[1379])\\d|88)|5[0-6])\\d)\\d{4}|9[69]1\\d{6}|9(?:[68]\\d|9[089])\\d{5}", [7, 8, 9, 10]], ["80080(?:0[1-9]|2\\d)\\d{3}", [10]], 0, 0, 0, 0, 0, ["1333\\d{4}", [8]]]], MN: ["976", "001", "[12]\\d{7,9}|[5-9]\\d{7}", [8, 9, 10], [["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["[12]1"], "0$1"], ["(\\d{4})(\\d{4})", "$1 $2", ["[5-9]"]], ["(\\d{3})(\\d{5,6})", "$1 $2", ["[12]2[1-3]"], "0$1"], ["(\\d{4})(\\d{5,6})", "$1 $2", ["[12](?:27|3[2-8]|4[2-68]|5[1-4689])", "[12](?:27|3[2-8]|4[2-68]|5[1-4689])[0-3]"], "0$1"], ["(\\d{5})(\\d{4,5})", "$1 $2", ["[12]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["[12]2[1-3]\\d{5,6}|(?:(?:[12](?:1|27)|5[368])\\d\\d|7(?:0(?:[0-5]\\d|7[078]|80)|128))\\d{4}|[12](?:3[2-8]|4[2-68]|5[1-4689])\\d{6,7}"], ["(?:83[01]|92[039])\\d{5}|(?:5[05]|6[069]|72|8[015689]|9[013-9])\\d{6}", [8]], 0, 0, 0, 0, 0, 0, ["712[0-79]\\d{4}|7(?:1[013-9]|[5-9]\\d)\\d{5}", [8]]]], MO: ["853", "00", "0800\\d{3}|(?:28|[68]\\d)\\d{6}", [7, 8], [["(\\d{4})(\\d{3})", "$1 $2", ["0"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[268]"]]], 0, 0, 0, 0, 0, 0, [["(?:28[2-9]|8(?:11|[2-57-9]\\d))\\d{5}", [8]], ["6800[0-79]\\d{3}|6(?:[235]\\d\\d|6(?:0[0-5]|[1-9]\\d)|8(?:0[1-9]|[14-8]\\d|2[5-9]|[39][0-4]))\\d{4}", [8]], ["0800\\d{3}", [7]]]], MP: ["1", "011", "[58]\\d{9}|(?:67|90)0\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "670$1", 0, "670", [["670(?:2(?:3[3-7]|56|8[4-8])|32[1-38]|4(?:33|8[348])|5(?:32|55|88)|6(?:64|70|82)|78[3589]|8[3-9]8|989)\\d{4}"], [""], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"]]], MQ: ["596", "00", "(?:596\\d|7091)\\d{5}|(?:69|[89]\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-79]|8(?:0[6-9]|[36])"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:596(?:[03-7]\\d|1[05]|2[7-9]|8[0-39]|9[04-9])|80[6-9]\\d\\d|9(?:477[6-9]|767[4589]))\\d{4}"], ["(?:69[67]\\d\\d|7091[0-3])\\d{4}"], ["80[0-5]\\d{6}"], ["8[129]\\d{7}"], 0, 0, 0, 0, ["9(?:397[0-3]|477[0-5]|76(?:6\\d|7[0-367]))\\d{4}"]]], MR: ["222", "00", "(?:[2-4]\\d\\d|800)\\d{5}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-48]"]]], 0, 0, 0, 0, 0, 0, [["(?:25[08]|35\\d|45[1-7])\\d{5}"], ["[2-4][0-46-9]\\d{6}"], ["800\\d{5}"]]], MS: ["1", "011", "(?:[58]\\d\\d|664|900)\\d{7}", [10], 0, "1", 0, "([34]\\d{6})$|1", "664$1", 0, "664", [["6644(?:1[0-3]|91)\\d{4}"], ["664(?:3(?:49|9[1-6])|49[2-6])\\d{4}"], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"]]], MT: ["356", "00", "3550\\d{4}|(?:[2579]\\d\\d|800)\\d{5}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[2357-9]"]]], 0, 0, 0, 0, 0, 0, [["20(?:3[1-4]|6[059])\\d{4}|2(?:0[19]|[1-357]\\d|60)\\d{5}"], ["(?:7(?:210|[79]\\d\\d)|9(?:[29]\\d\\d|69[67]|8(?:1[1-3]|89|97)))\\d{4}"], ["800(?:02|[3467]\\d)\\d{3}"], ["5(?:0(?:0(?:37|43)|(?:6\\d|70|9[0168])\\d)|[12]\\d0[1-5])\\d{3}"], 0, 0, ["501\\d{5}"], ["7117\\d{4}"], ["3550\\d{4}"]]], MU: ["230", "0(?:0|[24-7]0|3[03])", "(?:[57]|8\\d\\d)\\d{7}|[2-468]\\d{6}", [7, 8, 10], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-46]|8[013]"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[57]"]], ["(\\d{5})(\\d{5})", "$1 $2", ["8"]]], 0, 0, 0, 0, 0, 0, [["(?:2(?:[0346-8]\\d|1[0-7])|4(?:[013568]\\d|2[4-8]|71|90)|54(?:[3-5]\\d|71)|6\\d\\d|8(?:14|3[129]))\\d{4}", [7, 8]], ["5(?:4(?:2[1-389]|7[1-9])|87[15-8])\\d{4}|(?:5(?:2[5-9]|4[3-689]|[57]\\d|8[0-689]|9[0-8])|7(?:0[0-4]|3[013]))\\d{5}", [8]], ["802\\d{7}|80[0-2]\\d{4}", [7, 10]], ["30\\d{5}", [7]], 0, 0, 0, 0, ["3(?:20|9\\d)\\d{4}", [7]]], "020"], MV: ["960", "0(?:0|19)", "(?:800|9[0-57-9]\\d)\\d{7}|[34679]\\d{6}", [7, 10], [["(\\d{3})(\\d{4})", "$1-$2", ["[34679]"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[89]"]]], 0, 0, 0, 0, 0, 0, [["(?:3(?:0[0-4]|3[0-59])|6(?:[58][024689]|6[024-68]|7[02468]))\\d{4}", [7]], ["(?:46[46]|[79]\\d\\d)\\d{4}", [7]], ["800\\d{7}", [10]], ["900\\d{7}", [10]], 0, 0, ["4(?:0[01]|50)\\d{4}", [7]]], "00"], MW: ["265", "00", "(?:[1289]\\d|31|77)\\d{7}|1\\d{6}", [7, 9], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["1[2-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[137-9]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:1[2-9]|2[12]\\d\\d)\\d{5}"], ["111\\d{6}|(?:31|77|[89][89])\\d{7}", [9]]]], MX: ["52", "0[09]", "[2-9]\\d{9}", [10], [["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["33|5[56]|81"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-9]"]]], 0, 0, 0, 0, 0, 0, [["657[12]\\d{6}|(?:2(?:0[01]|2\\d|3[1-35-8]|4[13-9]|7[1-689]|8[1-578]|9[467])|3(?:1[1-79]|[2458][1-9]|3\\d|7[1-8]|9[1-5])|4(?:1[1-57-9]|[267][1-9]|3[1-8]|[45]\\d|8[1-35-9]|9[2-689])|5(?:[56]\\d|88|9[1-79])|6(?:1[2-68]|[2-4][1-9]|5[1-3689]|6[0-57-9]|7[1-7]|8[67]|9[4-8])|7(?:[1346][1-9]|[27]\\d|5[13-9]|8[1-69]|9[17])|8(?:1\\d|2[13-689]|3[1-6]|4[124-6]|6[1246-9]|7[0-378]|9[12479])|9(?:1[346-9]|2[1-4]|3[2-46-8]|5[1348]|[69]\\d|7[12]|8[1-8]))\\d{7}"], ["657[12]\\d{6}|(?:2(?:2\\d|3[1-35-8]|4[13-9]|7[1-689]|8[1-578]|9[467])|3(?:1[1-79]|[2458][1-9]|3\\d|7[1-8]|9[1-5])|4(?:1[1-57-9]|[267][1-9]|3[1-8]|[45]\\d|8[1-35-9]|9[2-689])|5(?:[56]\\d|88|9[1-79])|6(?:1[2-68]|[2-4][1-9]|5[1-3689]|6[0-57-9]|7[1-7]|8[67]|9[4-8])|7(?:[1346][1-9]|[27]\\d|5[13-9]|8[1-69]|9[17])|8(?:1\\d|2[13-689]|3[1-6]|4[124-6]|6[1246-9]|7[0-378]|9[12479])|9(?:1[346-9]|2[1-4]|3[2-46-8]|5[1348]|[69]\\d|7[12]|8[1-8]))\\d{7}"], ["8(?:00|88)\\d{7}"], ["900\\d{7}"], ["500\\d{7}"], 0, 0, 0, 0, ["300\\d{7}"]], "00"], MY: ["60", "00", "1\\d{8,9}|(?:3\\d|[4-9])\\d{7}", [8, 9, 10], [["(\\d)(\\d{3})(\\d{4})", "$1-$2 $3", ["[4-79]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1-$2 $3", ["1(?:[02469]|[378][1-9]|53)|8", "1(?:[02469]|[37][1-9]|53|8(?:[1-46-9]|5[7-9]))|8"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1-$2 $3", ["3"], "0$1"], ["(\\d)(\\d{3})(\\d{2})(\\d{4})", "$1-$2-$3-$4", ["1(?:[367]|80)"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2 $3", ["15"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1-$2 $3", ["1"], "0$1"]], "0", 0, 0, 0, 0, 0, [["4270\\d{4}|(?:3(?:2[0-36-9]|3[0-368]|4[0-278]|5[0-24-8]|6[0-467]|7[1246-9]|8\\d|9[0-57])\\d|4(?:2[0-689]|[3-79]\\d|8[1-35689])|5(?:2[0-589]|[3468]\\d|5[0-489]|7[1-9]|9[23])|6(?:2[2-9]|3[1357-9]|[46]\\d|5[0-6]|7[0-35-9]|85|9[015-8])|7(?:[2579]\\d|3[03-68]|4[0-8]|6[5-9]|8[0-35-9])|8(?:[24][2-8]|3[2-5]|5[2-7]|6[2-589]|7[2-578]|[89][2-9])|9(?:0[57]|13|[25-7]\\d|[3489][0-8]))\\d{5}", [8, 9]], ["1(?:1888[689]|4400|8(?:47|8[27])[0-4])\\d{4}|1(?:0(?:[23568]\\d|4[0-6]|7[016-9]|9[0-8])|1(?:[1-5]\\d\\d|6(?:0[5-9]|[1-9]\\d)|7(?:[0-4]\\d|5[0-7]))|(?:[269]\\d|[37][1-9]|4[235-9])\\d|5(?:31|9\\d\\d)|8(?:1[23]|[236]\\d|4[06]|5(?:46|[7-9])|7[016-9]|8[01]|9[0-8]))\\d{5}", [9, 10]], ["1[378]00\\d{6}", [10]], ["1600\\d{6}", [10]], 0, 0, 0, 0, ["15(?:4(?:6[0-4]\\d|8(?:0[125]|[17]\\d|21|3[01]|4[01589]|5[014]|6[02]))|6(?:32[0-6]|78\\d))\\d{4}", [10]]]], MZ: ["258", "00", "(?:2|8\\d)\\d{7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2|8[2-79]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]]], 0, 0, 0, 0, 0, 0, [["2(?:[1346]\\d|5[0-2]|[78][12]|93)\\d{5}", [8]], ["8[2-79]\\d{7}", [9]], ["800\\d{6}", [9]]]], NA: ["264", "00", "[68]\\d{7,8}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["88"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["6"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["87"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"], "0$1"]], "0", 0, 0, 0, 0, 0, [["64426\\d{3}|6(?:1(?:2[2-7]|3[01378]|4[0-4])|254|32[0237]|4(?:27|41|5[25])|52[236-8]|626|7(?:2[2-4]|30))\\d{4,5}|6(?:1(?:(?:0\\d|2[0189]|3[24-69]|4[5-9])\\d|17|69|7[014])|2(?:17|5[0-36-8]|69|70)|3(?:17|2[14-689]|34|6[289]|7[01]|81)|4(?:17|2[0-2]|4[06]|5[0137]|69|7[01])|5(?:17|2[0459]|69|7[01])|6(?:17|25|38|42|69|7[01])|7(?:17|2[569]|3[13]|6[89]|7[01]))\\d{4}"], ["(?:60|8[1245])\\d{7}", [9]], ["80\\d{7}", [9]], ["8701\\d{5}", [9]], 0, 0, 0, 0, ["8(?:3\\d\\d|86)\\d{5}"]]], NC: ["687", "00", "(?:050|[2-57-9]\\d\\d)\\d{3}", [6], [["(\\d{2})(\\d{2})(\\d{2})", "$1.$2.$3", ["[02-57-9]"]]], 0, 0, 0, 0, 0, 0, [["(?:2[03-9]|3[0-5]|4[1-7]|88)\\d{4}"], ["(?:[579]\\d|8[0-79])\\d{4}"], ["050\\d{3}"], ["36\\d{4}"]]], NE: ["227", "00", "[027-9]\\d{7}", [8], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["08"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[089]|2[013]|7[0467]"]]], 0, 0, 0, 0, 0, 0, [["2(?:0(?:20|3[1-8]|4[13-5]|5[14]|6[14578]|7[1-578])|1(?:4[145]|5[14]|6[14-68]|7[169]|88))\\d{4}"], ["(?:23|7[0467]|[89]\\d)\\d{6}"], ["08\\d{6}"], ["09\\d{6}"]]], NF: ["672", "00", "[13]\\d{5}", [6], [["(\\d{2})(\\d{4})", "$1 $2", ["1[0-3]"]], ["(\\d)(\\d{5})", "$1 $2", ["[13]"]]], 0, 0, "([0-258]\\d{4})$", "3$1", 0, 0, [["(?:1(?:06|17|28|39)|3[0-2]\\d)\\d{3}"], ["(?:14|3[58])\\d{4}"]]], NG: ["234", "009", "38\\d{6}|[78]\\d{9,13}|(?:20|9\\d)\\d{8}", [8, 10, 11, 12, 13, 14], [["(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["3"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[7-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["20[129]"], "0$1"], ["(\\d{4})(\\d{2})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{3})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["[78]"], "0$1"], ["(\\d{3})(\\d{5})(\\d{5,6})", "$1 $2 $3", ["[78]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:20(?:[1259]\\d|3[013-9]|4[1-8]|6[024-689]|7[1-79]|8[2-9])|38)\\d{6}", [8, 10]], ["(?:702[0-24-9]|819[01])\\d{6}|(?:7(?:0[13-9]|[12]\\d)|8(?:0[1-9]|1[0-8])|9(?:0[1-9]|1[1-6]))\\d{7}", [10]], ["800\\d{7,11}", [10, 11, 12, 13, 14]], 0, 0, 0, ["700\\d{7,11}", [10, 11, 12, 13, 14]]]], NI: ["505", "00", "(?:1800|[25-8]\\d{3})\\d{4}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[125-8]"]]], 0, 0, 0, 0, 0, 0, [["2\\d{7}"], ["(?:5(?:5[0-7]|[78]\\d)|6(?:20|3[035]|4[045]|5[05]|77|8[1-9]|9[059])|(?:7[5-8]|8\\d)\\d)\\d{5}"], ["1800\\d{4}"]]], NL: ["31", "00", "(?:[124-7]\\d\\d|3(?:[02-9]\\d|1[0-8]))\\d{6}|8\\d{6,9}|9\\d{6,10}|1\\d{4,5}", [5, 6, 7, 8, 9, 10, 11], [["(\\d{3})(\\d{4,7})", "$1 $2", ["[89]0"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["66"], "0$1"], ["(\\d)(\\d{8})", "$1 $2", ["6"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["1[16-8]|2[259]|3[124]|4[17-9]|5[124679]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-578]|91"], "0$1"], ["(\\d{3})(\\d{3})(\\d{5})", "$1 $2 $3", ["9"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:1(?:[035]\\d|1[13-578]|6[124-8]|7[24]|8[0-467])|2(?:[0346]\\d|2[2-46-9]|5[125]|9[479])|3(?:[03568]\\d|1[3-8]|2[01]|4[1-8])|4(?:[0356]\\d|1[1-368]|7[58]|8[15-8]|9[23579])|5(?:[0358]\\d|[19][1-9]|2[1-57-9]|4[13-8]|6[126]|7[0-3578])|7\\d\\d)\\d{6}", [9]], ["(?:6[1-58]|970\\d)\\d{7}", [9, 11]], ["800\\d{4,7}", [7, 8, 9, 10]], ["90[069]\\d{4,7}", [7, 8, 9, 10]], 0, 0, ["140(?:1[035]|2[0346]|3[03568]|4[0356]|5[0358]|8[458])|(?:140(?:1[16-8]|2[259]|3[124]|4[17-9]|5[124679]|7)|8[478]\\d{6})\\d", [5, 6, 9]], ["66\\d{7}", [9]], ["(?:85|91)\\d{7}", [9]]]], NO: ["47", "00", "(?:0|[2-9]\\d{3})\\d{4}", [5, 8], [["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["8"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-79]"]]], 0, 0, 0, 0, 0, "[02-689]|7[0-8]", [["(?:2[1-4]|3[1-3578]|5[1-35-7]|6[1-4679]|7[0-8])\\d{6}", [8]], ["(?:4[015-8]|9\\d)\\d{6}", [8]], ["80[01]\\d{5}", [8]], ["82[09]\\d{5}", [8]], ["880\\d{5}", [8]], ["81[23]\\d{5}", [8]], ["(?:0[235-9]|81(?:0(?:0[7-9]|1\\d)|5\\d\\d))\\d{3}"], 0, ["85[0-5]\\d{5}", [8]], ["810(?:0[0-6]|[2-8]\\d)\\d{3}", [8]]]], NP: ["977", "00", "(?:1\\d|9)\\d{9}|[1-9]\\d{7}", [8, 10, 11], [["(\\d)(\\d{7})", "$1-$2", ["1[2-6]"], "0$1"], ["(\\d{2})(\\d{6})", "$1-$2", ["1[01]|[2-8]|9(?:[1-59]|[67][2-6])"], "0$1"], ["(\\d{3})(\\d{7})", "$1-$2", ["9"]]], "0", 0, 0, 0, 0, 0, [["(?:1[0-6]\\d|99[02-6])\\d{5}|(?:2[13-79]|3[135-8]|4[146-9]|5[135-7]|6[13-9]|7[15-9]|8[1-46-9]|9[1-7])[2-6]\\d{5}", [8]], ["9(?:00|6[0-3]|7[024-6]|8[0-24-68])\\d{7}", [10]], ["1(?:66001|800\\d\\d)\\d{5}", [11]]]], NR: ["674", "00", "(?:444|(?:55|8\\d)\\d|666)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[4-68]"]]], 0, 0, 0, 0, 0, 0, [["444\\d{4}"], ["(?:55[3-9]|666|8\\d\\d)\\d{4}"]]], NU: ["683", "00", "(?:[4-7]|888\\d)\\d{3}", [4, 7], [["(\\d{3})(\\d{4})", "$1 $2", ["8"]]], 0, 0, 0, 0, 0, 0, [["[47]\\d{3}", [4]], ["(?:[56]|888[1-9])\\d{3}"]]], NZ: ["64", "0(?:0|161)", "[1289]\\d{9}|50\\d{5}(?:\\d{2,3})?|[27-9]\\d{7,8}|(?:[34]\\d|6[0-35-9])\\d{6}|8\\d{4,6}", [5, 6, 7, 8, 9, 10], [["(\\d{2})(\\d{3,8})", "$1 $2", ["8[1-79]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["50[036-8]|8|90", "50(?:[0367]|88)|8|90"], "0$1"], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["24|[346]|7[2-57-9]|9[2-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2(?:10|74)|[589]"], "0$1"], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["1|2[028]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,5})", "$1 $2 $3", ["2(?:[169]|7[0-35-9])|7"], "0$1"]], "0", 0, 0, 0, 0, 0, [["240\\d{5}|(?:3[2-79]|[49][2-9]|6[235-9]|7[2-57-9])\\d{6}", [8]], ["2(?:[0-27-9]\\d|6)\\d{6,7}|2(?:1\\d|75)\\d{5}", [8, 9, 10]], ["508\\d{6,7}|80\\d{6,8}", [8, 9, 10]], ["(?:1[13-57-9]\\d{5}|50(?:0[08]|30|66|77|88))\\d{3}|90\\d{6,8}", [7, 8, 9, 10]], ["70\\d{7}", [9]], 0, ["8(?:1[16-9]|22|3\\d|4[045]|5[459]|6[235-9]|7[0-3579]|90)\\d{2,7}"]], "00"], OM: ["968", "00", "(?:1505|[279]\\d{3}|500)\\d{4}|800\\d{5,6}", [7, 8, 9], [["(\\d{3})(\\d{4,6})", "$1 $2", ["[58]"]], ["(\\d{2})(\\d{6})", "$1 $2", ["2"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[179]"]]], 0, 0, 0, 0, 0, 0, [["2[1-6]\\d{6}", [8]], ["(?:1505|90[1-9]\\d)\\d{4}|(?:7[126-9]|9[1-9])\\d{6}", [8]], ["8007\\d{4,5}|(?:500|800[05])\\d{4}"], ["900\\d{5}", [8]]]], PA: ["507", "00", "(?:00800|8\\d{3})\\d{6}|[68]\\d{7}|[1-57-9]\\d{6}", [7, 8, 10, 11], [["(\\d{3})(\\d{4})", "$1-$2", ["[1-57-9]"]], ["(\\d{4})(\\d{4})", "$1-$2", ["[68]"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]]], 0, 0, 0, 0, 0, 0, [["(?:1(?:0\\d|1[479]|2[37]|3[0137]|4[17]|5[05]|6[058]|7[0167]|8[2358]|9[1389])|2(?:[0235-79]\\d|1[0-7]|4[013-9]|8[02-9])|3(?:[07-9]\\d|1[0-7]|2[0-5]|33|4[0-79]|5[0-35]|6[068])|4(?:00|3[0-579]|4\\d|7[0-57-9])|5(?:[01]\\d|2[0-7]|[56]0|79)|7(?:0[09]|2[0-26-8]|3[03]|4[04]|5[05-9]|6[0156]|7[0-24-9]|8[5-9]|90)|8(?:09|2[89]|3\\d|4[0-24-689]|5[014]|8[02])|9(?:0[5-9]|1[0135-8]|2[036-9]|3[35-79]|40|5[0457-9]|6[05-9]|7[04-9]|8[35-8]|9\\d))\\d{4}", [7]], ["(?:1[16]1|21[89]|6\\d{3}|8(?:1[01]|7[23]))\\d{4}", [7, 8]], ["800\\d{4,5}|(?:00800|800\\d)\\d{6}"], ["(?:8(?:22|55|60|7[78]|86)|9(?:00|81))\\d{4}", [7]]]], PE: ["51", "00|19(?:1[124]|77|90)00", "(?:[14-8]|9\\d)\\d{7}", [8, 9], [["(\\d{3})(\\d{5})", "$1 $2", ["80"], "(0$1)"], ["(\\d)(\\d{7})", "$1 $2", ["1"], "(0$1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["[4-8]"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"]]], "0", 0, 0, 0, 0, 0, [["(?:(?:(?:4[34]|5[14])[0-8]|687)\\d|7(?:173|(?:3[0-8]|55)\\d)|8(?:10[05689]|6(?:0[06-9]|1[6-9]|29)|7(?:0[0569]|[56]0)))\\d{4}|(?:1[0-8]|4[12]|5[236]|6[1-7]|7[246]|8[2-4])\\d{6}", [8]], ["9\\d{8}", [9]], ["800\\d{5}", [8]], ["805\\d{5}", [8]], ["80[24]\\d{5}", [8]], 0, 0, 0, 0, ["801\\d{5}", [8]]], "00", " Anexo "], PF: ["689", "00", "4\\d{5}(?:\\d{2})?|8\\d{7,8}", [6, 8, 9], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["44"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["4|8[7-9]"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]]], 0, 0, 0, 0, 0, 0, [["4(?:0[4-689]|9[4-68])\\d{5}", [8]], ["8[7-9]\\d{6}", [8]], ["80[0-5]\\d{6}", [9]], 0, 0, 0, ["44\\d{4}", [6]], 0, ["499\\d{5}", [8]]]], PG: ["675", "00|140[1-3]", "(?:180|[78]\\d{3})\\d{4}|(?:[2-589]\\d|64)\\d{5}", [7, 8], [["(\\d{3})(\\d{4})", "$1 $2", ["18|[2-69]|85"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[78]"]]], 0, 0, 0, 0, 0, 0, [["(?:(?:3[0-2]|4[257]|5[34]|9[78])\\d|64[1-9]|85[02-46-9])\\d{4}", [7]], ["(?:7\\d|8[1-38])\\d{6}", [8]], ["180\\d{4}", [7]], 0, 0, 0, 0, ["27[01]\\d{4}", [7]], ["2(?:0[0-57]|7[568])\\d{4}", [7]]], "00"], PH: ["63", "00", "(?:[2-7]|9\\d)\\d{8}|2\\d{5}|(?:1800|8)\\d{7,9}", [6, 8, 9, 10, 11, 12, 13], [["(\\d)(\\d{5})", "$1 $2", ["2"], "(0$1)"], ["(\\d{4})(\\d{4,6})", "$1 $2", ["3(?:23|39|46)|4(?:2[3-6]|[35]9|4[26]|76)|544|88[245]|(?:52|64|86)2", "3(?:230|397|461)|4(?:2(?:35|[46]4|51)|396|4(?:22|63)|59[347]|76[15])|5(?:221|446)|642[23]|8(?:622|8(?:[24]2|5[13]))"], "(0$1)"], ["(\\d{5})(\\d{4})", "$1 $2", ["346|4(?:27|9[35])|883", "3469|4(?:279|9(?:30|56))|8834"], "(0$1)"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[3-7]|8[2-8]"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[89]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]], ["(\\d{4})(\\d{1,2})(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["1"]]], "0", 0, 0, 0, 0, 0, [["(?:(?:2[3-8]|3[2-68]|4[2-9]|5[2-6]|6[2-58]|7[24578])\\d{3}|88(?:22\\d\\d|42))\\d{4}|(?:2|8[2-8]\\d\\d)\\d{5}", [6, 8, 9, 10]], ["(?:8(?:1[37]|9[5-8])|9(?:0[5-9]|1[0-24-9]|[235-7]\\d|4[2-9]|8[135-9]|9[1-9]))\\d{7}", [10]], ["1800\\d{7,9}", [11, 12, 13]]]], PK: ["92", "00", "122\\d{6}|[24-8]\\d{10,11}|9(?:[013-9]\\d{8,10}|2(?:[01]\\d\\d|2(?:[06-8]\\d|1[01]))\\d{7})|(?:[2-8]\\d{3}|92(?:[0-7]\\d|8[1-9]))\\d{6}|[24-9]\\d{8}|[89]\\d{7}", [8, 9, 10, 11, 12], [["(\\d{3})(\\d{3})(\\d{2,7})", "$1 $2 $3", ["[89]0"], "0$1"], ["(\\d{4})(\\d{5})", "$1 $2", ["1"]], ["(\\d{3})(\\d{6,7})", "$1 $2", ["2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:2[2-8]|3[27-9]|4[2-6]|6[3569]|9[25-8])", "9(?:2[3-8]|98)|(?:2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:22|3[27-9]|4[2-6]|6[3569]|9[25-7]))[2-9]"], "(0$1)"], ["(\\d{2})(\\d{7,8})", "$1 $2", ["(?:2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)[2-9]"], "(0$1)"], ["(\\d{5})(\\d{5})", "$1 $2", ["58"], "(0$1)"], ["(\\d{3})(\\d{7})", "$1 $2", ["3"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["[24-9]"], "(0$1)"]], "0", 0, 0, 0, 0, 0, [["(?:(?:21|42)[2-9]|58[126])\\d{7}|(?:2[25]|4[0146-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)[2-9]\\d{6,7}|(?:2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:2[2-8]|3[27-9]|4[2-6]|6[3569]|9[25-8]))[2-9]\\d{5,6}", [9, 10]], ["3(?:[0-247]\\d|3[0-79]|55|64)\\d{7}", [10]], ["800\\d{5}(?:\\d{3})?", [8, 11]], ["900\\d{5}", [8]], ["122\\d{6}", [9]], 0, ["(?:2(?:[125]|3[2358]|4[2-4]|9[2-8])|4(?:[0-246-9]|5[3479])|5(?:[1-35-7]|4[2-467])|6(?:0[468]|[1-8])|7(?:[14]|2[236])|8(?:[16]|2[2-689]|3[23578]|4[3478]|5[2356])|9(?:1|22|3[27-9]|4[2-6]|6[3569]|9[2-7]))111\\d{6}", [11, 12]]]], PL: ["48", "00", "(?:6|8\\d\\d)\\d{7}|[1-9]\\d{6}(?:\\d{2})?|[26]\\d{5}", [6, 7, 8, 9, 10], [["(\\d{5})", "$1", ["19"]], ["(\\d{3})(\\d{3})", "$1 $2", ["11|20|64"]], ["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])1", "(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])19"]], ["(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["64"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["21|39|45|5[0137]|6[0469]|7[02389]|8(?:0[14]|8)"]], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[2-8]|[2-7]|8[1-79]|9[145]"]], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["8"]]], 0, 0, 0, 0, 0, 0, [["47\\d{7}|(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])(?:[02-9]\\d{6}|1(?:[0-8]\\d{5}|9\\d{3}(?:\\d{2})?))", [7, 9]], ["2131[89]\\d{4}|21(?:1[013-5]|2\\d|3[2-9])\\d{5}|(?:45|5[0137]|6[069]|7[2389]|88)\\d{7}", [9]], ["800\\d{6,7}", [9, 10]], ["70[01346-8]\\d{6}", [9]], 0, 0, ["804\\d{6}", [9]], ["64\\d{4,7}", [6, 7, 8, 9]], ["39\\d{7}", [9]], ["801\\d{6}", [9]]]], PM: ["508", "00", "[45]\\d{5}|(?:708|8\\d\\d)\\d{6}", [6, 9], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["[45]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["7"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:4[1-35-9]|5[0-47-9]|80[6-9]\\d\\d)\\d{4}"], ["(?:4[02-489]|5[02-9]|708(?:4[0-5]|5[0-6]))\\d{4}"], ["80[0-5]\\d{6}", [9]], ["8[129]\\d{7}", [9]]]], PR: ["1", "011", "(?:[589]\\d\\d|787)\\d{7}", [10], 0, "1", 0, 0, 0, 0, "787|939", [["(?:787|939)[2-9]\\d{6}"], [""], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"]]], PS: ["970", "00", "[2489]2\\d{6}|(?:1\\d|5)\\d{8}", [8, 9, 10], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2489]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["5"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]]], "0", 0, 0, 0, 0, 0, [["(?:22[2-47-9]|42[45]|82[014-68]|92[3569])\\d{5}", [8]], ["5[69]\\d{7}", [9]], ["1800\\d{6}", [10]], 0, 0, 0, 0, 0, 0, ["1700\\d{6}", [10]]]], PT: ["351", "00", "1693\\d{5}|(?:[26-9]\\d|30)\\d{7}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["2[12]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["16|[236-9]"]]], 0, 0, 0, 0, 0, 0, [["2(?:[12]\\d|3[1-689]|4[1-59]|[57][1-9]|6[1-35689]|8[1-69]|9[1256])\\d{6}"], ["6(?:[06]92(?:30|9\\d)|[35]92(?:[049]\\d|3[034]))\\d{3}|(?:(?:16|6[0356])93|9(?:[1-36]\\d\\d|480))\\d{5}"], ["80[02]\\d{6}"], ["(?:6(?:0[178]|4[68])\\d|76(?:0[1-57]|1[2-47]|2[237]))\\d{5}"], ["884[0-4689]\\d{5}"], ["600\\d{6}|6[06]92(?:0\\d|3[349]|49)\\d{3}"], ["70(?:38[01]|596|(?:7\\d|8[17])\\d)\\d{4}"], ["6(?:222\\d|8988)\\d{4}"], ["30\\d{7}"], ["80(?:8\\d|9[1579])\\d{5}"]]], PW: ["680", "01[12]", "(?:[24-8]\\d\\d|345|900)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-9]"]]], 0, 0, 0, 0, 0, 0, [["(?:2(?:55|77)|345|488|5(?:35|44|87)|6(?:22|54|79)|7(?:33|47)|8(?:24|55|76)|900)\\d{4}"], ["(?:(?:46|83)[0-5]|(?:6[2-4689]|78)0)\\d{4}|(?:45|77|88)\\d{5}"]]], PY: ["595", "00", "59\\d{4,6}|9\\d{5,10}|(?:[2-46-8]\\d|5[0-8])\\d{4,7}", [6, 7, 8, 9, 10, 11], [["(\\d{3})(\\d{3,6})", "$1 $2", ["[2-9]0"], "0$1"], ["(\\d{2})(\\d{5})", "$1 $2", ["[26]1|3[289]|4[1246-8]|7[1-3]|8[1-36]"], "(0$1)"], ["(\\d{3})(\\d{4,5})", "$1 $2", ["2[279]|3[13-5]|4[359]|5|6(?:[34]|7[1-46-8])|7[46-8]|85"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2[14-68]|3[26-9]|4[1246-8]|6(?:1|75)|7[1-35]|8[1-36]"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["87"]], ["(\\d{3})(\\d{6})", "$1 $2", ["9(?:[5-79]|8[1-7])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-8]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["9"]]], "0", 0, 0, 0, 0, 0, [["(?:[26]1|3[289]|4[1246-8]|7[1-3]|8[1-36])\\d{5,7}|(?:2(?:2[4-68]|[4-68]\\d|7[15]|9[1-5])|3(?:18|3[167]|4[2357]|51|[67]\\d)|4(?:3[12]|5[13]|9[1-47])|5(?:[1-4]\\d|5[02-4])|6(?:3[1-3]|44|7[1-8])|7(?:4[0-4]|5\\d|6[1-578]|75|8[0-8])|858)\\d{5,6}", [7, 8, 9]], ["9(?:51|6[129]|7[1-6]|8[1-7]|9[1-5])\\d{6}", [9]], ["9800\\d{5,7}", [9, 10, 11]], 0, 0, 0, ["[2-9]0\\d{4,7}", [6, 7, 8, 9]], 0, ["8700[0-4]\\d{4}", [9]]]], QA: ["974", "00", "800\\d{4}|(?:2|800)\\d{6}|(?:0080|[3-7])\\d{7}", [7, 8, 9, 11], [["(\\d{3})(\\d{4})", "$1 $2", ["2[16]|8"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[3-7]"]]], 0, 0, 0, 0, 0, 0, [["4(?:1111|2022)\\d{3}|4(?:[04]\\d\\d|14[0-6]|999)\\d{4}", [8]], ["[35-7]\\d{7}", [8]], ["800\\d{4}|(?:0080[01]|800)\\d{6}", [7, 9, 11]], 0, 0, 0, 0, ["2[16]\\d{5}", [7]]]], RE: ["262", "00", "709\\d{6}|(?:26|[689]\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[26-9]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["26(?:2\\d\\d|3(?:0\\d|1[0-6]))\\d{4}"], ["(?:69(?:2\\d\\d|3(?:[06][0-6]|1[013]|2[0-2]|3[0-39]|4\\d|5[0-5]|7[0-37]|8[0-8]|9[0-479]))|7092[0-3])\\d{4}"], ["80\\d{7}"], ["89[1-37-9]\\d{6}"], 0, 0, 0, 0, ["9(?:399[0-3]|479[0-6]|76(?:2[278]|3[0-37]))\\d{4}"], ["8(?:1[019]|2[0156]|84|90)\\d{6}"]]], RO: ["40", "00", "(?:[236-8]\\d|90)\\d{7}|[23]\\d{5}", [6, 9], [["(\\d{3})(\\d{3})", "$1 $2", ["2[3-6]", "2[3-6]\\d9"], "0$1"], ["(\\d{2})(\\d{4})", "$1 $2", ["219|31"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[23]1"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[236-9]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["[23][13-6]\\d{7}|(?:2(?:19\\d|[3-6]\\d9)|31\\d\\d)\\d\\d"], ["(?:630|702)0\\d{5}|(?:6(?:00|2\\d)|7(?:0[013-9]|1[0-3]|[2-7]\\d|8[03-8]|9[0-39]))\\d{6}", [9]], ["800\\d{6}", [9]], ["90[0136]\\d{6}", [9]], 0, 0, ["(?:37\\d|80[578])\\d{6}", [9]], 0, 0, ["801\\d{6}", [9]]], 0, " int "], RS: ["381", "00", "38[02-9]\\d{6,9}|6\\d{7,9}|90\\d{4,8}|38\\d{5,6}|(?:7\\d\\d|800)\\d{3,9}|(?:[12]\\d|3[0-79])\\d{5,10}", [6, 7, 8, 9, 10, 11, 12], [["(\\d{3})(\\d{3,9})", "$1 $2", ["(?:2[389]|39)0|[7-9]"], "0$1"], ["(\\d{2})(\\d{5,10})", "$1 $2", ["[1-36]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:11[1-9]\\d|(?:2[389]|39)(?:0[2-9]|[2-9]\\d))\\d{3,8}|(?:1[02-9]|2[0-24-7]|3[0-8])[2-9]\\d{4,9}", [7, 8, 9, 10, 11, 12]], ["6(?:[0-689]|7\\d)\\d{6,7}", [8, 9, 10]], ["800\\d{3,9}"], ["(?:78\\d|90[0169])\\d{3,7}", [6, 7, 8, 9, 10]], 0, 0, ["7[06]\\d{4,10}"]]], RU: ["7", "810", "8\\d{13}|[347-9]\\d{9}", [10, 14], [["(\\d{4})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["7(?:1[0-8]|2[1-9])", "7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:1[23]|[2-9]2))", "7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:13[03-69]|62[013-9]))|72[1-57-9]2"], "8 ($1)", 1], ["(\\d{5})(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["7(?:1[0-68]|2[1-9])", "7(?:1(?:[06][3-6]|[18]|2[35]|[3-5][3-5])|2(?:[13][3-5]|[24-689]|7[457]))", "7(?:1(?:0(?:[356]|4[023])|[18]|2(?:3[013-9]|5)|3[45]|43[013-79]|5(?:3[1-8]|4[1-7]|5)|6(?:3[0-35-9]|[4-6]))|2(?:1(?:3[178]|[45])|[24-689]|3[35]|7[457]))|7(?:14|23)4[0-8]|71(?:33|45)[1-79]"], "8 ($1)", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "8 ($1)", 1], ["(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[349]|8(?:[02-7]|1[1-8])"], "8 ($1)", 1], ["(\\d{4})(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["8"], "8 ($1)"]], "8", 0, 0, 0, 0, "3[04-689]|[489]", [["(?:3(?:0[12]|4[1-35-79]|5[1-3]|65|8[1-58]|9[0145])|4(?:01|1[1356]|2[13467]|7[1-5]|8[1-7]|9[1-689])|8(?:1[1-8]|2[01]|3[13-6]|4[0-8]|5[15]|6[1-35-79]|7[1-37-9]))\\d{7}", [10]], ["9\\d{9}", [10]], ["8(?:0[04]|108\\d{3})\\d{7}"], ["80[39]\\d{7}", [10]], ["808\\d{7}", [10]]], "8~10"], RW: ["250", "00", "(?:06|[27]\\d\\d|[89]00)\\d{6}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["0"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[7-9]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:06|2[23568]\\d)\\d{6}"], ["7[237-9]\\d{7}", [9]], ["800\\d{6}", [9]], ["900\\d{6}", [9]]]], SA: ["966", "00", "92\\d{7}|(?:[15]|8\\d)\\d{8}", [9, 10], [["(\\d{4})(\\d{5})", "$1 $2", ["9"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["5"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["81"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]]], "0", 0, 0, 0, 0, 0, [["1(?:1\\d|2[24-8]|3[35-8]|4[3-68]|6[2-5]|7[235-7])\\d{6}", [9]], ["579[01]\\d{5}|5(?:[013-689]\\d|7[0-8])\\d{6}", [9]], ["800\\d{7}", [10]], ["925\\d{6}", [9]], 0, 0, ["811\\d{7}", [10]], 0, 0, ["920\\d{6}", [9]]]], SB: ["677", "0[01]", "[6-9]\\d{6}|[1-6]\\d{4}", [5, 7], [["(\\d{2})(\\d{5})", "$1 $2", ["6[89]|7|8[4-9]|9(?:[1-8]|9[0-8])"]]], 0, 0, 0, 0, 0, 0, [["(?:1[4-79]|[23]\\d|4[0-2]|5[03]|6[0-37])\\d{3}", [5]], ["48\\d{3}|(?:(?:6[89]|7[1-9]|8[4-9])\\d|9(?:1[2-9]|2[013-9]|3[0-2]|[46]\\d|5[0-46-9]|7[0-689]|8[0-79]|9[0-8]))\\d{4}"], ["1[38]\\d{3}", [5]], 0, 0, 0, 0, 0, ["5[12]\\d{3}", [5]]]], SC: ["248", "010|0[0-2]", "(?:[2489]\\d|64)\\d{5}", [7], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[246]|9[57]"]]], 0, 0, 0, 0, 0, 0, [["4[2-46]\\d{5}"], ["2[125-8]\\d{5}"], ["800[08]\\d{3}"], ["85\\d{5}"], 0, 0, 0, 0, ["971\\d{4}|(?:64|95)\\d{5}"]], "00"], SD: ["249", "00", "[19]\\d{8}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[19]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["1(?:5\\d|8[35-7])\\d{6}"], ["(?:1[0-2]|9[0-3569])\\d{7}"]]], SE: ["46", "00", "(?:[26]\\d\\d|9)\\d{9}|[1-9]\\d{8}|[1-689]\\d{7}|[1-4689]\\d{6}|2\\d{5}", [6, 7, 8, 9, 10, 12], [["(\\d{2})(\\d{2,3})(\\d{2})", "$1-$2 $3", ["20"], "0$1", 0, "$1 $2 $3"], ["(\\d{3})(\\d{4})", "$1-$2", ["9(?:00|39|44|9)"], "0$1", 0, "$1 $2"], ["(\\d{2})(\\d{3})(\\d{2})", "$1-$2 $3", ["[12][136]|3[356]|4[0246]|6[03]|90[1-9]"], "0$1", 0, "$1 $2 $3"], ["(\\d)(\\d{2,3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["8"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2,3})(\\d{2})", "$1-$2 $3", ["1[2457]|2(?:[247-9]|5[0138])|3[0247-9]|4[1357-9]|5[0-35-9]|6(?:[125689]|4[02-57]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"], "0$1", 0, "$1 $2 $3"], ["(\\d{3})(\\d{2,3})(\\d{3})", "$1-$2 $3", ["9(?:00|39|44)"], "0$1", 0, "$1 $2 $3"], ["(\\d{2})(\\d{2,3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["1[13689]|2[0136]|3[1356]|4[0246]|54|6[03]|90[1-9]"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["10|7"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d)(\\d{3})(\\d{3})(\\d{2})", "$1-$2 $3 $4", ["8"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["[13-5]|2(?:[247-9]|5[0138])|6(?:[124-689]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{3})", "$1-$2 $3 $4", ["9"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1-$2 $3 $4 $5", ["[26]"], "0$1", 0, "$1 $2 $3 $4 $5"]], "0", 0, 0, 0, 0, 0, [["(?:(?:[12][136]|3[356]|4[0246]|6[03]|8\\d)\\d|90[1-9])\\d{4,6}|(?:1(?:2[0-35]|4[0-4]|5[0-25-9]|7[13-6]|[89]\\d)|2(?:2[0-7]|4[0136-8]|5[0138]|7[018]|8[01]|9[0-57])|3(?:0[0-4]|1\\d|2[0-25]|4[056]|7[0-2]|8[0-3]|9[023])|4(?:1[013-8]|3[0135]|5[14-79]|7[0-246-9]|8[0156]|9[0-689])|5(?:0[0-6]|[15][0-5]|2[0-68]|3[0-4]|4\\d|6[03-5]|7[013]|8[0-79]|9[01])|6(?:1[1-3]|2[0-4]|4[02-57]|5[0-37]|6[0-3]|7[0-2]|8[0247]|9[0-356])|9(?:1[0-68]|2\\d|3[02-5]|4[0-3]|5[0-4]|[68][01]|7[0135-8]))\\d{5,6}", [7, 8, 9]], ["7[02369]\\d{7}", [9]], ["20\\d{4,7}", [6, 7, 8, 9]], ["649\\d{6}|99[1-59]\\d{4}(?:\\d{3})?|9(?:00|39|44)[1-8]\\d{3,6}", [7, 8, 9, 10]], ["75[1-8]\\d{6}", [9]], ["(?:25[245]|67[3-68])\\d{9}", [12]], ["10[1-8]\\d{6}", [9]], ["74[02-9]\\d{6}", [9]], 0, ["77[0-7]\\d{6}", [9]]]], SG: ["65", "0[0-3]\\d", "(?:(?:1\\d|8)\\d\\d|7000)\\d{7}|[3689]\\d{7}", [8, 10, 11], [["(\\d{4})(\\d{4})", "$1 $2", ["[369]|8(?:0[1-9]|[1-9])"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]], ["(\\d{4})(\\d{4})(\\d{3})", "$1 $2 $3", ["7"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]]], 0, 0, 0, 0, 0, 0, [["662[0-24-9]\\d{4}|6(?:[0-578]\\d|6[013-57-9]|9[0-35-9])\\d{5}", [8]], ["896[0-46-8]\\d{4}|(?:8(?:0[1-9]|[1-8]\\d|9[0-5])|9[0-8]\\d)\\d{5}", [8]], ["(?:18|8)00\\d{7}", [10, 11]], ["1900\\d{7}", [11]], 0, 0, ["7000\\d{7}", [11]], 0, ["(?:3[12]\\d|666)\\d{5}", [8]]]], SH: ["290", "00", "(?:[256]\\d|8)\\d{3}", [4, 5], 0, 0, 0, 0, 0, 0, "[256]", [["2(?:[0-57-9]\\d|6[4-9])\\d\\d"], ["[56]\\d{4}", [5]], 0, 0, 0, 0, 0, 0, ["262\\d\\d", [5]]]], SI: ["386", "00|10(?:22|66|88|99)", "[1-7]\\d{7}|8\\d{4,7}|90\\d{4,6}", [5, 6, 7, 8], [["(\\d{2})(\\d{3,6})", "$1 $2", ["8[09]|9"], "0$1"], ["(\\d{3})(\\d{5})", "$1 $2", ["59|8"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[37][01]|4[0139]|51|6"], "0$1"], ["(\\d)(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[1-57]"], "(0$1)"]], "0", 0, 0, 0, 0, 0, [["(?:[1-357][2-8]|4[24-8])\\d{6}", [8]], ["65(?:[178]\\d|5[56]|6[01])\\d{4}|(?:[37][01]|4[0139]|51|6[489])\\d{6}", [8]], ["80\\d{4,6}", [6, 7, 8]], ["89[1-3]\\d{2,5}|90\\d{4,6}"], 0, 0, 0, 0, ["(?:59\\d\\d|8(?:1(?:[67]\\d|8[0-589])|2(?:0\\d|2[0-37-9]|8[0-2489])|3[389]\\d))\\d{4}", [8]]], "00"], SJ: ["47", "00", "0\\d{4}|(?:[489]\\d|79)\\d{6}", [5, 8], 0, 0, 0, 0, 0, 0, "79", [["79\\d{6}", [8]], ["(?:4[015-8]|9\\d)\\d{6}", [8]], ["80[01]\\d{5}", [8]], ["82[09]\\d{5}", [8]], ["880\\d{5}", [8]], ["81[23]\\d{5}", [8]], ["(?:0[235-9]|81(?:0(?:0[7-9]|1\\d)|5\\d\\d))\\d{3}"], 0, ["85[0-5]\\d{5}", [8]], ["810(?:0[0-6]|[2-8]\\d)\\d{3}", [8]]]], SK: ["421", "00", "[2-689]\\d{8}|[2-59]\\d{6}|[2-5]\\d{5}", [6, 7, 9], [["(\\d)(\\d{2})(\\d{3,4})", "$1 $2 $3", ["21"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["[3-5][1-8]1", "[3-5][1-8]1[67]"], "0$1"], ["(\\d)(\\d{3})(\\d{3})(\\d{2})", "$1/$2 $3 $4", ["2"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[689]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1/$2 $3 $4", ["[3-5]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:2(?:16|[2-9]\\d{3})|(?:(?:[3-5][1-8]\\d|819)\\d|601[1-5])\\d)\\d{4}|(?:2|[3-5][1-8])1[67]\\d{3}|[3-5][1-8]16\\d\\d"], ["909[1-9]\\d{5}|9(?:0[1-8]|1[0-24-9]|4[03-57-9]|5\\d)\\d{6}", [9]], ["800\\d{6}", [9]], ["9(?:00|[78]\\d)\\d{6}", [9]], 0, 0, ["96\\d{7}", [9]], ["9090\\d{3}", [7]], ["6(?:02|5[0-4]|9[0-6])\\d{6}", [9]], ["8[5-9]\\d{7}", [9]]]], SL: ["232", "00", "(?:[237-9]\\d|66)\\d{6}", [8], [["(\\d{2})(\\d{6})", "$1 $2", ["[236-9]"], "(0$1)"]], "0", 0, 0, 0, 0, 0, [["22[2-4][2-9]\\d{4}"], ["(?:25|3[0-5]|66|7[1-9]|8[08]|9[09])\\d{6}"]]], SM: ["378", "00", "(?:0549|[5-7]\\d)\\d{6}", [8, 10], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-7]"]], ["(\\d{4})(\\d{6})", "$1 $2", ["0"]]], 0, 0, "([89]\\d{5})$", "0549$1", 0, 0, [["0549(?:8[0157-9]|9\\d)\\d{4}", [10]], ["6[16]\\d{6}", [8]], 0, ["7[178]\\d{6}", [8]], 0, 0, 0, 0, ["5[158]\\d{6}", [8]]]], SN: ["221", "00", "(?:[378]\\d|93)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[379]"]]], 0, 0, 0, 0, 0, 0, [["3(?:0(?:1[0-2]|80)|282|3(?:8[1-9]|9[3-9])|611)\\d{5}"], ["7(?:(?:[06-8]\\d|[19]0|21)\\d|5(?:0[01]|[19]0|2[25]|3[356]|[4-7]\\d|8[35]))\\d{5}"], ["800\\d{6}"], ["88[4689]\\d{6}"], 0, 0, 0, 0, ["(?:3(?:392|9[01]\\d)\\d|93(?:3[13]0|929))\\d{4}"], ["81[02468]\\d{6}"]]], SO: ["252", "00", "[346-9]\\d{8}|[12679]\\d{7}|[1-5]\\d{6}|[1348]\\d{5}", [6, 7, 8, 9], [["(\\d{2})(\\d{4})", "$1 $2", ["8[125]"]], ["(\\d{6})", "$1", ["[134]"]], ["(\\d)(\\d{6})", "$1 $2", ["[15]|2[0-79]|3[0-46-8]|4[0-7]"]], ["(\\d)(\\d{7})", "$1 $2", ["(?:2|90)4|[67]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[348]|64|79|90"]], ["(\\d{2})(\\d{5,7})", "$1 $2", ["1|28|6[0-35-9]|7[67]|9[2-9]"]]], "0", 0, 0, 0, 0, 0, [["(?:1\\d|2[0-79]|3[0-46-8]|4[0-7]|5[57-9])\\d{5}|(?:[134]\\d|8[125])\\d{4}", [6, 7]], ["(?:(?:15|(?:3[59]|4[89]|6\\d|7[679]|8[08])\\d|9(?:0\\d|[2-9]))\\d|2(?:4\\d|8))\\d{5}|(?:[67]\\d\\d|904)\\d{5}", [7, 8, 9]]]], SR: ["597", "00", "(?:[2-5]|68|[78]\\d)\\d{5}", [6, 7], [["(\\d{2})(\\d{2})(\\d{2})", "$1-$2-$3", ["56"]], ["(\\d{3})(\\d{3})", "$1-$2", ["[2-5]"]], ["(\\d{3})(\\d{4})", "$1-$2", ["[6-8]"]]], 0, 0, 0, 0, 0, 0, [["(?:2[1-3]|3[0-7]|(?:4|68)\\d|5[2-58])\\d{4}"], ["(?:7[124-7]|8[1-9])\\d{5}", [7]], 0, 0, 0, 0, 0, 0, ["56\\d{4}", [6]]]], SS: ["211", "00", "[19]\\d{8}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[19]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["1[89]\\d{7}"], ["(?:12|9[1257-9])\\d{7}"]]], ST: ["239", "00", "(?:22|9\\d)\\d{5}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[29]"]]], 0, 0, 0, 0, 0, 0, [["22\\d{5}"], ["900[5-9]\\d{3}|9(?:0[1-9]|[89]\\d)\\d{4}"]]], SV: ["503", "00", "[267]\\d{7}|(?:80\\d|900)\\d{4}(?:\\d{4})?", [7, 8, 11], [["(\\d{3})(\\d{4})", "$1 $2", ["[89]"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[267]"]], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["[89]"]]], 0, 0, 0, 0, 0, 0, [["2(?:79(?:0[0347-9]|[1-9]\\d)|89(?:0[024589]|[1-9]\\d))\\d{3}|2(?:[1-69]\\d|[78][0-8])\\d{5}", [8]], ["[67]\\d{7}", [8]], ["800\\d{8}|80[01]\\d{4}", [7, 11]], ["900\\d{4}(?:\\d{4})?", [7, 11]]]], SX: ["1", "011", "7215\\d{6}|(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "(5\\d{6})$|1", "721$1", 0, "721", [["7215(?:4[2-8]|8[239]|9[056])\\d{4}"], ["7215(?:1[02]|2\\d|5[034679]|8[014-8])\\d{4}"], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"]]], SY: ["963", "00", "[1-359]\\d{8}|[1-5]\\d{7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-4]|5[1-3]"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[59]"], "0$1", 1]], "0", 0, 0, 0, 0, 0, [["21\\d{6,7}|(?:1(?:[14]\\d|[2356])|2[235]|3(?:[13]\\d|4)|4[134]|5[1-3])\\d{6}"], ["(?:50|9[1-689])\\d{7}", [9]]]], SZ: ["268", "00", "0800\\d{4}|(?:[237]\\d|900)\\d{6}", [8, 9], [["(\\d{4})(\\d{4})", "$1 $2", ["[0237]"]], ["(\\d{5})(\\d{4})", "$1 $2", ["9"]]], 0, 0, 0, 0, 0, 0, [["[23][2-5]\\d{6}", [8]], ["7[6-9]\\d{6}", [8]], ["0800\\d{4}", [8]], ["900\\d{6}", [9]], 0, 0, 0, 0, ["70\\d{6}", [8]]]], TA: ["290", "00", "8\\d{3}", [4], 0, 0, 0, 0, 0, 0, "8", [["8\\d{3}"]]], TC: ["1", "011", "(?:[58]\\d\\d|649|900)\\d{7}", [10], 0, "1", 0, "([2-479]\\d{6})$|1", "649$1", 0, "649", [["649(?:266|712|9(?:4\\d|50))\\d{4}"], ["649(?:2(?:3[129]|4[1-79])|3\\d\\d|4[34][1-3])\\d{4}"], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"], 0, 0, 0, ["649(?:71[01]|966)\\d{4}"]]], TD: ["235", "00|16", "(?:22|[689]\\d|77)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[26-9]"]]], 0, 0, 0, 0, 0, 0, [["22(?:[37-9]0|5[0-5]|6[89])\\d{4}"], ["(?:[69]\\d|77|8[56])\\d{6}"]], "00"], TG: ["228", "00", "[279]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[279]"]]], 0, 0, 0, 0, 0, 0, [["2(?:2[2-7]|3[23]|4[45]|55|6[67]|77)\\d{5}"], ["(?:7[0-29]|9[0-36-9])\\d{6}"]]], TH: ["66", "00[1-9]", "(?:001800|[2-57]|[689]\\d)\\d{7}|1\\d{7,9}", [8, 9, 10, 13], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[13-9]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]]], "0", 0, 0, 0, 0, 0, [["(?:1[0689]|2\\d|3[2-9]|4[2-5]|5[2-6]|7[3-7])\\d{6}", [8]], ["67(?:1[0-8]|2[4-7])\\d{5}|(?:14|6[1-6]|[89]\\d)\\d{7}", [9]], ["(?:001800\\d|1800)\\d{6}", [10, 13]], ["1900\\d{6}", [10]], 0, 0, 0, 0, ["6[08]\\d{7}", [9]]]], TJ: ["992", "810", "[0-57-9]\\d{8}", [9], [["(\\d{6})(\\d)(\\d{2})", "$1 $2 $3", ["331", "3317"]], ["(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["44[02-479]|[34]7"]], ["(\\d{4})(\\d)(\\d{4})", "$1 $2 $3", ["3(?:[1245]|3[12])"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[0-57-9]"]]], 0, 0, 0, 0, 0, 0, [["(?:3(?:1[3-5]|2[245]|3[12]|4[24-7]|5[25]|72)|4(?:46|74|87))\\d{6}"], ["(?:33[03-9]|4(?:1[18]|4[02-479])|81[1-9])\\d{6}|(?:[09]\\d|1[0-27-9]|2[0-27]|[34]0|5[05]|7[01578]|8[078])\\d{7}"]], "8~10"], TK: ["690", "00", "[2-47]\\d{3,6}", [4, 5, 6, 7], 0, 0, 0, 0, 0, 0, 0, [["(?:2[2-4]|[34]\\d)\\d{2,5}"], ["7[2-4]\\d{2,5}"]]], TL: ["670", "00", "7\\d{7}|(?:[2-47]\\d|[89]0)\\d{5}", [7, 8], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-489]|70"]], ["(\\d{4})(\\d{4})", "$1 $2", ["7"]]], 0, 0, 0, 0, 0, 0, [["(?:2[1-5]|3[1-9]|4[1-4])\\d{5}", [7]], ["7[2-8]\\d{6}", [8]], ["80\\d{5}", [7]], ["90\\d{5}", [7]], ["70\\d{5}", [7]]]], TM: ["993", "810", "(?:[1-6]\\d|71)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["12"], "(8 $1)"], ["(\\d{3})(\\d)(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[1-5]"], "(8 $1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["[67]"], "8 $1"]], "8", 0, 0, 0, 0, 0, [["(?:1(?:2\\d|3[1-9])|2(?:22|4[0-35-8])|3(?:22|4[03-9])|4(?:22|3[128]|4\\d|6[15])|5(?:22|5[7-9]|6[014-689]))\\d{5}"], ["(?:6\\d|71)\\d{6}"]], "8~10"], TN: ["216", "00", "[2-57-9]\\d{7}", [8], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-57-9]"]]], 0, 0, 0, 0, 0, 0, [["81200\\d{3}|(?:3[0-2]|7\\d)\\d{6}"], ["3(?:001|[12]40)\\d{4}|(?:(?:[259]\\d|4[0-8])\\d|3(?:1[1-35]|6[0-4]|91))\\d{5}"], ["8010\\d{4}"], ["88\\d{6}"], 0, 0, 0, 0, 0, ["8[12]10\\d{4}"]]], TO: ["676", "00", "(?:0800|(?:[5-8]\\d\\d|999)\\d)\\d{3}|[2-8]\\d{4}", [5, 7], [["(\\d{2})(\\d{3})", "$1-$2", ["[2-4]|50|6[09]|7[0-24-69]|8[05]"]], ["(\\d{4})(\\d{3})", "$1 $2", ["0"]], ["(\\d{3})(\\d{4})", "$1 $2", ["[5-9]"]]], 0, 0, 0, 0, 0, 0, [["(?:2\\d|3[0-8]|4[0-4]|50|6[09]|7[0-24-69]|8[05])\\d{3}", [5]], ["(?:5(?:4[0-5]|5[4-6])|6(?:[09]\\d|3[02]|8[15-9])|(?:7\\d|8[46-9])\\d|999)\\d{4}", [7]], ["0800\\d{3}", [7]], 0, 0, 0, 0, 0, ["55[0-37-9]\\d{4}", [7]]]], TR: ["90", "00", "4\\d{6}|8\\d{11,12}|(?:[2-58]\\d\\d|900)\\d{7}", [7, 10, 12, 13], [["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["512|8[01589]|90"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["5(?:[0-59]|61)", "5(?:[0-59]|61[06])", "5(?:[0-59]|61[06]1)"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24][1-8]|3[1-9]"], "(0$1)", 1], ["(\\d{3})(\\d{3})(\\d{6,7})", "$1 $2 $3", ["80"], "0$1", 1]], "0", 0, 0, 0, 0, 0, [["(?:2(?:[13][26]|[28][2468]|[45][268]|[67][246])|3(?:[13][28]|[24-6][2468]|[78][02468]|92)|4(?:[16][246]|[23578][2468]|4[26]))\\d{7}", [10]], ["561(?:011|61\\d)\\d{4}|5(?:0[15-7]|1[06]|24|[34]\\d|5[1-59]|9[46])\\d{7}", [10]], ["8(?:00\\d{7}(?:\\d{2,3})?|11\\d{7})", [10, 12, 13]], ["(?:8[89]8|900)\\d{7}", [10]], ["592(?:21[12]|461)\\d{4}", [10]], 0, ["444\\d{4}", [7]], ["512\\d{7}", [10]], ["850\\d{7}", [10]]]], TT: ["1", "011", "(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-46-8]\\d{6})$|1", "868$1", 0, "868", [["868(?:2(?:01|1[5-9]|[23]\\d|4[0-2])|6(?:0[7-9]|1[02-8]|2[1-9]|[3-69]\\d|7[0-79])|82[124])\\d{4}"], ["868(?:(?:2[5-9]|3\\d)\\d|4(?:3[0-6]|[6-9]\\d)|6(?:20|78|8\\d)|7(?:0[1-9]|1[02-9]|[2-9]\\d))\\d{4}"], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"], ["868619\\d{4}"]]], TV: ["688", "00", "(?:2|7\\d\\d|90)\\d{4}", [5, 6, 7], [["(\\d{2})(\\d{3})", "$1 $2", ["2"]], ["(\\d{2})(\\d{4})", "$1 $2", ["90"]], ["(\\d{2})(\\d{5})", "$1 $2", ["7"]]], 0, 0, 0, 0, 0, 0, [["2[02-9]\\d{3}", [5]], ["(?:7[01]\\d|90)\\d{4}", [6, 7]]]], TW: ["886", "0(?:0[25-79]|19)", "[2-689]\\d{8}|7\\d{9,10}|[2-8]\\d{7}|2\\d{6}", [7, 8, 9, 10, 11], [["(\\d{2})(\\d)(\\d{4})", "$1 $2 $3", ["202"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[258]0"], "0$1"], ["(\\d)(\\d{3,4})(\\d{4})", "$1 $2 $3", ["[23568]|4(?:0[02-48]|[1-47-9])|7[1-9]", "[23568]|4(?:0[2-48]|[1-47-9])|(?:400|7)[1-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[49]"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["7"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:2[2-8]\\d|370|55[01]|7[1-9])\\d{6}|4(?:(?:0(?:0[1-9]|[2-48]\\d)|1[023]\\d)\\d{4,5}|(?:[239]\\d\\d|4(?:0[56]|12|49))\\d{5})|6(?:[01]\\d{7}|4(?:0[56]|12|24|4[09])\\d{4,5})|8(?:(?:2(?:3\\d|4[0-269]|[578]0|66)|36[24-9]|90\\d\\d)\\d{4}|4(?:0[56]|12|24|4[09])\\d{4,5})|(?:2(?:2(?:0\\d\\d|4(?:0[68]|[249]0|3[0-467]|5[0-25-9]|6[0235689]))|(?:3(?:[09]\\d|1[0-4])|(?:4\\d|5[0-49]|6[0-29]|7[0-5])\\d)\\d)|(?:(?:3[2-9]|5[2-8]|6[0-35-79]|8[7-9])\\d\\d|4(?:2(?:[089]\\d|7[1-9])|(?:3[0-4]|[78]\\d|9[01])\\d))\\d)\\d{3}", [8, 9]], ["(?:40001[0-2]|9[0-8]\\d{4})\\d{3}", [9]], ["80[0-79]\\d{6}|800\\d{5}", [8, 9]], ["20(?:[013-9]\\d\\d|2)\\d{4}", [7, 9]], ["99\\d{7}", [9]], 0, ["50[0-46-9]\\d{6}", [9]], 0, ["7010(?:[0-2679]\\d|3[0-7]|8[0-5])\\d{5}|70\\d{8}", [10, 11]]], 0, "#"], TZ: ["255", "00[056]", "(?:[25-8]\\d|41|90)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["[89]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[24]"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["5"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[67]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["2[2-8]\\d{7}"], ["(?:6[125-9]|7[13-9])\\d{7}"], ["80[08]\\d{6}"], ["90\\d{7}"], 0, 0, 0, 0, ["41\\d{7}"], ["8(?:40|6[01])\\d{6}"]]], UA: ["380", "00", "[89]\\d{9}|[3-9]\\d{8}", [9, 10], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6[12][29]|(?:3[1-8]|4[136-8]|5[12457]|6[49])2|(?:56|65)[24]", "6[12][29]|(?:35|4[1378]|5[12457]|6[49])2|(?:56|65)[24]|(?:3[1-46-8]|46)2[013-9]"], "0$1"], ["(\\d{4})(\\d{5})", "$1 $2", ["3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6[0135689]|7[4-6])|6(?:[12][3-7]|[459])", "3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6(?:[015689]|3[02389])|7[4-6])|6(?:[12][3-7]|[459])"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[3-7]|89|9[1-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[89]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:3[1-8]|4[13-8]|5[1-7]|6[12459])\\d{7}", [9]], ["790\\d{6}|(?:39|50|6[36-8]|7[1-357]|9[1-9])\\d{7}", [9]], ["800[1-8]\\d{5,6}"], ["900[239]\\d{5,6}"], 0, 0, 0, 0, ["89[1-579]\\d{6}", [9]]], "0~0"], UG: ["256", "00[057]", "800\\d{6}|(?:[29]0|[347]\\d)\\d{7}", [9], [["(\\d{4})(\\d{5})", "$1 $2", ["202", "2024"], "0$1"], ["(\\d{3})(\\d{6})", "$1 $2", ["[27-9]|4(?:6[45]|[7-9])"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["[34]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["20(?:(?:240|30[67])\\d|6(?:00[0-2]|30[0-4]))\\d{3}|(?:20(?:[017]\\d|2[5-9]|3[1-4]|5[0-4]|6[15-9])|[34]\\d{3})\\d{5}"], ["72[48]0\\d{5}|7(?:[015-8]\\d|2[067]|36|4[0-8]|9[089])\\d{6}"], ["800[1-3]\\d{5}"], ["90[1-3]\\d{6}"]]], US: ["1", "011", "[2-9]\\d{9}|3\\d{6}", [10], [["(\\d{3})(\\d{4})", "$1-$2", ["310"], 0, 1], ["(\\d{3})(\\d{3})(\\d{4})", "($1) $2-$3", ["[2-9]"], 0, 1, "$1-$2-$3"]], "1", 0, 0, 0, 0, 0, [["(?:3052(?:0[0-8]|[1-9]\\d)|5056(?:[0-35-9]\\d|4[468]))\\d{4}|(?:2742|305[3-9]|472[247-9]|505[2-57-9]|983[2-47-9])\\d{6}|(?:2(?:0[1-35-9]|1[02-9]|2[03-57-9]|3[1459]|4[08]|5[1-46]|6[0279]|7[0269]|8[13])|3(?:0[1-47-9]|1[02-9]|2[0135-79]|3[0-24679]|4[167]|5[0-2]|6[01349]|8[056])|4(?:0[124-9]|1[02-579]|2[3-5]|3[0245]|4[023578]|58|6[349]|7[0589]|8[04])|5(?:0[1-47-9]|1[0235-8]|20|3[0149]|4[01]|5[179]|6[1-47]|7[0-5]|8[0256])|6(?:0[1-35-9]|1[024-9]|2[03689]|3[016]|4[0156]|5[01679]|6[0-279]|78|8[0-29])|7(?:0[1-46-8]|1[2-9]|2[04-8]|3[0-247]|4[037]|5[47]|6[02359]|7[0-59]|8[156])|8(?:0[1-68]|1[02-8]|2[068]|3[0-2589]|4[03578]|5[046-9]|6[02-5]|7[028])|9(?:0[1346-9]|1[02-9]|2[0589]|3[0146-8]|4[01357-9]|5[12469]|7[0-389]|8[04-69]))[2-9]\\d{6}"], [""], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"], 0, 0, 0, ["305209\\d{4}"]]], UY: ["598", "0(?:0|1[3-9]\\d)", "0004\\d{2,9}|[1249]\\d{7}|(?:[49]\\d|80)\\d{5}", [6, 7, 8, 9, 10, 11, 12, 13], [["(\\d{3})(\\d{3,4})", "$1 $2", ["0"]], ["(\\d{3})(\\d{4})", "$1 $2", ["[49]0|8"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{4})(\\d{4})", "$1 $2", ["[124]"]], ["(\\d{3})(\\d{3})(\\d{2,4})", "$1 $2 $3", ["0"]], ["(\\d{3})(\\d{3})(\\d{3})(\\d{2,4})", "$1 $2 $3 $4", ["0"]]], "0", 0, 0, 0, 0, 0, [["(?:1(?:770|9(?:20|[89]7))|(?:2\\d|4[2-7])\\d\\d)\\d{4}", [8]], ["9[1-9]\\d{6}", [8]], ["0004\\d{2,9}|(?:405|80[05])\\d{4}"], ["90[0-8]\\d{4}", [7]]], "00", " int. "], UZ: ["998", "00", "(?:20|33|[5-9]\\d)\\d{7}", [9], [["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[235-9]"]]], 0, 0, 0, 0, 0, 0, [["(?:55\\d\\d|6(?:1(?:22|3[124]|4[1-4]|5[1-3578]|64)|2(?:22|3[0-57-9]|41)|5(?:22|3[3-7]|5[024-8])|[69]\\d\\d|7(?:[23]\\d|7[69]))|7(?:0(?:5[4-9]|6[0146]|7[124-6]|9[135-8])|(?:1[12]|[68]\\d)\\d|2(?:22|3[13-57-9]|4[1-3579]|5[14])|3(?:2\\d|3[1578]|4[1-35-7]|5[1-57]|61)|4(?:2\\d|3[1-579]|7[1-79])|5(?:22|5[1-9]|6[1457])|9(?:22|5[1-9])))\\d{5}"], ["(?:(?:[25]0|33|8[78]|9[0-57-9])\\d{3}|6(?:1(?:2(?:2[01]|98)|35[0-4]|50\\d|61[23]|7(?:[01][017]|4\\d|55|9[5-9]))|2(?:(?:11|7\\d)\\d|2(?:[12]1|9[01379])|5(?:[126]\\d|3[0-4]))|5(?:19[01]|2(?:27|9[26])|(?:30|59|7\\d)\\d)|6(?:2(?:1[5-9]|2[0367]|38|41|52|60)|(?:3[79]|9[0-3])\\d|4(?:56|83)|7(?:[07]\\d|1[017]|3[07]|4[047]|5[057]|67|8[0178]|9[79]))|7(?:2(?:24|3[237]|4[5-9]|7[15-8])|5(?:7[12]|8[0589])|7(?:0\\d|[39][07])|9(?:0\\d|7[079])))|7(?:[07]\\d{3}|1(?:13[01]|6(?:0[47]|1[67]|66)|71[3-69]|98\\d)|2(?:2(?:2[79]|95)|3(?:2[5-9]|6[0-6])|57\\d|7(?:0\\d|1[17]|2[27]|3[37]|44|5[057]|66|88))|3(?:2(?:1[0-6]|21|3[469]|7[159])|(?:33|9[4-6])\\d|5(?:0[0-4]|5[579]|9\\d)|7(?:[0-3579]\\d|4[0467]|6[67]|8[078]))|4(?:2(?:29|5[0257]|6[0-7]|7[1-57])|5(?:1[0-4]|8\\d|9[5-9])|7(?:0\\d|1[024589]|2[0-27]|3[0137]|[46][07]|5[01]|7[5-9]|9[079])|9(?:7[015-9]|[89]\\d))|5(?:112|2(?:0\\d|2[29]|[49]4)|3[1568]\\d|52[6-9]|7(?:0[01578]|1[017]|[23]7|4[047]|[5-7]\\d|8[78]|9[079]))|9(?:22[128]|3(?:2[0-4]|7\\d)|57[02569]|7(?:2[05-9]|3[37]|4\\d|60|7[2579]|87|9[07]))))\\d{4}"]]], VA: ["39", "00", "0\\d{5,10}|3[0-8]\\d{7,10}|55\\d{8}|8\\d{5}(?:\\d{2,4})?|(?:1\\d|39)\\d{7,8}", [6, 7, 8, 9, 10, 11, 12], 0, 0, 0, 0, 0, 0, "06698", [["06698\\d{1,6}", [6, 7, 8, 9, 10, 11]], ["3[1-9]\\d{8}|3[2-9]\\d{7}", [9, 10]], ["80(?:0\\d{3}|3)\\d{3}", [6, 9]], ["(?:0878\\d{3}|89(?:2\\d|3[04]|4(?:[0-4]|[5-9]\\d\\d)|5[0-4]))\\d\\d|(?:1(?:44|6[346])|89(?:38|5[5-9]|9))\\d{6}", [6, 8, 9, 10]], ["1(?:78\\d|99)\\d{6}", [9, 10]], ["3[2-8]\\d{9,10}", [11, 12]], 0, 0, ["55\\d{8}", [10]], ["84(?:[08]\\d{3}|[17])\\d{3}", [6, 9]]]], VC: ["1", "011", "(?:[58]\\d\\d|784|900)\\d{7}", [10], 0, "1", 0, "([2-7]\\d{6})$|1", "784$1", 0, "784", [["784(?:266|3(?:6[6-9]|7\\d|8[0-6])|4(?:38|5[0-36-8]|8[0-8])|5(?:55|7[0-2]|93)|638|784)\\d{4}"], ["784(?:4(?:3[0-5]|5[45]|89|9[0-8])|5(?:2[6-9]|3[0-4])|720)\\d{4}"], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"], 0, 0, 0, ["78451[0-2]\\d{4}"]]], VE: ["58", "00", "[68]00\\d{7}|(?:[24]\\d|[59]0)\\d{8}", [10], [["(\\d{3})(\\d{7})", "$1-$2", ["[24-689]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:2(?:12|3[457-9]|[467]\\d|[58][1-9]|9[1-6])|[4-6]00)\\d{7}"], ["4(?:1[24-8]|2[246])\\d{7}"], ["800\\d{7}"], ["90[01]\\d{7}"], 0, 0, ["501\\d{7}"]]], VG: ["1", "011", "(?:284|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-578]\\d{6})$|1", "284$1", 0, "284", [["284(?:229|4(?:22|9[45])|774|8(?:52|6[459]))\\d{4}"], ["284(?:245|3(?:0[0-3]|4[0-7]|68|9[34])|4(?:4[0-6]|68|9[69])|5(?:4[0-7]|68|9[69]))\\d{4}"], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"]]], VI: ["1", "011", "[58]\\d{9}|(?:34|90)0\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "340$1", 0, "340", [["340(?:2(?:0\\d|10|2[06-8]|4[49]|77)|3(?:32|44)|4(?:2[23]|44|7[34]|89)|5(?:1[34]|55)|6(?:2[56]|4[23]|77|9[023])|7(?:1[2-57-9]|2[57]|7\\d)|884|998)\\d{4}"], [""], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"]]], VN: ["84", "00", "[12]\\d{9}|[135-9]\\d{8}|[16]\\d{7}|[16-8]\\d{6}", [7, 8, 9, 10], [["(\\d{2})(\\d{5})", "$1 $2", ["80"], "0$1", 1], ["(\\d{4})(\\d{4,6})", "$1 $2", ["1"], 0, 1], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["6"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[357-9]"], "0$1", 1], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["2[48]"], "0$1", 1], ["(\\d{3})(\\d{4})(\\d{3})", "$1 $2 $3", ["2"], "0$1", 1]], "0", 0, 0, 0, 0, 0, [["2(?:0[3-9]|1[0-689]|2[0-25-9]|[38][2-9]|4[2-8]|5[124-9]|6[0-39]|7[0-7]|9[0-4679])\\d{7}", [10]], ["(?:5(?:2[238]|59)|89[6-9]|99[013-9])\\d{6}|(?:3\\d|5[1689]|7[06-9]|8[1-8]|9[0-8])\\d{7}", [9]], ["1800\\d{4,6}|12(?:0[13]|28)\\d{4}", [8, 9, 10]], ["1900\\d{4,6}", [8, 9, 10]], 0, 0, ["(?:[17]99|80\\d)\\d{4}|69\\d{5,6}", [7, 8]], 0, ["672\\d{6}", [9]]]], VU: ["678", "00", "[57-9]\\d{6}|(?:[238]\\d|48)\\d{3}", [5, 7], [["(\\d{3})(\\d{4})", "$1 $2", ["[57-9]"]]], 0, 0, 0, 0, 0, 0, [["(?:38[0-8]|48[4-9])\\d\\d|(?:2[02-9]|3[4-7]|88)\\d{3}", [5]], ["(?:[58]\\d|7[013-7])\\d{5}", [7]], ["81[18]\\d\\d", [5]], 0, 0, 0, ["(?:3[03]|900\\d)\\d{3}"], 0, ["9(?:0[1-9]|1[01])\\d{4}", [7]]]], WF: ["681", "00", "(?:40|72|8\\d{4})\\d{4}|[89]\\d{5}", [6, 9], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["[47-9]"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]]], 0, 0, 0, 0, 0, 0, [["72\\d{4}", [6]], ["(?:72|8[23])\\d{4}", [6]], ["80[0-5]\\d{6}", [9]], 0, 0, ["[48]0\\d{4}", [6]], 0, 0, ["9[23]\\d{4}", [6]]]], WS: ["685", "0", "(?:[2-6]|8\\d{5})\\d{4}|[78]\\d{6}|[68]\\d{5}", [5, 6, 7, 10], [["(\\d{5})", "$1", ["[2-5]|6[1-9]"]], ["(\\d{3})(\\d{3,7})", "$1 $2", ["[68]"]], ["(\\d{2})(\\d{5})", "$1 $2", ["7"]]], 0, 0, 0, 0, 0, 0, [["6[1-9]\\d{3}|(?:[2-5]|60)\\d{4}", [5, 6]], ["(?:7[1-35-7]|8(?:[3-7]|9\\d{3}))\\d{5}", [7, 10]], ["800\\d{3}", [6]]]], XK: ["383", "00", "2\\d{7,8}|3\\d{7,11}|(?:4\\d\\d|[89]00)\\d{5}", [8, 9, 10, 11, 12], [["(\\d{3})(\\d{5})", "$1 $2", ["[89]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-4]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["2|39"], "0$1"], ["(\\d{2})(\\d{7,10})", "$1 $2", ["3"], "0$1"]], "0", 0, 0, 0, 0, 0, [["38\\d{6,10}|(?:2[89]|39)(?:0\\d{5,6}|[1-9]\\d{5})"], ["4[3-9]\\d{6}", [8]], ["800\\d{5}", [8]], ["900\\d{5}", [8]]]], YE: ["967", "00", "(?:1|7\\d)\\d{7}|[1-7]\\d{6}", [7, 8, 9], [["(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-6]|7(?:[24-6]|8[0-7])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["7"], "0$1"]], "0", 0, 0, 0, 0, 0, [["78[0-7]\\d{4}|17\\d{6}|(?:[12][2-68]|3[2358]|4[2-58]|5[2-6]|6[3-58]|7[24-6])\\d{5}", [7, 8]], ["7[01378]\\d{7}", [9]]]], YT: ["262", "00", "7093\\d{5}|(?:80|9\\d)\\d{7}|(?:26|63)9\\d{6}", [9], 0, "0", 0, 0, 0, 0, 0, [["269(?:0[0-467]|15|5[0-4]|6\\d|[78]0)\\d{4}"], ["(?:639(?:0[0-79]|1[019]|[267]\\d|3[09]|40|5[05-9]|9[04-79])|7093[5-7])\\d{4}"], ["80\\d{7}"], 0, 0, 0, 0, 0, ["9(?:(?:39|47)8[01]|769\\d)\\d{4}"]]], ZA: ["27", "00", "[1-79]\\d{8}|8\\d{4,9}", [5, 6, 7, 8, 9, 10], [["(\\d{2})(\\d{3,4})", "$1 $2", ["8[1-4]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["8[1-4]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["860"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"], "0$1"]], "0", 0, 0, 0, 0, 0, [["50[0-2]\\d{6}|(?:2(?:0330|4302)|52087)0\\d{3}|(?:1[0-8]|2[1-378]|3[1-69]|4\\d|5[1346-8])\\d{7}", [9]], ["(?:1(?:3492[0-25]|4495[0235]|549(?:20|5[01]))|4[34]492[01])\\d{3}|8[1-4]\\d{3,7}|(?:2[27]|47|54)4950\\d{3}|(?:1(?:049[2-4]|9[12]\\d\\d)|(?:6\\d\\d|7(?:[0-46-9]\\d|5[0-4]))\\d\\d|8(?:5\\d{3}|7(?:08[67]|158|28[5-9]|310)))\\d{4}|(?:1[6-8]|28|3[2-69]|4[025689]|5[36-8])4920\\d{3}|(?:12|[2-5]1)492\\d{4}", [5, 6, 7, 8, 9]], ["80\\d{7}", [9]], ["(?:86[2-9]|9[0-2]\\d)\\d{6}", [9]], 0, 0, ["861\\d{6,7}", [9, 10]], 0, ["87(?:08[0-589]|15[0-79]|28[0-4]|31[1-9])\\d{4}|87(?:[02][0-79]|1[0-46-9]|3[02-9]|[4-9]\\d)\\d{5}", [9]], ["860\\d{6}", [9]]]], ZM: ["260", "00", "800\\d{6}|(?:21|63|[79]\\d)\\d{7}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[28]"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["[79]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["21[1-8]\\d{6}"], ["(?:7[5-79]|9[5-8])\\d{7}"], ["800\\d{6}"], 0, 0, 0, 0, 0, ["63\\d{7}"]]], ZW: ["263", "00", "2(?:[0-57-9]\\d{6,8}|6[0-24-9]\\d{6,7})|[38]\\d{9}|[35-8]\\d{8}|[3-6]\\d{7}|[1-689]\\d{6}|[1-3569]\\d{5}|[1356]\\d{4}", [5, 6, 7, 8, 9, 10], [["(\\d{3})(\\d{3,5})", "$1 $2", ["2(?:0[45]|2[278]|[49]8)|3(?:[09]8|17)|6(?:[29]8|37|75)|[23][78]|(?:33|5[15]|6[68])[78]"], "0$1"], ["(\\d)(\\d{3})(\\d{2,4})", "$1 $2 $3", ["[49]"], "0$1"], ["(\\d{3})(\\d{4})", "$1 $2", ["80"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["24|8[13-59]|(?:2[05-79]|39|5[45]|6[15-8])2", "2(?:02[014]|4|[56]20|[79]2)|392|5(?:42|525)|6(?:[16-8]21|52[013])|8[13-59]"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2(?:1[39]|2[0157]|[378]|[56][14])|3(?:12|29)", "2(?:1[39]|2[0157]|[378]|[56][14])|3(?:123|29)"], "0$1"], ["(\\d{4})(\\d{6})", "$1 $2", ["8"], "0$1"], ["(\\d{2})(\\d{3,5})", "$1 $2", ["1|2(?:0[0-36-9]|12|29|[56])|3(?:1[0-689]|[24-6])|5(?:[0236-9]|1[2-4])|6(?:[013-59]|7[0-46-9])|(?:33|55|6[68])[0-69]|(?:29|3[09]|62)[0-79]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["29[013-9]|39|54"], "0$1"], ["(\\d{4})(\\d{3,5})", "$1 $2", ["(?:25|54)8", "258|5483"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:1(?:(?:3\\d|9)\\d|[4-8])|2(?:(?:(?:0(?:2[014]|5)|(?:2[0157]|31|84|9)\\d\\d|[56](?:[14]\\d\\d|20)|7(?:[089]|2[03]|[35]\\d\\d))\\d|4(?:2\\d\\d|8))\\d|1(?:2|[39]\\d{4}))|3(?:(?:123|(?:29\\d|92)\\d)\\d\\d|7(?:[19]|[56]\\d))|5(?:0|1[2-478]|26|[37]2|4(?:2\\d{3}|83)|5(?:25\\d\\d|[78])|[689]\\d)|6(?:(?:[16-8]21|28|52[013])\\d\\d|[39])|8(?:[1349]28|523)\\d\\d)\\d{3}|(?:4\\d\\d|9[2-9])\\d{4,5}|(?:(?:2(?:(?:(?:0|8[146])\\d|7[1-7])\\d|2(?:[278]\\d|92)|58(?:2\\d|3))|3(?:[26]|9\\d{3})|5(?:4\\d|5)\\d\\d)\\d|6(?:(?:(?:[0-246]|[78]\\d)\\d|37)\\d|5[2-8]))\\d\\d|(?:2(?:[569]\\d|8[2-57-9])|3(?:[013-59]\\d|8[37])|6[89]8)\\d{3}"], ["7(?:[1278]\\d|3[1-9])\\d{6}", [9]], ["80(?:[01]\\d|20|8[0-8])\\d{3}", [7]], 0, 0, 0, 0, 0, ["86(?:1[12]|22|30|44|55|77|8[368])\\d{6}", [10]]]] }, nonGeographic: { 800: ["800", 0, "(?:00|[1-9]\\d)\\d{6}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["\\d"]]], 0, 0, 0, 0, 0, 0, [0, 0, ["(?:00|[1-9]\\d)\\d{6}"]]], 808: ["808", 0, "[1-9]\\d{7}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[1-9]"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, 0, 0, 0, ["[1-9]\\d{7}"]]], 870: ["870", 0, "7\\d{11}|[235-7]\\d{8}", [9, 12], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[235-7]"]]], 0, 0, 0, 0, 0, 0, [0, ["(?:[356]|774[45])\\d{8}|7[6-8]\\d{7}"], 0, 0, 0, 0, 0, 0, ["2\\d{8}", [9]]]], 878: ["878", 0, "10\\d{10}", [12], [["(\\d{2})(\\d{5})(\\d{5})", "$1 $2 $3", ["1"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, 0, 0, ["10\\d{10}"]]], 881: ["881", 0, "6\\d{9}|[0-36-9]\\d{8}", [9, 10], [["(\\d)(\\d{3})(\\d{5})", "$1 $2 $3", ["[0-37-9]"]], ["(\\d)(\\d{3})(\\d{5,6})", "$1 $2 $3", ["6"]]], 0, 0, 0, 0, 0, 0, [0, ["6\\d{9}|[0-36-9]\\d{8}"]]], 882: ["882", 0, "[13]\\d{6}(?:\\d{2,5})?|[19]\\d{7}|(?:[25]\\d\\d|4)\\d{7}(?:\\d{2})?", [7, 8, 9, 10, 11, 12], [["(\\d{2})(\\d{5})", "$1 $2", ["16|342"]], ["(\\d{2})(\\d{6})", "$1 $2", ["49"]], ["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["1[36]|9"]], ["(\\d{2})(\\d{4})(\\d{3})", "$1 $2 $3", ["3[23]"]], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["16"]], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["10|23|3(?:[15]|4[57])|4|51"]], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["34"]], ["(\\d{2})(\\d{4,5})(\\d{5})", "$1 $2 $3", ["[1-35]"]]], 0, 0, 0, 0, 0, 0, [0, ["342\\d{4}|(?:337|49)\\d{6}|(?:3(?:2|47|7\\d{3})|50\\d{3})\\d{7}", [7, 8, 9, 10, 12]], 0, 0, 0, ["348[57]\\d{7}", [11]], 0, 0, ["1(?:3(?:0[0347]|[13][0139]|2[035]|4[013568]|6[0459]|7[06]|8[15-8]|9[0689])\\d{4}|6\\d{5,10})|(?:345\\d|9[89])\\d{6}|(?:10|2(?:3|85\\d)|3(?:[15]|[69]\\d\\d)|4[15-8]|51)\\d{8}"]]], 883: ["883", 0, "(?:[1-4]\\d|51)\\d{6,10}", [8, 9, 10, 11, 12], [["(\\d{3})(\\d{3})(\\d{2,8})", "$1 $2 $3", ["[14]|2[24-689]|3[02-689]|51[24-9]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["510"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["21"]], ["(\\d{4})(\\d{4})(\\d{4})", "$1 $2 $3", ["51[13]"]], ["(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["[235]"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, 0, 0, ["(?:2(?:00\\d\\d|10)|(?:370[1-9]|51\\d0)\\d)\\d{7}|51(?:00\\d{5}|[24-9]0\\d{4,7})|(?:1[0-79]|2[24-689]|3[02-689]|4[0-4])0\\d{5,9}"]]], 888: ["888", 0, "\\d{11}", [11], [["(\\d{3})(\\d{3})(\\d{5})", "$1 $2 $3"]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, ["\\d{11}"]]], 979: ["979", 0, "[1359]\\d{8}", [9], [["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["[1359]"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, ["[1359]\\d{8}"]]] } };
function ys(n, e) {
  var t = Array.prototype.slice.call(e);
  return t.push(_s), n.apply(this, t);
}
function Xt(n, e) {
  n = n.split("-"), e = e.split("-");
  for (var t = n[0].split("."), r = e[0].split("."), o = 0; o < 3; o++) {
    var a = Number(t[o]), d = Number(r[o]);
    if (a > d)
      return 1;
    if (d > a)
      return -1;
    if (!isNaN(a) && isNaN(d))
      return 1;
    if (isNaN(a) && !isNaN(d))
      return -1;
  }
  return n[1] && e[1] ? n[1] > e[1] ? 1 : n[1] < e[1] ? -1 : 0 : !n[1] && e[1] ? 1 : n[1] && !e[1] ? -1 : 0;
}
var vs = {}.constructor;
function un(n) {
  return n != null && n.constructor === vs;
}
function _t(n) {
  "@babel/helpers - typeof";
  return _t = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, _t(n);
}
function Xn(n, e) {
  if (!(n instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function Ns(n, e) {
  for (var t = 0; t < e.length; t++) {
    var r = e[t];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(n, r.key, r);
  }
}
function et(n, e, t) {
  return e && Ns(n.prototype, e), Object.defineProperty(n, "prototype", { writable: !1 }), n;
}
var Cs = "1.2.0", bs = "1.7.35", er = " ext. ", ws = /^\d+$/, Ce = /* @__PURE__ */ function() {
  function n(e) {
    Xn(this, n), Dr(e), this.metadata = e, Fr.call(this, e);
  }
  return et(n, [{
    key: "getCountries",
    value: function() {
      return Object.keys(this.metadata.countries).filter(function(t) {
        return t !== "001";
      });
    }
  }, {
    key: "getCountryMetadata",
    value: function(t) {
      return this.metadata.countries[t];
    }
  }, {
    key: "nonGeographic",
    value: function() {
      if (!(this.v1 || this.v2 || this.v3))
        return this.metadata.nonGeographic || this.metadata.nonGeographical;
    }
  }, {
    key: "hasCountry",
    value: function(t) {
      return this.getCountryMetadata(t) !== void 0;
    }
  }, {
    key: "hasCallingCode",
    value: function(t) {
      if (this.getCountryCodesForCallingCode(t))
        return !0;
      if (this.nonGeographic()) {
        if (this.nonGeographic()[t])
          return !0;
      } else {
        var r = this.countryCallingCodes()[t];
        if (r && r.length === 1 && r[0] === "001")
          return !0;
      }
    }
  }, {
    key: "isNonGeographicCallingCode",
    value: function(t) {
      return this.nonGeographic() ? !!this.nonGeographic()[t] : !this.getCountryCodesForCallingCode(t);
    }
    // Deprecated.
  }, {
    key: "country",
    value: function(t) {
      return this.selectNumberingPlan(t);
    }
  }, {
    key: "selectNumberingPlan",
    value: function(t, r) {
      if (t && ws.test(t) && (r = t, t = null), t && t !== "001") {
        if (!this.hasCountry(t))
          throw new Error("Unknown country: ".concat(t));
        this.numberingPlan = new nr(this.getCountryMetadata(t), this);
      } else if (r) {
        if (!this.hasCallingCode(r))
          throw new Error("Unknown calling code: ".concat(r));
        this.numberingPlan = new nr(this.getNumberingPlanMetadata(r), this);
      } else
        this.numberingPlan = void 0;
      return this;
    }
  }, {
    key: "getCountryCodesForCallingCode",
    value: function(t) {
      var r = this.countryCallingCodes()[t];
      if (r)
        return r.length === 1 && r[0].length === 3 ? void 0 : r;
    }
  }, {
    key: "getCountryCodeForCallingCode",
    value: function(t) {
      var r = this.getCountryCodesForCallingCode(t);
      if (r)
        return r[0];
    }
  }, {
    key: "getNumberingPlanMetadata",
    value: function(t) {
      var r = this.getCountryCodeForCallingCode(t);
      if (r)
        return this.getCountryMetadata(r);
      if (this.nonGeographic()) {
        var o = this.nonGeographic()[t];
        if (o)
          return o;
      } else {
        var a = this.countryCallingCodes()[t];
        if (a && a.length === 1 && a[0] === "001")
          return this.metadata.countries["001"];
      }
    }
    // Deprecated.
  }, {
    key: "countryCallingCode",
    value: function() {
      return this.numberingPlan.callingCode();
    }
    // Deprecated.
  }, {
    key: "IDDPrefix",
    value: function() {
      return this.numberingPlan.IDDPrefix();
    }
    // Deprecated.
  }, {
    key: "defaultIDDPrefix",
    value: function() {
      return this.numberingPlan.defaultIDDPrefix();
    }
    // Deprecated.
  }, {
    key: "nationalNumberPattern",
    value: function() {
      return this.numberingPlan.nationalNumberPattern();
    }
    // Deprecated.
  }, {
    key: "possibleLengths",
    value: function() {
      return this.numberingPlan.possibleLengths();
    }
    // Deprecated.
  }, {
    key: "formats",
    value: function() {
      return this.numberingPlan.formats();
    }
    // Deprecated.
  }, {
    key: "nationalPrefixForParsing",
    value: function() {
      return this.numberingPlan.nationalPrefixForParsing();
    }
    // Deprecated.
  }, {
    key: "nationalPrefixTransformRule",
    value: function() {
      return this.numberingPlan.nationalPrefixTransformRule();
    }
    // Deprecated.
  }, {
    key: "leadingDigits",
    value: function() {
      return this.numberingPlan.leadingDigits();
    }
    // Deprecated.
  }, {
    key: "hasTypes",
    value: function() {
      return this.numberingPlan.hasTypes();
    }
    // Deprecated.
  }, {
    key: "type",
    value: function(t) {
      return this.numberingPlan.type(t);
    }
    // Deprecated.
  }, {
    key: "ext",
    value: function() {
      return this.numberingPlan.ext();
    }
  }, {
    key: "countryCallingCodes",
    value: function() {
      return this.v1 ? this.metadata.country_phone_code_to_countries : this.metadata.country_calling_codes;
    }
    // Deprecated.
  }, {
    key: "chooseCountryByCountryCallingCode",
    value: function(t) {
      return this.selectNumberingPlan(t);
    }
  }, {
    key: "hasSelectedNumberingPlan",
    value: function() {
      return this.numberingPlan !== void 0;
    }
  }]), n;
}(), nr = /* @__PURE__ */ function() {
  function n(e, t) {
    Xn(this, n), this.globalMetadataObject = t, this.metadata = e, Fr.call(this, t.metadata);
  }
  return et(n, [{
    key: "callingCode",
    value: function() {
      return this.metadata[0];
    }
    // Formatting information for regions which share
    // a country calling code is contained by only one region
    // for performance reasons. For example, for NANPA region
    // ("North American Numbering Plan Administration",
    //  which includes USA, Canada, Cayman Islands, Bahamas, etc)
    // it will be contained in the metadata for `US`.
  }, {
    key: "getDefaultCountryMetadataForRegion",
    value: function() {
      return this.globalMetadataObject.getNumberingPlanMetadata(this.callingCode());
    }
    // Is always present.
  }, {
    key: "IDDPrefix",
    value: function() {
      if (!(this.v1 || this.v2))
        return this.metadata[1];
    }
    // Is only present when a country supports multiple IDD prefixes.
  }, {
    key: "defaultIDDPrefix",
    value: function() {
      if (!(this.v1 || this.v2))
        return this.metadata[12];
    }
  }, {
    key: "nationalNumberPattern",
    value: function() {
      return this.v1 || this.v2 ? this.metadata[1] : this.metadata[2];
    }
    // "possible length" data is always present in Google's metadata.
  }, {
    key: "possibleLengths",
    value: function() {
      if (!this.v1)
        return this.metadata[this.v2 ? 2 : 3];
    }
  }, {
    key: "_getFormats",
    value: function(t) {
      return t[this.v1 ? 2 : this.v2 ? 3 : 4];
    }
    // For countries of the same region (e.g. NANPA)
    // formats are all stored in the "main" country for that region.
    // E.g. "RU" and "KZ", "US" and "CA".
  }, {
    key: "formats",
    value: function() {
      var t = this, r = this._getFormats(this.metadata) || this._getFormats(this.getDefaultCountryMetadataForRegion()) || [];
      return r.map(function(o) {
        return new Es(o, t);
      });
    }
  }, {
    key: "nationalPrefix",
    value: function() {
      return this.metadata[this.v1 ? 3 : this.v2 ? 4 : 5];
    }
  }, {
    key: "_getNationalPrefixFormattingRule",
    value: function(t) {
      return t[this.v1 ? 4 : this.v2 ? 5 : 6];
    }
    // For countries of the same region (e.g. NANPA)
    // national prefix formatting rule is stored in the "main" country for that region.
    // E.g. "RU" and "KZ", "US" and "CA".
  }, {
    key: "nationalPrefixFormattingRule",
    value: function() {
      return this._getNationalPrefixFormattingRule(this.metadata) || this._getNationalPrefixFormattingRule(this.getDefaultCountryMetadataForRegion());
    }
  }, {
    key: "_nationalPrefixForParsing",
    value: function() {
      return this.metadata[this.v1 ? 5 : this.v2 ? 6 : 7];
    }
  }, {
    key: "nationalPrefixForParsing",
    value: function() {
      return this._nationalPrefixForParsing() || this.nationalPrefix();
    }
  }, {
    key: "nationalPrefixTransformRule",
    value: function() {
      return this.metadata[this.v1 ? 6 : this.v2 ? 7 : 8];
    }
  }, {
    key: "_getNationalPrefixIsOptionalWhenFormatting",
    value: function() {
      return !!this.metadata[this.v1 ? 7 : this.v2 ? 8 : 9];
    }
    // For countries of the same region (e.g. NANPA)
    // "national prefix is optional when formatting" flag is
    // stored in the "main" country for that region.
    // E.g. "RU" and "KZ", "US" and "CA".
  }, {
    key: "nationalPrefixIsOptionalWhenFormattingInNationalFormat",
    value: function() {
      return this._getNationalPrefixIsOptionalWhenFormatting(this.metadata) || this._getNationalPrefixIsOptionalWhenFormatting(this.getDefaultCountryMetadataForRegion());
    }
  }, {
    key: "leadingDigits",
    value: function() {
      return this.metadata[this.v1 ? 8 : this.v2 ? 9 : 10];
    }
  }, {
    key: "types",
    value: function() {
      return this.metadata[this.v1 ? 9 : this.v2 ? 10 : 11];
    }
  }, {
    key: "hasTypes",
    value: function() {
      return this.types() && this.types().length === 0 ? !1 : !!this.types();
    }
  }, {
    key: "type",
    value: function(t) {
      if (this.hasTypes() && tr(this.types(), t))
        return new Os(tr(this.types(), t), this);
    }
  }, {
    key: "ext",
    value: function() {
      return this.v1 || this.v2 ? er : this.metadata[13] || er;
    }
  }]), n;
}(), Es = /* @__PURE__ */ function() {
  function n(e, t) {
    Xn(this, n), this._format = e, this.metadata = t;
  }
  return et(n, [{
    key: "pattern",
    value: function() {
      return this._format[0];
    }
  }, {
    key: "format",
    value: function() {
      return this._format[1];
    }
  }, {
    key: "leadingDigitsPatterns",
    value: function() {
      return this._format[2] || [];
    }
  }, {
    key: "nationalPrefixFormattingRule",
    value: function() {
      return this._format[3] || this.metadata.nationalPrefixFormattingRule();
    }
  }, {
    key: "nationalPrefixIsOptionalWhenFormattingInNationalFormat",
    value: function() {
      return !!this._format[4] || this.metadata.nationalPrefixIsOptionalWhenFormattingInNationalFormat();
    }
  }, {
    key: "nationalPrefixIsMandatoryWhenFormattingInNationalFormat",
    value: function() {
      return this.usesNationalPrefix() && !this.nationalPrefixIsOptionalWhenFormattingInNationalFormat();
    }
    // Checks whether national prefix formatting rule contains national prefix.
  }, {
    key: "usesNationalPrefix",
    value: function() {
      return !!(this.nationalPrefixFormattingRule() && // Check that national prefix formatting rule is not a "dummy" one.
      !As.test(this.nationalPrefixFormattingRule()));
    }
  }, {
    key: "internationalFormat",
    value: function() {
      return this._format[5] || this.format();
    }
  }]), n;
}(), As = /^\(?\$1\)?$/, Os = /* @__PURE__ */ function() {
  function n(e, t) {
    Xn(this, n), this.type = e, this.metadata = t;
  }
  return et(n, [{
    key: "pattern",
    value: function() {
      return this.metadata.v1 ? this.type : this.type[0];
    }
  }, {
    key: "possibleLengths",
    value: function() {
      if (!this.metadata.v1)
        return this.type[1] || this.metadata.possibleLengths();
    }
  }]), n;
}();
function tr(n, e) {
  switch (e) {
    case "FIXED_LINE":
      return n[0];
    case "MOBILE":
      return n[1];
    case "TOLL_FREE":
      return n[2];
    case "PREMIUM_RATE":
      return n[3];
    case "PERSONAL_NUMBER":
      return n[4];
    case "VOICEMAIL":
      return n[5];
    case "UAN":
      return n[6];
    case "PAGER":
      return n[7];
    case "VOIP":
      return n[8];
    case "SHARED_COST":
      return n[9];
  }
}
function Dr(n) {
  if (!n)
    throw new Error("[libphonenumber-js] `metadata` argument not passed. Check your arguments.");
  if (!un(n) || !un(n.countries))
    throw new Error("[libphonenumber-js] `metadata` argument was passed but it's not a valid metadata. Must be an object having `.countries` child object property. Got ".concat(un(n) ? "an object of shape: { " + Object.keys(n).join(", ") + " }" : "a " + Ss(n) + ": " + n, "."));
}
var Ss = function(e) {
  return _t(e);
};
function Pt(n, e) {
  if (e = new Ce(e), e.hasCountry(n))
    return e.country(n).countryCallingCode();
  throw new Error("Unknown country: ".concat(n));
}
function Ts(n, e) {
  return e.countries.hasOwnProperty(n);
}
function Fr(n) {
  var e = n.version;
  typeof e == "number" ? (this.v1 = e === 1, this.v2 = e === 2, this.v3 = e === 3, this.v4 = e === 4) : e ? Xt(e, Cs) === -1 ? this.v2 = !0 : Xt(e, bs) === -1 ? this.v3 = !0 : this.v4 = !0 : this.v1 = !0;
}
function Lt(n, e) {
  return ks(n, void 0, e);
}
function ks(n, e, t) {
  var r = t.type(e), o = r && r.possibleLengths() || t.possibleLengths();
  if (!o)
    return "IS_POSSIBLE";
  var a = n.length, d = o[0];
  return d === a ? "IS_POSSIBLE" : d > a ? "TOO_SHORT" : o[o.length - 1] < a ? "TOO_LONG" : o.indexOf(a, 1) >= 0 ? "IS_POSSIBLE" : "INVALID_LENGTH";
}
function Is(n, e, t) {
  if (e === void 0 && (e = {}), t = new Ce(t), e.v2) {
    if (!n.countryCallingCode)
      throw new Error("Invalid phone number object passed");
    t.selectNumberingPlan(n.countryCallingCode);
  } else {
    if (!n.phone)
      return !1;
    if (n.country) {
      if (!t.hasCountry(n.country))
        throw new Error("Unknown country: ".concat(n.country));
      t.country(n.country);
    } else {
      if (!n.countryCallingCode)
        throw new Error("Invalid phone number object passed");
      t.selectNumberingPlan(n.countryCallingCode);
    }
  }
  if (t.possibleLengths())
    return Ur(n.phone || n.nationalNumber, t);
  if (n.countryCallingCode && t.isNonGeographicCallingCode(n.countryCallingCode))
    return !0;
  throw new Error('Missing "possibleLengths" in metadata. Perhaps the metadata has been generated before v1.0.18.');
}
function Ur(n, e) {
  switch (Lt(n, e)) {
    case "IS_POSSIBLE":
      return !0;
    default:
      return !1;
  }
}
function Ke(n, e) {
  return n = n || "", new RegExp("^(?:" + e + ")$").test(n);
}
function Rs(n, e) {
  var t = typeof Symbol < "u" && n[Symbol.iterator] || n["@@iterator"];
  if (t)
    return (t = t.call(n)).next.bind(t);
  if (Array.isArray(n) || (t = Ps(n)) || e) {
    t && (n = t);
    var r = 0;
    return function() {
      return r >= n.length ? { done: !0 } : { done: !1, value: n[r++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Ps(n, e) {
  if (n) {
    if (typeof n == "string")
      return rr(n, e);
    var t = Object.prototype.toString.call(n).slice(8, -1);
    if (t === "Object" && n.constructor && (t = n.constructor.name), t === "Map" || t === "Set")
      return Array.from(n);
    if (t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t))
      return rr(n, e);
  }
}
function rr(n, e) {
  (e == null || e > n.length) && (e = n.length);
  for (var t = 0, r = new Array(e); t < e; t++)
    r[t] = n[t];
  return r;
}
var Ls = ["MOBILE", "PREMIUM_RATE", "TOLL_FREE", "SHARED_COST", "VOIP", "PERSONAL_NUMBER", "PAGER", "UAN", "VOICEMAIL"];
function xt(n, e, t) {
  if (e = e || {}, !(!n.country && !n.countryCallingCode)) {
    t = new Ce(t), t.selectNumberingPlan(n.country, n.countryCallingCode);
    var r = e.v2 ? n.nationalNumber : n.phone;
    if (Ke(r, t.nationalNumberPattern())) {
      if (dt(r, "FIXED_LINE", t))
        return t.type("MOBILE") && t.type("MOBILE").pattern() === "" || !t.type("MOBILE") || dt(r, "MOBILE", t) ? "FIXED_LINE_OR_MOBILE" : "FIXED_LINE";
      for (var o = Rs(Ls), a; !(a = o()).done; ) {
        var d = a.value;
        if (dt(r, d, t))
          return d;
      }
    }
  }
}
function dt(n, e, t) {
  return e = t.type(e), !e || !e.pattern() || e.possibleLengths() && e.possibleLengths().indexOf(n.length) < 0 ? !1 : Ke(n, e.pattern());
}
function xs(n, e, t) {
  if (e = e || {}, t = new Ce(t), t.selectNumberingPlan(n.country, n.countryCallingCode), t.hasTypes())
    return xt(n, e, t.metadata) !== void 0;
  var r = e.v2 ? n.nationalNumber : n.phone;
  return Ke(r, t.nationalNumberPattern());
}
function Ms(n, e, t) {
  var r = new Ce(t), o = r.getCountryCodesForCallingCode(n);
  return o ? o.filter(function(a) {
    return Ds(e, a, t);
  }) : [];
}
function Ds(n, e, t) {
  var r = new Ce(t);
  return r.selectNumberingPlan(e), r.numberingPlan.possibleLengths().indexOf(n.length) >= 0;
}
var Mt = 2, Fs = 17, Us = 3, Pe = "0-9０-９٠-٩۰-۹", Gs = "-‐-―−ー－", Bs = "／/", js = "．.", Hs = "  ­​⁠　", Vs = "()（）［］\\[\\]", zs = "~⁓∼～", Kn = "".concat(Gs).concat(Bs).concat(js).concat(Hs).concat(Vs).concat(zs), Dt = "+＋", Ks = new RegExp("([" + Pe + "])");
function qs(n, e, t, r) {
  if (e) {
    var o = new Ce(r);
    o.selectNumberingPlan(e, t);
    var a = new RegExp(o.IDDPrefix());
    if (n.search(a) === 0) {
      n = n.slice(n.match(a)[0].length);
      var d = n.match(Ks);
      if (!(d && d[1] != null && d[1].length > 0 && d[1] === "0"))
        return n;
    }
  }
}
function Qs(n, e) {
  if (n && e.numberingPlan.nationalPrefixForParsing()) {
    var t = new RegExp("^(?:" + e.numberingPlan.nationalPrefixForParsing() + ")"), r = t.exec(n);
    if (r) {
      var o, a, d = r.length - 1, s = d > 0 && r[d];
      if (e.nationalPrefixTransformRule() && s)
        o = n.replace(t, e.nationalPrefixTransformRule()), d > 1 && (a = r[1]);
      else {
        var l = r[0];
        o = n.slice(l.length), s && (a = r[1]);
      }
      var f;
      if (s) {
        var p = n.indexOf(r[1]), _ = n.slice(0, p);
        _ === e.numberingPlan.nationalPrefix() && (f = e.numberingPlan.nationalPrefix());
      } else
        f = r[0];
      return {
        nationalNumber: o,
        nationalPrefix: f,
        carrierCode: a
      };
    }
  }
  return {
    nationalNumber: n
  };
}
function yt(n, e) {
  var t = Qs(n, e), r = t.carrierCode, o = t.nationalNumber;
  if (o !== n) {
    if (!Ws(n, o, e))
      return {
        nationalNumber: n
      };
    if (e.possibleLengths() && !Zs(o, e))
      return {
        nationalNumber: n
      };
  }
  return {
    nationalNumber: o,
    carrierCode: r
  };
}
function Ws(n, e, t) {
  return !(Ke(n, t.nationalNumberPattern()) && !Ke(e, t.nationalNumberPattern()));
}
function Zs(n, e) {
  switch (Lt(n, e)) {
    case "TOO_SHORT":
    case "INVALID_LENGTH":
      return !1;
    default:
      return !0;
  }
}
function Js(n, e, t, r) {
  var o = e ? Pt(e, r) : t;
  if (n.indexOf(o) === 0) {
    r = new Ce(r), r.selectNumberingPlan(e, t);
    var a = n.slice(o.length), d = yt(a, r), s = d.nationalNumber, l = yt(n, r), f = l.nationalNumber;
    if (!Ke(f, r.nationalNumberPattern()) && Ke(s, r.nationalNumberPattern()) || Lt(f, r) === "TOO_LONG")
      return {
        countryCallingCode: o,
        number: a
      };
  }
  return {
    number: n
  };
}
function Gr(n, e, t, r) {
  if (!n)
    return {};
  var o;
  if (n[0] !== "+") {
    var a = qs(n, e, t, r);
    if (a && a !== n)
      o = !0, n = "+" + a;
    else {
      if (e || t) {
        var d = Js(n, e, t, r), s = d.countryCallingCode, l = d.number;
        if (s)
          return {
            countryCallingCodeSource: "FROM_NUMBER_WITHOUT_PLUS_SIGN",
            countryCallingCode: s,
            number: l
          };
      }
      return {
        // No need to set it to `UNSPECIFIED`. It can be just `undefined`.
        // countryCallingCodeSource: 'UNSPECIFIED',
        number: n
      };
    }
  }
  if (n[1] === "0")
    return {};
  r = new Ce(r);
  for (var f = 2; f - 1 <= Us && f <= n.length; ) {
    var p = n.slice(1, f);
    if (r.hasCallingCode(p))
      return r.selectNumberingPlan(p), {
        countryCallingCodeSource: o ? "FROM_NUMBER_WITH_IDD" : "FROM_NUMBER_WITH_PLUS_SIGN",
        countryCallingCode: p,
        number: n.slice(f)
      };
    f++;
  }
  return {};
}
function Ys(n) {
  return n.replace(new RegExp("[".concat(Kn, "]+"), "g"), " ").trim();
}
var Xs = /(\$\d)/;
function ec(n, e, t) {
  var r = t.useInternationalFormat, o = t.withNationalPrefix, a = n.replace(new RegExp(e.pattern()), r ? e.internationalFormat() : (
    // This library doesn't use `domestic_carrier_code_formatting_rule`,
    // because that one is only used when formatting phone numbers
    // for dialing from a mobile phone, and this is not a dialing library.
    // carrierCode && format.domesticCarrierCodeFormattingRule()
    // 	// First, replace the $CC in the formatting rule with the desired carrier code.
    // 	// Then, replace the $FG in the formatting rule with the first group
    // 	// and the carrier code combined in the appropriate way.
    // 	? format.format().replace(FIRST_GROUP_PATTERN, format.domesticCarrierCodeFormattingRule().replace('$CC', carrierCode))
    // 	: (
    // 		withNationalPrefix && format.nationalPrefixFormattingRule()
    // 			? format.format().replace(FIRST_GROUP_PATTERN, format.nationalPrefixFormattingRule())
    // 			: format.format()
    // 	)
    o && e.nationalPrefixFormattingRule() ? e.format().replace(Xs, e.nationalPrefixFormattingRule()) : e.format()
  ));
  return r ? Ys(a) : a;
}
var nc = /^[\d]+(?:[~\u2053\u223C\uFF5E][\d]+)?$/;
function tc(n, e, t) {
  var r = new Ce(t);
  if (r.selectNumberingPlan(n, e), r.defaultIDDPrefix())
    return r.defaultIDDPrefix();
  if (nc.test(r.IDDPrefix()))
    return r.IDDPrefix();
}
var rc = ";ext=", cn = function(e) {
  return "([".concat(Pe, "]{1,").concat(e, "})");
};
function Br(n) {
  var e = "20", t = "15", r = "9", o = "6", a = "[  \\t,]*", d = "[:\\.．]?[  \\t,-]*", s = "#?", l = "(?:e?xt(?:ensi(?:ó?|ó))?n?|ｅ?ｘｔｎ?|доб|anexo)", f = "(?:[xｘ#＃~～]|int|ｉｎｔ)", p = "[- ]+", _ = "[  \\t]*", y = "(?:,{2}|;)", u = rc + cn(e), g = a + l + d + cn(e) + s, h = a + f + d + cn(r) + s, c = p + cn(o) + "#", i = _ + y + d + cn(t) + s, m = _ + "(?:,)+" + d + cn(r) + s;
  return u + "|" + g + "|" + h + "|" + c + "|" + i + "|" + m;
}
var oc = "[" + Pe + "]{" + Mt + "}", dc = "[" + Dt + "]{0,1}(?:[" + Kn + "]*[" + Pe + "]){3,}[" + Kn + Pe + "]*", ac = new RegExp("^[" + Dt + "]{0,1}(?:[" + Kn + "]*[" + Pe + "]){1,2}$", "i"), ic = dc + // Phone number extensions
"(?:" + Br() + ")?", sc = new RegExp(
  // Either a short two-digit-only phone number
  "^" + oc + "$|^" + ic + "$",
  "i"
);
function cc(n) {
  return n.length >= Mt && sc.test(n);
}
function lc(n) {
  return ac.test(n);
}
function uc(n) {
  var e = n.number, t = n.ext;
  if (!e)
    return "";
  if (e[0] !== "+")
    throw new Error('"formatRFC3966()" expects "number" to be in E.164 format.');
  return "tel:".concat(e).concat(t ? ";ext=" + t : "");
}
function hc(n, e) {
  var t = typeof Symbol < "u" && n[Symbol.iterator] || n["@@iterator"];
  if (t)
    return (t = t.call(n)).next.bind(t);
  if (Array.isArray(n) || (t = gc(n)) || e) {
    t && (n = t);
    var r = 0;
    return function() {
      return r >= n.length ? { done: !0 } : { done: !1, value: n[r++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function gc(n, e) {
  if (n) {
    if (typeof n == "string")
      return or(n, e);
    var t = Object.prototype.toString.call(n).slice(8, -1);
    if (t === "Object" && n.constructor && (t = n.constructor.name), t === "Map" || t === "Set")
      return Array.from(n);
    if (t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t))
      return or(n, e);
  }
}
function or(n, e) {
  (e == null || e > n.length) && (e = n.length);
  for (var t = 0, r = new Array(e); t < e; t++)
    r[t] = n[t];
  return r;
}
function dr(n, e) {
  var t = Object.keys(n);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(n);
    e && (r = r.filter(function(o) {
      return Object.getOwnPropertyDescriptor(n, o).enumerable;
    })), t.push.apply(t, r);
  }
  return t;
}
function ar(n) {
  for (var e = 1; e < arguments.length; e++) {
    var t = arguments[e] != null ? arguments[e] : {};
    e % 2 ? dr(Object(t), !0).forEach(function(r) {
      fc(n, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(n, Object.getOwnPropertyDescriptors(t)) : dr(Object(t)).forEach(function(r) {
      Object.defineProperty(n, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return n;
}
function fc(n, e, t) {
  return e in n ? Object.defineProperty(n, e, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : n[e] = t, n;
}
var ir = {
  formatExtension: function(e, t, r) {
    return "".concat(e).concat(r.ext()).concat(t);
  }
};
function mc(n, e, t, r) {
  if (t ? t = ar(ar({}, ir), t) : t = ir, r = new Ce(r), n.country && n.country !== "001") {
    if (!r.hasCountry(n.country))
      throw new Error("Unknown country: ".concat(n.country));
    r.country(n.country);
  } else if (n.countryCallingCode)
    r.selectNumberingPlan(n.countryCallingCode);
  else
    return n.phone || "";
  var o = r.countryCallingCode(), a = t.v2 ? n.nationalNumber : n.phone, d;
  switch (e) {
    case "NATIONAL":
      return a ? (d = qn(a, n.carrierCode, "NATIONAL", r, t), at(d, n.ext, r, t.formatExtension)) : "";
    case "INTERNATIONAL":
      return a ? (d = qn(a, null, "INTERNATIONAL", r, t), d = "+".concat(o, " ").concat(d), at(d, n.ext, r, t.formatExtension)) : "+".concat(o);
    case "E.164":
      return "+".concat(o).concat(a);
    case "RFC3966":
      return uc({
        number: "+".concat(o).concat(a),
        ext: n.ext
      });
    case "IDD":
      if (!t.fromCountry)
        return;
      var s = $c(a, n.carrierCode, o, t.fromCountry, r);
      return at(s, n.ext, r, t.formatExtension);
    default:
      throw new Error('Unknown "format" argument passed to "formatNumber()": "'.concat(e, '"'));
  }
}
function qn(n, e, t, r, o) {
  var a = pc(r.formats(), n);
  return a ? ec(n, a, {
    useInternationalFormat: t === "INTERNATIONAL",
    withNationalPrefix: !(a.nationalPrefixIsOptionalWhenFormattingInNationalFormat() && o && o.nationalPrefix === !1)
  }) : n;
}
function pc(n, e) {
  for (var t = hc(n), r; !(r = t()).done; ) {
    var o = r.value;
    if (o.leadingDigitsPatterns().length > 0) {
      var a = o.leadingDigitsPatterns()[o.leadingDigitsPatterns().length - 1];
      if (e.search(a) !== 0)
        continue;
    }
    if (Ke(e, o.pattern()))
      return o;
  }
}
function at(n, e, t, r) {
  return e ? r(n, e, t) : n;
}
function $c(n, e, t, r, o) {
  var a = Pt(r, o.metadata);
  if (a === t) {
    var d = qn(n, e, "NATIONAL", o);
    return t === "1" ? t + " " + d : d;
  }
  var s = tc(r, void 0, o.metadata);
  if (s)
    return "".concat(s, " ").concat(t, " ").concat(qn(n, null, "INTERNATIONAL", o));
}
function sr(n, e) {
  var t = Object.keys(n);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(n);
    e && (r = r.filter(function(o) {
      return Object.getOwnPropertyDescriptor(n, o).enumerable;
    })), t.push.apply(t, r);
  }
  return t;
}
function cr(n) {
  for (var e = 1; e < arguments.length; e++) {
    var t = arguments[e] != null ? arguments[e] : {};
    e % 2 ? sr(Object(t), !0).forEach(function(r) {
      _c(n, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(n, Object.getOwnPropertyDescriptors(t)) : sr(Object(t)).forEach(function(r) {
      Object.defineProperty(n, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return n;
}
function _c(n, e, t) {
  return e in n ? Object.defineProperty(n, e, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : n[e] = t, n;
}
function yc(n, e) {
  if (!(n instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function vc(n, e) {
  for (var t = 0; t < e.length; t++) {
    var r = e[t];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(n, r.key, r);
  }
}
function Nc(n, e, t) {
  return e && vc(n.prototype, e), Object.defineProperty(n, "prototype", { writable: !1 }), n;
}
var Cc = /* @__PURE__ */ function() {
  function n(e, t, r) {
    if (yc(this, n), !e)
      throw new TypeError("First argument is required");
    if (typeof e != "string")
      throw new TypeError("First argument must be a string");
    if (typeof e == "string") {
      if (e[0] === "+" && !t)
        throw new TypeError("`metadata` argument not passed");
      if (un(t) && un(t.countries)) {
        r = t;
        var o = e;
        if (!Ec.test(o))
          throw new Error('Invalid `number` argument passed: must consist of a "+" followed by digits');
        var a = Gr(o, void 0, void 0, r), d = a.countryCallingCode, s = a.number;
        if (t = s, e = d, !t)
          throw new Error("Invalid `number` argument passed: too short");
      }
    }
    if (!t)
      throw new TypeError("`nationalNumber` argument is required");
    if (typeof t != "string")
      throw new TypeError("`nationalNumber` argument must be a string");
    Dr(r);
    var l = wc(e, r), f = l.country, p = l.countryCallingCode;
    this.country = f, this.countryCallingCode = p, this.nationalNumber = t, this.number = "+" + this.countryCallingCode + this.nationalNumber, this.getMetadata = function() {
      return r;
    };
  }
  return Nc(n, [{
    key: "setExt",
    value: function(t) {
      this.ext = t;
    }
  }, {
    key: "getPossibleCountries",
    value: function() {
      return this.country ? [this.country] : Ms(this.countryCallingCode, this.nationalNumber, this.getMetadata());
    }
  }, {
    key: "isPossible",
    value: function() {
      return Is(this, {
        v2: !0
      }, this.getMetadata());
    }
  }, {
    key: "isValid",
    value: function() {
      return xs(this, {
        v2: !0
      }, this.getMetadata());
    }
  }, {
    key: "isNonGeographic",
    value: function() {
      var t = new Ce(this.getMetadata());
      return t.isNonGeographicCallingCode(this.countryCallingCode);
    }
  }, {
    key: "isEqual",
    value: function(t) {
      return this.number === t.number && this.ext === t.ext;
    }
    // This function was originally meant to be an equivalent for `validatePhoneNumberLength()`,
    // but later it was found out that it doesn't include the possible `TOO_SHORT` result
    // returned from `parsePhoneNumberWithError()` in the original `validatePhoneNumberLength()`,
    // so eventually I simply commented out this method from the `PhoneNumber` class
    // and just left the `validatePhoneNumberLength()` function, even though that one would require
    // and additional step to also validate the actual country / calling code of the phone number.
    // validateLength() {
    // 	const metadata = new Metadata(this.getMetadata())
    // 	metadata.selectNumberingPlan(this.countryCallingCode)
    // 	const result = checkNumberLength(this.nationalNumber, metadata)
    // 	if (result !== 'IS_POSSIBLE') {
    // 		return result
    // 	}
    // }
  }, {
    key: "getType",
    value: function() {
      return xt(this, {
        v2: !0
      }, this.getMetadata());
    }
  }, {
    key: "format",
    value: function(t, r) {
      return mc(this, t, r ? cr(cr({}, r), {}, {
        v2: !0
      }) : {
        v2: !0
      }, this.getMetadata());
    }
  }, {
    key: "formatNational",
    value: function(t) {
      return this.format("NATIONAL", t);
    }
  }, {
    key: "formatInternational",
    value: function(t) {
      return this.format("INTERNATIONAL", t);
    }
  }, {
    key: "getURI",
    value: function(t) {
      return this.format("RFC3966", t);
    }
  }]), n;
}(), bc = function(e) {
  return /^[A-Z]{2}$/.test(e);
};
function wc(n, e) {
  var t, r, o = new Ce(e);
  return bc(n) ? (t = n, o.selectNumberingPlan(t), r = o.countryCallingCode()) : r = n, {
    country: t,
    countryCallingCode: r
  };
}
var Ec = /^\+\d+$/;
function vt(n) {
  "@babel/helpers - typeof";
  return vt = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, vt(n);
}
function Ac(n, e, t) {
  return Object.defineProperty(n, "prototype", { writable: !1 }), n;
}
function Oc(n, e) {
  if (!(n instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function Sc(n, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  n.prototype = Object.create(e && e.prototype, { constructor: { value: n, writable: !0, configurable: !0 } }), Object.defineProperty(n, "prototype", { writable: !1 }), e && An(n, e);
}
function Tc(n) {
  var e = Hr();
  return function() {
    var r = On(n), o;
    if (e) {
      var a = On(this).constructor;
      o = Reflect.construct(r, arguments, a);
    } else
      o = r.apply(this, arguments);
    return kc(this, o);
  };
}
function kc(n, e) {
  if (e && (vt(e) === "object" || typeof e == "function"))
    return e;
  if (e !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return jr(n);
}
function jr(n) {
  if (n === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return n;
}
function Nt(n) {
  var e = typeof Map == "function" ? /* @__PURE__ */ new Map() : void 0;
  return Nt = function(r) {
    if (r === null || !Ic(r))
      return r;
    if (typeof r != "function")
      throw new TypeError("Super expression must either be null or a function");
    if (typeof e < "u") {
      if (e.has(r))
        return e.get(r);
      e.set(r, o);
    }
    function o() {
      return Un(r, arguments, On(this).constructor);
    }
    return o.prototype = Object.create(r.prototype, { constructor: { value: o, enumerable: !1, writable: !0, configurable: !0 } }), An(o, r);
  }, Nt(n);
}
function Un(n, e, t) {
  return Hr() ? Un = Reflect.construct : Un = function(o, a, d) {
    var s = [null];
    s.push.apply(s, a);
    var l = Function.bind.apply(o, s), f = new l();
    return d && An(f, d.prototype), f;
  }, Un.apply(null, arguments);
}
function Hr() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function Ic(n) {
  return Function.toString.call(n).indexOf("[native code]") !== -1;
}
function An(n, e) {
  return An = Object.setPrototypeOf || function(r, o) {
    return r.__proto__ = o, r;
  }, An(n, e);
}
function On(n) {
  return On = Object.setPrototypeOf ? Object.getPrototypeOf : function(t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, On(n);
}
var Ve = /* @__PURE__ */ function(n) {
  Sc(t, n);
  var e = Tc(t);
  function t(r) {
    var o;
    return Oc(this, t), o = e.call(this, r), Object.setPrototypeOf(jr(o), t.prototype), o.name = o.constructor.name, o;
  }
  return Ac(t);
}(/* @__PURE__ */ Nt(Error)), lr = new RegExp("(?:" + Br() + ")$", "i");
function Rc(n) {
  var e = n.search(lr);
  if (e < 0)
    return {};
  for (var t = n.slice(0, e), r = n.match(lr), o = 1; o < r.length; ) {
    if (r[o])
      return {
        number: t,
        ext: r[o]
      };
    o++;
  }
}
var Pc = {
  0: "0",
  1: "1",
  2: "2",
  3: "3",
  4: "4",
  5: "5",
  6: "6",
  7: "7",
  8: "8",
  9: "9",
  "０": "0",
  // Fullwidth digit 0
  "１": "1",
  // Fullwidth digit 1
  "２": "2",
  // Fullwidth digit 2
  "３": "3",
  // Fullwidth digit 3
  "４": "4",
  // Fullwidth digit 4
  "５": "5",
  // Fullwidth digit 5
  "６": "6",
  // Fullwidth digit 6
  "７": "7",
  // Fullwidth digit 7
  "８": "8",
  // Fullwidth digit 8
  "９": "9",
  // Fullwidth digit 9
  "٠": "0",
  // Arabic-indic digit 0
  "١": "1",
  // Arabic-indic digit 1
  "٢": "2",
  // Arabic-indic digit 2
  "٣": "3",
  // Arabic-indic digit 3
  "٤": "4",
  // Arabic-indic digit 4
  "٥": "5",
  // Arabic-indic digit 5
  "٦": "6",
  // Arabic-indic digit 6
  "٧": "7",
  // Arabic-indic digit 7
  "٨": "8",
  // Arabic-indic digit 8
  "٩": "9",
  // Arabic-indic digit 9
  "۰": "0",
  // Eastern-Arabic digit 0
  "۱": "1",
  // Eastern-Arabic digit 1
  "۲": "2",
  // Eastern-Arabic digit 2
  "۳": "3",
  // Eastern-Arabic digit 3
  "۴": "4",
  // Eastern-Arabic digit 4
  "۵": "5",
  // Eastern-Arabic digit 5
  "۶": "6",
  // Eastern-Arabic digit 6
  "۷": "7",
  // Eastern-Arabic digit 7
  "۸": "8",
  // Eastern-Arabic digit 8
  "۹": "9"
  // Eastern-Arabic digit 9
};
function Lc(n) {
  return Pc[n];
}
function xc(n, e) {
  var t = typeof Symbol < "u" && n[Symbol.iterator] || n["@@iterator"];
  if (t)
    return (t = t.call(n)).next.bind(t);
  if (Array.isArray(n) || (t = Mc(n)) || e) {
    t && (n = t);
    var r = 0;
    return function() {
      return r >= n.length ? { done: !0 } : { done: !1, value: n[r++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Mc(n, e) {
  if (n) {
    if (typeof n == "string")
      return ur(n, e);
    var t = Object.prototype.toString.call(n).slice(8, -1);
    if (t === "Object" && n.constructor && (t = n.constructor.name), t === "Map" || t === "Set")
      return Array.from(n);
    if (t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t))
      return ur(n, e);
  }
}
function ur(n, e) {
  (e == null || e > n.length) && (e = n.length);
  for (var t = 0, r = new Array(e); t < e; t++)
    r[t] = n[t];
  return r;
}
function hr(n) {
  for (var e = "", t = xc(n.split("")), r; !(r = t()).done; ) {
    var o = r.value;
    e += Dc(o, e) || "";
  }
  return e;
}
function Dc(n, e, t) {
  return n === "+" ? e ? void 0 : "+" : Lc(n);
}
function Fc(n, e) {
  var t = typeof Symbol < "u" && n[Symbol.iterator] || n["@@iterator"];
  if (t)
    return (t = t.call(n)).next.bind(t);
  if (Array.isArray(n) || (t = Uc(n)) || e) {
    t && (n = t);
    var r = 0;
    return function() {
      return r >= n.length ? { done: !0 } : { done: !1, value: n[r++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Uc(n, e) {
  if (n) {
    if (typeof n == "string")
      return gr(n, e);
    var t = Object.prototype.toString.call(n).slice(8, -1);
    if (t === "Object" && n.constructor && (t = n.constructor.name), t === "Map" || t === "Set")
      return Array.from(n);
    if (t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t))
      return gr(n, e);
  }
}
function gr(n, e) {
  (e == null || e > n.length) && (e = n.length);
  for (var t = 0, r = new Array(e); t < e; t++)
    r[t] = n[t];
  return r;
}
function Gc(n, e) {
  var t = e.countries, r = e.metadata;
  r = new Ce(r);
  for (var o = Fc(t), a; !(a = o()).done; ) {
    var d = a.value;
    if (r.country(d), r.leadingDigits()) {
      if (n && n.search(r.leadingDigits()) === 0)
        return d;
    } else if (xt({
      phone: n,
      country: d
    }, void 0, r.metadata))
      return d;
  }
}
function Bc(n, e) {
  var t = e.nationalNumber, r = e.metadata, o = r.getCountryCodesForCallingCode(n);
  if (o)
    return o.length === 1 ? o[0] : Gc(t, {
      countries: o,
      metadata: r.metadata
    });
}
var Vr = "+", jc = "[\\-\\.\\(\\)]?", fr = "([" + Pe + "]|" + jc + ")", Hc = "^\\" + Vr + fr + "*[" + Pe + "]" + fr + "*$", Vc = new RegExp(Hc, "g"), Ct = Pe, zc = "[" + Ct + "]+((\\-)*[" + Ct + "])*", Kc = "a-zA-Z", qc = "[" + Kc + "]+((\\-)*[" + Ct + "])*", Qc = "^(" + zc + "\\.)*" + qc + "\\.?$", Wc = new RegExp(Qc, "g"), mr = "tel:", bt = ";phone-context=", Zc = ";isub=";
function Jc(n) {
  var e = n.indexOf(bt);
  if (e < 0)
    return null;
  var t = e + bt.length;
  if (t >= n.length)
    return "";
  var r = n.indexOf(";", t);
  return r >= 0 ? n.substring(t, r) : n.substring(t);
}
function Yc(n) {
  return n === null ? !0 : n.length === 0 ? !1 : Vc.test(n) || Wc.test(n);
}
function Xc(n, e) {
  var t = e.extractFormattedPhoneNumber, r = Jc(n);
  if (!Yc(r))
    throw new Ve("NOT_A_NUMBER");
  var o;
  if (r === null)
    o = t(n) || "";
  else {
    o = "", r.charAt(0) === Vr && (o += r);
    var a = n.indexOf(mr), d;
    a >= 0 ? d = a + mr.length : d = 0;
    var s = n.indexOf(bt);
    o += n.substring(d, s);
  }
  var l = o.indexOf(Zc);
  if (l > 0 && (o = o.substring(0, l)), o !== "")
    return o;
}
var el = 250, nl = new RegExp("[" + Dt + Pe + "]"), tl = new RegExp("[^" + Pe + "#]+$");
function rl(n, e, t) {
  if (e = e || {}, t = new Ce(t), e.defaultCountry && !t.hasCountry(e.defaultCountry))
    throw e.v2 ? new Ve("INVALID_COUNTRY") : new Error("Unknown country: ".concat(e.defaultCountry));
  var r = dl(n, e.v2, e.extract), o = r.number, a = r.ext, d = r.error;
  if (!o) {
    if (e.v2)
      throw d === "TOO_SHORT" ? new Ve("TOO_SHORT") : new Ve("NOT_A_NUMBER");
    return {};
  }
  var s = il(o, e.defaultCountry, e.defaultCallingCode, t), l = s.country, f = s.nationalNumber, p = s.countryCallingCode, _ = s.countryCallingCodeSource, y = s.carrierCode;
  if (!t.hasSelectedNumberingPlan()) {
    if (e.v2)
      throw new Ve("INVALID_COUNTRY");
    return {};
  }
  if (!f || f.length < Mt) {
    if (e.v2)
      throw new Ve("TOO_SHORT");
    return {};
  }
  if (f.length > Fs) {
    if (e.v2)
      throw new Ve("TOO_LONG");
    return {};
  }
  if (e.v2) {
    var u = new Cc(p, f, t.metadata);
    return l && (u.country = l), y && (u.carrierCode = y), a && (u.ext = a), u.__countryCallingCodeSource = _, u;
  }
  var g = (e.extended ? t.hasSelectedNumberingPlan() : l) ? Ke(f, t.nationalNumberPattern()) : !1;
  return e.extended ? {
    country: l,
    countryCallingCode: p,
    carrierCode: y,
    valid: g,
    possible: g ? !0 : !!(e.extended === !0 && t.possibleLengths() && Ur(f, t)),
    phone: f,
    ext: a
  } : g ? al(l, f, a) : {};
}
function ol(n, e, t) {
  if (n) {
    if (n.length > el) {
      if (t)
        throw new Ve("TOO_LONG");
      return;
    }
    if (e === !1)
      return n;
    var r = n.search(nl);
    if (!(r < 0))
      return n.slice(r).replace(tl, "");
  }
}
function dl(n, e, t) {
  var r = Xc(n, {
    extractFormattedPhoneNumber: function(d) {
      return ol(d, t, e);
    }
  });
  if (!r)
    return {};
  if (!cc(r))
    return lc(r) ? {
      error: "TOO_SHORT"
    } : {};
  var o = Rc(r);
  return o.ext ? o : {
    number: r
  };
}
function al(n, e, t) {
  var r = {
    country: n,
    phone: e
  };
  return t && (r.ext = t), r;
}
function il(n, e, t, r) {
  var o = Gr(hr(n), e, t, r.metadata), a = o.countryCallingCodeSource, d = o.countryCallingCode, s = o.number, l;
  if (d)
    r.selectNumberingPlan(d);
  else if (s && (e || t))
    r.selectNumberingPlan(e, t), e && (l = e), d = t || Pt(e, r.metadata);
  else
    return {};
  if (!s)
    return {
      countryCallingCodeSource: a,
      countryCallingCode: d
    };
  var f = yt(hr(s), r), p = f.nationalNumber, _ = f.carrierCode, y = Bc(d, {
    nationalNumber: p,
    metadata: r
  });
  return y && (l = y, y === "001" || r.country(l)), {
    country: l,
    countryCallingCode: d,
    countryCallingCodeSource: a,
    nationalNumber: p,
    carrierCode: _
  };
}
function pr(n, e) {
  var t = Object.keys(n);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(n);
    e && (r = r.filter(function(o) {
      return Object.getOwnPropertyDescriptor(n, o).enumerable;
    })), t.push.apply(t, r);
  }
  return t;
}
function $r(n) {
  for (var e = 1; e < arguments.length; e++) {
    var t = arguments[e] != null ? arguments[e] : {};
    e % 2 ? pr(Object(t), !0).forEach(function(r) {
      sl(n, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(n, Object.getOwnPropertyDescriptors(t)) : pr(Object(t)).forEach(function(r) {
      Object.defineProperty(n, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return n;
}
function sl(n, e, t) {
  return e in n ? Object.defineProperty(n, e, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : n[e] = t, n;
}
function cl(n, e, t) {
  return rl(n, $r($r({}, e), {}, {
    v2: !0
  }), t);
}
function _r(n, e) {
  var t = Object.keys(n);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(n);
    e && (r = r.filter(function(o) {
      return Object.getOwnPropertyDescriptor(n, o).enumerable;
    })), t.push.apply(t, r);
  }
  return t;
}
function ll(n) {
  for (var e = 1; e < arguments.length; e++) {
    var t = arguments[e] != null ? arguments[e] : {};
    e % 2 ? _r(Object(t), !0).forEach(function(r) {
      ul(n, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(n, Object.getOwnPropertyDescriptors(t)) : _r(Object(t)).forEach(function(r) {
      Object.defineProperty(n, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return n;
}
function ul(n, e, t) {
  return e in n ? Object.defineProperty(n, e, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : n[e] = t, n;
}
function hl(n, e) {
  return pl(n) || ml(n, e) || fl(n, e) || gl();
}
function gl() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function fl(n, e) {
  if (n) {
    if (typeof n == "string")
      return yr(n, e);
    var t = Object.prototype.toString.call(n).slice(8, -1);
    if (t === "Object" && n.constructor && (t = n.constructor.name), t === "Map" || t === "Set")
      return Array.from(n);
    if (t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t))
      return yr(n, e);
  }
}
function yr(n, e) {
  (e == null || e > n.length) && (e = n.length);
  for (var t = 0, r = new Array(e); t < e; t++)
    r[t] = n[t];
  return r;
}
function ml(n, e) {
  var t = n == null ? null : typeof Symbol < "u" && n[Symbol.iterator] || n["@@iterator"];
  if (t != null) {
    var r = [], o = !0, a = !1, d, s;
    try {
      for (t = t.call(n); !(o = (d = t.next()).done) && (r.push(d.value), !(e && r.length === e)); o = !0)
        ;
    } catch (l) {
      a = !0, s = l;
    } finally {
      try {
        !o && t.return != null && t.return();
      } finally {
        if (a)
          throw s;
      }
    }
    return r;
  }
}
function pl(n) {
  if (Array.isArray(n))
    return n;
}
function $l(n) {
  var e = Array.prototype.slice.call(n), t = hl(e, 4), r = t[0], o = t[1], a = t[2], d = t[3], s, l, f;
  if (typeof r == "string")
    s = r;
  else
    throw new TypeError("A text for parsing must be a string.");
  if (!o || typeof o == "string")
    d ? (l = a, f = d) : (l = void 0, f = a), o && (l = ll({
      defaultCountry: o
    }, l));
  else if (un(o))
    a ? (l = o, f = a) : f = o;
  else
    throw new Error("Invalid second argument: ".concat(o));
  return {
    text: s,
    options: l,
    metadata: f
  };
}
function vr(n, e) {
  var t = Object.keys(n);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(n);
    e && (r = r.filter(function(o) {
      return Object.getOwnPropertyDescriptor(n, o).enumerable;
    })), t.push.apply(t, r);
  }
  return t;
}
function Nr(n) {
  for (var e = 1; e < arguments.length; e++) {
    var t = arguments[e] != null ? arguments[e] : {};
    e % 2 ? vr(Object(t), !0).forEach(function(r) {
      _l(n, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(n, Object.getOwnPropertyDescriptors(t)) : vr(Object(t)).forEach(function(r) {
      Object.defineProperty(n, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return n;
}
function _l(n, e, t) {
  return e in n ? Object.defineProperty(n, e, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : n[e] = t, n;
}
function yl(n, e, t) {
  e && e.defaultCountry && !Ts(e.defaultCountry, t) && (e = Nr(Nr({}, e), {}, {
    defaultCountry: void 0
  }));
  try {
    return cl(n, e, t);
  } catch (r) {
    if (!(r instanceof Ve))
      throw r;
  }
}
function vl() {
  var n = $l(arguments), e = n.text, t = n.options, r = n.metadata;
  return yl(e, t, r);
}
function Nl() {
  return ys(vl, arguments);
}
const vn = [
  {
    englishName: "Canada",
    chineseName: "加拿大",
    countryCode: "CA",
    phoneCode: "+1"
  },
  {
    englishName: "UnitedStates",
    chineseName: "美国",
    countryCode: "US",
    phoneCode: "+1"
  },
  {
    englishName: "Egypt",
    chineseName: "埃及",
    countryCode: "EG",
    phoneCode: "+20"
  },
  {
    englishName: "SouthAfrica",
    chineseName: "南非",
    countryCode: "ZA",
    phoneCode: "+27"
  },
  {
    englishName: "France",
    chineseName: "法国",
    countryCode: "FR",
    phoneCode: "+33"
  },
  {
    englishName: "IslasCanarias",
    chineseName: "加那利群岛",
    countryCode: "ES",
    phoneCode: "+34"
  },
  {
    englishName: "Spain",
    chineseName: "西班牙",
    countryCode: "ES",
    phoneCode: "+34"
  },
  {
    englishName: "Italy",
    chineseName: "意大利",
    countryCode: "IT",
    phoneCode: "+39"
  },
  {
    englishName: "UnitedKingdom",
    chineseName: "英国",
    countryCode: "GB",
    phoneCode: "+44"
  },
  {
    englishName: "Denmark",
    chineseName: "丹麦",
    countryCode: "DK",
    phoneCode: "+45"
  },
  {
    englishName: "Sweden",
    chineseName: "瑞典",
    countryCode: "SE",
    phoneCode: "+46"
  },
  {
    englishName: "Poland",
    chineseName: "波兰",
    countryCode: "PL",
    phoneCode: "+48"
  },
  {
    englishName: "Germany",
    chineseName: "德国",
    countryCode: "DE",
    phoneCode: "+49"
  },
  {
    englishName: "Mexico",
    chineseName: "墨西哥",
    countryCode: "MX",
    phoneCode: "+52"
  },
  {
    englishName: "Brazil",
    chineseName: "巴西",
    countryCode: "BR",
    phoneCode: "+55"
  },
  {
    englishName: "Chile",
    chineseName: "智利",
    countryCode: "CL",
    phoneCode: "+56"
  },
  {
    englishName: "Colombia",
    chineseName: "哥伦比亚",
    countryCode: "CO",
    phoneCode: "+57"
  },
  {
    englishName: "Malaysia",
    chineseName: "马来西亚",
    countryCode: "MY",
    phoneCode: "+60"
  },
  {
    englishName: "Australia",
    chineseName: "澳大利亚",
    countryCode: "AU",
    phoneCode: "+61"
  },
  {
    englishName: "Indonesia",
    chineseName: "印度尼西亚",
    countryCode: "ID",
    phoneCode: "+62"
  },
  {
    englishName: "Philippines",
    chineseName: "菲律宾",
    countryCode: "PH",
    phoneCode: "+63"
  },
  {
    englishName: "NewZealand",
    chineseName: "新西兰",
    countryCode: "NZ",
    phoneCode: "+64"
  },
  {
    englishName: "Singapore",
    chineseName: "新加坡",
    countryCode: "SG",
    phoneCode: "+65"
  },
  {
    englishName: "Thailand",
    chineseName: "泰国",
    countryCode: "TH",
    phoneCode: "+66"
  },
  {
    englishName: "Japan",
    chineseName: "日本",
    countryCode: "JP",
    phoneCode: "+81"
  },
  {
    englishName: "SouthKorea",
    chineseName: "韩国",
    countryCode: "KR",
    phoneCode: "+82"
  },
  {
    englishName: "Vietnam",
    chineseName: "越南",
    countryCode: "VN",
    phoneCode: "+84"
  },
  {
    englishName: "China",
    chineseName: "中国",
    countryCode: "CN",
    phoneCode: "+86"
  },
  {
    englishName: "Turkey",
    chineseName: "土耳其",
    countryCode: "TR",
    phoneCode: "+90"
  },
  {
    englishName: "India",
    chineseName: "印度",
    countryCode: "IN",
    phoneCode: "+91"
  },
  {
    englishName: "Pakistan",
    chineseName: "巴基斯坦",
    countryCode: "PK",
    phoneCode: "+92"
  },
  {
    englishName: "Myanmar",
    chineseName: "缅甸",
    countryCode: "MM",
    phoneCode: "+95"
  },
  {
    englishName: "Iran",
    chineseName: "伊朗",
    countryCode: "IR",
    phoneCode: "+98"
  },
  {
    englishName: "Morocco",
    chineseName: "摩洛哥",
    countryCode: "MA",
    phoneCode: "+212"
  },
  {
    englishName: "Algeria",
    chineseName: "阿尔及利亚",
    countryCode: "DZ",
    phoneCode: "+213"
  },
  {
    englishName: "Gambia",
    chineseName: "冈比亚",
    countryCode: "GM",
    phoneCode: "+220"
  },
  {
    englishName: "IvoryCoast",
    chineseName: "象牙海岸",
    countryCode: "CI",
    phoneCode: "+225"
  },
  {
    englishName: "BurkinaFaso",
    chineseName: "布基纳法索",
    countryCode: "BF",
    phoneCode: "+226"
  },
  {
    englishName: "Togo",
    chineseName: "多哥",
    countryCode: "TG",
    phoneCode: "+228"
  },
  {
    englishName: "SierraLeone",
    chineseName: "塞拉利昂",
    countryCode: "SL",
    phoneCode: "+232"
  },
  {
    englishName: "Ghana",
    chineseName: "加纳",
    countryCode: "GH",
    phoneCode: "+233"
  },
  {
    englishName: "Nigeria",
    chineseName: "尼日利亚",
    countryCode: "NG",
    phoneCode: "+234"
  },
  {
    englishName: "Chad",
    chineseName: "乍得",
    countryCode: "TD",
    phoneCode: "+235"
  },
  {
    englishName: "CentralAfricanRepublic",
    chineseName: "中非共和国",
    countryCode: "CF",
    phoneCode: "+236"
  },
  {
    englishName: "SaoTomeandPrincipe",
    chineseName: "圣多美和普林西比",
    countryCode: "ST",
    phoneCode: "+239"
  },
  {
    englishName: "EquatorialGuinea",
    chineseName: "赤道几内亚",
    countryCode: "GQ",
    phoneCode: "+240"
  },
  {
    englishName: "Gabon",
    chineseName: "加蓬",
    countryCode: "GA",
    phoneCode: "+241"
  },
  {
    englishName: "RepublicOfTheCongo",
    chineseName: "刚果共和国",
    countryCode: "CG",
    phoneCode: "+242"
  },
  {
    englishName: "Seychelles",
    chineseName: "塞舌尔",
    countryCode: "SC",
    phoneCode: "+248"
  },
  {
    englishName: "Rwanda",
    chineseName: "卢旺达",
    countryCode: "RW",
    phoneCode: "+250"
  },
  {
    englishName: "Ethiopia",
    chineseName: "埃塞俄比亚",
    countryCode: "ET",
    phoneCode: "+251"
  },
  {
    englishName: "Djibouti",
    chineseName: "吉布提",
    countryCode: "DJ",
    phoneCode: "+253"
  },
  {
    englishName: "Burundi",
    chineseName: "布隆迪",
    countryCode: "BI",
    phoneCode: "+257"
  },
  {
    englishName: "Mozambique",
    chineseName: "莫桑比克",
    countryCode: "MZ",
    phoneCode: "+258"
  },
  {
    englishName: "Zambia",
    chineseName: "赞比亚",
    countryCode: "ZM",
    phoneCode: "+260"
  },
  {
    englishName: "Madagascar",
    chineseName: "马达加斯加",
    countryCode: "MG",
    phoneCode: "+261"
  },
  {
    englishName: "Namibia",
    chineseName: "纳米比亚",
    countryCode: "NA",
    phoneCode: "+264"
  },
  {
    englishName: "Lesotho",
    chineseName: "莱索托",
    countryCode: "LS",
    phoneCode: "+266"
  },
  {
    englishName: "Swaziland",
    chineseName: "斯威士兰",
    countryCode: "SZ",
    phoneCode: "+268"
  },
  {
    englishName: "Comoros",
    chineseName: "科摩罗",
    countryCode: "KM",
    phoneCode: "+269"
  },
  {
    englishName: "Mayotte",
    chineseName: "马约特",
    countryCode: "YT",
    phoneCode: "+269"
  },
  {
    englishName: "Eritrea",
    chineseName: "厄立特里亚",
    countryCode: "ER",
    phoneCode: "+291"
  },
  {
    englishName: "FaroeIslands",
    chineseName: "法罗群岛",
    countryCode: "FO",
    phoneCode: "+298"
  },
  {
    englishName: "Gibraltar",
    chineseName: "直布罗陀",
    countryCode: "GI",
    phoneCode: "+350"
  },
  {
    englishName: "Portugal",
    chineseName: "葡萄牙",
    countryCode: "PT",
    phoneCode: "+351"
  },
  {
    englishName: "Iceland",
    chineseName: "冰岛",
    countryCode: "IS",
    phoneCode: "+354"
  },
  {
    englishName: "Malta",
    chineseName: "马耳他",
    countryCode: "MT",
    phoneCode: "+356"
  },
  {
    englishName: "Cyprus",
    chineseName: "塞浦路斯",
    countryCode: "CY",
    phoneCode: "+357"
  },
  {
    englishName: "Lithuania",
    chineseName: "立陶宛",
    countryCode: "LT",
    phoneCode: "+370"
  },
  {
    englishName: "Estonia",
    chineseName: "爱沙尼亚",
    countryCode: "EE",
    phoneCode: "+372"
  },
  {
    englishName: "Andorra",
    chineseName: "安道尔",
    countryCode: "AD",
    phoneCode: "+376"
  },
  {
    englishName: "Serbia",
    chineseName: "塞尔维亚",
    countryCode: "RS",
    phoneCode: "+381"
  },
  {
    englishName: "Montenegro",
    chineseName: "黑山",
    countryCode: "ME",
    phoneCode: "+382"
  },
  {
    englishName: "Slovenia",
    chineseName: "斯洛文尼亚",
    countryCode: "SI",
    phoneCode: "+386"
  },
  {
    englishName: "Macedonia",
    chineseName: "马其顿",
    countryCode: "MK",
    phoneCode: "+389"
  },
  {
    englishName: "Liechtenstein",
    chineseName: "列支敦士登",
    countryCode: "LI",
    phoneCode: "+423"
  },
  {
    englishName: "FalklandIslands",
    chineseName: "福克兰群岛",
    countryCode: "FK",
    phoneCode: "+500"
  },
  {
    englishName: "Guatemala",
    chineseName: "瓜地马拉",
    countryCode: "GT",
    phoneCode: "+502"
  },
  {
    englishName: "Honduras",
    chineseName: "洪都拉斯",
    countryCode: "HN",
    phoneCode: "+504"
  },
  {
    englishName: "CostaRica",
    chineseName: "哥斯达黎加",
    countryCode: "CR",
    phoneCode: "+506"
  },
  {
    englishName: "SaintPierreandMiquelon",
    chineseName: "圣彼埃尔和密克隆岛",
    countryCode: "PM",
    phoneCode: "+508"
  },
  {
    englishName: "Bolivia",
    chineseName: "玻利维亚",
    countryCode: "BO",
    phoneCode: "+591"
  },
  {
    englishName: "Guyana",
    chineseName: "圭亚那",
    countryCode: "GY",
    phoneCode: "+592"
  },
  {
    englishName: "Ecuador",
    chineseName: "厄瓜多尔",
    countryCode: "EC",
    phoneCode: "+593"
  },
  {
    englishName: "Paraguay",
    chineseName: "巴拉圭",
    countryCode: "PY",
    phoneCode: "+595"
  },
  {
    englishName: "Suriname",
    chineseName: "苏里南",
    countryCode: "SR",
    phoneCode: "+597"
  },
  {
    englishName: "Curacao",
    chineseName: "库拉索",
    countryCode: "CW",
    phoneCode: "+599"
  },
  {
    englishName: "Timor-Leste",
    chineseName: "东帝汶",
    countryCode: "TL",
    phoneCode: "+670"
  },
  {
    englishName: "Brunei",
    chineseName: "文莱",
    countryCode: "BN",
    phoneCode: "+673"
  },
  {
    englishName: "PapuaNewGuinea",
    chineseName: "巴布亚新几内亚",
    countryCode: "PG",
    phoneCode: "+675"
  },
  {
    englishName: "Tonga",
    chineseName: "汤加",
    countryCode: "TO",
    phoneCode: "+676"
  },
  {
    englishName: "Palau",
    chineseName: "帕劳",
    countryCode: "PW",
    phoneCode: "+680"
  },
  {
    englishName: "CookIslands",
    chineseName: "库克群岛",
    countryCode: "CK",
    phoneCode: "+682"
  },
  {
    englishName: "Samoa,Eastern",
    chineseName: "东萨摩亚(美)",
    countryCode: "AS",
    phoneCode: "+684"
  },
  {
    englishName: "Samoa",
    chineseName: "萨摩亚",
    countryCode: "WS",
    phoneCode: "+685"
  },
  {
    englishName: "Kiribati",
    chineseName: "基里巴斯",
    countryCode: "KI",
    phoneCode: "+686"
  },
  {
    englishName: "NewCaledonia",
    chineseName: "新喀里多尼亚",
    countryCode: "NC",
    phoneCode: "+687"
  },
  {
    englishName: "FrenchPolynesia",
    chineseName: "法属波利尼西亚",
    countryCode: "PF",
    phoneCode: "+689"
  },
  {
    englishName: "TokelauIs.",
    chineseName: "托克劳群岛(新)",
    countryCode: "TK",
    phoneCode: "+690"
  },
  {
    englishName: "Micronesia",
    chineseName: "密克罗尼西亚",
    countryCode: "FM",
    phoneCode: "+691"
  },
  {
    englishName: "HongKong",
    chineseName: "中国香港",
    countryCode: "HK",
    phoneCode: "+852"
  },
  {
    englishName: "Macau",
    chineseName: "中国澳门",
    countryCode: "MO",
    phoneCode: "+853"
  },
  {
    englishName: "Laos",
    chineseName: "老挝",
    countryCode: "LA",
    phoneCode: "+856"
  },
  {
    englishName: "Bangladesh",
    chineseName: "孟加拉国",
    countryCode: "BD",
    phoneCode: "+880"
  },
  {
    englishName: "Taiwan",
    chineseName: "中国台湾",
    countryCode: "TW",
    phoneCode: "+886"
  },
  {
    englishName: "Maldives",
    chineseName: "马尔代夫",
    countryCode: "MV",
    phoneCode: "+960"
  },
  {
    englishName: "Jordan",
    chineseName: "约旦",
    countryCode: "JO",
    phoneCode: "+962"
  },
  {
    englishName: "Syria",
    chineseName: "叙利亚",
    countryCode: "SY",
    phoneCode: "+963"
  },
  {
    englishName: "Iraq",
    chineseName: "伊拉克",
    countryCode: "IQ",
    phoneCode: "+964"
  },
  {
    englishName: "SaudiArabia",
    chineseName: "沙特阿拉伯",
    countryCode: "SA",
    phoneCode: "+966"
  },
  {
    englishName: "UnitedArabEmirates",
    chineseName: "阿拉伯联合酋长国",
    countryCode: "AE",
    phoneCode: "+971"
  },
  {
    englishName: "Bahrain",
    chineseName: "巴林",
    countryCode: "BH",
    phoneCode: "+973"
  },
  {
    englishName: "Qatar",
    chineseName: "卡塔尔",
    countryCode: "QA",
    phoneCode: "+974"
  },
  {
    englishName: "Bhutan",
    chineseName: "不丹",
    countryCode: "BT",
    phoneCode: "+975"
  },
  {
    englishName: "Turkmenistan",
    chineseName: "土库曼斯坦",
    countryCode: "TM",
    phoneCode: "+993"
  },
  {
    englishName: "Georgia",
    chineseName: "格鲁吉亚",
    countryCode: "GE",
    phoneCode: "+995"
  },
  {
    englishName: "Kyrgyzstan",
    chineseName: "吉尔吉斯斯坦",
    countryCode: "KG",
    phoneCode: "+996"
  },
  {
    englishName: "Montserrat",
    chineseName: "蒙特塞拉特岛",
    countryCode: "MS",
    phoneCode: "+1664"
  }
], Cl = () => {
  const e = new URLSearchParams(window.location.search).get("login");
  if (/\/landing$/i.test(window.location.pathname) && !e)
    return "OAuthLogin";
  if (e)
    switch (e) {
      case "email":
        return "EmailLogin";
      case "register":
        return "EmailRegister";
      case "oauth":
        return "OAuthLogin";
      case "phone":
        return "PhoneLogin";
      case "qr-code":
        return "QRCodeLogin";
      case "auth":
        return "AuthLogin";
      default:
        return "OAuthLogin";
    }
  return "OAuthLogin";
}, X = () => {
  switch (new URLSearchParams(window.location.search).get("login")) {
    case "email":
      return "email";
    case "register":
      return "register";
    case "oauth":
      return "oauth";
    case "auth":
      return "auth";
    default:
      return "oauth";
  }
}, Qn = () => {
  var r;
  const n = (r = Jn.webOrigins) == null ? void 0 : r.find(Boolean);
  if (n)
    return n;
  const e = /^file/i.test(window.location.origin), t = new URLSearchParams(window.location.search);
  return e || t.has("env") ? /dev/i.test(t.get("env") || "") ? `https://dev.${Yt}` : `https://${Yt}` : window.location.origin;
}, zr = (n, e) => {
  const t = parseInt(n, 10), { countryCode: r } = vn.find(
    ({ phoneCode: d }) => parseInt(d, 10) === t
  ), o = `${n}${e}`;
  return Nl(o, r);
}, wt = (n, e) => {
  try {
    const t = zr(n, e);
    return t ? t.isValid() : !1;
  } catch {
    return !0;
  }
}, Kr = (n, e) => {
  const t = zr(n, e);
  return t ? t.format("E.164") : `${n}${e}`;
}, bl = () => /kakao/i.test(window.navigator.userAgent || ""), qr = () => /PikPak/i.test(window.navigator.userAgent || ""), wl = () => /iphone/i.test(window.navigator.userAgent || ""), en = (n) => {
  var t;
  const e = (t = n.details) == null ? void 0 : t.find(
    (r) => (r == null ? void 0 : r.locale) && r.message
  );
  return e == null ? void 0 : e.message;
}, El = (n) => /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/i.test(
  n
), Al = () => /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
  window.navigator.userAgent
), Ol = { class: "error-message" }, Sl = /* @__PURE__ */ le({
  __name: "EmailRegister",
  props: {
    client: {},
    authInfo: {}
  },
  emits: ["command"],
  setup(n, { expose: e, emit: t }) {
    const r = me.global.t, o = t, a = an({
      email: "",
      verificationCode: "",
      password: "",
      confirmPassword: ""
    });
    Yn(a, "email");
    const d = (h) => {
      a.email = [a.email.split("@")[0], h].join(
        "@"
      );
    }, s = ne(0), l = be(
      () => s.value === 0 && El(a.email)
    ), { tm: f } = Sr(), p = be(
      () => f("scMOylJrrhNLlrFu6VTki").replace(
        "{0}",
        `${s.value}`
      )
    ), _ = be(() => {
      const { email: h, verificationCode: c, password: i, confirmPassword: m } = a;
      return ![h, c, i, m].map(($) => $.trim()).includes("");
    }), y = () => {
      l.value && o("command", {
        type: D.HANDLE_SEND_EMAIL_MESSAGE,
        registerInfo: a
      });
    }, u = () => {
      _.value && o("command", {
        type: D.HANDLE_REGISTER_BY_EMAIL,
        registerInfo: a
      });
    };
    return e({
      startCountDown: () => {
        s.value = 60;
        let h = setInterval(() => {
          s.value -= 1, s.value <= 0 && clearInterval(h);
        }, 1e3);
      }
    }), (h, c) => (P(), L(Ue, null, [
      W(dn, {
        class: "pp-basic-input",
        modelValue: a.email,
        "onUpdate:modelValue": c[0] || (c[0] = (i) => a.email = i),
        clearable: "",
        type: "text",
        "input-filter": R(Lr),
        placeholder: R(r)("rjaGoUfPmGl6TaS463Cn")
      }, {
        "email-suffix": fe(() => [
          W(xr, {
            class: "email-suffix",
            value: a.email,
            onClick: d
          }, null, 8, ["value"])
        ]),
        _: 1
      }, 8, ["modelValue", "input-filter", "placeholder"]),
      W(zn, {
        modelValue: a.verificationCode,
        "onUpdate:modelValue": c[1] || (c[1] = (i) => a.verificationCode = i),
        class: "verification-code-input mt-12",
        type: "text",
        placeholder: R(r)("pqc4Olt4lfdLp_8y6ZSuA"),
        "input-filter": R(Pr),
        clearable: !0
      }, {
        suffix: fe(() => [
          W(Mr, {
            disabled: !l.value,
            onClick: y
          }, {
            default: fe(() => [
              Fe(G(s.value > 0 ? p.value : R(r)("vtKgvl4yJauSnsTy3ORf")), 1)
            ]),
            _: 1
          }, 8, ["disabled"])
        ]),
        _: 1
      }, 8, ["modelValue", "placeholder", "input-filter"]),
      W(dn, {
        class: "pp-basic-input mt-12",
        modelValue: a.password,
        "onUpdate:modelValue": c[2] || (c[2] = (i) => a.password = i),
        eye: "",
        clearable: "",
        type: "password",
        placeholder: R(r)("n67Zbeckh9qf0VZFqd2x"),
        "input-filter": R($t)
      }, null, 8, ["modelValue", "placeholder", "input-filter"]),
      W(dn, {
        class: "pp-basic-input mt-12",
        modelValue: a.confirmPassword,
        "onUpdate:modelValue": c[3] || (c[3] = (i) => a.confirmPassword = i),
        eye: "",
        clearable: "",
        type: "password",
        placeholder: R(r)("s7TOj9RzdgxEmLc0iQ1G"),
        "input-filter": R($t)
      }, null, 8, ["modelValue", "placeholder", "input-filter"]),
      k("div", Ol, [
        Re(h.$slots, "x-base-error", {}, void 0, !0)
      ]),
      W(kn, {
        onClick: u,
        disabled: !_.value
      }, {
        default: fe(() => [
          Fe(G(R(r)("ufUkrBGbv4Xt457vFOa4D")), 1)
        ]),
        _: 1
      }, 8, ["disabled"])
    ], 64));
  }
}), Tl = /* @__PURE__ */ ue(Sl, [["__scopeId", "data-v-a9a7a5f1"]]), kl = async () => {
  var n;
  try {
    const t = `https://api-drive.${window.location.host.split(".").slice(-2).join(".")}/drive/v1/privilege/area_country_code?user_id=1`, o = await (await fetch(t, {
      // TODO: get client id from config
      headers: { "x-client-id": "YUMx5nI8ZU8Ap8pm" }
    })).json();
    return ((n = o == null ? void 0 : o.data) == null ? void 0 : n.countryCode) || Jt;
  } catch (e) {
    return console.warn("get user region failed", e), Jt;
  }
}, Il = { class: "country-code-wrapper" }, Rl = { class: "country-code-popup" }, Pl = {
  key: 0,
  class: "empty"
}, Ll = {
  key: 1,
  class: "country-code-popup__list"
}, xl = ["onClick"], Ml = /* @__PURE__ */ le({
  __name: "CountryCodeSelector",
  emits: ["phone-code-change"],
  setup(n, { emit: e }) {
    const t = e, r = me.global.t, o = ne(!1), a = ne(pt), d = ne(!1), s = ne([]);
    let l = a.value;
    const f = () => {
      vn.some((h) => h.phoneCode === a.value) || (a.value = l), d.value = !1, s.value = [];
    }, p = () => o.value = !0, _ = () => {
      o.value = !1, f();
    }, y = () => setTimeout(_, 300);
    Rt(() => {
      ie.phoneCode && ie.phoneCode !== a.value && (a.value = ie.phoneCode);
    }), hn(a, (h, c) => {
      let i = h;
      /^\+\d{0,}$/i.test(h) || (i = c), a.value = i, t("phone-code-change", i), ie.phoneCode = i, o.value && (!d.value && h !== c && (d.value = !0, l = c), s.value = vn.filter(
        (m) => m.phoneCode.startsWith(i)
      ), Vt(() => {
        var m;
        (m = document.querySelector(".country-code-popup__list")) == null || m.scrollTo({ top: 0 });
      }));
    });
    const u = (h) => {
      _(), a.value = h.phoneCode;
    };
    hn(o, () => {
      o.value && Vt(() => {
        var h;
        (h = document.querySelector(`.country-code-popup__item_${a.value.slice(1)}`)) == null || h.scrollIntoView();
      });
    });
    const g = be(() => ["zh-CN", "zh-TW"].includes(me.global.locale.value));
    return $n(async () => {
      var i;
      const h = await kl(), c = ((i = vn.find((m) => m.countryCode === h)) == null ? void 0 : i.phoneCode) || pt;
      a.value = ie.phoneCode && ie.phoneCode !== c ? ie.phoneCode : c, t("phone-code-change", a.value);
    }), (h, c) => (P(), L("div", Il, [
      zt(k("input", {
        type: "text",
        class: "inner-input",
        "onUpdate:modelValue": c[0] || (c[0] = (i) => a.value = i),
        onFocus: p,
        onBlur: y
      }, null, 544), [
        [bo, a.value]
      ]),
      zt(k("div", Rl, [
        d.value && s.value.length === 0 ? (P(), L("div", Pl, G(R(r)("6IsOzjcj00s5HGgImQx2v")), 1)) : (P(), L("ul", Ll, [
          (P(!0), L(Ue, null, Tn(d.value ? s.value : R(vn), (i, m) => (P(), L("li", {
            class: Ie([{
              "country-code-popup__item": !0,
              [`country-code-popup__item_${i.phoneCode.slice(1)}`]: !0,
              focus: i.phoneCode === a.value
            }, "{{'focus': item.phoneCodeWithAdd === phoneCode}}"]),
            key: i.englishName + m,
            onClick: ($) => u(i)
          }, G(`${g.value ? i.chineseName : i.englishName} ${i.phoneCode}`), 11, xl))), 128))
        ]))
      ], 512), [
        [wo, o.value]
      ])
    ]));
  }
}), Qr = /* @__PURE__ */ ue(Ml, [["__scopeId", "data-v-16b12d9e"]]), Dl = { class: "error-message" }, Fl = { class: "phone-login-tips" }, Ul = /* @__PURE__ */ le({
  __name: "PhoneLogin",
  props: {
    client: {},
    authInfo: {}
  },
  emits: ["command"],
  setup(n, { expose: e, emit: t }) {
    const r = me.global.t, o = t, a = an({
      phoneCode: pt,
      phoneNumber: "",
      verificationCode: ""
    });
    Yn(a, "phoneNumber");
    const d = (h) => a.phoneCode = h, s = ne(0), l = be(
      () => s.value === 0 && wt(a.phoneCode, a.phoneNumber)
    ), { tm: f } = Sr(), p = be(
      () => f("scMOylJrrhNLlrFu6VTki").replace(
        "{0}",
        `${s.value}`
      )
    ), _ = be(
      () => wt(a.phoneCode, a.phoneNumber) && a.verificationCode.length === 6
    ), y = () => {
      l.value && o("command", {
        type: D.HANDLE_SEND_PHONE_MESSAGE,
        phoneNumber: Kr(
          a.phoneCode,
          a.phoneNumber
        )
      });
    }, u = () => {
      _.value && o("command", {
        type: D.HANDLE_LOGIN_BY_PHONE_NUMBER,
        loginInfo: a
      });
    };
    return e({
      startCountDown: () => {
        s.value = 60;
        let h = setInterval(() => {
          s.value -= 1, s.value <= 0 && clearInterval(h);
        }, 1e3);
      }
    }), (h, c) => (P(), L(Ue, null, [
      W(zn, {
        type: "text",
        placeholder: R(r)("uunm9VjxdmUucFse2Qjs"),
        clearable: !0,
        "input-filter": R(Rr),
        modelValue: a.phoneNumber,
        "onUpdate:modelValue": c[0] || (c[0] = (i) => a.phoneNumber = i)
      }, {
        prefix: fe(() => [
          W(Qr, { onPhoneCodeChange: d })
        ]),
        _: 1
      }, 8, ["placeholder", "input-filter", "modelValue"]),
      W(zn, {
        modelValue: a.verificationCode,
        "onUpdate:modelValue": c[1] || (c[1] = (i) => a.verificationCode = i),
        class: "verification-code-input",
        type: "text",
        placeholder: R(r)("pqc4Olt4lfdLp_8y6ZSuA"),
        "input-filter": R(Pr),
        clearable: !0
      }, {
        suffix: fe(() => [
          W(Mr, {
            disabled: !l.value,
            onClick: y
          }, {
            default: fe(() => [
              Fe(G(s.value > 0 ? p.value : R(r)("vtKgvl4yJauSnsTy3ORf")), 1)
            ]),
            _: 1
          }, 8, ["disabled"])
        ]),
        _: 1
      }, 8, ["modelValue", "placeholder", "input-filter"]),
      k("div", Dl, [
        Re(h.$slots, "x-base-error", {}, void 0, !0)
      ]),
      W(kn, {
        onClick: u,
        disabled: !_.value
      }, {
        default: fe(() => [
          Fe(G(R(r)("mLlnoecfSMuJxTrxodqMt")), 1)
        ]),
        _: 1
      }, 8, ["disabled"]),
      k("div", Fl, G(R(r)("eaK82n7hjR623PupHmVhj")), 1)
    ], 64));
  }
}), Gl = /* @__PURE__ */ ue(Ul, [["__scopeId", "data-v-80f11a2d"]]), Bl = { class: "error-message" }, jl = /* @__PURE__ */ le({
  __name: "PasswordLogin",
  props: {
    client: {},
    authInfo: {}
  },
  emits: ["command"],
  setup(n, { emit: e }) {
    const t = me.global.t, r = e, o = an({
      phoneCode: "",
      phoneNumber: "",
      password: ""
    });
    Yn(o, "phoneNumber");
    const a = (l) => o.phoneCode = l, d = be(
      () => wt(o.phoneCode, o.phoneNumber) && o.password.trim() !== ""
    ), s = () => {
      d.value && r("command", {
        type: D.HANDLE_LOGIN_BY_PASSWORD,
        loginInfo: o
      });
    };
    return (l, f) => (P(), L(Ue, null, [
      W(zn, {
        placeholder: R(t)("uunm9VjxdmUucFse2Qjs"),
        clearable: !0,
        "input-filter": R(Rr),
        modelValue: o.phoneNumber,
        "onUpdate:modelValue": f[0] || (f[0] = (p) => o.phoneNumber = p),
        autocomplete: "tel-local"
      }, {
        prefix: fe(() => [
          W(Qr, { onPhoneCodeChange: a })
        ]),
        _: 1
      }, 8, ["placeholder", "input-filter", "modelValue"]),
      W(dn, {
        class: "pp-basic-input",
        modelValue: o.password,
        "onUpdate:modelValue": f[1] || (f[1] = (p) => o.password = p),
        eye: "",
        clearable: "",
        type: "password",
        placeholder: R(t)("nIlLdBnvEaFymQzCZwYbe"),
        autocomplete: "current-password"
      }, null, 8, ["modelValue", "placeholder"]),
      k("div", Bl, [
        Re(l.$slots, "x-base-error", {}, void 0, !0)
      ]),
      W(kn, {
        onClick: s,
        disabled: !d.value
      }, {
        default: fe(() => [
          Fe(G(R(t)("mLlnoecfSMuJxTrxodqMt")), 1)
        ]),
        _: 1
      }, 8, ["disabled"]),
      k("div", {
        class: "forget-password",
        onClick: f[2] || (f[2] = () => r("command", {
          type: R(D).GOTO_FORGET_PASSWORD,
          data: "phone"
        }))
      }, G(R(t)("jEVoi8AbtDyqmxg0uI9")), 1)
    ], 64));
  }
}), Hl = /* @__PURE__ */ ue(jl, [["__scopeId", "data-v-98a43950"]]);
var In = {}, Vl = function() {
  return typeof Promise == "function" && Promise.prototype && Promise.prototype.then;
}, Wr = {}, Ae = {};
let Ft;
const zl = [
  0,
  // Not used
  26,
  44,
  70,
  100,
  134,
  172,
  196,
  242,
  292,
  346,
  404,
  466,
  532,
  581,
  655,
  733,
  815,
  901,
  991,
  1085,
  1156,
  1258,
  1364,
  1474,
  1588,
  1706,
  1828,
  1921,
  2051,
  2185,
  2323,
  2465,
  2611,
  2761,
  2876,
  3034,
  3196,
  3362,
  3532,
  3706
];
Ae.getSymbolSize = function(e) {
  if (!e)
    throw new Error('"version" cannot be null or undefined');
  if (e < 1 || e > 40)
    throw new Error('"version" should be in range from 1 to 40');
  return e * 4 + 17;
};
Ae.getSymbolTotalCodewords = function(e) {
  return zl[e];
};
Ae.getBCHDigit = function(n) {
  let e = 0;
  for (; n !== 0; )
    e++, n >>>= 1;
  return e;
};
Ae.setToSJISFunction = function(e) {
  if (typeof e != "function")
    throw new Error('"toSJISFunc" is not a valid function.');
  Ft = e;
};
Ae.isKanjiModeEnabled = function() {
  return typeof Ft < "u";
};
Ae.toSJIS = function(e) {
  return Ft(e);
};
var nt = {};
(function(n) {
  n.L = { bit: 1 }, n.M = { bit: 0 }, n.Q = { bit: 3 }, n.H = { bit: 2 };
  function e(t) {
    if (typeof t != "string")
      throw new Error("Param is not a string");
    switch (t.toLowerCase()) {
      case "l":
      case "low":
        return n.L;
      case "m":
      case "medium":
        return n.M;
      case "q":
      case "quartile":
        return n.Q;
      case "h":
      case "high":
        return n.H;
      default:
        throw new Error("Unknown EC Level: " + t);
    }
  }
  n.isValid = function(r) {
    return r && typeof r.bit < "u" && r.bit >= 0 && r.bit < 4;
  }, n.from = function(r, o) {
    if (n.isValid(r))
      return r;
    try {
      return e(r);
    } catch {
      return o;
    }
  };
})(nt);
function Zr() {
  this.buffer = [], this.length = 0;
}
Zr.prototype = {
  get: function(n) {
    const e = Math.floor(n / 8);
    return (this.buffer[e] >>> 7 - n % 8 & 1) === 1;
  },
  put: function(n, e) {
    for (let t = 0; t < e; t++)
      this.putBit((n >>> e - t - 1 & 1) === 1);
  },
  getLengthInBits: function() {
    return this.length;
  },
  putBit: function(n) {
    const e = Math.floor(this.length / 8);
    this.buffer.length <= e && this.buffer.push(0), n && (this.buffer[e] |= 128 >>> this.length % 8), this.length++;
  }
};
var Kl = Zr;
function Rn(n) {
  if (!n || n < 1)
    throw new Error("BitMatrix size must be defined and greater than 0");
  this.size = n, this.data = new Uint8Array(n * n), this.reservedBit = new Uint8Array(n * n);
}
Rn.prototype.set = function(n, e, t, r) {
  const o = n * this.size + e;
  this.data[o] = t, r && (this.reservedBit[o] = !0);
};
Rn.prototype.get = function(n, e) {
  return this.data[n * this.size + e];
};
Rn.prototype.xor = function(n, e, t) {
  this.data[n * this.size + e] ^= t;
};
Rn.prototype.isReserved = function(n, e) {
  return this.reservedBit[n * this.size + e];
};
var ql = Rn, Jr = {};
(function(n) {
  const e = Ae.getSymbolSize;
  n.getRowColCoords = function(r) {
    if (r === 1)
      return [];
    const o = Math.floor(r / 7) + 2, a = e(r), d = a === 145 ? 26 : Math.ceil((a - 13) / (2 * o - 2)) * 2, s = [a - 7];
    for (let l = 1; l < o - 1; l++)
      s[l] = s[l - 1] - d;
    return s.push(6), s.reverse();
  }, n.getPositions = function(r) {
    const o = [], a = n.getRowColCoords(r), d = a.length;
    for (let s = 0; s < d; s++)
      for (let l = 0; l < d; l++)
        s === 0 && l === 0 || // top-left
        s === 0 && l === d - 1 || // bottom-left
        s === d - 1 && l === 0 || o.push([a[s], a[l]]);
    return o;
  };
})(Jr);
var Yr = {};
const Ql = Ae.getSymbolSize, Cr = 7;
Yr.getPositions = function(e) {
  const t = Ql(e);
  return [
    // top-left
    [0, 0],
    // top-right
    [t - Cr, 0],
    // bottom-left
    [0, t - Cr]
  ];
};
var Xr = {};
(function(n) {
  n.Patterns = {
    PATTERN000: 0,
    PATTERN001: 1,
    PATTERN010: 2,
    PATTERN011: 3,
    PATTERN100: 4,
    PATTERN101: 5,
    PATTERN110: 6,
    PATTERN111: 7
  };
  const e = {
    N1: 3,
    N2: 3,
    N3: 40,
    N4: 10
  };
  n.isValid = function(o) {
    return o != null && o !== "" && !isNaN(o) && o >= 0 && o <= 7;
  }, n.from = function(o) {
    return n.isValid(o) ? parseInt(o, 10) : void 0;
  }, n.getPenaltyN1 = function(o) {
    const a = o.size;
    let d = 0, s = 0, l = 0, f = null, p = null;
    for (let _ = 0; _ < a; _++) {
      s = l = 0, f = p = null;
      for (let y = 0; y < a; y++) {
        let u = o.get(_, y);
        u === f ? s++ : (s >= 5 && (d += e.N1 + (s - 5)), f = u, s = 1), u = o.get(y, _), u === p ? l++ : (l >= 5 && (d += e.N1 + (l - 5)), p = u, l = 1);
      }
      s >= 5 && (d += e.N1 + (s - 5)), l >= 5 && (d += e.N1 + (l - 5));
    }
    return d;
  }, n.getPenaltyN2 = function(o) {
    const a = o.size;
    let d = 0;
    for (let s = 0; s < a - 1; s++)
      for (let l = 0; l < a - 1; l++) {
        const f = o.get(s, l) + o.get(s, l + 1) + o.get(s + 1, l) + o.get(s + 1, l + 1);
        (f === 4 || f === 0) && d++;
      }
    return d * e.N2;
  }, n.getPenaltyN3 = function(o) {
    const a = o.size;
    let d = 0, s = 0, l = 0;
    for (let f = 0; f < a; f++) {
      s = l = 0;
      for (let p = 0; p < a; p++)
        s = s << 1 & 2047 | o.get(f, p), p >= 10 && (s === 1488 || s === 93) && d++, l = l << 1 & 2047 | o.get(p, f), p >= 10 && (l === 1488 || l === 93) && d++;
    }
    return d * e.N3;
  }, n.getPenaltyN4 = function(o) {
    let a = 0;
    const d = o.data.length;
    for (let l = 0; l < d; l++)
      a += o.data[l];
    return Math.abs(Math.ceil(a * 100 / d / 5) - 10) * e.N4;
  };
  function t(r, o, a) {
    switch (r) {
      case n.Patterns.PATTERN000:
        return (o + a) % 2 === 0;
      case n.Patterns.PATTERN001:
        return o % 2 === 0;
      case n.Patterns.PATTERN010:
        return a % 3 === 0;
      case n.Patterns.PATTERN011:
        return (o + a) % 3 === 0;
      case n.Patterns.PATTERN100:
        return (Math.floor(o / 2) + Math.floor(a / 3)) % 2 === 0;
      case n.Patterns.PATTERN101:
        return o * a % 2 + o * a % 3 === 0;
      case n.Patterns.PATTERN110:
        return (o * a % 2 + o * a % 3) % 2 === 0;
      case n.Patterns.PATTERN111:
        return (o * a % 3 + (o + a) % 2) % 2 === 0;
      default:
        throw new Error("bad maskPattern:" + r);
    }
  }
  n.applyMask = function(o, a) {
    const d = a.size;
    for (let s = 0; s < d; s++)
      for (let l = 0; l < d; l++)
        a.isReserved(l, s) || a.xor(l, s, t(o, l, s));
  }, n.getBestMask = function(o, a) {
    const d = Object.keys(n.Patterns).length;
    let s = 0, l = 1 / 0;
    for (let f = 0; f < d; f++) {
      a(f), n.applyMask(f, o);
      const p = n.getPenaltyN1(o) + n.getPenaltyN2(o) + n.getPenaltyN3(o) + n.getPenaltyN4(o);
      n.applyMask(f, o), p < l && (l = p, s = f);
    }
    return s;
  };
})(Xr);
var tt = {};
const nn = nt, Ln = [
  // L  M  Q  H
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  2,
  2,
  1,
  2,
  2,
  4,
  1,
  2,
  4,
  4,
  2,
  4,
  4,
  4,
  2,
  4,
  6,
  5,
  2,
  4,
  6,
  6,
  2,
  5,
  8,
  8,
  4,
  5,
  8,
  8,
  4,
  5,
  8,
  11,
  4,
  8,
  10,
  11,
  4,
  9,
  12,
  16,
  4,
  9,
  16,
  16,
  6,
  10,
  12,
  18,
  6,
  10,
  17,
  16,
  6,
  11,
  16,
  19,
  6,
  13,
  18,
  21,
  7,
  14,
  21,
  25,
  8,
  16,
  20,
  25,
  8,
  17,
  23,
  25,
  9,
  17,
  23,
  34,
  9,
  18,
  25,
  30,
  10,
  20,
  27,
  32,
  12,
  21,
  29,
  35,
  12,
  23,
  34,
  37,
  12,
  25,
  34,
  40,
  13,
  26,
  35,
  42,
  14,
  28,
  38,
  45,
  15,
  29,
  40,
  48,
  16,
  31,
  43,
  51,
  17,
  33,
  45,
  54,
  18,
  35,
  48,
  57,
  19,
  37,
  51,
  60,
  19,
  38,
  53,
  63,
  20,
  40,
  56,
  66,
  21,
  43,
  59,
  70,
  22,
  45,
  62,
  74,
  24,
  47,
  65,
  77,
  25,
  49,
  68,
  81
], xn = [
  // L  M  Q  H
  7,
  10,
  13,
  17,
  10,
  16,
  22,
  28,
  15,
  26,
  36,
  44,
  20,
  36,
  52,
  64,
  26,
  48,
  72,
  88,
  36,
  64,
  96,
  112,
  40,
  72,
  108,
  130,
  48,
  88,
  132,
  156,
  60,
  110,
  160,
  192,
  72,
  130,
  192,
  224,
  80,
  150,
  224,
  264,
  96,
  176,
  260,
  308,
  104,
  198,
  288,
  352,
  120,
  216,
  320,
  384,
  132,
  240,
  360,
  432,
  144,
  280,
  408,
  480,
  168,
  308,
  448,
  532,
  180,
  338,
  504,
  588,
  196,
  364,
  546,
  650,
  224,
  416,
  600,
  700,
  224,
  442,
  644,
  750,
  252,
  476,
  690,
  816,
  270,
  504,
  750,
  900,
  300,
  560,
  810,
  960,
  312,
  588,
  870,
  1050,
  336,
  644,
  952,
  1110,
  360,
  700,
  1020,
  1200,
  390,
  728,
  1050,
  1260,
  420,
  784,
  1140,
  1350,
  450,
  812,
  1200,
  1440,
  480,
  868,
  1290,
  1530,
  510,
  924,
  1350,
  1620,
  540,
  980,
  1440,
  1710,
  570,
  1036,
  1530,
  1800,
  570,
  1064,
  1590,
  1890,
  600,
  1120,
  1680,
  1980,
  630,
  1204,
  1770,
  2100,
  660,
  1260,
  1860,
  2220,
  720,
  1316,
  1950,
  2310,
  750,
  1372,
  2040,
  2430
];
tt.getBlocksCount = function(e, t) {
  switch (t) {
    case nn.L:
      return Ln[(e - 1) * 4 + 0];
    case nn.M:
      return Ln[(e - 1) * 4 + 1];
    case nn.Q:
      return Ln[(e - 1) * 4 + 2];
    case nn.H:
      return Ln[(e - 1) * 4 + 3];
    default:
      return;
  }
};
tt.getTotalCodewordsCount = function(e, t) {
  switch (t) {
    case nn.L:
      return xn[(e - 1) * 4 + 0];
    case nn.M:
      return xn[(e - 1) * 4 + 1];
    case nn.Q:
      return xn[(e - 1) * 4 + 2];
    case nn.H:
      return xn[(e - 1) * 4 + 3];
    default:
      return;
  }
};
var eo = {}, rt = {};
const bn = new Uint8Array(512), Wn = new Uint8Array(256);
(function() {
  let e = 1;
  for (let t = 0; t < 255; t++)
    bn[t] = e, Wn[e] = t, e <<= 1, e & 256 && (e ^= 285);
  for (let t = 255; t < 512; t++)
    bn[t] = bn[t - 255];
})();
rt.log = function(e) {
  if (e < 1)
    throw new Error("log(" + e + ")");
  return Wn[e];
};
rt.exp = function(e) {
  return bn[e];
};
rt.mul = function(e, t) {
  return e === 0 || t === 0 ? 0 : bn[Wn[e] + Wn[t]];
};
(function(n) {
  const e = rt;
  n.mul = function(r, o) {
    const a = new Uint8Array(r.length + o.length - 1);
    for (let d = 0; d < r.length; d++)
      for (let s = 0; s < o.length; s++)
        a[d + s] ^= e.mul(r[d], o[s]);
    return a;
  }, n.mod = function(r, o) {
    let a = new Uint8Array(r);
    for (; a.length - o.length >= 0; ) {
      const d = a[0];
      for (let l = 0; l < o.length; l++)
        a[l] ^= e.mul(o[l], d);
      let s = 0;
      for (; s < a.length && a[s] === 0; )
        s++;
      a = a.slice(s);
    }
    return a;
  }, n.generateECPolynomial = function(r) {
    let o = new Uint8Array([1]);
    for (let a = 0; a < r; a++)
      o = n.mul(o, new Uint8Array([1, e.exp(a)]));
    return o;
  };
})(eo);
const no = eo;
function Ut(n) {
  this.genPoly = void 0, this.degree = n, this.degree && this.initialize(this.degree);
}
Ut.prototype.initialize = function(e) {
  this.degree = e, this.genPoly = no.generateECPolynomial(this.degree);
};
Ut.prototype.encode = function(e) {
  if (!this.genPoly)
    throw new Error("Encoder not initialized");
  const t = new Uint8Array(e.length + this.degree);
  t.set(e);
  const r = no.mod(t, this.genPoly), o = this.degree - r.length;
  if (o > 0) {
    const a = new Uint8Array(this.degree);
    return a.set(r, o), a;
  }
  return r;
};
var Wl = Ut, to = {}, rn = {}, Gt = {};
Gt.isValid = function(e) {
  return !isNaN(e) && e >= 1 && e <= 40;
};
var Ge = {};
const ro = "[0-9]+", Zl = "[A-Z $%*+\\-./:]+";
let Sn = "(?:[u3000-u303F]|[u3040-u309F]|[u30A0-u30FF]|[uFF00-uFFEF]|[u4E00-u9FAF]|[u2605-u2606]|[u2190-u2195]|u203B|[u2010u2015u2018u2019u2025u2026u201Cu201Du2225u2260]|[u0391-u0451]|[u00A7u00A8u00B1u00B4u00D7u00F7])+";
Sn = Sn.replace(/u/g, "\\u");
const Jl = "(?:(?![A-Z0-9 $%*+\\-./:]|" + Sn + `)(?:.|[\r
]))+`;
Ge.KANJI = new RegExp(Sn, "g");
Ge.BYTE_KANJI = new RegExp("[^A-Z0-9 $%*+\\-./:]+", "g");
Ge.BYTE = new RegExp(Jl, "g");
Ge.NUMERIC = new RegExp(ro, "g");
Ge.ALPHANUMERIC = new RegExp(Zl, "g");
const Yl = new RegExp("^" + Sn + "$"), Xl = new RegExp("^" + ro + "$"), e3 = new RegExp("^[A-Z0-9 $%*+\\-./:]+$");
Ge.testKanji = function(e) {
  return Yl.test(e);
};
Ge.testNumeric = function(e) {
  return Xl.test(e);
};
Ge.testAlphanumeric = function(e) {
  return e3.test(e);
};
(function(n) {
  const e = Gt, t = Ge;
  n.NUMERIC = {
    id: "Numeric",
    bit: 1,
    ccBits: [10, 12, 14]
  }, n.ALPHANUMERIC = {
    id: "Alphanumeric",
    bit: 2,
    ccBits: [9, 11, 13]
  }, n.BYTE = {
    id: "Byte",
    bit: 4,
    ccBits: [8, 16, 16]
  }, n.KANJI = {
    id: "Kanji",
    bit: 8,
    ccBits: [8, 10, 12]
  }, n.MIXED = {
    bit: -1
  }, n.getCharCountIndicator = function(a, d) {
    if (!a.ccBits)
      throw new Error("Invalid mode: " + a);
    if (!e.isValid(d))
      throw new Error("Invalid version: " + d);
    return d >= 1 && d < 10 ? a.ccBits[0] : d < 27 ? a.ccBits[1] : a.ccBits[2];
  }, n.getBestModeForData = function(a) {
    return t.testNumeric(a) ? n.NUMERIC : t.testAlphanumeric(a) ? n.ALPHANUMERIC : t.testKanji(a) ? n.KANJI : n.BYTE;
  }, n.toString = function(a) {
    if (a && a.id)
      return a.id;
    throw new Error("Invalid mode");
  }, n.isValid = function(a) {
    return a && a.bit && a.ccBits;
  };
  function r(o) {
    if (typeof o != "string")
      throw new Error("Param is not a string");
    switch (o.toLowerCase()) {
      case "numeric":
        return n.NUMERIC;
      case "alphanumeric":
        return n.ALPHANUMERIC;
      case "kanji":
        return n.KANJI;
      case "byte":
        return n.BYTE;
      default:
        throw new Error("Unknown mode: " + o);
    }
  }
  n.from = function(a, d) {
    if (n.isValid(a))
      return a;
    try {
      return r(a);
    } catch {
      return d;
    }
  };
})(rn);
(function(n) {
  const e = Ae, t = tt, r = nt, o = rn, a = Gt, d = 7973, s = e.getBCHDigit(d);
  function l(y, u, g) {
    for (let h = 1; h <= 40; h++)
      if (u <= n.getCapacity(h, g, y))
        return h;
  }
  function f(y, u) {
    return o.getCharCountIndicator(y, u) + 4;
  }
  function p(y, u) {
    let g = 0;
    return y.forEach(function(h) {
      const c = f(h.mode, u);
      g += c + h.getBitsLength();
    }), g;
  }
  function _(y, u) {
    for (let g = 1; g <= 40; g++)
      if (p(y, g) <= n.getCapacity(g, u, o.MIXED))
        return g;
  }
  n.from = function(u, g) {
    return a.isValid(u) ? parseInt(u, 10) : g;
  }, n.getCapacity = function(u, g, h) {
    if (!a.isValid(u))
      throw new Error("Invalid QR Code version");
    typeof h > "u" && (h = o.BYTE);
    const c = e.getSymbolTotalCodewords(u), i = t.getTotalCodewordsCount(u, g), m = (c - i) * 8;
    if (h === o.MIXED)
      return m;
    const $ = m - f(h, u);
    switch (h) {
      case o.NUMERIC:
        return Math.floor($ / 10 * 3);
      case o.ALPHANUMERIC:
        return Math.floor($ / 11 * 2);
      case o.KANJI:
        return Math.floor($ / 13);
      case o.BYTE:
      default:
        return Math.floor($ / 8);
    }
  }, n.getBestVersionForData = function(u, g) {
    let h;
    const c = r.from(g, r.M);
    if (Array.isArray(u)) {
      if (u.length > 1)
        return _(u, c);
      if (u.length === 0)
        return 1;
      h = u[0];
    } else
      h = u;
    return l(h.mode, h.getLength(), c);
  }, n.getEncodedBits = function(u) {
    if (!a.isValid(u) || u < 7)
      throw new Error("Invalid QR Code version");
    let g = u << 12;
    for (; e.getBCHDigit(g) - s >= 0; )
      g ^= d << e.getBCHDigit(g) - s;
    return u << 12 | g;
  };
})(to);
var oo = {};
const Et = Ae, ao = 1335, n3 = 21522, br = Et.getBCHDigit(ao);
oo.getEncodedBits = function(e, t) {
  const r = e.bit << 3 | t;
  let o = r << 10;
  for (; Et.getBCHDigit(o) - br >= 0; )
    o ^= ao << Et.getBCHDigit(o) - br;
  return (r << 10 | o) ^ n3;
};
var io = {};
const t3 = rn;
function gn(n) {
  this.mode = t3.NUMERIC, this.data = n.toString();
}
gn.getBitsLength = function(e) {
  return 10 * Math.floor(e / 3) + (e % 3 ? e % 3 * 3 + 1 : 0);
};
gn.prototype.getLength = function() {
  return this.data.length;
};
gn.prototype.getBitsLength = function() {
  return gn.getBitsLength(this.data.length);
};
gn.prototype.write = function(e) {
  let t, r, o;
  for (t = 0; t + 3 <= this.data.length; t += 3)
    r = this.data.substr(t, 3), o = parseInt(r, 10), e.put(o, 10);
  const a = this.data.length - t;
  a > 0 && (r = this.data.substr(t), o = parseInt(r, 10), e.put(o, a * 3 + 1));
};
var r3 = gn;
const o3 = rn, it = [
  "0",
  "1",
  "2",
  "3",
  "4",
  "5",
  "6",
  "7",
  "8",
  "9",
  "A",
  "B",
  "C",
  "D",
  "E",
  "F",
  "G",
  "H",
  "I",
  "J",
  "K",
  "L",
  "M",
  "N",
  "O",
  "P",
  "Q",
  "R",
  "S",
  "T",
  "U",
  "V",
  "W",
  "X",
  "Y",
  "Z",
  " ",
  "$",
  "%",
  "*",
  "+",
  "-",
  ".",
  "/",
  ":"
];
function fn(n) {
  this.mode = o3.ALPHANUMERIC, this.data = n;
}
fn.getBitsLength = function(e) {
  return 11 * Math.floor(e / 2) + 6 * (e % 2);
};
fn.prototype.getLength = function() {
  return this.data.length;
};
fn.prototype.getBitsLength = function() {
  return fn.getBitsLength(this.data.length);
};
fn.prototype.write = function(e) {
  let t;
  for (t = 0; t + 2 <= this.data.length; t += 2) {
    let r = it.indexOf(this.data[t]) * 45;
    r += it.indexOf(this.data[t + 1]), e.put(r, 11);
  }
  this.data.length % 2 && e.put(it.indexOf(this.data[t]), 6);
};
var d3 = fn;
const a3 = rn;
function mn(n) {
  this.mode = a3.BYTE, typeof n == "string" ? this.data = new TextEncoder().encode(n) : this.data = new Uint8Array(n);
}
mn.getBitsLength = function(e) {
  return e * 8;
};
mn.prototype.getLength = function() {
  return this.data.length;
};
mn.prototype.getBitsLength = function() {
  return mn.getBitsLength(this.data.length);
};
mn.prototype.write = function(n) {
  for (let e = 0, t = this.data.length; e < t; e++)
    n.put(this.data[e], 8);
};
var i3 = mn;
const s3 = rn, c3 = Ae;
function pn(n) {
  this.mode = s3.KANJI, this.data = n;
}
pn.getBitsLength = function(e) {
  return e * 13;
};
pn.prototype.getLength = function() {
  return this.data.length;
};
pn.prototype.getBitsLength = function() {
  return pn.getBitsLength(this.data.length);
};
pn.prototype.write = function(n) {
  let e;
  for (e = 0; e < this.data.length; e++) {
    let t = c3.toSJIS(this.data[e]);
    if (t >= 33088 && t <= 40956)
      t -= 33088;
    else if (t >= 57408 && t <= 60351)
      t -= 49472;
    else
      throw new Error(
        "Invalid SJIS character: " + this.data[e] + `
Make sure your charset is UTF-8`
      );
    t = (t >>> 8 & 255) * 192 + (t & 255), n.put(t, 13);
  }
};
var l3 = pn, so = { exports: {} };
(function(n) {
  var e = {
    single_source_shortest_paths: function(t, r, o) {
      var a = {}, d = {};
      d[r] = 0;
      var s = e.PriorityQueue.make();
      s.push(r, 0);
      for (var l, f, p, _, y, u, g, h, c; !s.empty(); ) {
        l = s.pop(), f = l.value, _ = l.cost, y = t[f] || {};
        for (p in y)
          y.hasOwnProperty(p) && (u = y[p], g = _ + u, h = d[p], c = typeof d[p] > "u", (c || h > g) && (d[p] = g, s.push(p, g), a[p] = f));
      }
      if (typeof o < "u" && typeof d[o] > "u") {
        var i = ["Could not find a path from ", r, " to ", o, "."].join("");
        throw new Error(i);
      }
      return a;
    },
    extract_shortest_path_from_predecessor_list: function(t, r) {
      for (var o = [], a = r; a; )
        o.push(a), t[a], a = t[a];
      return o.reverse(), o;
    },
    find_path: function(t, r, o) {
      var a = e.single_source_shortest_paths(t, r, o);
      return e.extract_shortest_path_from_predecessor_list(
        a,
        o
      );
    },
    /**
     * A very naive priority queue implementation.
     */
    PriorityQueue: {
      make: function(t) {
        var r = e.PriorityQueue, o = {}, a;
        t = t || {};
        for (a in r)
          r.hasOwnProperty(a) && (o[a] = r[a]);
        return o.queue = [], o.sorter = t.sorter || r.default_sorter, o;
      },
      default_sorter: function(t, r) {
        return t.cost - r.cost;
      },
      /**
       * Add a new item to the queue and ensure the highest priority element
       * is at the front of the queue.
       */
      push: function(t, r) {
        var o = { value: t, cost: r };
        this.queue.push(o), this.queue.sort(this.sorter);
      },
      /**
       * Return the highest priority element in the queue.
       */
      pop: function() {
        return this.queue.shift();
      },
      empty: function() {
        return this.queue.length === 0;
      }
    }
  };
  n.exports = e;
})(so);
var u3 = so.exports;
(function(n) {
  const e = rn, t = r3, r = d3, o = i3, a = l3, d = Ge, s = Ae, l = u3;
  function f(i) {
    return unescape(encodeURIComponent(i)).length;
  }
  function p(i, m, $) {
    const v = [];
    let N;
    for (; (N = i.exec($)) !== null; )
      v.push({
        data: N[0],
        index: N.index,
        mode: m,
        length: N[0].length
      });
    return v;
  }
  function _(i) {
    const m = p(d.NUMERIC, e.NUMERIC, i), $ = p(d.ALPHANUMERIC, e.ALPHANUMERIC, i);
    let v, N;
    return s.isKanjiModeEnabled() ? (v = p(d.BYTE, e.BYTE, i), N = p(d.KANJI, e.KANJI, i)) : (v = p(d.BYTE_KANJI, e.BYTE, i), N = []), m.concat($, v, N).sort(function(w, A) {
      return w.index - A.index;
    }).map(function(w) {
      return {
        data: w.data,
        mode: w.mode,
        length: w.length
      };
    });
  }
  function y(i, m) {
    switch (m) {
      case e.NUMERIC:
        return t.getBitsLength(i);
      case e.ALPHANUMERIC:
        return r.getBitsLength(i);
      case e.KANJI:
        return a.getBitsLength(i);
      case e.BYTE:
        return o.getBitsLength(i);
    }
  }
  function u(i) {
    return i.reduce(function(m, $) {
      const v = m.length - 1 >= 0 ? m[m.length - 1] : null;
      return v && v.mode === $.mode ? (m[m.length - 1].data += $.data, m) : (m.push($), m);
    }, []);
  }
  function g(i) {
    const m = [];
    for (let $ = 0; $ < i.length; $++) {
      const v = i[$];
      switch (v.mode) {
        case e.NUMERIC:
          m.push([
            v,
            { data: v.data, mode: e.ALPHANUMERIC, length: v.length },
            { data: v.data, mode: e.BYTE, length: v.length }
          ]);
          break;
        case e.ALPHANUMERIC:
          m.push([
            v,
            { data: v.data, mode: e.BYTE, length: v.length }
          ]);
          break;
        case e.KANJI:
          m.push([
            v,
            { data: v.data, mode: e.BYTE, length: f(v.data) }
          ]);
          break;
        case e.BYTE:
          m.push([
            { data: v.data, mode: e.BYTE, length: f(v.data) }
          ]);
      }
    }
    return m;
  }
  function h(i, m) {
    const $ = {}, v = { start: {} };
    let N = ["start"];
    for (let C = 0; C < i.length; C++) {
      const w = i[C], A = [];
      for (let I = 0; I < w.length; I++) {
        const E = w[I], x = "" + C + I;
        A.push(x), $[x] = { node: E, lastCount: 0 }, v[x] = {};
        for (let F = 0; F < N.length; F++) {
          const q = N[F];
          $[q] && $[q].node.mode === E.mode ? (v[q][x] = y($[q].lastCount + E.length, E.mode) - y($[q].lastCount, E.mode), $[q].lastCount += E.length) : ($[q] && ($[q].lastCount = E.length), v[q][x] = y(E.length, E.mode) + 4 + e.getCharCountIndicator(E.mode, m));
        }
      }
      N = A;
    }
    for (let C = 0; C < N.length; C++)
      v[N[C]].end = 0;
    return { map: v, table: $ };
  }
  function c(i, m) {
    let $;
    const v = e.getBestModeForData(i);
    if ($ = e.from(m, v), $ !== e.BYTE && $.bit < v.bit)
      throw new Error('"' + i + '" cannot be encoded with mode ' + e.toString($) + `.
 Suggested mode is: ` + e.toString(v));
    switch ($ === e.KANJI && !s.isKanjiModeEnabled() && ($ = e.BYTE), $) {
      case e.NUMERIC:
        return new t(i);
      case e.ALPHANUMERIC:
        return new r(i);
      case e.KANJI:
        return new a(i);
      case e.BYTE:
        return new o(i);
    }
  }
  n.fromArray = function(m) {
    return m.reduce(function($, v) {
      return typeof v == "string" ? $.push(c(v, null)) : v.data && $.push(c(v.data, v.mode)), $;
    }, []);
  }, n.fromString = function(m, $) {
    const v = _(m, s.isKanjiModeEnabled()), N = g(v), C = h(N, $), w = l.find_path(C.map, "start", "end"), A = [];
    for (let I = 1; I < w.length - 1; I++)
      A.push(C.table[w[I]].node);
    return n.fromArray(u(A));
  }, n.rawSplit = function(m) {
    return n.fromArray(
      _(m, s.isKanjiModeEnabled())
    );
  };
})(io);
const ot = Ae, st = nt, h3 = Kl, g3 = ql, f3 = Jr, m3 = Yr, At = Xr, Ot = tt, p3 = Wl, Zn = to, $3 = oo, _3 = rn, ct = io;
function y3(n, e) {
  const t = n.size, r = m3.getPositions(e);
  for (let o = 0; o < r.length; o++) {
    const a = r[o][0], d = r[o][1];
    for (let s = -1; s <= 7; s++)
      if (!(a + s <= -1 || t <= a + s))
        for (let l = -1; l <= 7; l++)
          d + l <= -1 || t <= d + l || (s >= 0 && s <= 6 && (l === 0 || l === 6) || l >= 0 && l <= 6 && (s === 0 || s === 6) || s >= 2 && s <= 4 && l >= 2 && l <= 4 ? n.set(a + s, d + l, !0, !0) : n.set(a + s, d + l, !1, !0));
  }
}
function v3(n) {
  const e = n.size;
  for (let t = 8; t < e - 8; t++) {
    const r = t % 2 === 0;
    n.set(t, 6, r, !0), n.set(6, t, r, !0);
  }
}
function N3(n, e) {
  const t = f3.getPositions(e);
  for (let r = 0; r < t.length; r++) {
    const o = t[r][0], a = t[r][1];
    for (let d = -2; d <= 2; d++)
      for (let s = -2; s <= 2; s++)
        d === -2 || d === 2 || s === -2 || s === 2 || d === 0 && s === 0 ? n.set(o + d, a + s, !0, !0) : n.set(o + d, a + s, !1, !0);
  }
}
function C3(n, e) {
  const t = n.size, r = Zn.getEncodedBits(e);
  let o, a, d;
  for (let s = 0; s < 18; s++)
    o = Math.floor(s / 3), a = s % 3 + t - 8 - 3, d = (r >> s & 1) === 1, n.set(o, a, d, !0), n.set(a, o, d, !0);
}
function lt(n, e, t) {
  const r = n.size, o = $3.getEncodedBits(e, t);
  let a, d;
  for (a = 0; a < 15; a++)
    d = (o >> a & 1) === 1, a < 6 ? n.set(a, 8, d, !0) : a < 8 ? n.set(a + 1, 8, d, !0) : n.set(r - 15 + a, 8, d, !0), a < 8 ? n.set(8, r - a - 1, d, !0) : a < 9 ? n.set(8, 15 - a - 1 + 1, d, !0) : n.set(8, 15 - a - 1, d, !0);
  n.set(r - 8, 8, 1, !0);
}
function b3(n, e) {
  const t = n.size;
  let r = -1, o = t - 1, a = 7, d = 0;
  for (let s = t - 1; s > 0; s -= 2)
    for (s === 6 && s--; ; ) {
      for (let l = 0; l < 2; l++)
        if (!n.isReserved(o, s - l)) {
          let f = !1;
          d < e.length && (f = (e[d] >>> a & 1) === 1), n.set(o, s - l, f), a--, a === -1 && (d++, a = 7);
        }
      if (o += r, o < 0 || t <= o) {
        o -= r, r = -r;
        break;
      }
    }
}
function w3(n, e, t) {
  const r = new h3();
  t.forEach(function(l) {
    r.put(l.mode.bit, 4), r.put(l.getLength(), _3.getCharCountIndicator(l.mode, n)), l.write(r);
  });
  const o = ot.getSymbolTotalCodewords(n), a = Ot.getTotalCodewordsCount(n, e), d = (o - a) * 8;
  for (r.getLengthInBits() + 4 <= d && r.put(0, 4); r.getLengthInBits() % 8 !== 0; )
    r.putBit(0);
  const s = (d - r.getLengthInBits()) / 8;
  for (let l = 0; l < s; l++)
    r.put(l % 2 ? 17 : 236, 8);
  return E3(r, n, e);
}
function E3(n, e, t) {
  const r = ot.getSymbolTotalCodewords(e), o = Ot.getTotalCodewordsCount(e, t), a = r - o, d = Ot.getBlocksCount(e, t), s = r % d, l = d - s, f = Math.floor(r / d), p = Math.floor(a / d), _ = p + 1, y = f - p, u = new p3(y);
  let g = 0;
  const h = new Array(d), c = new Array(d);
  let i = 0;
  const m = new Uint8Array(n.buffer);
  for (let w = 0; w < d; w++) {
    const A = w < l ? p : _;
    h[w] = m.slice(g, g + A), c[w] = u.encode(h[w]), g += A, i = Math.max(i, A);
  }
  const $ = new Uint8Array(r);
  let v = 0, N, C;
  for (N = 0; N < i; N++)
    for (C = 0; C < d; C++)
      N < h[C].length && ($[v++] = h[C][N]);
  for (N = 0; N < y; N++)
    for (C = 0; C < d; C++)
      $[v++] = c[C][N];
  return $;
}
function A3(n, e, t, r) {
  let o;
  if (Array.isArray(n))
    o = ct.fromArray(n);
  else if (typeof n == "string") {
    let f = e;
    if (!f) {
      const p = ct.rawSplit(n);
      f = Zn.getBestVersionForData(p, t);
    }
    o = ct.fromString(n, f || 40);
  } else
    throw new Error("Invalid data");
  const a = Zn.getBestVersionForData(o, t);
  if (!a)
    throw new Error("The amount of data is too big to be stored in a QR Code");
  if (!e)
    e = a;
  else if (e < a)
    throw new Error(
      `
The chosen QR Code version cannot contain this amount of data.
Minimum version required to store current data is: ` + a + `.
`
    );
  const d = w3(e, t, o), s = ot.getSymbolSize(e), l = new g3(s);
  return y3(l, e), v3(l), N3(l, e), lt(l, t, 0), e >= 7 && C3(l, e), b3(l, d), isNaN(r) && (r = At.getBestMask(
    l,
    lt.bind(null, l, t)
  )), At.applyMask(r, l), lt(l, t, r), {
    modules: l,
    version: e,
    errorCorrectionLevel: t,
    maskPattern: r,
    segments: o
  };
}
Wr.create = function(e, t) {
  if (typeof e > "u" || e === "")
    throw new Error("No input text");
  let r = st.M, o, a;
  return typeof t < "u" && (r = st.from(t.errorCorrectionLevel, st.M), o = Zn.from(t.version), a = At.from(t.maskPattern), t.toSJISFunc && ot.setToSJISFunction(t.toSJISFunc)), A3(e, o, r, a);
};
var co = {}, Bt = {};
(function(n) {
  function e(t) {
    if (typeof t == "number" && (t = t.toString()), typeof t != "string")
      throw new Error("Color should be defined as hex string");
    let r = t.slice().replace("#", "").split("");
    if (r.length < 3 || r.length === 5 || r.length > 8)
      throw new Error("Invalid hex color: " + t);
    (r.length === 3 || r.length === 4) && (r = Array.prototype.concat.apply([], r.map(function(a) {
      return [a, a];
    }))), r.length === 6 && r.push("F", "F");
    const o = parseInt(r.join(""), 16);
    return {
      r: o >> 24 & 255,
      g: o >> 16 & 255,
      b: o >> 8 & 255,
      a: o & 255,
      hex: "#" + r.slice(0, 6).join("")
    };
  }
  n.getOptions = function(r) {
    r || (r = {}), r.color || (r.color = {});
    const o = typeof r.margin > "u" || r.margin === null || r.margin < 0 ? 4 : r.margin, a = r.width && r.width >= 21 ? r.width : void 0, d = r.scale || 4;
    return {
      width: a,
      scale: a ? 4 : d,
      margin: o,
      color: {
        dark: e(r.color.dark || "#000000ff"),
        light: e(r.color.light || "#ffffffff")
      },
      type: r.type,
      rendererOpts: r.rendererOpts || {}
    };
  }, n.getScale = function(r, o) {
    return o.width && o.width >= r + o.margin * 2 ? o.width / (r + o.margin * 2) : o.scale;
  }, n.getImageWidth = function(r, o) {
    const a = n.getScale(r, o);
    return Math.floor((r + o.margin * 2) * a);
  }, n.qrToImageData = function(r, o, a) {
    const d = o.modules.size, s = o.modules.data, l = n.getScale(d, a), f = Math.floor((d + a.margin * 2) * l), p = a.margin * l, _ = [a.color.light, a.color.dark];
    for (let y = 0; y < f; y++)
      for (let u = 0; u < f; u++) {
        let g = (y * f + u) * 4, h = a.color.light;
        if (y >= p && u >= p && y < f - p && u < f - p) {
          const c = Math.floor((y - p) / l), i = Math.floor((u - p) / l);
          h = _[s[c * d + i] ? 1 : 0];
        }
        r[g++] = h.r, r[g++] = h.g, r[g++] = h.b, r[g] = h.a;
      }
  };
})(Bt);
(function(n) {
  const e = Bt;
  function t(o, a, d) {
    o.clearRect(0, 0, a.width, a.height), a.style || (a.style = {}), a.height = d, a.width = d, a.style.height = d + "px", a.style.width = d + "px";
  }
  function r() {
    try {
      return document.createElement("canvas");
    } catch {
      throw new Error("You need to specify a canvas element");
    }
  }
  n.render = function(a, d, s) {
    let l = s, f = d;
    typeof l > "u" && (!d || !d.getContext) && (l = d, d = void 0), d || (f = r()), l = e.getOptions(l);
    const p = e.getImageWidth(a.modules.size, l), _ = f.getContext("2d"), y = _.createImageData(p, p);
    return e.qrToImageData(y.data, a, l), t(_, f, p), _.putImageData(y, 0, 0), f;
  }, n.renderToDataURL = function(a, d, s) {
    let l = s;
    typeof l > "u" && (!d || !d.getContext) && (l = d, d = void 0), l || (l = {});
    const f = n.render(a, d, l), p = l.type || "image/png", _ = l.rendererOpts || {};
    return f.toDataURL(p, _.quality);
  };
})(co);
var lo = {};
const O3 = Bt;
function wr(n, e) {
  const t = n.a / 255, r = e + '="' + n.hex + '"';
  return t < 1 ? r + " " + e + '-opacity="' + t.toFixed(2).slice(1) + '"' : r;
}
function ut(n, e, t) {
  let r = n + e;
  return typeof t < "u" && (r += " " + t), r;
}
function S3(n, e, t) {
  let r = "", o = 0, a = !1, d = 0;
  for (let s = 0; s < n.length; s++) {
    const l = Math.floor(s % e), f = Math.floor(s / e);
    !l && !a && (a = !0), n[s] ? (d++, s > 0 && l > 0 && n[s - 1] || (r += a ? ut("M", l + t, 0.5 + f + t) : ut("m", o, 0), o = 0, a = !1), l + 1 < e && n[s + 1] || (r += ut("h", d), d = 0)) : o++;
  }
  return r;
}
lo.render = function(e, t, r) {
  const o = O3.getOptions(t), a = e.modules.size, d = e.modules.data, s = a + o.margin * 2, l = o.color.light.a ? "<path " + wr(o.color.light, "fill") + ' d="M0 0h' + s + "v" + s + 'H0z"/>' : "", f = "<path " + wr(o.color.dark, "stroke") + ' d="' + S3(d, a, o.margin) + '"/>', p = 'viewBox="0 0 ' + s + " " + s + '"', y = '<svg xmlns="http://www.w3.org/2000/svg" ' + (o.width ? 'width="' + o.width + '" height="' + o.width + '" ' : "") + p + ' shape-rendering="crispEdges">' + l + f + `</svg>
`;
  return typeof r == "function" && r(null, y), y;
};
const T3 = Vl, St = Wr, uo = co, k3 = lo;
function jt(n, e, t, r, o) {
  const a = [].slice.call(arguments, 1), d = a.length, s = typeof a[d - 1] == "function";
  if (!s && !T3())
    throw new Error("Callback required as last argument");
  if (s) {
    if (d < 2)
      throw new Error("Too few arguments provided");
    d === 2 ? (o = t, t = e, e = r = void 0) : d === 3 && (e.getContext && typeof o > "u" ? (o = r, r = void 0) : (o = r, r = t, t = e, e = void 0));
  } else {
    if (d < 1)
      throw new Error("Too few arguments provided");
    return d === 1 ? (t = e, e = r = void 0) : d === 2 && !e.getContext && (r = t, t = e, e = void 0), new Promise(function(l, f) {
      try {
        const p = St.create(t, r);
        l(n(p, e, r));
      } catch (p) {
        f(p);
      }
    });
  }
  try {
    const l = St.create(t, r);
    o(null, n(l, e, r));
  } catch (l) {
    o(l);
  }
}
In.create = St.create;
In.toCanvas = jt.bind(null, uo.render);
In.toDataURL = jt.bind(null, uo.renderToDataURL);
In.toString = jt.bind(null, function(n, e, t) {
  return k3.render(n, t);
});
const I3 = async (n) => {
  try {
    return await In.toDataURL(n, {
      errorCorrectionLevel: "L",
      margin: 0
    });
  } catch (e) {
    console.warn("generate qr code error: ", e);
  }
};
var R3 = { 46: (n) => {
  var e, t = typeof Reflect == "object" ? Reflect : null, r = t && typeof t.apply == "function" ? t.apply : function(c, i, m) {
    return Function.prototype.apply.call(c, i, m);
  };
  e = t && typeof t.ownKeys == "function" ? t.ownKeys : Object.getOwnPropertySymbols ? function(c) {
    return Object.getOwnPropertyNames(c).concat(Object.getOwnPropertySymbols(c));
  } : function(c) {
    return Object.getOwnPropertyNames(c);
  };
  var o = Number.isNaN || function(c) {
    return c != c;
  };
  function a() {
    a.init.call(this);
  }
  n.exports = a, n.exports.once = function(c, i) {
    return new Promise(function(m, $) {
      function v(C) {
        c.removeListener(i, N), $(C);
      }
      function N() {
        typeof c.removeListener == "function" && c.removeListener("error", v), m([].slice.call(arguments));
      }
      h(c, i, N, { once: !0 }), i !== "error" && function(C, w, A) {
        typeof C.on == "function" && h(C, "error", w, A);
      }(c, v, { once: !0 });
    });
  }, a.EventEmitter = a, a.prototype._events = void 0, a.prototype._eventsCount = 0, a.prototype._maxListeners = void 0;
  var d = 10;
  function s(c) {
    if (typeof c != "function")
      throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof c);
  }
  function l(c) {
    return c._maxListeners === void 0 ? a.defaultMaxListeners : c._maxListeners;
  }
  function f(c, i, m, $) {
    var v, N, C, w;
    if (s(m), (N = c._events) === void 0 ? (N = c._events = /* @__PURE__ */ Object.create(null), c._eventsCount = 0) : (N.newListener !== void 0 && (c.emit("newListener", i, m.listener ? m.listener : m), N = c._events), C = N[i]), C === void 0)
      C = N[i] = m, ++c._eventsCount;
    else if (typeof C == "function" ? C = N[i] = $ ? [m, C] : [C, m] : $ ? C.unshift(m) : C.push(m), (v = l(c)) > 0 && C.length > v && !C.warned) {
      C.warned = !0;
      var A = new Error("Possible EventEmitter memory leak detected. " + C.length + " " + String(i) + " listeners added. Use emitter.setMaxListeners() to increase limit");
      A.name = "MaxListenersExceededWarning", A.emitter = c, A.type = i, A.count = C.length, w = A, console && console.warn && console.warn(w);
    }
    return c;
  }
  function p() {
    if (!this.fired)
      return this.target.removeListener(this.type, this.wrapFn), this.fired = !0, arguments.length === 0 ? this.listener.call(this.target) : this.listener.apply(this.target, arguments);
  }
  function _(c, i, m) {
    var $ = { fired: !1, wrapFn: void 0, target: c, type: i, listener: m }, v = p.bind($);
    return v.listener = m, $.wrapFn = v, v;
  }
  function y(c, i, m) {
    var $ = c._events;
    if ($ === void 0)
      return [];
    var v = $[i];
    return v === void 0 ? [] : typeof v == "function" ? m ? [v.listener || v] : [v] : m ? function(N) {
      for (var C = new Array(N.length), w = 0; w < C.length; ++w)
        C[w] = N[w].listener || N[w];
      return C;
    }(v) : g(v, v.length);
  }
  function u(c) {
    var i = this._events;
    if (i !== void 0) {
      var m = i[c];
      if (typeof m == "function")
        return 1;
      if (m !== void 0)
        return m.length;
    }
    return 0;
  }
  function g(c, i) {
    for (var m = new Array(i), $ = 0; $ < i; ++$)
      m[$] = c[$];
    return m;
  }
  function h(c, i, m, $) {
    if (typeof c.on == "function")
      $.once ? c.once(i, m) : c.on(i, m);
    else {
      if (typeof c.addEventListener != "function")
        throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof c);
      c.addEventListener(i, function v(N) {
        $.once && c.removeEventListener(i, v), m(N);
      });
    }
  }
  Object.defineProperty(a, "defaultMaxListeners", { enumerable: !0, get: function() {
    return d;
  }, set: function(c) {
    if (typeof c != "number" || c < 0 || o(c))
      throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + c + ".");
    d = c;
  } }), a.init = function() {
    this._events !== void 0 && this._events !== Object.getPrototypeOf(this)._events || (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0), this._maxListeners = this._maxListeners || void 0;
  }, a.prototype.setMaxListeners = function(c) {
    if (typeof c != "number" || c < 0 || o(c))
      throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + c + ".");
    return this._maxListeners = c, this;
  }, a.prototype.getMaxListeners = function() {
    return l(this);
  }, a.prototype.emit = function(c) {
    for (var i = [], m = 1; m < arguments.length; m++)
      i.push(arguments[m]);
    var $ = c === "error", v = this._events;
    if (v !== void 0)
      $ = $ && v.error === void 0;
    else if (!$)
      return !1;
    if ($) {
      var N;
      if (i.length > 0 && (N = i[0]), N instanceof Error)
        throw N;
      var C = new Error("Unhandled error." + (N ? " (" + N.message + ")" : ""));
      throw C.context = N, C;
    }
    var w = v[c];
    if (w === void 0)
      return !1;
    if (typeof w == "function")
      r(w, this, i);
    else {
      var A = w.length, I = g(w, A);
      for (m = 0; m < A; ++m)
        r(I[m], this, i);
    }
    return !0;
  }, a.prototype.addListener = function(c, i) {
    return f(this, c, i, !1);
  }, a.prototype.on = a.prototype.addListener, a.prototype.prependListener = function(c, i) {
    return f(this, c, i, !0);
  }, a.prototype.once = function(c, i) {
    return s(i), this.on(c, _(this, c, i)), this;
  }, a.prototype.prependOnceListener = function(c, i) {
    return s(i), this.prependListener(c, _(this, c, i)), this;
  }, a.prototype.removeListener = function(c, i) {
    var m, $, v, N, C;
    if (s(i), ($ = this._events) === void 0)
      return this;
    if ((m = $[c]) === void 0)
      return this;
    if (m === i || m.listener === i)
      --this._eventsCount == 0 ? this._events = /* @__PURE__ */ Object.create(null) : (delete $[c], $.removeListener && this.emit("removeListener", c, m.listener || i));
    else if (typeof m != "function") {
      for (v = -1, N = m.length - 1; N >= 0; N--)
        if (m[N] === i || m[N].listener === i) {
          C = m[N].listener, v = N;
          break;
        }
      if (v < 0)
        return this;
      v === 0 ? m.shift() : function(w, A) {
        for (; A + 1 < w.length; A++)
          w[A] = w[A + 1];
        w.pop();
      }(m, v), m.length === 1 && ($[c] = m[0]), $.removeListener !== void 0 && this.emit("removeListener", c, C || i);
    }
    return this;
  }, a.prototype.off = a.prototype.removeListener, a.prototype.removeAllListeners = function(c) {
    var i, m, $;
    if ((m = this._events) === void 0)
      return this;
    if (m.removeListener === void 0)
      return arguments.length === 0 ? (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0) : m[c] !== void 0 && (--this._eventsCount == 0 ? this._events = /* @__PURE__ */ Object.create(null) : delete m[c]), this;
    if (arguments.length === 0) {
      var v, N = Object.keys(m);
      for ($ = 0; $ < N.length; ++$)
        (v = N[$]) !== "removeListener" && this.removeAllListeners(v);
      return this.removeAllListeners("removeListener"), this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0, this;
    }
    if (typeof (i = m[c]) == "function")
      this.removeListener(c, i);
    else if (i !== void 0)
      for ($ = i.length - 1; $ >= 0; $--)
        this.removeListener(c, i[$]);
    return this;
  }, a.prototype.listeners = function(c) {
    return y(this, c, !0);
  }, a.prototype.rawListeners = function(c) {
    return y(this, c, !1);
  }, a.listenerCount = function(c, i) {
    return typeof c.listenerCount == "function" ? c.listenerCount(i) : u.call(c, i);
  }, a.prototype.listenerCount = u, a.prototype.eventNames = function() {
    return this._eventsCount > 0 ? e(this._events) : [];
  };
}, 513: (n) => {
  var e = Object.getOwnPropertySymbols, t = Object.prototype.hasOwnProperty, r = Object.prototype.propertyIsEnumerable;
  n.exports = function() {
    try {
      if (!Object.assign)
        return !1;
      var o = new String("abc");
      if (o[5] = "de", Object.getOwnPropertyNames(o)[0] === "5")
        return !1;
      for (var a = {}, d = 0; d < 10; d++)
        a["_" + String.fromCharCode(d)] = d;
      if (Object.getOwnPropertyNames(a).map(function(l) {
        return a[l];
      }).join("") !== "0123456789")
        return !1;
      var s = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(l) {
        s[l] = l;
      }), Object.keys(Object.assign({}, s)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }() ? Object.assign : function(o, a) {
    for (var d, s, l = function(y) {
      if (y == null)
        throw new TypeError("Object.assign cannot be called with null or undefined");
      return Object(y);
    }(o), f = 1; f < arguments.length; f++) {
      for (var p in d = Object(arguments[f]))
        t.call(d, p) && (l[p] = d[p]);
      if (e) {
        s = e(d);
        for (var _ = 0; _ < s.length; _++)
          r.call(d, s[_]) && (l[s[_]] = d[s[_]]);
      }
    }
    return l;
  };
}, 56: (n, e, t) => {
  var r, o = t(41);
  (r = o) && typeof r == "object" && "default" in r && r.default;
  var a = t(569), d = new a(), s = d.getBrowser();
  d.getCPU();
  var l = d.getDevice(), f = d.getEngine(), p = d.getOS(), _ = d.getUA(), y = "mobile", u = "tablet", g = "smarttv", h = "console", c = "wearable", i = "embedded", m = void 0, $ = { Chrome: "Chrome", Firefox: "Firefox", Opera: "Opera", Yandex: "Yandex", Safari: "Safari", InternetExplorer: "Internet Explorer", Edge: "Edge", Chromium: "Chromium", Ie: "IE", MobileSafari: "Mobile Safari", MIUI: "MIUI Browser", SamsungBrowser: "Samsung Browser" }, v = { IOS: "iOS", Android: "Android", WindowsPhone: "Windows Phone", Windows: "Windows", MAC_OS: "Mac OS" }, N = function(O) {
    return O || (arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "none");
  }, C = function() {
    return !(typeof window > "u" || !window.navigator && !navigator) && (window.navigator || navigator);
  }, w = function(O) {
    var H = C();
    return H && H.platform && (H.platform.indexOf(O) !== -1 || H.platform === "MacIntel" && H.maxTouchPoints > 1 && !window.MSStream);
  }, A = function(O) {
    return O.type === y;
  }, I = function(O) {
    return O.type === u;
  }, E = function(O) {
    var H = O.type;
    return H === y || H === u;
  }, x = function(O) {
    return O.type === g;
  }, F = function(O) {
    return O.type === m;
  }, q = function(O) {
    return O.type === c;
  }, he = function(O) {
    return O.type === h;
  }, se = function(O) {
    return O.type === i;
  }, Te = function(O) {
    var H = O.vendor;
    return N(H);
  }, b = function(O) {
    var H = O.model;
    return N(H);
  }, S = function(O) {
    var H = O.type;
    return N(H, "browser");
  }, U = function(O) {
    return O.name === v.Android;
  }, j = function(O) {
    return O.name === v.Windows;
  }, Q = function(O) {
    return O.name === v.MAC_OS;
  }, te = function(O) {
    return O.name === v.WindowsPhone;
  }, ae = function(O) {
    return O.name === v.IOS;
  }, ee = function(O) {
    var H = O.version;
    return N(H);
  }, re = function(O) {
    var H = O.name;
    return N(H);
  }, J = function(O) {
    return O.name === $.Chrome;
  }, qe = function(O) {
    return O.name === $.Firefox;
  }, Be = function(O) {
    return O.name === $.Chromium;
  }, on = function(O) {
    return O.name === $.Edge;
  }, z = function(O) {
    return O.name === $.Yandex;
  }, ye = function(O) {
    var H = O.name;
    return H === $.Safari || H === $.MobileSafari;
  }, pe = function(O) {
    return O.name === $.MobileSafari;
  }, Oe = function(O) {
    return O.name === $.Opera;
  }, Qe = function(O) {
    var H = O.name;
    return H === $.InternetExplorer || H === $.Ie;
  }, Pn = function(O) {
    return O.name === $.MIUI;
  }, ve = function(O) {
    return O.name === $.SamsungBrowser;
  }, We = function(O) {
    var H = O.version;
    return N(H);
  }, sn = function(O) {
    var H = O.major;
    return N(H);
  }, Y = function(O) {
    var H = O.name;
    return N(H);
  }, de = function(O) {
    var H = O.name;
    return N(H);
  }, B = function(O) {
    var H = O.version;
    return N(H);
  }, $e = function() {
    var O = C(), H = O && O.userAgent && O.userAgent.toLowerCase();
    return typeof H == "string" && /electron/.test(H);
  }, Ne = function(O) {
    return typeof O == "string" && O.indexOf("Edg/") !== -1;
  }, K = function() {
    return w("iPad");
  }, ke = function() {
    return w("iPhone");
  }, M = function() {
    return w("iPod");
  };
  x(l), he(l), q(l), se(l), pe(s) || K(), Be(s);
  var _e = E(l) || K();
  A(l), I(l) || K();
  var je = F(l);
  F(l), U(p), te(p), ae(p) || K(), J(s), qe(s), ye(s), Oe(s), Qe(s), ee(p), re(p), We(s), sn(s), Y(s), Te(l), b(l), de(f), B(f), on(s) || Ne(_), z(s), S(l), K(), ke(), M(), $e(), Ne(_), on(s) && Ne(_), j(p), Q(p), Pn(s), ve(s), e.Bd = je, e.Fr = _e;
}, 304: (n, e, t) => {
  var r = t(513), o = 60103, a = 60106;
  e.Fragment = 60107, e.StrictMode = 60108, e.Profiler = 60114;
  var d = 60109, s = 60110, l = 60112;
  e.Suspense = 60113;
  var f = 60115, p = 60116;
  if (typeof Symbol == "function" && Symbol.for) {
    var _ = Symbol.for;
    o = _("react.element"), a = _("react.portal"), e.Fragment = _("react.fragment"), e.StrictMode = _("react.strict_mode"), e.Profiler = _("react.profiler"), d = _("react.provider"), s = _("react.context"), l = _("react.forward_ref"), e.Suspense = _("react.suspense"), f = _("react.memo"), p = _("react.lazy");
  }
  var y = typeof Symbol == "function" && Symbol.iterator;
  function u(b) {
    for (var S = "https://reactjs.org/docs/error-decoder.html?invariant=" + b, U = 1; U < arguments.length; U++)
      S += "&args[]=" + encodeURIComponent(arguments[U]);
    return "Minified React error #" + b + "; visit " + S + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
  }
  var g = { isMounted: function() {
    return !1;
  }, enqueueForceUpdate: function() {
  }, enqueueReplaceState: function() {
  }, enqueueSetState: function() {
  } }, h = {};
  function c(b, S, U) {
    this.props = b, this.context = S, this.refs = h, this.updater = U || g;
  }
  function i() {
  }
  function m(b, S, U) {
    this.props = b, this.context = S, this.refs = h, this.updater = U || g;
  }
  c.prototype.isReactComponent = {}, c.prototype.setState = function(b, S) {
    if (typeof b != "object" && typeof b != "function" && b != null)
      throw Error(u(85));
    this.updater.enqueueSetState(this, b, S, "setState");
  }, c.prototype.forceUpdate = function(b) {
    this.updater.enqueueForceUpdate(this, b, "forceUpdate");
  }, i.prototype = c.prototype;
  var $ = m.prototype = new i();
  $.constructor = m, r($, c.prototype), $.isPureReactComponent = !0;
  var v = { current: null }, N = Object.prototype.hasOwnProperty, C = { key: !0, ref: !0, __self: !0, __source: !0 };
  function w(b, S, U) {
    var j, Q = {}, te = null, ae = null;
    if (S != null)
      for (j in S.ref !== void 0 && (ae = S.ref), S.key !== void 0 && (te = "" + S.key), S)
        N.call(S, j) && !C.hasOwnProperty(j) && (Q[j] = S[j]);
    var ee = arguments.length - 2;
    if (ee === 1)
      Q.children = U;
    else if (1 < ee) {
      for (var re = Array(ee), J = 0; J < ee; J++)
        re[J] = arguments[J + 2];
      Q.children = re;
    }
    if (b && b.defaultProps)
      for (j in ee = b.defaultProps)
        Q[j] === void 0 && (Q[j] = ee[j]);
    return { $$typeof: o, type: b, key: te, ref: ae, props: Q, _owner: v.current };
  }
  function A(b) {
    return typeof b == "object" && b !== null && b.$$typeof === o;
  }
  var I = /\/+/g;
  function E(b, S) {
    return typeof b == "object" && b !== null && b.key != null ? function(U) {
      var j = { "=": "=0", ":": "=2" };
      return "$" + U.replace(/[=:]/g, function(Q) {
        return j[Q];
      });
    }("" + b.key) : S.toString(36);
  }
  function x(b, S, U, j, Q) {
    var te = typeof b;
    te !== "undefined" && te !== "boolean" || (b = null);
    var ae = !1;
    if (b === null)
      ae = !0;
    else
      switch (te) {
        case "string":
        case "number":
          ae = !0;
          break;
        case "object":
          switch (b.$$typeof) {
            case o:
            case a:
              ae = !0;
          }
      }
    if (ae)
      return Q = Q(ae = b), b = j === "" ? "." + E(ae, 0) : j, Array.isArray(Q) ? (U = "", b != null && (U = b.replace(I, "$&/") + "/"), x(Q, S, U, "", function(J) {
        return J;
      })) : Q != null && (A(Q) && (Q = function(J, qe) {
        return { $$typeof: o, type: J.type, key: qe, ref: J.ref, props: J.props, _owner: J._owner };
      }(Q, U + (!Q.key || ae && ae.key === Q.key ? "" : ("" + Q.key).replace(I, "$&/") + "/") + b)), S.push(Q)), 1;
    if (ae = 0, j = j === "" ? "." : j + ":", Array.isArray(b))
      for (var ee = 0; ee < b.length; ee++) {
        var re = j + E(te = b[ee], ee);
        ae += x(te, S, U, re, Q);
      }
    else if (re = function(J) {
      return J === null || typeof J != "object" ? null : typeof (J = y && J[y] || J["@@iterator"]) == "function" ? J : null;
    }(b), typeof re == "function")
      for (b = re.call(b), ee = 0; !(te = b.next()).done; )
        ae += x(te = te.value, S, U, re = j + E(te, ee++), Q);
    else if (te === "object")
      throw S = "" + b, Error(u(31, S === "[object Object]" ? "object with keys {" + Object.keys(b).join(", ") + "}" : S));
    return ae;
  }
  function F(b, S, U) {
    if (b == null)
      return b;
    var j = [], Q = 0;
    return x(b, j, "", "", function(te) {
      return S.call(U, te, Q++);
    }), j;
  }
  function q(b) {
    if (b._status === -1) {
      var S = b._result;
      S = S(), b._status = 0, b._result = S, S.then(function(U) {
        b._status === 0 && (U = U.default, b._status = 1, b._result = U);
      }, function(U) {
        b._status === 0 && (b._status = 2, b._result = U);
      });
    }
    if (b._status === 1)
      return b._result;
    throw b._result;
  }
  var he = { current: null };
  function se() {
    var b = he.current;
    if (b === null)
      throw Error(u(321));
    return b;
  }
  var Te = { ReactCurrentDispatcher: he, ReactCurrentBatchConfig: { transition: 0 }, ReactCurrentOwner: v, IsSomeRendererActing: { current: !1 }, assign: r };
  e.Children = { map: F, forEach: function(b, S, U) {
    F(b, function() {
      S.apply(this, arguments);
    }, U);
  }, count: function(b) {
    var S = 0;
    return F(b, function() {
      S++;
    }), S;
  }, toArray: function(b) {
    return F(b, function(S) {
      return S;
    }) || [];
  }, only: function(b) {
    if (!A(b))
      throw Error(u(143));
    return b;
  } }, e.Component = c, e.PureComponent = m, e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = Te, e.cloneElement = function(b, S, U) {
    if (b == null)
      throw Error(u(267, b));
    var j = r({}, b.props), Q = b.key, te = b.ref, ae = b._owner;
    if (S != null) {
      if (S.ref !== void 0 && (te = S.ref, ae = v.current), S.key !== void 0 && (Q = "" + S.key), b.type && b.type.defaultProps)
        var ee = b.type.defaultProps;
      for (re in S)
        N.call(S, re) && !C.hasOwnProperty(re) && (j[re] = S[re] === void 0 && ee !== void 0 ? ee[re] : S[re]);
    }
    var re = arguments.length - 2;
    if (re === 1)
      j.children = U;
    else if (1 < re) {
      ee = Array(re);
      for (var J = 0; J < re; J++)
        ee[J] = arguments[J + 2];
      j.children = ee;
    }
    return { $$typeof: o, type: b.type, key: Q, ref: te, props: j, _owner: ae };
  }, e.createContext = function(b, S) {
    return S === void 0 && (S = null), (b = { $$typeof: s, _calculateChangedBits: S, _currentValue: b, _currentValue2: b, _threadCount: 0, Provider: null, Consumer: null }).Provider = { $$typeof: d, _context: b }, b.Consumer = b;
  }, e.createElement = w, e.createFactory = function(b) {
    var S = w.bind(null, b);
    return S.type = b, S;
  }, e.createRef = function() {
    return { current: null };
  }, e.forwardRef = function(b) {
    return { $$typeof: l, render: b };
  }, e.isValidElement = A, e.lazy = function(b) {
    return { $$typeof: p, _payload: { _status: -1, _result: b }, _init: q };
  }, e.memo = function(b, S) {
    return { $$typeof: f, type: b, compare: S === void 0 ? null : S };
  }, e.useCallback = function(b, S) {
    return se().useCallback(b, S);
  }, e.useContext = function(b, S) {
    return se().useContext(b, S);
  }, e.useDebugValue = function() {
  }, e.useEffect = function(b, S) {
    return se().useEffect(b, S);
  }, e.useImperativeHandle = function(b, S, U) {
    return se().useImperativeHandle(b, S, U);
  }, e.useLayoutEffect = function(b, S) {
    return se().useLayoutEffect(b, S);
  }, e.useMemo = function(b, S) {
    return se().useMemo(b, S);
  }, e.useReducer = function(b, S, U) {
    return se().useReducer(b, S, U);
  }, e.useRef = function(b) {
    return se().useRef(b);
  }, e.useState = function(b) {
    return se().useState(b);
  }, e.version = "17.0.2";
}, 41: (n, e, t) => {
  n.exports = t(304);
}, 977: (n, e, t) => {
  function r(d) {
    return new Promise((s) => {
      setTimeout(() => {
        s();
      }, d);
    });
  }
  function o() {
    return Promise.resolve();
  }
  function a() {
    return new Promise(() => {
    });
  }
  t.d(e, { D7: () => o, SX: () => a, yy: () => r });
}, 196: (n, e, t) => {
  t.d(e, { G: () => s });
  var r = t(977), o = function(l, f, p, _) {
    return new (p || (p = Promise))(function(y, u) {
      function g(i) {
        try {
          c(_.next(i));
        } catch (m) {
          u(m);
        }
      }
      function h(i) {
        try {
          c(_.throw(i));
        } catch (m) {
          u(m);
        }
      }
      function c(i) {
        var m;
        i.done ? y(i.value) : (m = i.value, m instanceof p ? m : new p(function($) {
          $(m);
        })).then(g, h);
      }
      c((_ = _.apply(l, [])).next());
    });
  };
  class a {
    constructor(f) {
      this._isOver = !1, this._isSuccess = !1, this._result = void 0, this._fn = f;
    }
    run() {
      return o(this, void 0, void 0, function* () {
        try {
          return this._result = yield this._fn(), this._isOver = !0, this._isSuccess = !0, this._runOnCompleteLater(), this._result;
        } catch (f) {
          throw this._error = f, this._isOver = !0, this._isSuccess = !1, this._runOnCompleteLater(), this._error;
        }
      });
    }
    waitForOver() {
      return o(this, void 0, void 0, function* () {
        if (this._isOver) {
          if (this._isSuccess)
            return this._result;
          throw this._error;
        }
        return new Promise((f, p) => {
          this._onComplete = () => {
            this._isSuccess ? f(this._result) : p(this._error);
          };
        });
      });
    }
    _runOnCompleteLater() {
      setTimeout(() => {
        var f;
        (f = this._onComplete) === null || f === void 0 || f.call(this);
      }, 0);
    }
  }
  var d = function(l, f, p, _) {
    return new (p || (p = Promise))(function(y, u) {
      function g(i) {
        try {
          c(_.next(i));
        } catch (m) {
          u(m);
        }
      }
      function h(i) {
        try {
          c(_.throw(i));
        } catch (m) {
          u(m);
        }
      }
      function c(i) {
        var m;
        i.done ? y(i.value) : (m = i.value, m instanceof p ? m : new p(function($) {
          $(m);
        })).then(g, h);
      }
      c((_ = _.apply(l, [])).next());
    });
  };
  class s {
    constructor(f = 1) {
      this._promiseTaskList = [], this._concurrentTaskCount = 0, this._maxConcurrency = f >= 1 ? f : 1;
    }
    run(f) {
      return d(this, void 0, void 0, function* () {
        const p = new a(f);
        return this._promiseTaskList.push(p), yield (0, r.D7)(), this._runConcurrentTasks(), p.waitForOver();
      });
    }
    _runConcurrentTasks() {
      return d(this, void 0, void 0, function* () {
        if (!(this._concurrentTaskCount >= this._maxConcurrency)) {
          for (this._concurrentTaskCount++; this._promiseTaskList.length > 0; ) {
            const f = this._promiseTaskList.shift();
            if (f)
              try {
                yield f.run();
              } catch {
              }
          }
          this._concurrentTaskCount--;
        }
      });
    }
  }
}, 401: (n, e, t) => {
  t.d(e, { S: () => o });
  var r = function(a, d, s, l) {
    return new (s || (s = Promise))(function(f, p) {
      function _(g) {
        try {
          u(l.next(g));
        } catch (h) {
          p(h);
        }
      }
      function y(g) {
        try {
          u(l.throw(g));
        } catch (h) {
          p(h);
        }
      }
      function u(g) {
        var h;
        g.done ? f(g.value) : (h = g.value, h instanceof s ? h : new s(function(c) {
          c(h);
        })).then(_, y);
      }
      u((l = l.apply(a, [])).next());
    });
  };
  class o {
    constructor() {
      this._fnPromiseMap = /* @__PURE__ */ new Map();
    }
    run(d, s) {
      return r(this, void 0, void 0, function* () {
        let l = this._fnPromiseMap.get(d);
        return l || (l = new Promise((f, p) => r(this, void 0, void 0, function* () {
          try {
            yield this._runIdlePromise();
            const _ = s();
            f(yield _);
          } catch (_) {
            p(_);
          } finally {
            this._fnPromiseMap.delete(d);
          }
        })), this._fnPromiseMap.set(d, l)), l;
      });
    }
    _runIdlePromise() {
      return Promise.resolve();
    }
  }
}, 276: (n, e, t) => {
  var r;
  t.d(e, { w: () => r }), function(o) {
    o.CLIENT_ID = "client_id", o.CLIENT_SECRET = "client_secret", o.RESPONSE_TYPE = "response_type", o.SCOPE = "scope", o.STATE = "state", o.REDIRECT_URI = "redirect_uri", o.ERROR = "error", o.ERROR_DESCRIPTION = "error_description", o.ERROR_URI = "error_uri", o.GRANT_TYPE = "grant_type", o.CODE = "code", o.ACCESS_TOKEN = "access_token", o.TOKEN_TYPE = "token_type", o.EXPIRES_IN = "expires_in", o.USERNAME = "username", o.PASSWORD = "password", o.REFRESH_TOKEN = "refresh_token";
  }(r || (r = {}));
}, 884: (n, e, t) => {
  t.d(e, { H: () => r });
  class r {
    constructor() {
    }
    getCookies(a = !0) {
      return this._getCurrentCookieObject((d) => (a && d !== void 0 && (d = this._decode(d)), d));
    }
    getCookie(a, d = !0) {
      const s = this._getCurrentCookieObject((l) => (d && l !== void 0 && (l = this._decode(l)), l))[a];
      return s === void 0 ? "" : s;
    }
    setCookie(a, d, s, l, f, p) {
      let _, y = "";
      l && (y = new Date((/* @__PURE__ */ new Date()).getTime() + l).toUTCString()), _ = a + "=" + escape(d), _ += "; path=" + (f || "/"), _ += "; domain=" + s, p && (_ += "; secure"), l && (_ += "; expires=" + y), document.cookie = _;
    }
    delCookie(a, d, s, l) {
      this.setCookie(a, "", d, -6e4, s, l);
    }
    loadScript(a, d = { type: "text/javascript", language: "javascript" }) {
      return new Promise((s, l) => {
        const f = document, p = f.createElement("script");
        let _ = !1;
        p.href = a, p.src = a;
        const y = { type: "text/javascript", language: "javascript" };
        for (const u in y)
          p[u] = y[u], p.setAttribute(u, y[u]);
        for (const u in d)
          p[u] = d[u], p.setAttribute(u, d[u]);
        p.onload = p.onreadystatechange = function() {
          _ || p.readyState && p.readyState != "loaded" && p.readyState != "complete" || (_ = !0, s());
        }, f.getElementsByTagName("head")[0].appendChild(p);
      });
    }
    _getCurrentCookieObject(a) {
      const d = document.cookie.split("; "), s = {};
      return d.forEach((l) => {
        const f = l.split("="), p = f.shift(), _ = f.join("=");
        s[p] = a(_);
      }), s;
    }
    _decode(a) {
      try {
        a = decodeURIComponent(a);
      } catch {
        a = unescape(a);
      }
      return a;
    }
  }
}, 856: (n, e, t) => {
  t.d(e, { Z: () => a });
  const r = [{ alpha2: "AF", alpha3: "AFG", numeric: 4, englishName: "Afghanistan", chineseName: "阿富汗", callingCode: "+93" }, { alpha2: "AX", alpha3: "ALA", numeric: 248, englishName: "", chineseName: "", callingCode: "" }, { alpha2: "AL", alpha3: "ALB", numeric: 8, englishName: "Albania", chineseName: "阿尔巴尼亚", callingCode: "+355" }, { alpha2: "DZ", alpha3: "DZA", numeric: 12, englishName: "Algeria", chineseName: "阿尔及利亚", callingCode: "+213" }, { alpha2: "AS", alpha3: "ASM", numeric: 16, englishName: "American Samoa", chineseName: "美属萨摩亚", callingCode: "+1684" }, { alpha2: "AD", alpha3: "AND", numeric: 20, englishName: "Andorra", chineseName: "安道尔", callingCode: "+376" }, { alpha2: "AO", alpha3: "AGO", numeric: 24, englishName: "Angola", chineseName: "安哥拉", callingCode: "+244" }, { alpha2: "AI", alpha3: "AIA", numeric: 660, englishName: "Anguilla", chineseName: "安圭拉", callingCode: "+1264" }, { alpha2: "AQ", alpha3: "ATA", numeric: 10, englishName: "", chineseName: "", callingCode: "" }, { alpha2: "AG", alpha3: "ATG", numeric: 28, englishName: "Antigua and Barbuda", chineseName: "安提瓜和巴布达", callingCode: "+1268" }, { alpha2: "AR", alpha3: "ARG", numeric: 32, englishName: "Argentina", chineseName: "阿根廷", callingCode: "+54" }, { alpha2: "AM", alpha3: "ARM", numeric: 51, englishName: "Armenia", chineseName: "亚美尼亚", callingCode: "+374" }, { alpha2: "AW", alpha3: "ABW", numeric: 533, englishName: "Aruba", chineseName: "阿鲁巴", callingCode: "+297" }, { alpha2: "AU", alpha3: "AUS", numeric: 36, englishName: "Australia", chineseName: "澳大利亚", callingCode: "+61" }, { alpha2: "AT", alpha3: "AUT", numeric: 40, englishName: "Austria", chineseName: "奥地利", callingCode: "+43" }, { alpha2: "AZ", alpha3: "AZE", numeric: 31, englishName: "Azerbaijan", chineseName: "阿塞拜疆", callingCode: "+994" }, { alpha2: "BS", alpha3: "BHS", numeric: 44, englishName: "Bahamas", chineseName: "巴哈马", callingCode: "+1242" }, { alpha2: "BH", alpha3: "BHR", numeric: 48, englishName: "Bahrain", chineseName: "巴林", callingCode: "+973" }, { alpha2: "BD", alpha3: "BGD", numeric: 50, englishName: "Bangladesh", chineseName: "孟加拉国", callingCode: "+880" }, { alpha2: "BB", alpha3: "BRB", numeric: 52, englishName: "Barbados", chineseName: "巴巴多斯", callingCode: "+1246" }, { alpha2: "BY", alpha3: "BLR", numeric: 112, englishName: "Belarus", chineseName: "白俄罗斯", callingCode: "+375" }, { alpha2: "BE", alpha3: "BEL", numeric: 56, englishName: "Belgium", chineseName: "比利时", callingCode: "+32" }, { alpha2: "BZ", alpha3: "BLZ", numeric: 84, englishName: "Belize", chineseName: "伯利兹", callingCode: "+501" }, { alpha2: "BJ", alpha3: "BEN", numeric: 204, englishName: "Benin", chineseName: "贝宁", callingCode: "+229" }, { alpha2: "BM", alpha3: "BMU", numeric: 60, englishName: "Bermuda", chineseName: "百慕大群岛", callingCode: "+1441" }, { alpha2: "BT", alpha3: "BTN", numeric: 64, englishName: "Bhutan", chineseName: "不丹", callingCode: "+975" }, { alpha2: "BO", alpha3: "BOL", numeric: 68, englishName: "Bolivia", chineseName: "玻利维亚", callingCode: "+591" }, { alpha2: "BQ", alpha3: "BES", numeric: 535, englishName: "", chineseName: "", callingCode: "" }, { alpha2: "BA", alpha3: "BIH", numeric: 70, englishName: "Bosnia and Herzegovina", chineseName: "波斯尼亚和黑塞哥维那", callingCode: "+387" }, { alpha2: "BW", alpha3: "BWA", numeric: 72, englishName: "Botswana", chineseName: "博茨瓦纳", callingCode: "+267" }, { alpha2: "BV", alpha3: "BVT", numeric: 74, englishName: "", chineseName: "", callingCode: "" }, { alpha2: "BR", alpha3: "BRA", numeric: 76, englishName: "Brazil", chineseName: "巴西", callingCode: "+55" }, { alpha2: "IO", alpha3: "IOT", numeric: 86, englishName: "", chineseName: "", callingCode: "" }, { alpha2: "BN", alpha3: "BRN", numeric: 96, englishName: "Brunei", chineseName: "文莱", callingCode: "+673" }, { alpha2: "BG", alpha3: "BGR", numeric: 100, englishName: "Bulgaria", chineseName: "保加利亚", callingCode: "+359" }, { alpha2: "BF", alpha3: "BFA", numeric: 854, englishName: "Burkina Faso", chineseName: "布基纳法索", callingCode: "+226" }, { alpha2: "BI", alpha3: "BDI", numeric: 108, englishName: "Burundi", chineseName: "布隆迪", callingCode: "+257" }, { alpha2: "CV", alpha3: "CPV", numeric: 132, englishName: "Cape Verde", chineseName: "开普", callingCode: "+238" }, { alpha2: "KH", alpha3: "KHM", numeric: 116, englishName: "Cambodia", chineseName: "柬埔寨", callingCode: "+855" }, { alpha2: "CM", alpha3: "CMR", numeric: 120, englishName: "Cameroon", chineseName: "喀麦隆", callingCode: "+237" }, { alpha2: "CA", alpha3: "CAN", numeric: 124, englishName: "Canada", chineseName: "加拿大", callingCode: "+1" }, { alpha2: "KY", alpha3: "CYM", numeric: 136, englishName: "Cayman Islands", chineseName: "开曼群岛", callingCode: "+1345" }, { alpha2: "CF", alpha3: "CAF", numeric: 140, englishName: "Central African Republic", chineseName: "中非共和国", callingCode: "+236" }, { alpha2: "TD", alpha3: "TCD", numeric: 148, englishName: "Chad", chineseName: "乍得", callingCode: "+235" }, { alpha2: "CL", alpha3: "CHL", numeric: 152, englishName: "Chile", chineseName: "智利", callingCode: "+56" }, { alpha2: "CN", alpha3: "CHN", numeric: 156, englishName: "China", chineseName: "中国大陆", callingCode: "+86" }, { alpha2: "CX", alpha3: "CXR", numeric: 162, englishName: "Christmas Island", chineseName: "圣诞岛", callingCode: "+0061 9164" }, { alpha2: "CC", alpha3: "CCK", numeric: 166, englishName: "Cocos Island", chineseName: "科科斯岛", callingCode: "+0061 9162" }, { alpha2: "CO", alpha3: "COL", numeric: 170, englishName: "Colombia", chineseName: "哥伦比亚", callingCode: "+57" }, { alpha2: "KM", alpha3: "COM", numeric: 174, englishName: "Comoros", chineseName: "科摩罗", callingCode: "+269" }, { alpha2: "CG", alpha3: "COG", numeric: 178, englishName: "Republic Of The Congo", chineseName: "刚果共和国", callingCode: "+242" }, { alpha2: "CD", alpha3: "COD", numeric: 180, englishName: "", chineseName: "", callingCode: "" }, { alpha2: "CK", alpha3: "COK", numeric: 184, englishName: "Cook Islands", chineseName: "库克群岛", callingCode: "+682" }, { alpha2: "CR", alpha3: "CRI", numeric: 188, englishName: "Costa Rica", chineseName: "哥斯达黎加", callingCode: "+506" }, { alpha2: "CI", alpha3: "CIV", numeric: 384, englishName: "Ivory Coast", chineseName: "象牙海岸", callingCode: "+225" }, { alpha2: "HR", alpha3: "HRV", numeric: 191, englishName: "Croatia", chineseName: "克罗地亚", callingCode: "+385" }, { alpha2: "CU", alpha3: "CUB", numeric: 192, englishName: "Cuba", chineseName: "古巴", callingCode: "+53" }, { alpha2: "CW", alpha3: "CUW", numeric: 531, englishName: "Curacao", chineseName: "库拉索", callingCode: "+599" }, { alpha2: "CY", alpha3: "CYP", numeric: 196, englishName: "Cyprus", chineseName: "塞浦路斯", callingCode: "+357" }, { alpha2: "CZ", alpha3: "CZE", numeric: 203, englishName: "Czech", chineseName: "捷克", callingCode: "+420" }, { alpha2: "DK", alpha3: "DNK", numeric: 208, englishName: "Denmark", chineseName: "丹麦", callingCode: "+45" }, { alpha2: "DJ", alpha3: "DJI", numeric: 262, englishName: "Djibouti", chineseName: "吉布提", callingCode: "+253" }, { alpha2: "DM", alpha3: "DMA", numeric: 212, englishName: "Dominica", chineseName: "多米尼加", callingCode: "+1767" }, { alpha2: "DO", alpha3: "DOM", numeric: 214, englishName: "Dominican Republic", chineseName: "多米尼加共和国", callingCode: "+1809" }, { alpha2: "EC", alpha3: "ECU", numeric: 218, englishName: "Ecuador", chineseName: "厄瓜多尔", callingCode: "+593" }, { alpha2: "EG", alpha3: "EGY", numeric: 818, englishName: "Egypt", chineseName: "埃及", callingCode: "+20" }, { alpha2: "SV", alpha3: "SLV", numeric: 222, englishName: "El Salvador", chineseName: "萨尔瓦多", callingCode: "+503" }, { alpha2: "GQ", alpha3: "GNQ", numeric: 226, englishName: "Equatorial Guinea", chineseName: "赤道几内亚", callingCode: "+240" }, { alpha2: "ER", alpha3: "ERI", numeric: 232, englishName: "Eritrea", chineseName: "厄立特里亚", callingCode: "+291" }, { alpha2: "EE", alpha3: "EST", numeric: 233, englishName: "Estonia", chineseName: "爱沙尼亚", callingCode: "+372" }, { alpha2: "SZ", alpha3: "SWZ", numeric: 748, englishName: "Swaziland", chineseName: "斯威士兰", callingCode: "+268" }, { alpha2: "ET", alpha3: "ETH", numeric: 231, englishName: "Ethiopia", chineseName: "埃塞俄比亚", callingCode: "+251" }, { alpha2: "FK", alpha3: "FLK", numeric: 238, englishName: "Falkland Islands", chineseName: "福克兰群岛", callingCode: "+500" }, { alpha2: "FO", alpha3: "FRO", numeric: 234, englishName: "Faroe Islands", chineseName: "法罗群岛", callingCode: "+298" }, { alpha2: "FJ", alpha3: "FJI", numeric: 242, englishName: "Fiji", chineseName: "斐济", callingCode: "+679" }, { alpha2: "FI", alpha3: "FIN", numeric: 246, englishName: "Finland", chineseName: "芬兰", callingCode: "+358" }, { alpha2: "FR", alpha3: "FRA", numeric: 250, englishName: "France", chineseName: "法国", callingCode: "+33" }, { alpha2: "GF", alpha3: "GUF", numeric: 254, englishName: "French Guiana", chineseName: "法属圭亚那", callingCode: "+594" }, { alpha2: "PF", alpha3: "PYF", numeric: 258, englishName: "French Polynesia", chineseName: "法属波利尼西亚", callingCode: "+689" }, { alpha2: "TF", alpha3: "ATF", numeric: 260, englishName: "", chineseName: "", callingCode: "" }, { alpha2: "GA", alpha3: "GAB", numeric: 266, englishName: "Gabon", chineseName: "加蓬", callingCode: "+241" }, { alpha2: "GM", alpha3: "GMB", numeric: 270, englishName: "Gambia", chineseName: "冈比亚", callingCode: "+220" }, { alpha2: "GE", alpha3: "GEO", numeric: 268, englishName: "Georgia", chineseName: "格鲁吉亚", callingCode: "+995" }, { alpha2: "DE", alpha3: "DEU", numeric: 276, englishName: "Germany", chineseName: "德国", callingCode: "+49" }, { alpha2: "GH", alpha3: "GHA", numeric: 288, englishName: "Ghana", chineseName: "加纳", callingCode: "+233" }, { alpha2: "GI", alpha3: "GIB", numeric: 292, englishName: "Gibraltar", chineseName: "直布罗陀", callingCode: "+350" }, { alpha2: "GR", alpha3: "GRC", numeric: 300, englishName: "Greece", chineseName: "希腊", callingCode: "+30" }, { alpha2: "GL", alpha3: "GRL", numeric: 304, englishName: "Greenland", chineseName: "格陵兰岛", callingCode: "+299" }, { alpha2: "GD", alpha3: "GRD", numeric: 308, englishName: "Grenada", chineseName: "格林纳达", callingCode: "+1473" }, { alpha2: "GP", alpha3: "GLP", numeric: 312, englishName: "Guadeloupe", chineseName: "瓜德罗普岛", callingCode: "+590" }, { alpha2: "GU", alpha3: "GUM", numeric: 316, englishName: "Guam", chineseName: "关岛", callingCode: "+1671" }, { alpha2: "GT", alpha3: "GTM", numeric: 320, englishName: "Guatemala", chineseName: "瓜地马拉", callingCode: "+502" }, { alpha2: "GG", alpha3: "GGY", numeric: 831, englishName: "", chineseName: "", callingCode: "" }, { alpha2: "GN", alpha3: "GIN", numeric: 324, englishName: "Guinea", chineseName: "几内亚", callingCode: "+224" }, { alpha2: "GW", alpha3: "GNB", numeric: 624, englishName: "Guinea-Bissau", chineseName: "几内亚比绍共和国", callingCode: "+245" }, { alpha2: "GY", alpha3: "GUY", numeric: 328, englishName: "Guyana", chineseName: "圭亚那", callingCode: "+592" }, { alpha2: "HT", alpha3: "HTI", numeric: 332, englishName: "Haiti", chineseName: "海地", callingCode: "+509" }, { alpha2: "HM", alpha3: "HMD", numeric: 334, englishName: "", chineseName: "", callingCode: "" }, { alpha2: "VA", alpha3: "VAT", numeric: 336, englishName: "", chineseName: "", callingCode: "" }, { alpha2: "HN", alpha3: "HND", numeric: 340, englishName: "Honduras", chineseName: "洪都拉斯", callingCode: "+504" }, { alpha2: "HK", alpha3: "HKG", numeric: 344, englishName: "Hong Kong", chineseName: "中国香港", callingCode: "+852" }, { alpha2: "HU", alpha3: "HUN", numeric: 348, englishName: "Hungary", chineseName: "匈牙利", callingCode: "+36" }, { alpha2: "IS", alpha3: "ISL", numeric: 352, englishName: "Iceland", chineseName: "冰岛", callingCode: "+354" }, { alpha2: "IN", alpha3: "IND", numeric: 356, englishName: "India", chineseName: "印度", callingCode: "+91" }, { alpha2: "ID", alpha3: "IDN", numeric: 360, englishName: "Indonesia", chineseName: "印度尼西亚", callingCode: "+62" }, { alpha2: "IR", alpha3: "IRN", numeric: 364, englishName: "Iran", chineseName: "伊朗", callingCode: "+98" }, { alpha2: "IQ", alpha3: "IRQ", numeric: 368, englishName: "Iraq", chineseName: "伊拉克", callingCode: "+964" }, { alpha2: "IE", alpha3: "IRL", numeric: 372, englishName: "Ireland", chineseName: "爱尔兰", callingCode: "+353" }, { alpha2: "IM", alpha3: "IMN", numeric: 833, englishName: "", chineseName: "", callingCode: "" }, { alpha2: "IL", alpha3: "ISR", numeric: 376, englishName: "Israel", chineseName: "以色列", callingCode: "+972" }, { alpha2: "IT", alpha3: "ITA", numeric: 380, englishName: "Italy", chineseName: "意大利", callingCode: "+39" }, { alpha2: "JM", alpha3: "JAM", numeric: 388, englishName: "Jamaica", chineseName: "牙买加", callingCode: "+1876" }, { alpha2: "JP", alpha3: "JPN", numeric: 392, englishName: "Japan", chineseName: "日本", callingCode: "+81" }, { alpha2: "JE", alpha3: "JEY", numeric: 832, englishName: "", chineseName: "", callingCode: "" }, { alpha2: "JO", alpha3: "JOR", numeric: 400, englishName: "Jordan", chineseName: "约旦", callingCode: "+962" }, { alpha2: "KZ", alpha3: "KAZ", numeric: 398, englishName: "Kazakhstan", chineseName: "哈萨克斯坦", callingCode: "+7" }, { alpha2: "KE", alpha3: "KEN", numeric: 404, englishName: "Kenya", chineseName: "肯尼亚", callingCode: "+254" }, { alpha2: "KI", alpha3: "KIR", numeric: 296, englishName: "Kiribati", chineseName: "基里巴斯", callingCode: "+686" }, { alpha2: "KP", alpha3: "PRK", numeric: 408, englishName: "Korea Democratic Rep.", chineseName: "朝鲜", callingCode: "+85" }, { alpha2: "KR", alpha3: "KOR", numeric: 410, englishName: "South Korea", chineseName: "韩国", callingCode: "+82" }, { alpha2: "KW", alpha3: "KWT", numeric: 414, englishName: "Kuwait", chineseName: "科威特", callingCode: "+965" }, { alpha2: "KG", alpha3: "KGZ", numeric: 417, englishName: "Kyrgyzstan", chineseName: "吉尔吉斯斯坦", callingCode: "+996" }, { alpha2: "LA", alpha3: "LAO", numeric: 418, englishName: "Laos", chineseName: "老挝", callingCode: "+856" }, { alpha2: "LV", alpha3: "LVA", numeric: 428, englishName: "Latvia", chineseName: "拉脱维亚", callingCode: "+371" }, { alpha2: "LB", alpha3: "LBN", numeric: 422, englishName: "Lebanon", chineseName: "黎巴嫩", callingCode: "+961" }, { alpha2: "LS", alpha3: "LSO", numeric: 426, englishName: "Lesotho", chineseName: "莱索托", callingCode: "+266" }, { alpha2: "LR", alpha3: "LBR", numeric: 430, englishName: "Liberia", chineseName: "利比里亚", callingCode: "+231" }, { alpha2: "LY", alpha3: "LBY", numeric: 434, englishName: "Libya", chineseName: "利比亚", callingCode: "+218" }, { alpha2: "LI", alpha3: "LIE", numeric: 438, englishName: "Liechtenstein", chineseName: "列支敦士登", callingCode: "+423" }, { alpha2: "LT", alpha3: "LTU", numeric: 440, englishName: "Lithuania", chineseName: "立陶宛", callingCode: "+370" }, { alpha2: "LU", alpha3: "LUX", numeric: 442, englishName: "Luxembourg", chineseName: "卢森堡", callingCode: "+352" }, { alpha2: "MO", alpha3: "MAC", numeric: 446, englishName: "Macau", chineseName: "中国澳门", callingCode: "+853" }, { alpha2: "MG", alpha3: "MDG", numeric: 450, englishName: "Madagascar", chineseName: "马达加斯加", callingCode: "+261" }, { alpha2: "MW", alpha3: "MWI", numeric: 454, englishName: "Malawi", chineseName: "马拉维", callingCode: "+265" }, { alpha2: "MY", alpha3: "MYS", numeric: 458, englishName: "Malaysia", chineseName: "马来西亚", callingCode: "+60" }, { alpha2: "MV", alpha3: "MDV", numeric: 462, englishName: "Maldives", chineseName: "马尔代夫", callingCode: "+960" }, { alpha2: "ML", alpha3: "MLI", numeric: 466, englishName: "Mali", chineseName: "马里", callingCode: "+223" }, { alpha2: "MT", alpha3: "MLT", numeric: 470, englishName: "Malta", chineseName: "马耳他", callingCode: "+356" }, { alpha2: "MH", alpha3: "MHL", numeric: 584, englishName: "Marshall Islands", chineseName: "马绍尔群岛", callingCode: "+692" }, { alpha2: "MQ", alpha3: "MTQ", numeric: 474, englishName: "Martinique", chineseName: "马提尼克", callingCode: "+596" }, { alpha2: "MR", alpha3: "MRT", numeric: 478, englishName: "Mauritania", chineseName: "毛里塔尼亚", callingCode: "+222" }, { alpha2: "MU", alpha3: "MUS", numeric: 480, englishName: "Mauritius", chineseName: "毛里求斯", callingCode: "+230" }, { alpha2: "YT", alpha3: "MYT", numeric: 175, englishName: "Mayotte", chineseName: "马约特", callingCode: "+269" }, { alpha2: "MX", alpha3: "MEX", numeric: 484, englishName: "Mexico", chineseName: "墨西哥", callingCode: "+52" }, { alpha2: "FM", alpha3: "FSM", numeric: 583, englishName: "Micronesia", chineseName: "密克罗尼西亚", callingCode: "+691" }, { alpha2: "MD", alpha3: "MDA", numeric: 498, englishName: "Moldova", chineseName: "摩尔多瓦", callingCode: "+373" }, { alpha2: "MC", alpha3: "MCO", numeric: 492, englishName: "Monaco", chineseName: "摩纳哥", callingCode: "+377" }, { alpha2: "MN", alpha3: "MNG", numeric: 496, englishName: "Mongolia", chineseName: "蒙古", callingCode: "+976" }, { alpha2: "ME", alpha3: "MNE", numeric: 499, englishName: "Montenegro", chineseName: "黑山", callingCode: "+382" }, { alpha2: "MS", alpha3: "MSR", numeric: 500, englishName: "Montserrat", chineseName: "蒙特塞拉特岛", callingCode: "+1664" }, { alpha2: "MA", alpha3: "MAR", numeric: 504, englishName: "Morocco", chineseName: "摩洛哥", callingCode: "+212" }, { alpha2: "MZ", alpha3: "MOZ", numeric: 508, englishName: "Mozambique", chineseName: "莫桑比克", callingCode: "+258" }, { alpha2: "MM", alpha3: "MMR", numeric: 104, englishName: "Myanmar", chineseName: "缅甸", callingCode: "+95" }, { alpha2: "NA", alpha3: "NAM", numeric: 516, englishName: "Namibia", chineseName: "纳米比亚", callingCode: "+264" }, { alpha2: "NR", alpha3: "NRU", numeric: 520, englishName: "Nauru", chineseName: "拿鲁岛", callingCode: "+674" }, { alpha2: "NP", alpha3: "NPL", numeric: 524, englishName: "Nepal", chineseName: "尼泊尔", callingCode: "+977" }, { alpha2: "NL", alpha3: "NLD", numeric: 528, englishName: "Netherlands", chineseName: "荷兰", callingCode: "+31" }, { alpha2: "NC", alpha3: "NCL", numeric: 540, englishName: "New Caledonia", chineseName: "新喀里多尼亚", callingCode: "+687" }, { alpha2: "NZ", alpha3: "NZL", numeric: 554, englishName: "New Zealand", chineseName: "新西兰", callingCode: "+64" }, { alpha2: "NI", alpha3: "NIC", numeric: 558, englishName: "Nicaragua", chineseName: "尼加拉瓜", callingCode: "+505" }, { alpha2: "NE", alpha3: "NER", numeric: 562, englishName: "Niger", chineseName: "尼日尔", callingCode: "+227" }, { alpha2: "NG", alpha3: "NGA", numeric: 566, englishName: "Nigeria", chineseName: "尼日利亚", callingCode: "+234" }, { alpha2: "NU", alpha3: "NIU", numeric: 570, englishName: "Niue Island", chineseName: "纽埃岛(新)", callingCode: "+683" }, { alpha2: "NF", alpha3: "NFK", numeric: 574, englishName: "Norfolk Island", chineseName: "诺福克岛(澳)", callingCode: "+6723" }, { alpha2: "MK", alpha3: "MKD", numeric: 807, englishName: "Macedonia", chineseName: "马其顿", callingCode: "+389" }, { alpha2: "MP", alpha3: "MNP", numeric: 580, englishName: "", chineseName: "", callingCode: "" }, { alpha2: "NO", alpha3: "NOR", numeric: 578, englishName: "Norway", chineseName: "挪威", callingCode: "+47" }, { alpha2: "OM", alpha3: "OMN", numeric: 512, englishName: "Oman", chineseName: "阿曼", callingCode: "+968" }, { alpha2: "PK", alpha3: "PAK", numeric: 586, englishName: "Pakistan", chineseName: "巴基斯坦", callingCode: "+92" }, { alpha2: "PW", alpha3: "PLW", numeric: 585, englishName: "Palau", chineseName: "帕劳", callingCode: "+680" }, { alpha2: "PS", alpha3: "PSE", numeric: 275, englishName: "", chineseName: "", callingCode: "" }, { alpha2: "PA", alpha3: "PAN", numeric: 591, englishName: "Panama", chineseName: "巴拿马", callingCode: "+507" }, { alpha2: "PG", alpha3: "PNG", numeric: 598, englishName: "Papua New Guinea", chineseName: "巴布亚新几内亚", callingCode: "+675" }, { alpha2: "PY", alpha3: "PRY", numeric: 600, englishName: "Paraguay", chineseName: "巴拉圭", callingCode: "+595" }, { alpha2: "PE", alpha3: "PER", numeric: 604, englishName: "Peru", chineseName: "秘鲁", callingCode: "+51" }, { alpha2: "PH", alpha3: "PHL", numeric: 608, englishName: "Philippines", chineseName: "菲律宾", callingCode: "+63" }, { alpha2: "PN", alpha3: "PCN", numeric: 612, englishName: "", chineseName: "", callingCode: "" }, { alpha2: "PL", alpha3: "POL", numeric: 616, englishName: "Poland", chineseName: "波兰", callingCode: "+48" }, { alpha2: "PT", alpha3: "PRT", numeric: 620, englishName: "Portugal", chineseName: "葡萄牙", callingCode: "+351" }, { alpha2: "PR", alpha3: "PRI", numeric: 630, englishName: "Puerto Rico", chineseName: "波多黎各", callingCode: "+1787" }, { alpha2: "QA", alpha3: "QAT", numeric: 634, englishName: "Qatar", chineseName: "卡塔尔", callingCode: "+974" }, { alpha2: "RE", alpha3: "REU", numeric: 638, englishName: "Réunion Island", chineseName: "留尼汪", callingCode: "+262" }, { alpha2: "RO", alpha3: "ROU", numeric: 642, englishName: "Romania", chineseName: "罗马尼亚", callingCode: "+40" }, { alpha2: "RU", alpha3: "RUS", numeric: 643, englishName: "Russia", chineseName: "俄罗斯", callingCode: "+7" }, { alpha2: "RW", alpha3: "RWA", numeric: 646, englishName: "Rwanda", chineseName: "卢旺达", callingCode: "+250" }, { alpha2: "BL", alpha3: "BLM", numeric: 652, englishName: "", chineseName: "", callingCode: "" }, { alpha2: "SH", alpha3: "SHN", numeric: 654, englishName: "Ascension", chineseName: "阿森松", callingCode: "+247" }, { alpha2: "KN", alpha3: "KNA", numeric: 659, englishName: "", chineseName: "", callingCode: "" }, { alpha2: "LC", alpha3: "LCA", numeric: 662, englishName: "Saint Lucia", chineseName: "圣露西亚", callingCode: "+1758" }, { alpha2: "MF", alpha3: "MAF", numeric: 663, englishName: "", chineseName: "", callingCode: "" }, { alpha2: "PM", alpha3: "SPM", numeric: 666, englishName: "Saint Pierre and Miquelon", chineseName: "圣彼埃尔和密克隆岛", callingCode: "+508" }, { alpha2: "VC", alpha3: "VCT", numeric: 670, englishName: "Saint Vincent and The Grenadines", chineseName: "圣文森特和格林纳丁斯", callingCode: "+1784" }, { alpha2: "WS", alpha3: "WSM", numeric: 882, englishName: "Samoa", chineseName: "萨摩亚", callingCode: "+685" }, { alpha2: "SM", alpha3: "SMR", numeric: 674, englishName: "San Marino", chineseName: "圣马力诺", callingCode: "+378" }, { alpha2: "ST", alpha3: "STP", numeric: 678, englishName: "Sao Tome and Principe", chineseName: "圣多美和普林西比", callingCode: "+239" }, { alpha2: "SA", alpha3: "SAU", numeric: 682, englishName: "Saudi Arabia", chineseName: "沙特阿拉伯", callingCode: "+966" }, { alpha2: "SN", alpha3: "SEN", numeric: 686, englishName: "Senegal", chineseName: "塞内加尔", callingCode: "+221" }, { alpha2: "RS", alpha3: "SRB", numeric: 688, englishName: "Serbia", chineseName: "塞尔维亚", callingCode: "+381" }, { alpha2: "SC", alpha3: "SYC", numeric: 690, englishName: "Seychelles", chineseName: "塞舌尔", callingCode: "+248" }, { alpha2: "SL", alpha3: "SLE", numeric: 694, englishName: "Sierra Leone", chineseName: "塞拉利昂", callingCode: "+232" }, { alpha2: "SG", alpha3: "SGP", numeric: 702, englishName: "Singapore", chineseName: "新加坡", callingCode: "+65" }, { alpha2: "SX", alpha3: "SXM", numeric: 534, englishName: "Saint Maarten (Dutch Part)", chineseName: "圣马丁岛（荷兰部分）", callingCode: "+1721" }, { alpha2: "SK", alpha3: "SVK", numeric: 703, englishName: "Slovakia", chineseName: "斯洛伐克", callingCode: "+421" }, { alpha2: "SI", alpha3: "SVN", numeric: 705, englishName: "Slovenia", chineseName: "斯洛文尼亚", callingCode: "+386" }, { alpha2: "SB", alpha3: "SLB", numeric: 90, englishName: "Solomon Islands", chineseName: "所罗门群岛", callingCode: "+677" }, { alpha2: "SO", alpha3: "SOM", numeric: 706, englishName: "Somalia", chineseName: "索马里", callingCode: "+252" }, { alpha2: "ZA", alpha3: "ZAF", numeric: 710, englishName: "South Africa", chineseName: "南非", callingCode: "+27" }, { alpha2: "GS", alpha3: "SGS", numeric: 239, englishName: "", chineseName: "", callingCode: "" }, { alpha2: "SS", alpha3: "SSD", numeric: 728, englishName: "", chineseName: "", callingCode: "" }, { alpha2: "ES", alpha3: "ESP", numeric: 724, englishName: "Islas Canarias", chineseName: "加那利群岛", callingCode: "+34" }, { alpha2: "LK", alpha3: "LKA", numeric: 144, englishName: "Sri Lanka", chineseName: "斯里兰卡", callingCode: "+94" }, { alpha2: "SD", alpha3: "SDN", numeric: 729, englishName: "Sudan", chineseName: "苏丹", callingCode: "+249" }, { alpha2: "SR", alpha3: "SUR", numeric: 740, englishName: "Suriname", chineseName: "苏里南", callingCode: "+597" }, { alpha2: "SJ", alpha3: "SJM", numeric: 744, englishName: "", chineseName: "", callingCode: "" }, { alpha2: "SE", alpha3: "SWE", numeric: 752, englishName: "Sweden", chineseName: "瑞典", callingCode: "+46" }, { alpha2: "CH", alpha3: "CHE", numeric: 756, englishName: "Switzerland", chineseName: "瑞士", callingCode: "+41" }, { alpha2: "SY", alpha3: "SYR", numeric: 760, englishName: "Syria", chineseName: "叙利亚", callingCode: "+963" }, { alpha2: "TW", alpha3: "TWN", numeric: 158, englishName: "Taiwan", chineseName: "中国台湾", callingCode: "+886" }, { alpha2: "TJ", alpha3: "TJK", numeric: 762, englishName: "Tajikistan", chineseName: "塔吉克斯坦", callingCode: "+992" }, { alpha2: "TZ", alpha3: "TZA", numeric: 834, englishName: "Tanzania", chineseName: "坦桑尼亚", callingCode: "+255" }, { alpha2: "TH", alpha3: "THA", numeric: 764, englishName: "Thailand", chineseName: "泰国", callingCode: "+66" }, { alpha2: "TL", alpha3: "TLS", numeric: 626, englishName: "Timor-Leste", chineseName: "东帝汶", callingCode: "+670" }, { alpha2: "TG", alpha3: "TGO", numeric: 768, englishName: "Togo", chineseName: "多哥", callingCode: "+228" }, { alpha2: "TK", alpha3: "TKL", numeric: 772, englishName: "Tokelau Is.", chineseName: "托克劳群岛(新)", callingCode: "+690" }, { alpha2: "TO", alpha3: "TON", numeric: 776, englishName: "Tonga", chineseName: "汤加", callingCode: "+676" }, { alpha2: "TT", alpha3: "TTO", numeric: 780, englishName: "Trinidad and Tobago", chineseName: "特立尼达和多巴哥", callingCode: "+1868" }, { alpha2: "TN", alpha3: "TUN", numeric: 788, englishName: "Tunisia", chineseName: "突尼斯", callingCode: "+216" }, { alpha2: "TR", alpha3: "TUR", numeric: 792, englishName: "Turkey", chineseName: "土耳其", callingCode: "+90" }, { alpha2: "TM", alpha3: "TKM", numeric: 795, englishName: "Turkmenistan", chineseName: "土库曼斯坦", callingCode: "+993" }, { alpha2: "TC", alpha3: "TCA", numeric: 796, englishName: "Turks and Caicos Islands", chineseName: "特克斯和凯科斯群岛", callingCode: "+1649" }, { alpha2: "TV", alpha3: "TUV", numeric: 798, englishName: "", chineseName: "", callingCode: "" }, { alpha2: "UG", alpha3: "UGA", numeric: 800, englishName: "Uganda", chineseName: "乌干达", callingCode: "+256" }, { alpha2: "UA", alpha3: "UKR", numeric: 804, englishName: "Ukraine", chineseName: "乌克兰", callingCode: "+380" }, { alpha2: "AE", alpha3: "ARE", numeric: 784, englishName: "United Arab Emirates", chineseName: "阿拉伯联合酋长国", callingCode: "+971" }, { alpha2: "GB", alpha3: "GBR", numeric: 826, englishName: "United Kingdom", chineseName: "英国", callingCode: "+44" }, { alpha2: "US", alpha3: "USA", numeric: 840, englishName: "United States", chineseName: "美国", callingCode: "+1" }, { alpha2: "UM", alpha3: "UMI", numeric: 581, englishName: "Wake I.", chineseName: "威克岛(美)", callingCode: "+1808" }, { alpha2: "UY", alpha3: "URY", numeric: 858, englishName: "Uruguay", chineseName: "乌拉圭", callingCode: "+598" }, { alpha2: "UZ", alpha3: "UZB", numeric: 860, englishName: "Uzbekistan", chineseName: "乌兹别克斯坦", callingCode: "+998" }, { alpha2: "VU", alpha3: "VUT", numeric: 548, englishName: "Vanuatu", chineseName: "瓦努阿图", callingCode: "+678" }, { alpha2: "VE", alpha3: "VEN", numeric: 862, englishName: "Venezuela", chineseName: "委内瑞拉", callingCode: "+58" }, { alpha2: "VN", alpha3: "VNM", numeric: 704, englishName: "Vietnam", chineseName: "越南", callingCode: "+84" }, { alpha2: "VG", alpha3: "VGB", numeric: 92, englishName: "", chineseName: "", callingCode: "" }, { alpha2: "VI", alpha3: "VIR", numeric: 850, englishName: "", chineseName: "", callingCode: "" }, { alpha2: "WF", alpha3: "WLF", numeric: 876, englishName: "", chineseName: "", callingCode: "" }, { alpha2: "EH", alpha3: "ESH", numeric: 732, englishName: "", chineseName: "", callingCode: "" }, { alpha2: "YE", alpha3: "YEM", numeric: 887, englishName: "Yemen", chineseName: "也门", callingCode: "+967" }, { alpha2: "ZM", alpha3: "ZMB", numeric: 894, englishName: "Zambia", chineseName: "赞比亚", callingCode: "+260" }, { alpha2: "ZW", alpha3: "ZWE", numeric: 716, englishName: "Zimbabwe", chineseName: "津巴布韦", callingCode: "+263" }], o = (() => {
    const d = /* @__PURE__ */ new Map();
    for (const s of r)
      d.set(s.alpha2, s);
    return d;
  })();
  function a(d) {
    return o.get(d);
  }
}, 516: (n, e, t) => {
  t.d(e, { p: () => r });
  class r {
    error(a, ...d) {
      typeof console.error == "function" && console.error(a, ...d);
    }
    info(a, ...d) {
      typeof console.info == "function" && console.info(a, ...d);
    }
    log(a, ...d) {
      typeof console.log == "function" && console.log(a, ...d);
    }
    warn(a, ...d) {
      typeof console.warn == "function" && console.warn(a, ...d);
    }
  }
}, 396: (n, e, t) => {
  t.d(e, { l: () => a });
  var r = t(70), o = function(d, s, l, f) {
    return new (l || (l = Promise))(function(p, _) {
      function y(h) {
        try {
          g(f.next(h));
        } catch (c) {
          _(c);
        }
      }
      function u(h) {
        try {
          g(f.throw(h));
        } catch (c) {
          _(c);
        }
      }
      function g(h) {
        var c;
        h.done ? p(h.value) : (c = h.value, c instanceof l ? c : new l(function(i) {
          i(c);
        })).then(y, u);
      }
      g((f = f.apply(d, [])).next());
    });
  };
  const a = (d, s) => o(void 0, void 0, void 0, function* () {
    let l = null, f = null;
    try {
      const p = Object.assign({ method: "GET", mode: "cors" }, s), _ = Object.assign({ "content-type": "application/json" }, p.headers);
      p.headers = _, p.body && typeof p.body != "string" && (p.body = JSON.stringify(p.body));
      const y = yield fetch(d, p), u = yield y.json();
      u && u.error ? (f = u, f.error_uri = new URL(d).pathname) : l = u;
    } catch (p) {
      f = { error: r.By.UNREACHABLE, error_code: r._Y.UNREACHABLE, error_description: p == null ? void 0 : p.message, error_uri: new URL(d).pathname };
    }
    if (f)
      throw f;
    return l;
  });
}, 348: (n, e, t) => {
  t.d(e, { h: () => o });
  var r = function(a, d, s, l) {
    return new (s || (s = Promise))(function(f, p) {
      function _(g) {
        try {
          u(l.next(g));
        } catch (h) {
          p(h);
        }
      }
      function y(g) {
        try {
          u(l.throw(g));
        } catch (h) {
          p(h);
        }
      }
      function u(g) {
        var h;
        g.done ? f(g.value) : (h = g.value, h instanceof s ? h : new s(function(c) {
          c(h);
        })).then(_, y);
      }
      u((l = l.apply(a, [])).next());
    });
  };
  class o {
    getLength() {
      return r(this, void 0, void 0, function* () {
        return window.localStorage.length;
      });
    }
    getItem(d) {
      return r(this, void 0, void 0, function* () {
        return window.localStorage.getItem(d);
      });
    }
    key(d) {
      return r(this, void 0, void 0, function* () {
        return window.localStorage.key(d);
      });
    }
    removeItem(d) {
      return r(this, void 0, void 0, function* () {
        window.localStorage.removeItem(d);
      });
    }
    setItem(d, s) {
      return r(this, void 0, void 0, function* () {
        window.localStorage.setItem(d, s);
      });
    }
  }
}, 362: (n, e, t) => {
  t.d(e, { X: () => o });
  var r = function(a, d, s, l) {
    return new (s || (s = Promise))(function(f, p) {
      function _(g) {
        try {
          u(l.next(g));
        } catch (h) {
          p(h);
        }
      }
      function y(g) {
        try {
          u(l.throw(g));
        } catch (h) {
          p(h);
        }
      }
      function u(g) {
        var h;
        g.done ? f(g.value) : (h = g.value, h instanceof s ? h : new s(function(c) {
          c(h);
        })).then(_, y);
      }
      u((l = l.apply(a, [])).next());
    });
  };
  class o {
    constructor() {
      this._map = /* @__PURE__ */ new Map(), this._array = [];
    }
    getLength() {
      return r(this, void 0, void 0, function* () {
        return this._map.size;
      });
    }
    getItem(d) {
      return r(this, void 0, void 0, function* () {
        return this._map.has(d) ? this._map.get(d) || "" : null;
      });
    }
    key(d) {
      return r(this, void 0, void 0, function* () {
        return this._array[d];
      });
    }
    removeItem(d) {
      return r(this, void 0, void 0, function* () {
        this._map.delete(d);
        const s = this._array.length;
        for (let l = 0; l < s; l++)
          if (this._array[l] === d) {
            this._array.slice(l, 1);
            break;
          }
      });
    }
    setItem(d, s) {
      return r(this, void 0, void 0, function* () {
        this._map.set(d, s), this._map.has(d) || this._array.push(d);
      });
    }
  }
}, 109: (n, e, t) => {
  t.d(e, { eC: () => o, Zc: () => I, BK: () => se, Hn: () => Te, S3: () => qe, Q: () => J, Nq: () => on, mw: () => Be, Bd: () => d, UP: () => w, un: () => Q, IX: () => S, Fr: () => j, KW: () => b, C6: () => q, a9: () => he, wh: () => F, RQ: () => U, pM: () => x, uo: () => A, m: () => E });
  var r = t(56);
  class o {
    constructor() {
    }
    static isBrowser() {
      return !!o._canUseReactDeviceDetect && r.Bd;
    }
    static isMobile() {
      return !!o._canUseReactDeviceDetect && r.Fr;
    }
    static isWechatMiniProgramWebView() {
      return o._ua.includes("miniprogram");
    }
  }
  function a(z) {
    return z == 1 ? ["T", "h", "u", "n", "d", "e", "r"].join("") : z == 2 ? ["t", "h", "u", "n", "d", "e", "r"].join("") : "";
  }
  o._UA = typeof window < "u" ? window.navigator.userAgent : "", o._ua = o._UA.toLocaleLowerCase(), o._canUseReactDeviceDetect = typeof window < "u";
  const d = typeof window < "u" && window.document !== void 0, s = d && window.navigator.userAgent.toLocaleLowerCase() || "", l = (() => {
    if (d)
      return window;
  })();
  let f, p, _, y, u, g, h, c, i, m, $, v, N, C;
  function w() {
    return f === void 0 && (f = /\bedge\b/.test(s)), f;
  }
  function A() {
    if (p === void 0) {
      const z = a(2);
      p = new RegExp(`[ ]${z}\\/10.0([\\d.]*)`).test(s) || new RegExp(`[ ]${z}( )?\\/( )?9.([\\d.]*)`).test(s);
    }
    return p;
  }
  function I() {
    if (_ === void 0) {
      const z = a(2);
      _ = new RegExp(`\\b${z}\\/10.[1-9][\\d.]*`).test(s);
    }
    return _;
  }
  function E() {
    if (y === void 0)
      try {
        y = d && /\bmac\b/.test(s) && !!l.WebViewJavascriptBridge && typeof l.WebViewJavascriptBridge.addEventListener == "function";
      } catch {
        y = !1;
      }
    return y;
  }
  function x() {
    return u === void 0 && (u = /\belectron\/\d+(\.\d+){2}\b/.test(s)), u;
  }
  function F() {
    return g === void 0 && (g = d && /\btbc\/\d+(\.\d+){3}\b/.test(s) && !!l.native), g;
  }
  function q() {
    return h === void 0 && (h = !he() && (!(!d || l.XLJSWebViewBridgeExport === void 0) || !(!d || l.XLJSWebViewBridge === void 0))), h;
  }
  function he() {
    return c === void 0 && (c = !(!d || l.webkit === void 0 || (l.webkit.messageHandlers, 0) || l.webkit.messageHandlers.XLJSWebViewBridgeExport === void 0) || !(!d || l.webkit === void 0 || (l.webkit.messageHandlers, 0) || l.webkit.messageHandlers.XLJSWebViewBridge === void 0)), c;
  }
  function se() {
    return i === void 0 && (i = d && l.XLAccountJsBridge !== void 0), i;
  }
  function Te() {
    return m === void 0 && (m = d && /\bharmonybridge\/\b/.test(s) && l.nativeCore !== void 0), m;
  }
  function b() {
    return I() || !A() && F();
  }
  function S() {
    return $ === void 0 && ($ = location.protocol === "file:"), $;
  }
  function U() {
    return v === void 0 && (v = /micromessenger/i.test(s)), v;
  }
  function j() {
    return N === void 0 && (N = /mobile|android|iphone|ipad|iemobile/i.test(s)), N;
  }
  function Q() {
    return C === void 0 && (C = j() && /iphone|ipad|ipod|ios/i.test(s)), C;
  }
  const te = ["Trident", "Electron", `Android.${a(1)}`, `IOS.${a(1)}`, a(1), "MicroMessenger", "360", "MQQBrowser", "QQBrowser", "UCBrowser", "UBrowser", "Metasr", "Edge", "Firefox", "Maxthon", "Chrome", "Safari", "mobile"], ae = (z) => {
    if (d) {
      const ye = window.navigator.mimeTypes;
      for (const pe in ye)
        if (ye[pe].type == z)
          return !0;
    }
    return !1;
  }, ee = (() => {
    for (let z = te.length - 1, ye = 0; ye <= z; ye++) {
      const pe = te[ye];
      if (pe !== "360") {
        if (s.indexOf(pe.toLowerCase()) > -1)
          return pe;
      } else if (ae("application/vnd.chromium.remoting-viewer"))
        return pe;
    }
    return "unknown";
  })();
  function re() {
    return ee == "Trident" ? "IE" : ee;
  }
  function J() {
    return `${j() ? "Mobile" : "PC"}-${re()}`;
  }
  function qe() {
    return `${re()}/${function() {
      let z = ee.toLowerCase();
      if (z.indexOf("unknown") > 0)
        return "unknown";
      if (z == "trident") {
        if (s.indexOf("gecko") > 0)
          return "11";
        {
          const Qe = s.match(/msie (\d+)/);
          return Qe && Qe.length >= 1 ? Qe[1] : "unknown";
        }
      }
      z != "360" && z != `android.${a(2)}` || (z = "chrome"), z == `ios.${a(2)}` && (z = "mobile");
      const ye = new RegExp(z + "[/][\\d.]+"), pe = s.match(ye);
      let Oe;
      return pe && pe.length >= 0 && (Oe = pe[0].substr(z.length + 1)), Oe = typeof Oe == "string" && Oe.length > 0 ? Oe : void 0, Oe || "unknown";
    }()}`.toLocaleLowerCase();
  }
  function Be() {
    let z = "";
    return z = j() ? "WAP" : F() ? "PC" : E() ? "MAC" : "WEB", z;
  }
  function on() {
    const z = Be(), ye = { PC: "0", WEB: "1", WAP: "3", MAC: "4", ANDROID: "10", LINUX: "12" };
    return ye[z] ? ye[z] : "1";
  }
}, 496: (n, e, t) => {
  function r() {
    const o = location.hostname.split("."), a = o.length;
    return o[a - 2] + "." + o[a - 1];
  }
  t.d(e, { i: () => r });
}, 890: (n, e, t) => {
  var r;
  function o(i) {
    for (const m in r)
      if (r[m].toLowerCase() === i.toLowerCase())
        return r[m];
    return r.UNKNOWN;
  }
  function a(i, m) {
    return function($, v) {
      const N = $;
      for (const C in v) {
        const w = v[C];
        if (typeof w == "object") {
          const A = N[C];
          N[C] = A == null ? w : a(N[C], w);
        } else
          w !== void 0 && (N[C] = w);
      }
      return N;
    }(JSON.parse(JSON.stringify(i)), JSON.parse(JSON.stringify(m)));
  }
  t.d(e, { _N: () => c, DL: () => y, hT: () => r, Fh: () => o }), function(i) {
    i.EN = "en", i.EN_AU = "en-au", i.EN_BZ = "en-bz", i.EN_CA = "en-ca", i.EN_CB = "en-cb", i.EN_GB = "en-gb", i.EN_IE = "en-ie", i.EN_JM = "en-jm", i.EN_NZ = "en-nz", i.EN_PH = "en-ph", i.EN_TT = "en-tt", i.EN_US = "en-us", i.EN_ZA = "en-za", i.EN_ZW = "en-zw", i.ID = "id", i.ID_ID = "id-id", i.IN_ID = "in-id", i.KO = "ko", i.MS = "ms", i.ZH = "zh", i.ZH_HANT = "zh-hant", i.ZH_CHT = "zh-cht", i.ZH_HK = "zh-hk", i.ZH_MO = "zh-mo", i.ZH_TW = "zh-tw", i.ZH_CHS = "zh-chs", i.ZH_CN = "zh-cn", i.ZH_HANS = "zh-hans", i.UNKNOWN = "unknown";
  }(r || (r = {}));
  const d = { error: { error_code_0: "Operate successfully", error_code_1: "Operate cancelled", error_code_2: "Unknown error", error_code_3: "Invalid parameter", error_code_4: "Request timeout", error_code_5: "Request not found", error_code_6: "Already exist", error_code_7: "No permission to access", error_code_8: "Insufficient resources", error_code_9: "The operation was rejected", error_code_10: "Operation terminated", error_code_11: "The operation is outside the valid range", error_code_12: "The operation is not supported", error_code_13: "Internal error", error_code_14: "The operation is currently unavailable", error_code_15: "Irrecoverable data loss or corruption", error_code_16: "Unauthorized", error_code_4001: "Please enter the verification code", error_code_4002: "Verification code is incorrect", error_code_4010: "Invalid password", error_code_4011: "Account is locked. Please try again later", error_code_4012: "Account not activated", error_code_4013: "Account is locked. Please try again later", error_code_4014: "Verification code is incorrect", error_code_4015: "Need a second verification code", error_code_4016: "The secondary verification code is incorrect", error_code_4017: "The secondary verification recovery code is incorrect.", error_code_4018: "Under review", error_code_4019: "Tripartite unknown error", error_code_4020: "Please enter SMS verification code", error_code_4021: "Please try to retrieve the password", error_code_4022: "Wrong account number or password, please re-enter", error_code_4024: "Verification code is expired", error_code_4121: "Invalid request", error_code_4122: "The client is not authorized", error_code_4123: "Access denied", error_code_4124: "The server is not authorized", error_code_4125: "The scope of the request is invalid", error_code_4126: "The refresh token is incorrect or expired", error_code_5026: "Server error", error_code_5027: "The authorization service is temporarily unavailable", error_code_4050: "Authorization in progress", error_code_4051: "Authorization polling in progress", error_code_4052: "Token expired", error_code_4031: "Interactive request", error_code_4032: "Please log in first", error_code_4033: "Please select an account to complete authentication", error_code_4034: "Please agree to authorize", error_code_4035: "Invalid URI", error_code_4036: "Invalid request object", error_code_4037: "Invalid request", error_code_4038: "The current URI is not supported", error_code_4039: "Signup is not supported", error_code_50: "The account is in the period of cancellation audit and cannot be used", error_code_38: "Account is frozen, please try again later", error_code_4023: "Wrong account number or password, please re-enter", unreachable: "unreachable", default: "", your_operation_is_too_frequent__please_try_again_later: "Your operation is too frequent, please try again later" } }, s = { error: { error_code_0: "Operasi berhasil", error_code_1: "Permintaan dibatalkan", error_code_2: "Terjadi kesalahan yang tidak diketahui", error_code_3: "Parameter tidak valid", error_code_4: "Waktu permintaan habis", error_code_5: "Permintaan tidak ditemukan", error_code_6: "Sudah ada", error_code_7: "Tidak ada akses", error_code_8: "Sumber daya tidak cukup", error_code_9: "Operasi ditolak", error_code_10: "Operasi dihentikan", error_code_11: "Operasi di luar rentang yang valid", error_code_12: "Operasi tidak didukung", error_code_13: "Terjadi kesalahan internal ", error_code_14: "Operasi saat ini tidak tersedia", error_code_15: "Kehilangan atau kerusakan data yang tidak dapat dipulihkan", error_code_16: "Tidak sah", error_code_4001: "Silakan masukkan kode verifikasi", error_code_4002: "Kode verifikasi salah", error_code_4010: "Kata laluan tidak sah", error_code_4011: "Akun terkunci, silakan coba lagi nanti", error_code_4012: "Akun Anda tidak diaktifkan", error_code_4013: "Akun terkunci, silakan coba lagi nanti", error_code_4014: "Kode verifikasi salah", error_code_4015: "Butuh kode verifikasi kedua", error_code_4016: "Kode verifikasi kedua salah", error_code_4017: "Kode pemulihan verifikasi kedua salah", error_code_4018: "Sedang ditinjau", error_code_4019: "Terjadi kesalahan pihak ketiga yang tidak diketahui", error_code_4020: "Silakan masukkan kode verifikasi SMS", error_code_4021: "Silakan coba untuk mendapatkan kembali kata sandi Anda", error_code_4022: "Informasi akun atau kata sandi salah, silakan masukkan kembali", error_code_4024: "Kod penentusahan telah tamat tempoh.", error_code_4121: "Permintaan tidak valid", error_code_4122: "Klien tidak berwenang", error_code_4123: "Akses ditolak", error_code_4124: "Server tidak berwenang", error_code_4125: "Permintaan cakupan tidak valid", error_code_4126: "Token penyegaran salah atau kedaluwarsa;", error_code_5026: "Terjadi kesalahan server", error_code_5027: "Layanan otorisasi tidak tersedia untuk sementara", error_code_4050: "Pengotorisasian", error_code_4051: "Pengotorisasian jajak pendapat", error_code_4052: "Token kedaluwarsa", error_code_4031: "Permintaan interaktif", error_code_4032: "Harap masuk terlebih dulu", error_code_4033: "Pilih akun untuk menyelesaikan autentikasi identitas", error_code_4034: "Harap setuju untuk memberi otorisasi", error_code_4035: "Uri tidak valid", error_code_4036: "Objek permintaan tidak valid", error_code_4037: "Permintaan tidak valid", error_code_4038: "Tidak mendukung uri saat ini", error_code_4039: "Tidak mendukung pendaftaran", error_code_50: "Akun sedang dalam periode tinjauan pembatalan dan tidak dapat digunakan", error_code_38: "Akun ini ditangguhkan, silakan coba lagi nanti", error_code_4023: "Informasi akun atau kata sandi salah, silakan masukkan kembali", unreachable: "Waktu jaringan habis, silakan coba lagi", default: "", your_operation_is_too_frequent__please_try_again_later: "Operasi terlalu kerap. Sila cuba lagi kemudian." } }, l = { error: { error_code_0: "작업 성공", error_code_1: "작업 취소됨", error_code_2: "알 수 없는 오류", error_code_3: "잘못된 매개 변수", error_code_4: "요청 시간 초과", error_code_5: "요청을 찾을 수 없습니다.", error_code_6: "이미 존재함", error_code_7: "액세스 권한이 부여되지 않음", error_code_8: "리소스 부족", error_code_9: "작업 거부", error_code_10: "작업 종료", error_code_11: "이 작업은 유효한 범위를 초과합니다.", error_code_12: "이 작업은 지원되지 않습니다.", error_code_13: "내부 오류", error_code_14: "이 작업은 현재 사용할 수 없습니다.", error_code_15: "복구할 수 없는 데이터 손실 또는 손상", error_code_16: "인증되지 않은", error_code_4001: "보안 인증을 진행해 주세요", error_code_4002: "보안 인증 실패. 다시 확인하세요.", error_code_4010: "유효하지 않은 비밀번호", error_code_4011: "이 계정은 잠겨 있습니다. 나중에 다시 시도 해주십시오.", error_code_4012: "이 계정은 활성화되지 않았습니다.", error_code_4013: "이 계정은 잠겨 있습니다. 나중에 다시 시도 해주십시오.", error_code_4014: "잘못된 인증 코드", error_code_4015: "2차 인증 코드가 필요합니다.", error_code_4016: "2차 인증 코드가 올바르지 않습니다.", error_code_4017: "2차 인증 복구 코드가 올바르지 않습니다.", error_code_4018: "검토 중", error_code_4019: "알 수 없는 타사 오류", error_code_4020: "SMS 인증 코드를 입력하세요.", error_code_4021: "비밀번호 복구를 시도하십시오.", error_code_4022: "계정 정보 또는 비밀번호가 올바르지 않습니다. 다시 입력해 주세요.", error_code_4024: "인증 코드가 만료되었습니다.", error_code_4121: "잘못된 요청", error_code_4122: "클라이언트가 인증되지 않았습니다.", error_code_4123: "접근 불가", error_code_4124: "서버가 인증되지 않았습니다.", error_code_4125: "요청 범위가 잘못되었습니다.", error_code_4126: "새로고침 토큰이 잘못되었거나 만료되었습니다.", error_code_5026: "서버 오류", error_code_5027: "승인 서비스를 일시적으로 사용할 수 없습니다.", error_code_4050: "승인", error_code_4051: "인증 폴링", error_code_4052: "토큰이 만료되었습니다.", error_code_4031: "상호 요청", error_code_4032: "먼저 로그인하세요.", error_code_4033: "본인 확인을 위해 계정을 선택해주세요.", error_code_4034: "승인에 동의해 주세요.", error_code_4035: "잘못된 URI", error_code_4036: "잘못된 요청 개체", error_code_4037: "잘못된 요청", error_code_4038: "현재 URI는 지원되지 않습니다.", error_code_4039: "등록이 지원되지 않습니다.", error_code_50: "이 계정은 탈퇴 검토 중이므로 사용할 수 없습니다.", error_code_38: "계정이 정지되었습니다. 나중에 다시 시도해 주세요.", error_code_4023: "계정 정보 또는 비밀번호가 올바르지 않습니다. 다시 입력해 주세요.", unreachable: "네트워크에 연결할 수 없습니다.", default: "", your_operation_is_too_frequent__please_try_again_later: "작업이 너무 빈번합니다. 나중에 다시 시도하세요." } }, f = { error: { error_code_0: "Operasi berjaya", error_code_1: "Operasi dibatalkan", error_code_2: "Ralat tidak diketahui", error_code_3: "Parameter tidak sah", error_code_4: "Permintaan ini sudah tamat tempoh.", error_code_5: "Permintaan tidak dijumpai.", error_code_6: "Wujud", error_code_7: "Akses tidak ditentusahkan", error_code_8: "Sumber tidak mencukupi", error_code_9: "Operasi ditolak", error_code_10: "Operasi ditamatkan", error_code_11: "Operasi ini melebihi skop yang sah.", error_code_12: "Operasi ini tidak disokong.", error_code_13: "Ralat dalaman", error_code_14: "Operasi ini tidak tersedia ketika ini.", error_code_15: "Kehilangan data atau korupsi yang tidak boleh dipulihkan", error_code_16: "Tidak disahkan", error_code_4001: "Sila lengkapkan penentusahan keselamatan.", error_code_4002: "Penentusahan gagal. Sila cuba lagi.", error_code_4010: "Kata laluan tidak sah", error_code_4011: "Akaun ini telah dikunci. Sila cuba lagi kemudian.", error_code_4012: "Akaun ini masih belum diaktifkan.", error_code_4013: "Akaun ini telah dikunci. Sila cuba lagi kemudian.", error_code_4014: "Kod penentusahan tidak betul", error_code_4015: "Kod penentusahan kedua diperlukan.", error_code_4016: "Kod penentusahan kedua tidak betul.", error_code_4017: "Kod pemulihan penentusahan kedua tidak betul.", error_code_4018: "Dalam penilaian", error_code_4019: "Ralat pihak ketiga tidak diketahui", error_code_4020: "Sila masukkan kod penentusahan SMS.", error_code_4021: "Sila cuba untuk memulihkan kata laluan anda.", error_code_4022: "Maklumat akaun atau kata laluan tidak betul. Sila masukkan semula.", error_code_4024: "Kod penentusahan telah tamat tempoh.", error_code_4121: "Permintaan tidak sah", error_code_4122: "Klien ini belum ditentusahkan.", error_code_4123: "Akses ditolak", error_code_4124: "Pelayan masih belum ditentusahkan.", error_code_4125: "Skop permintaan tidak sah.", error_code_4126: "Token segar semula tidak betul atau tamat tempoh.", error_code_5026: "Ralat pelayan", error_code_5027: "Perkhidmatan penentusahan tidak tersedia ketika ini.", error_code_4050: "Menentusah", error_code_4051: "Undian penentusahan", error_code_4052: "Token ini telah tamat tempoh.", error_code_4031: "Permintaan interaksi", error_code_4032: "Sila log masuk dahulu.", error_code_4033: "Sila pilih akaun anda untuk melengkapkan penentusahan identiti.", error_code_4034: "Sila setuju dengan penentusahan.", error_code_4035: "Uri tidak sah", error_code_4036: "Objek permintaan tidak sah", error_code_4037: "Permintaan tidak sah", error_code_4038: "Uri semasa tidak disokong.", error_code_4039: "Pendaftaran tidak disokong.", error_code_50: "Akaun ini telah dilog keluar dan sedang dinilai. Ia tidak boleh digunakan.", error_code_38: "Akaun ini telah dibekukan. Sila cuba lagi kemudian.", error_code_4023: "Maklumat akaun atau kata laluan tidak betul. Sila masukkan semula.", unreachable: "Rangkaian ini tidak boleh disambungkan.", default: "", your_operation_is_too_frequent__please_try_again_later: "Operasi terlalu kerap. Sila cuba lagi kemudian." } }, p = { error: { error_code_0: "操作成功", error_code_1: "操作已取消", error_code_2: "未知错误", error_code_3: "无效参数", error_code_4: "请求超时", error_code_5: "未找到请求", error_code_6: "已存在", error_code_7: "无权限访问", error_code_8: "资源不足", error_code_9: "操作被拒绝", error_code_10: "操作终止", error_code_11: "该操作超出有效范围", error_code_12: "不支持该操作", error_code_13: "内部错误", error_code_14: "操作当前不可用", error_code_15: "不可恢复的数据丢失或损坏", error_code_16: "未授权", error_code_4001: "请进行安全验证", error_code_4002: "安全验证未通过，请重新验证", error_code_4010: "密码无效", error_code_4011: "账号被锁定, 请稍后再试", error_code_4012: "账号未激活", error_code_4013: "账号被锁定, 请稍后重试", error_code_4014: "验证码不正确", error_code_4015: "需要二次验证码", error_code_4016: "二次验证码不正确", error_code_4017: "二次验证恢复码不正确", error_code_4018: "审核中", error_code_4019: "三方未知错误", error_code_4020: "请输入短信验证码", error_code_4021: "请尝试找回密码", error_code_4022: "账号或密码错误，请重新输入", error_code_4024: "验证码过期", error_code_4121: "无效请求", error_code_4122: "客户端未获得授权", error_code_4123: "拒绝访问", error_code_4124: "服务器未获得授权", error_code_4125: "请求的范围无效", error_code_4126: "refresh token 不正确或已过期;", error_code_5026: "服务器错误", error_code_5027: "授权服务暂不可用", error_code_4050: "授权中", error_code_4051: "授权轮询中", error_code_4052: "token过期", error_code_4031: "交互请求", error_code_4032: "请先登录", error_code_4033: "请选择账号以完成身份验证", error_code_4034: "请同意授权", error_code_4035: "无效的uri", error_code_4036: "无效的请求对象", error_code_4037: "无效请求", error_code_4038: "不支持当前的uri", error_code_4039: "不支持注册", error_code_50: "账号处于注销审核期，无法使用", error_code_38: "账号被冻结, 请稍后再试", error_code_4023: "账号或密码错误，请重新输入", unreachable: "网络不可达", default: "", your_operation_is_too_frequent__please_try_again_later: "操作过于频繁，请稍后再试" } }, _ = { error: { error_code_0: "操作成功", error_code_1: "操作已取消", error_code_2: "未知錯誤", error_code_3: "無效參數", error_code_4: "請求超時", error_code_5: "未找到請求", error_code_6: "已存在", error_code_7: "無權限訪問", error_code_8: "資源不足", error_code_9: "操作被拒絕", error_code_10: "操作終止", error_code_11: "該操作超出有效範圍", error_code_12: "不支持該操作", error_code_13: "內部錯誤", error_code_14: "操作當前不可用", error_code_15: "不可恢復的數據丟失或損壞", error_code_16: "未授權", error_code_4001: "請進行安全驗證", error_code_4002: "安全驗證未通過，請重驗證", error_code_4010: "密碼無效", error_code_4011: "帳號被鎖定, 請稍後再試", error_code_4012: "帳號未激活", error_code_4013: "帳號被鎖定, 請稍後重試", error_code_4014: "驗證碼不正確", error_code_4015: "需要二次驗證碼", error_code_4016: "二次驗證碼不正確", error_code_4017: "二次驗證恢復碼不正確", error_code_4018: "審核中", error_code_4019: "三方未知錯誤", error_code_4020: "請輸入短信驗證碼", error_code_4021: "請嘗試找回密碼", error_code_4022: "帳號或密碼錯誤，請重新輸入", error_code_4024: "驗證碼過期", error_code_4121: "無效請求", error_code_4122: "客戶端未獲得授權", error_code_4123: "拒絕訪問", error_code_4124: "服務器未獲得授權", error_code_4125: "請求的範圍無效", error_code_4126: "refresh token 不正確或已過期;", error_code_5026: "服務器錯誤", error_code_5027: "授權服務暫不可用", error_code_4050: "授權中", error_code_4051: "授權輪詢中", error_code_4052: "token過期", error_code_4031: "交互請求", error_code_4032: "請先登錄", error_code_4033: "請選擇帳號以完成身份驗證", error_code_4034: "請同意授權", error_code_4035: "無效的uri", error_code_4036: "無效的請求對象", error_code_4037: "無效請求", error_code_4038: "不支持當前的uri", error_code_4039: "不支持註冊", error_code_50: "帳號處於註銷審核期，無法使用", error_code_38: "帳號被凍結, 請稍後再試", error_code_4023: "帳號或密碼錯誤，請重新輸入", unreachable: "網絡不可達", default: "", your_operation_is_too_frequent__please_try_again_later: "操作過於頻繁，請稍後再試" } };
  class y {
    constructor(m) {
      this._locale = m.locale, this._localePackage = this._getLocalePackageByLocale(m.locale), m.localePackage && (this._localePackage = a(this._localePackage, m.localePackage));
    }
    get locale() {
      return this._locale;
    }
    setLocale(m, $) {
      this._locale = m, this._localePackage = this._getLocalePackageByLocale(m), this._localePackage = a(this._localePackage, $);
    }
    translate(m, $, v) {
      let N;
      const C = this._localePackage[m];
      if (C && (N = C[$]), v && typeof N == "string") {
        let w = N;
        if (typeof w == "string" && w.length > 0)
          for (const A in v) {
            const I = this._escapeRegExp("${" + A + "}"), E = new RegExp(I, "g");
            w = w.replace(E, v[A].toString());
          }
        N = w;
      }
      return N;
    }
    _escapeRegExp(m) {
      return m.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    }
    _getLocalePackageByLocale(m) {
      let $;
      switch (m) {
        case r.EN:
        case r.EN_AU:
        case r.EN_BZ:
        case r.EN_CA:
        case r.EN_CB:
        case r.EN_GB:
        case r.EN_IE:
        case r.EN_JM:
        case r.EN_NZ:
        case r.EN_PH:
        case r.EN_TT:
        case r.EN_US:
        case r.EN_ZA:
        case r.EN_ZW:
          $ = d;
          break;
        case r.ID:
        case r.ID_ID:
        case r.IN_ID:
          $ = s;
          break;
        case r.KO:
          $ = l;
          break;
        case r.MS:
          $ = f;
          break;
        case r.ZH_HANT:
        case r.ZH_CHT:
        case r.ZH_HK:
        case r.ZH_MO:
        case r.ZH_TW:
          $ = _;
          break;
        case r.ZH:
        case r.ZH_CHS:
        case r.ZH_CN:
        case r.ZH_HANS:
        case r.UNKNOWN:
        default:
          $ = p;
      }
      return $;
    }
  }
  var u, g = t(70);
  (function(i) {
    i[i.error_code_0 = 0] = "error_code_0", i[i.error_code_1 = 1] = "error_code_1", i[i.error_code_2 = 2] = "error_code_2", i[i.error_code_3 = 3] = "error_code_3", i[i.error_code_4 = 4] = "error_code_4", i[i.error_code_5 = 5] = "error_code_5", i[i.error_code_6 = 6] = "error_code_6", i[i.error_code_7 = 7] = "error_code_7", i[i.error_code_8 = 8] = "error_code_8", i[i.error_code_9 = 9] = "error_code_9", i[i.error_code_10 = 10] = "error_code_10", i[i.error_code_11 = 11] = "error_code_11", i[i.error_code_12 = 12] = "error_code_12", i[i.error_code_13 = 13] = "error_code_13", i[i.error_code_14 = 14] = "error_code_14", i[i.error_code_15 = 15] = "error_code_15", i[i.error_code_16 = 16] = "error_code_16", i[i.error_code_4001 = 17] = "error_code_4001", i[i.error_code_4002 = 18] = "error_code_4002", i[i.invalid_password = 4010] = "invalid_password", i[i.error_code_4011 = 4011] = "error_code_4011", i[i.error_code_4012 = 4012] = "error_code_4012", i[i.error_code_4013 = 4013] = "error_code_4013", i[i.error_code_4014 = 4014] = "error_code_4014", i[i.error_code_4015 = 4015] = "error_code_4015", i[i.error_code_4016 = 4016] = "error_code_4016", i[i.error_code_4017 = 4017] = "error_code_4017", i[i.error_code_4018 = 4018] = "error_code_4018", i[i.error_code_4019 = 4019] = "error_code_4019", i[i.error_code_4020 = 4020] = "error_code_4020", i[i.error_code_4021 = 4021] = "error_code_4021", i[i.error_code_4022 = 4022] = "error_code_4022", i[i.error_code_4024 = 4023] = "error_code_4024", i[i.error_code_4121 = 4024] = "error_code_4121", i[i.error_code_4122 = 4025] = "error_code_4122", i[i.error_code_4123 = 4026] = "error_code_4123", i[i.error_code_4124 = 4027] = "error_code_4124", i[i.error_code_4125 = 4028] = "error_code_4125", i[i.error_code_4126 = 4029] = "error_code_4126", i[i.error_code_5026 = 4030] = "error_code_5026", i[i.error_code_5027 = 4031] = "error_code_5027", i[i.error_code_4050 = 4032] = "error_code_4050", i[i.error_code_4051 = 4033] = "error_code_4051", i[i.error_code_4052 = 4034] = "error_code_4052", i[i.error_code_4031 = 4035] = "error_code_4031", i[i.error_code_4032 = 4036] = "error_code_4032", i[i.error_code_4033 = 4037] = "error_code_4033", i[i.error_code_4034 = 4038] = "error_code_4034", i[i.error_code_4035 = 4039] = "error_code_4035", i[i.error_code_4036 = 4040] = "error_code_4036", i[i.error_code_4037 = 4041] = "error_code_4037", i[i.error_code_4038 = 4042] = "error_code_4038", i[i.error_code_4039 = 4043] = "error_code_4039", i[i.error_code_50 = 4044] = "error_code_50", i[i.error_code_38 = 4045] = "error_code_38", i[i.error_code_4023 = 4046] = "error_code_4023", i[i.unreachable = 4047] = "unreachable", i[i.default = 4048] = "default", i[i.your_operation_is_too_frequent__please_try_again_later = 4049] = "your_operation_is_too_frequent__please_try_again_later";
  })(u || (u = {}));
  var h = t(372);
  class c {
    constructor(m) {
      this._internationalization = m;
    }
    getText(m) {
      let $ = "";
      do {
        if (m instanceof Error) {
          $ = this._getDefaultText(m);
          break;
        }
        if ($ = this._handleErrorTextByLocalizedMessageDetail(m), typeof $ == "string" && $.length > 0 || ($ = this._handleErrorTextByErrorError(m), typeof $ == "string" && $.length > 0))
          break;
        if (m && typeof m.error == "string" && typeof m.error_code == "number") {
          const v = this._handleErrorTextByErrorCode(m, !1);
          if (typeof v == "string") {
            $ = v;
            break;
          }
        }
        $ = this._getDefaultText(m);
      } while (!1);
      return $ || "";
    }
    _getDefaultText(m) {
      let $ = "", v = !1;
      return m && (m instanceof Error || m.error) && (v = !0), v && ($ = this._handleErrorTextByErrorCode(m, !0) || "", $.length === 0 && ($ = `${this._internationalization.translate("error", u[u.default].toString())} ${this._handleDefaultErrorText(m)}`)), $;
    }
    _handleDefaultErrorText(m) {
      let $ = "";
      return m instanceof Error ? $ += `[${m.message ? m.message : "*"}]` : $ += `[${m.error ? m.error : "*"}][${m.error_description ? m.error_description : "*"}]`, $;
    }
    _handleErrorTextByLocalizedMessageDetail(m) {
      if (m && m.error) {
        const $ = (0, h.R2)(m);
        for (const v of $)
          if (v.message && v.message.length > 0)
            return v.message;
      }
    }
    _handleErrorTextByErrorError(m) {
      let $;
      if (m && m.error)
        switch (m.error) {
          case g.By.UNREACHABLE:
            $ = `${this._internationalization.translate("error", u[u.unreachable].toString())}`;
            break;
          case g.By.CAPTCHA_INVALID:
            $ = `${this._internationalization.translate("error", u[u.your_operation_is_too_frequent__please_try_again_later].toString())}`;
        }
      return $;
    }
    _handleErrorTextByErrorCode(m, $) {
      if (m && typeof m.error_code == "number" && (m.error_code >= 17 || $))
        return this._internationalization.translate("error", `error_code_${m.error_code}`);
    }
  }
}, 584: (n, e, t) => {
  t.d(e, { c: () => _ });
  var r = t(46), o = t(152), a = t(70), d = t(372), s = function(y, u, g, h) {
    return new (g || (g = Promise))(function(c, i) {
      function m(N) {
        try {
          v(h.next(N));
        } catch (C) {
          i(C);
        }
      }
      function $(N) {
        try {
          v(h.throw(N));
        } catch (C) {
          i(C);
        }
      }
      function v(N) {
        var C;
        N.done ? c(N.value) : (C = N.value, C instanceof g ? C : new g(function(w) {
          w(C);
        })).then(m, $);
      }
      v((h = h.apply(y, [])).next());
    });
  };
  function l(y) {
    return `[lockSession:(${y == null ? void 0 : y.time})]`;
  }
  function f(y) {
    return `[lockOptions:(${y.action}|${y.timeout}|${l(y.session)})]`;
  }
  function p(y) {
    return `[safeLockOptions:(${y.action}|${y.timeout}|${l(y.session)})]`;
  }
  class _ {
    constructor(u) {
      this._sourceInfo = null, this._eventEmitter = new r.EventEmitter(), this._logger = new o.Vy({ packageName: "@xbase/common", className: "Lock", logLevel: u.logLevel, console: u.console }), this._config = { lockType: u.lockType, name: u.name, timeout: this._formatTimeout(u.timeout, _._defaultTimeout) }, this._eventEmitter.setMaxListeners(0);
    }
    get logLevel() {
      return this._logger.logLevel;
    }
    set logLevel(u) {
      this._logger.logLevel = u;
    }
    lock(u) {
      return s(this, void 0, void 0, function* () {
        return yield (0, o._w)("lock", () => s(this, void 0, void 0, function* () {
          return new Promise((g, h) => s(this, void 0, void 0, function* () {
            let c;
            this._logger.trace(`lock action is ${f(u)}`);
            const i = () => {
              c && clearTimeout(c);
            };
            try {
              const m = this._formatTimeout(u.timeout, this._config.timeout), $ = () => {
                try {
                  const v = this._acquireSource(u);
                  v && (i(), this._eventEmitter.off(_._eventKey, $), this._logger.trace(`lock action ${f(u)} lock success`), g(v.session));
                } catch (v) {
                  i(), this._logger.trace(`lock action ${f(u)} lock failed(2)`), h((0, d.JT)(v));
                }
              };
              this._eventEmitter.on(_._eventKey, $), this._fireAcquireSourceEvent(_._eventKey), typeof m == "number" && (c = setTimeout(() => {
                this._logger.trace(`lock action ${f(u)} lock failed(1)`), h({ error: a.By.LOCAL, error_code: a._Y.LOCAL, error_description: "lock timeout" });
              }, m));
            } catch (m) {
              i(), this._logger.trace(`lock action ${f(u)} lock failed(0)`), h((0, d.JT)(m));
            }
          }));
        }), this._logger);
      });
    }
    unlock(u) {
      return s(this, void 0, void 0, function* () {
        return yield (0, o._w)("unlock", () => s(this, void 0, void 0, function* () {
          this._logger.trace(`unlock action ${l(u)} 1`), this._freeSource(u) && (this._logger.trace(`unlock action ${l(u)} 2`), this._fireAcquireSourceEvent(_._eventKey)), this._logger.trace(`unlock action ${l(u)} 3`);
        }), this._logger);
      });
    }
    safeLock(u) {
      return s(this, void 0, void 0, function* () {
        return yield (0, o._w)("safeLock", () => s(this, void 0, void 0, function* () {
          this._logger.trace(`safeLock action ${p(u)}`);
          let g, h = !1, c = null;
          try {
            {
              if (this._logger.trace(`safeLock action ${p(u)}: safeLock 1`), typeof u.callBack != "function")
                throw new Error("safeLock: callBack is not function");
              this._logger.trace(`safeLock action ${p(u)}: safeLock 2`), c = yield this.lock(u), this._logger.trace(`safeLock action ${p(u)}: safeLock 3`);
              const i = u.callBack(c);
              this._logger.trace(`safeLock action ${p(u)}: safeLock 4`), g = i instanceof Promise ? yield i : i, this._logger.trace(`safeLock action ${p(u)}: safeLock 5`), h = !0, yield this.unlock(c), this._logger.trace(`safeLock action ${p(u)}: safeLock 6`);
            }
          } catch (i) {
            throw this._logger.trace(`action ${p(u)}: safeLock 7`), (0, d.JT)(i);
          } finally {
            this._logger.trace(`safeLock action ${p(u)}: safeLock 8`), !h && c && (this._logger.trace(`safeLock action ${p(u)}: safeLock 9`), yield this.unlock(c), this._logger.trace(`safeLock action ${p(u)}: safeLock 10`)), this._logger.trace(`safeLock action ${p(u)}: safeLock 11`);
          }
          return g;
        }), this._logger);
      });
    }
    _isReentrant() {
      return this._config.lockType === "reentrant";
    }
    _acquireSource(u) {
      return (0, o.n2)("_acquireSource", () => {
        var g;
        let h = null;
        if (this._logger && u.session && !this._isReentrant() && this._logger.warn("_acquireSource: non-reentrant lock shouldn't pass session", u), this._sourceInfo) {
          if (this._isReentrant() && (h = this._sourceInfo, h))
            if (u.session) {
              if (h.session.time !== ((g = u.session) === null || g === void 0 ? void 0 : g.time))
                throw new Error("_acquireSource: sourceInfo.session.time don't match");
              h.actions.push(u.action), h.referenceCount++;
            } else
              h = null;
        } else
          h = { actions: [u.action], session: { time: (/* @__PURE__ */ new Date()).getTime() }, referenceCount: 1 }, this._sourceInfo = h;
        return h;
      }, this._logger);
    }
    _freeSource(u) {
      return (0, o.n2)("_freeSource", () => {
        let g = !1;
        do {
          if (!u) {
            this._logger.error("lsession is invalid");
            break;
          }
          const h = this._sourceInfo;
          if (!h) {
            this._logger.error("sourceInfo is null");
            break;
          }
          if (h.session !== u) {
            this._logger.error("session of lock don't match");
            break;
          }
          h.actions.pop(), h.referenceCount--, h.referenceCount <= 0 && (this._sourceInfo = null), g = !0;
        } while (!1);
        return g;
      }, this._logger);
    }
    _fireAcquireSourceEvent(u) {
      return (0, o.n2)("_fireAcquireSourceEvent", () => {
        this._eventEmitter.emit(u);
      }, this._logger);
    }
    _formatTimeout(u, g) {
      return typeof u != "number" ? this._checkTimeout(g) : this._checkTimeout(u);
    }
    _checkTimeout(u) {
      let g = null;
      if (typeof u != "number" && u !== void 0 && (g = { error: a.By.LOCAL, error_code: a._Y.LOCAL, error_description: "wrong options param: timeout" }), g)
        throw g;
      return u;
    }
  }
  _._defaultTimeout = void 0, _._eventKey = "event-key";
}, 152: (n, e, t) => {
  var r;
  t.d(e, { $b: () => r, Vy: () => u, _w: () => l, n2: () => p, de: () => s, W3: () => f }), function(g) {
    g.OFF = "off", g.ERROR = "error", g.WARN = "warn", g.INFO = "info", g.DEBUG = "debug", g.TRACE = "trace", g.ALL = "all";
  }(r || (r = {}));
  var o = function(g, h, c, i) {
    return new (c || (c = Promise))(function(m, $) {
      function v(w) {
        try {
          C(i.next(w));
        } catch (A) {
          $(A);
        }
      }
      function N(w) {
        try {
          C(i.throw(w));
        } catch (A) {
          $(A);
        }
      }
      function C(w) {
        var A;
        w.done ? m(w.value) : (A = w.value, A instanceof c ? A : new c(function(I) {
          I(A);
        })).then(v, N);
      }
      C((i = i.apply(g, [])).next());
    });
  };
  function a(g, h, c, i) {
    return o(this, void 0, void 0, function* () {
      let m;
      c == null || c[i](`${g} in`);
      let $, v = !1;
      try {
        m = yield h();
      } catch (N) {
        v = !0, $ = N, c == null || c.error(`${g} error:`, $);
      } finally {
        return v ? Promise.reject($) : (c == null || c[i](`${g} out`, m), m);
      }
    });
  }
  function d(g, h, c, i) {
    let m;
    c == null || c[i](`${g} in`);
    let $, v = !1;
    try {
      m = h();
    } catch (N) {
      v = !0, $ = N, c == null || c.error(`${g} error:`, $);
    } finally {
      if (v)
        throw $;
      return c == null || c[i](`${g} out`, m), m;
    }
  }
  function s(g, h, c) {
    return o(this, void 0, void 0, function* () {
      return a(g, h, c || null, "info");
    });
  }
  function l(g, h, c) {
    return o(this, void 0, void 0, function* () {
      return a(g, h, c || null, "debug");
    });
  }
  function f(g, h, c) {
    return d(g, h, c || null, "info");
  }
  function p(g, h, c) {
    return d(g, h, c || null, "debug");
  }
  var _ = t(516);
  function y(g) {
    switch (g) {
      case r.OFF:
        return 6;
      case r.ERROR:
        return 5;
      case r.WARN:
        return 4;
      case r.INFO:
        return 3;
      case r.DEBUG:
        return 2;
      case r.TRACE:
        return 1;
      case r.ALL:
      default:
        return 0;
    }
  }
  class u {
    constructor(h) {
      const c = h.logLevel || r.OFF;
      this._config = { packageName: h.packageName, logLevel: c, logLevelNumber: y(c), className: h.className, console: h.console || new _.p() };
    }
    get logLevel() {
      return this._config.logLevel;
    }
    set logLevel(h) {
      this._config.logLevel = h, this._config.logLevelNumber = y(h);
    }
    error(h, ...c) {
      this._config.console && this._canLog(r.ERROR) && this._config.console.error(`${this._getPreLog(r.ERROR)}`, h, ...c);
    }
    warn(h, ...c) {
      this._config.console && this._canLog(r.WARN) && this._config.console.warn(`${this._getPreLog(r.WARN)}`, h, ...c);
    }
    info(h, ...c) {
      this._config.console && this._canLog(r.INFO) && this._config.console.info(`${this._getPreLog(r.INFO)}`, h, ...c);
    }
    debug(h, ...c) {
      this._config.console && this._canLog(r.DEBUG) && this._config.console.log(`${this._getPreLog(r.DEBUG)}`, h, ...c);
    }
    trace(h, ...c) {
      this._config.console && this._canLog(r.TRACE) && this._config.console.log(`${this._getPreLog(r.TRACE)}`, h, ...c);
    }
    _getPreLog(h) {
      return `[${this._date2DateString(/* @__PURE__ */ new Date())}][${h}][${this._config.packageName}][${this._config.className ? this._config.className : ""}]`;
    }
    _paddingZero(h, c) {
      let i;
      return i = c > h.length ? new Array(c - h.length + 1).join("0") + h : h, i;
    }
    _date2DateString(h) {
      const c = h.getFullYear().toString(), i = (h.getMonth() + 1).toString(), m = h.getDate().toString(), $ = h.getHours().toString(), v = h.getMinutes().toString(), N = h.getSeconds().toString(), C = h.getMilliseconds().toString();
      return `${c}-${this._paddingZero(i, 2)}-${this._paddingZero(m, 2)} ${this._paddingZero($, 2)}:${this._paddingZero(v, 2)}:${this._paddingZero(N, 2)}:${this._paddingZero(C, 3)}`;
    }
    _canLog(h) {
      return this._config.logLevelNumber <= y(h);
    }
  }
}, 70: (n, e, t) => {
  var r, o, a;
  t.d(e, { _Y: () => o, mQ: () => a, By: () => r }), function(d) {
    d.UNREACHABLE = "unreachable", d.LOCAL = "local", d.CANCELLED = "cancelled", d.UNKNOWN = "unknown", d.INVALID_ARGUMENT = "invalid_argument", d.DEADLINE_EXCEEDED = "deadline_exceeded", d.NOT_FOUND = "not_found", d.ALREADY_EXISTS = "already_exists", d.PERMISSION_DENIED = "permission_denied", d.UNAUTHENTICATED = "unauthenticated", d.RESOURCE_EXHAUSTED = "resource_exhausted", d.FAILED_PRECONDITION = "failed_precondition", d.ABORTED = "aborted", d.OUT_OF_RANGE = "out_of_range", d.UNIMPLEMENTED = "unimplemented", d.INTERNAL = "internal", d.UNAVAILABLE = "unavailable", d.DATA_LOSS = "data_loss", d.CAPTCHA_REQUIRED = "captcha_required", d.CAPTCHA_INVALID = "captcha_invalid", d.INVALID_PASSWORD = "invalid_password", d.INVALID_STATUS = "invalid_status", d.USER_PENDING = "user_pending", d.USER_BLOCKED = "user_blocked", d.INVALID_VERIFICATION_CODE = "invalid_verification_code", d.TWO_FACTOR_REQUIRED = "two_factor_required", d.INVALID_TWO_FACTOR = "invalid_two_factor", d.INVALID_TWO_FACTOR_RECOVERY = "invalid_two_factor_recovery", d.UNDER_REVIEW = "under_review", d.PROVIDER_ERROR = "provider_error", d.VALIDATE_REQUIRED = "validate_required", d.PASSWORD_RESET_REQUIRED = "password_reset_required", d.INVALID_ACCOUNT_OR_PASSWORD = "invalid_account_or_password", d.EXPIRED_VERIFICATION_CODE = "expired_verification_code", d.INVALID_REQUEST = "invalid_request", d.UNAUTHORIZED_CLIENT = "unauthorized_client", d.ACCESS_DENIED = "access_denied", d.UNSUPPORTED_RESPONSE_TYPE = "unsupported_response_type", d.INVALID_SCOPE = "invalid_scope", d.INVALID_GRANT = "invalid_grant", d.SERVER_ERROR = "server_error", d.TEMPORARILY_UNAVAILABLE = "temporarily_unavailable", d.AUTHORIZATION_PENDING = "authorization_pending", d.SLOW_DOWN = "slow_down", d.EXPIRED_TOKEN = "expired_token", d.INTERACTION_REQUIRED = "interaction_required", d.LOGIN_REQUIRED = "login_required", d.ACCOUNT_SELECTION_REQUIRED = "account_selection_required", d.CONSENT_REQUIRED = "consent_required", d.INVALID_REQUEST_URI = "invalid_request_uri", d.INVALID_REQUEST_OBJECT = "invalid_request_object", d.REQUEST_NOT_SUPPORTED = "request_not_supported", d.REQUEST_URI_NOT_SUPPORTED = "request_uri_not_supported", d.REGISTRATION_NOT_SUPPORTED = "registration_not_supported", d.ACCOUNT_FREEZE = "account_freeze", d.CANNOT_UNLOCK = "cannot_unlock", d.USER_NOT_EXIST = "user_not_exist";
  }(r || (r = {})), function(d) {
    d[d.OK = 0] = "OK", d[d.CANCELLED = 1] = "CANCELLED", d[d.UNKNOWN = 2] = "UNKNOWN", d[d.INVALID_ARGUMENT = 3] = "INVALID_ARGUMENT", d[d.DEADLINE_EXCEEDED = 4] = "DEADLINE_EXCEEDED", d[d.NOT_FOUND = 5] = "NOT_FOUND", d[d.ALREADY_EXISTS = 6] = "ALREADY_EXISTS", d[d.PERMISSION_DENIED = 7] = "PERMISSION_DENIED", d[d.RESOURCE_EXHAUSTED = 8] = "RESOURCE_EXHAUSTED", d[d.FAILED_PRECONDITION = 9] = "FAILED_PRECONDITION", d[d.ABORTED = 10] = "ABORTED", d[d.OUT_OF_RANGE = 11] = "OUT_OF_RANGE", d[d.UNIMPLEMENTED = 12] = "UNIMPLEMENTED", d[d.INTERNAL = 13] = "INTERNAL", d[d.UNAVAILABLE = 14] = "UNAVAILABLE", d[d.DATA_LOSS = 15] = "DATA_LOSS", d[d.UNAUTHENTICATED = 16] = "UNAUTHENTICATED", d[d.CAPTCHA_REQUIRED = 4001] = "CAPTCHA_REQUIRED", d[d.CAPTCHA_INVALID = 4002] = "CAPTCHA_INVALID", d[d.INVALID_PASSWORD = 4010] = "INVALID_PASSWORD", d[d.INVALID_STATUS = 4011] = "INVALID_STATUS", d[d.USER_PENDING = 4012] = "USER_PENDING", d[d.USER_BLOCKED = 4013] = "USER_BLOCKED", d[d.INVALID_VERIFICATION_CODE = 4014] = "INVALID_VERIFICATION_CODE", d[d.TWO_FACTOR_REQUIRED = 4015] = "TWO_FACTOR_REQUIRED", d[d.INVALID_TWO_FACTOR = 4016] = "INVALID_TWO_FACTOR", d[d.INVALID_TWO_FACTOR_RECOVERY = 4017] = "INVALID_TWO_FACTOR_RECOVERY", d[d.UNDER_REVIEW = 4018] = "UNDER_REVIEW", d[d.PROVIDER_ERROR = 4019] = "PROVIDER_ERROR", d[d.VALIDATE_REQUIRED = 4020] = "VALIDATE_REQUIRED", d[d.PASSWORD_RESET_REQUIRED = 4021] = "PASSWORD_RESET_REQUIRED", d[d.INVALID_ACCOUNT_OR_PASSWORD = 4022] = "INVALID_ACCOUNT_OR_PASSWORD", d[d.EXPIRED_VERIFICATION_CODE = 4024] = "EXPIRED_VERIFICATION_CODE", d[d.INVALID_REQUEST = 4121] = "INVALID_REQUEST", d[d.UNAUTHORIZED_CLIENT = 4122] = "UNAUTHORIZED_CLIENT", d[d.ACCESS_DENIED = 4123] = "ACCESS_DENIED", d[d.UNSUPPORTED_RESPONSE_TYPE = 4124] = "UNSUPPORTED_RESPONSE_TYPE", d[d.INVALID_SCOPE = 4125] = "INVALID_SCOPE", d[d.INVALID_GRANT = 4126] = "INVALID_GRANT", d[d.SERVER_ERROR = 5026] = "SERVER_ERROR", d[d.TEMPORARILY_UNAVAILABLE = 5027] = "TEMPORARILY_UNAVAILABLE", d[d.authorization_pending = 4050] = "authorization_pending", d[d.slow_down = 4051] = "slow_down", d[d.expired_token = 4052] = "expired_token", d[d.INTERACTION_REQUIRED = 4031] = "INTERACTION_REQUIRED", d[d.LOGIN_REQUIRED = 4032] = "LOGIN_REQUIRED", d[d.ACCOUNT_SELECTION_REQUIRED = 4033] = "ACCOUNT_SELECTION_REQUIRED", d[d.CONSENT_REQUIRED = 4034] = "CONSENT_REQUIRED", d[d.INVALID_REQUEST_URI = 4035] = "INVALID_REQUEST_URI", d[d.INVALID_REQUEST_OBJECT = 4036] = "INVALID_REQUEST_OBJECT", d[d.REQUEST_NOT_SUPPORTED = 4037] = "REQUEST_NOT_SUPPORTED", d[d.REQUEST_URI_NOT_SUPPORTED = 4038] = "REQUEST_URI_NOT_SUPPORTED", d[d.REGISTRATION_NOT_SUPPORTED = 4039] = "REGISTRATION_NOT_SUPPORTED", d[d.ACCOUNT_FREEZE = 50] = "ACCOUNT_FREEZE", d[d.CANNOT_UNLOCK = 38] = "CANNOT_UNLOCK", d[d.USER_NOT_EXIST = 4023] = "USER_NOT_EXIST", d[d.UNREACHABLE = 8e3] = "UNREACHABLE", d[d.LOCAL = 8001] = "LOCAL", d[d.LOCAL_THIRD_PARTY_ERROR = 8002] = "LOCAL_THIRD_PARTY_ERROR", d[d.LOCAL_PROVIDER_ACCOUNT_ERROR = 8003] = "LOCAL_PROVIDER_ACCOUNT_ERROR";
  }(o || (o = {})), function(d) {
    d.ErrorInfo = "type.googleapis.com/google.rpc.ErrorInfo", d.LocalizedMessage = "type.googleapis.com/google.rpc.LocalizedMessage";
  }(a || (a = {}));
}, 988: (n, e, t) => {
  var r;
  t.d(e, { r: () => r }), function(o) {
    o.DID_NAVIGATE = "did-navigate", o.DID_FINISH_LOAD = "did-finish-load", o.CLOSED = "closed";
  }(r || (r = {}));
}, 782: (n, e, t) => {
  function r(o) {
    return o == null ? o : JSON.parse(JSON.stringify(o));
  }
  t.d(e, { m: () => r });
}, 954: (n, e, t) => {
  t.d(e, { k: () => r });
  class r {
    constructor(a, d) {
      this._typePrefix = a || "", this._sourcePrefix = d || "";
    }
    buildEvent(a) {
      return { specversion: "1.0.1", id: "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (d) => {
        const s = 16 * Math.random() | 0;
        return (d == "x" ? s : 3 & s | 8).toString(16);
      }), type: this._typePrefix + a.typeSuffix, source: this._sourcePrefix + a.sourceSuffix, time: a.time || /* @__PURE__ */ new Date(), datacontenttype: a.datacontenttype || "application/json", dataschema: a.dataschema, subject: a.subject, data: a.data };
    }
  }
}, 590: (n, e, t) => {
  t.d(e, { R0: () => _, j7: () => g, F8: () => a, $l: () => o, Nk: () => d });
  var r = t(372);
  function o(h, c) {
    return !(!(0, r.gr)(c) || c.error_uri !== new URL(h).pathname);
  }
  function a(h, c) {
    return h.startsWith("/") ? o(`https://test.com${h}`, c) : o(h, c);
  }
  function d(h, c) {
    let i = !1;
    try {
      const m = new URL(h);
      for (const $ of c)
        if (m.origin === $) {
          i = !0;
          break;
        }
    } catch {
      i = !1;
    }
    return i;
  }
  var s = t(152), l = t(977), f = t(70), p = function(h, c, i, m) {
    return new (i || (i = Promise))(function($, v) {
      function N(A) {
        try {
          w(m.next(A));
        } catch (I) {
          v(I);
        }
      }
      function C(A) {
        try {
          w(m.throw(A));
        } catch (I) {
          v(I);
        }
      }
      function w(A) {
        var I;
        A.done ? $(A.value) : (I = A.value, I instanceof i ? I : new i(function(E) {
          E(I);
        })).then(N, C);
      }
      w((m = m.apply(h, [])).next());
    });
  };
  class _ {
    constructor(c) {
      this._config = { apiOrigins: c.apiOrigins, requestFunction: c.requestFunction, retry: this._formatRetry(c.retry, _._defaultRetry) }, this._logger = new s.Vy({ packageName: "@xbase/common", className: "RequestClient", logLevel: c.logLevel, console: c.console });
    }
    get logLevel() {
      return this._logger.logLevel;
    }
    set logLevel(c) {
      this._logger.logLevel = c;
    }
    formatRetry(c) {
      return this._formatRetry(c, this._config.retry);
    }
    request(c) {
      return p(this, void 0, void 0, function* () {
        return yield (0, s._w)("request", () => p(this, void 0, void 0, function* () {
          var i;
          const m = this.formatRetry((i = c.requestOptions) === null || i === void 0 ? void 0 : i.retry) + 1;
          return this._innerRequest({ requestOptions: c, lastResponseError: void 0, maxRequestCount: m, requestCount: 0 });
        }), this._logger);
      });
    }
    _innerRequest(c) {
      return p(this, void 0, void 0, function* () {
        return yield (0, s._w)("_innerRequest", () => p(this, void 0, void 0, function* () {
          let i = !1, m = "";
          if (c.maxRequestCount < 0 || c.requestCount < 0 ? (i = !0, m = `maxRequestCount(${c.maxRequestCount}) or requestCount(${c.requestCount}) < 0`) : c.requestCount >= c.maxRequestCount && (i = !0, m = `requestCount(${c.requestCount}) >= maxRequestCount(${c.maxRequestCount})`), i) {
            if (c.lastResponseError)
              return Promise.reject(c.lastResponseError);
            const v = { error: f.By.LOCAL, error_code: f._Y.LOCAL, error_description: m };
            return Promise.reject(v);
          }
          const $ = this._getRequestUri(c.requestOptions.url, this._config.apiOrigins, c.requestCount);
          try {
            const v = c.requestOptions.requestOptions;
            return v && (v.retry = 0), yield this._config.requestFunction($, v);
          } catch (v) {
            const N = (0, r.JT)(v);
            return o($, N) ? (yield (0, l.yy)(300), this._innerRequest({ requestOptions: c.requestOptions, lastResponseError: N, maxRequestCount: c.maxRequestCount, requestCount: c.requestCount + 1 })) : Promise.reject(N);
          }
        }), this._logger);
      });
    }
    _formatRetry(c, i) {
      return typeof c != "number" ? this._checkRetry(i) : this._checkRetry(c);
    }
    _checkRetry(c) {
      return c < _._minRetry ? _._minRetry : c > _._maxRetry ? _._maxRetry : c;
    }
    _getRequestUri(c, i, m) {
      const $ = i[m % i.length];
      let v;
      if (c.startsWith("/")) {
        v = new URL(`${$}${c}`);
        const N = new URL($);
        return N.pathname = v.pathname, N.search = v.search, N.href;
      }
      return v = new URL(c), v.href;
    }
  }
  _._defaultRetry = 2, _._minRetry = 0, _._maxRetry = 4;
  var y = t(782), u = function(h, c, i, m) {
    return new (i || (i = Promise))(function($, v) {
      function N(A) {
        try {
          w(m.next(A));
        } catch (I) {
          v(I);
        }
      }
      function C(A) {
        try {
          w(m.throw(A));
        } catch (I) {
          v(I);
        }
      }
      function w(A) {
        var I;
        A.done ? $(A.value) : (I = A.value, I instanceof i ? I : new i(function(E) {
          E(I);
        })).then(N, C);
      }
      w((m = m.apply(h, [])).next());
    });
  };
  class g {
    constructor(c) {
      this._config = { apiOrigins: c.apiOrigins, requestFunction: c.requestFunction, beforeRequestOfRequestClientCallback: c.beforeRequestOfRequestClientCallback, retry: this._formatRetry(c.retry, g._defaultRetry) }, this._logger = new s.Vy({ packageName: "@xbase/common", className: "RequestClient2", logLevel: c.logLevel, console: c.console });
    }
    get logLevel() {
      return this._logger.logLevel;
    }
    set logLevel(c) {
      this._logger.logLevel = c;
    }
    request(c) {
      return u(this, void 0, void 0, function* () {
        return yield (0, s._w)("request", () => u(this, void 0, void 0, function* () {
          var i;
          let m = null;
          const $ = this._formatRetry((i = c.requestOptions) === null || i === void 0 ? void 0 : i.retry, this._config.retry);
          let v;
          for (let N = 0, C = 0, w = !1; N <= $ && C < g._maxRequestTimes; N++, C++) {
            w = !1, v = void 0;
            const A = this._getRequestUri(c.url, this._config.apiOrigins, N), I = c.requestOptions;
            let E, x = A;
            try {
              const F = this._getBeforeRequestOfRequestClientCallback(c.beforeRequestOfRequestClientCallback);
              if (F) {
                const q = yield F({ originUrl: c.url, url: A, requestOptions: I });
                x = q.url, E = q.requestOptions;
              } else
                E = (0, y.m)(c.requestOptions) || void 0;
              E && (E.retry = 0), m = yield this._config.requestFunction(x, E), w = !0;
            } catch (F) {
              v = (0, r.JT)(F);
            } finally {
              let F = !0, q = !0;
              const he = this._getAfterRequestOfRequestClientCallback(c.afterRequestOfRequestClientCallback);
              if (he) {
                const se = yield he({ originUrl: c.url, originRequestOptions: I, url: x, requestOptions: E, response: m || v || void 0, requestSuccess: w });
                q = se.costRetry === !0, q || (N -= 1);
                const Te = N > $;
                F = se.needRetry && !Te, (0, r.JO)(se.result) ? (m = null, v = se.result) : (m = se.result || null, v = void 0);
              } else {
                if (w)
                  F = !1;
                else {
                  const se = (0, r.cH)(v) && o(x, v);
                  v && se || (F = !1);
                }
                N > $ && (F = !1);
              }
              if (!F)
                break;
            }
            yield this._sleep(N);
          }
          return (0, r.JO)(v) ? Promise.reject(v) : m;
        }), this._logger);
      });
    }
    _formatRetry(c, i) {
      return typeof c != "number" ? this._checkRetry(i) : this._checkRetry(c);
    }
    _checkRetry(c) {
      let i = null;
      if ((typeof c != "number" || c < g._minRetry || c > g._maxRetry) && (i = { error: f.By.LOCAL, error_description: "wrong options param: retry" }), i)
        throw i;
      return c;
    }
    _sleep(c) {
      return u(this, void 0, void 0, function* () {
        return new Promise((i) => {
          setTimeout(() => {
            i();
          }, 1e3 * Math.pow(2, c));
        });
      });
    }
    _getBeforeRequestOfRequestClientCallback(c) {
      return typeof c == "function" ? c : typeof this._config.beforeRequestOfRequestClientCallback == "function" ? this._config.beforeRequestOfRequestClientCallback : void 0;
    }
    _getAfterRequestOfRequestClientCallback(c) {
      return typeof c == "function" ? c : typeof this._config.afterRequestOfRequestClientCallback == "function" ? this._config.afterRequestOfRequestClientCallback : void 0;
    }
    _getRequestUri(c, i, m) {
      const $ = i[m % i.length];
      let v;
      if (c.startsWith("/")) {
        v = new URL(`${$}${c}`);
        const N = new URL($);
        return N.pathname = v.pathname, N.search = v.search, N.href;
      }
      return v = new URL(c), v.href;
    }
  }
  g._defaultRetry = 2, g._minRetry = 0, g._maxRetry = 4, g._maxRequestTimes = 15;
}, 372: (n, e, t) => {
  t.d(e, { JO: () => d, JT: () => s, R2: () => f, U1: () => p, cH: () => o, gr: () => a, qk: () => y, xM: () => _, zg: () => l });
  var r = t(70);
  function o(u) {
    return u && u.error !== void 0;
  }
  function a(u) {
    return u.error === r.By.INTERNAL || u.error === r.By.UNREACHABLE;
  }
  function d(u) {
    return u instanceof Error || o(u);
  }
  function s(u, g) {
    let h;
    const c = g || {};
    if (u instanceof Error)
      h = { error: c.error || r.By.LOCAL, error_code: typeof c.error_code == "number" ? c.error_code : r._Y.LOCAL, error_description: c.error_description || `${u.message}


${u.stack}`, error_uri: c.error_uri, details: c.details || [] };
    else {
      const i = u || {};
      h = { error: c.error || i.error || r.By.LOCAL, error_code: typeof c.error_code == "number" ? c.error_code : i.error_code, error_description: c.error_description || i.error_description, error_uri: c.error_uri || i.error_uri, details: c.details || i.details };
    }
    return h;
  }
  function l(u) {
    return u && u !== void 0;
  }
  function f(u) {
    const g = [];
    if (u && Array.isArray(u.details))
      for (const h of u.details)
        l(h) && g.push(h);
    return g;
  }
  function p(u, g) {
    const h = [];
    if (u && Array.isArray(u.details))
      for (const c of u.details)
        l(c) && c.domain === g && h.push(c);
    return h;
  }
  function _(u) {
    return u && u.resource_id !== void 0;
  }
  function y(u, g) {
    u && (Array.isArray(u.details) || (u.details = []), u.details.push(g));
  }
}, 569: function(n, e, t) {
  var r;
  (function(o, a) {
    var d = "function", s = "undefined", l = "object", f = "string", p = "major", _ = "model", y = "name", u = "type", g = "vendor", h = "version", c = "architecture", i = "console", m = "mobile", $ = "tablet", v = "smarttv", N = "wearable", C = "embedded", w = "Amazon", A = "Apple", I = "ASUS", E = "BlackBerry", x = "Browser", F = "Chrome", q = "Firefox", he = "Google", se = "Huawei", Te = "LG", b = "Microsoft", S = "Motorola", U = "Opera", j = "Samsung", Q = "Sharp", te = "Sony", ae = "Xiaomi", ee = "Zebra", re = "Facebook", J = "Chromium OS", qe = "Mac OS", Be = function(Y) {
      for (var de = {}, B = 0; B < Y.length; B++)
        de[Y[B].toUpperCase()] = Y[B];
      return de;
    }, on = function(Y, de) {
      return typeof Y === f && z(de).indexOf(z(Y)) !== -1;
    }, z = function(Y) {
      return Y.toLowerCase();
    }, ye = function(Y, de) {
      if (typeof Y === f)
        return Y = Y.replace(/^\s\s*/, ""), typeof de === s ? Y : Y.substring(0, 500);
    }, pe = function(Y, de) {
      for (var B, $e, Ne, K, ke, M, _e = 0; _e < de.length && !ke; ) {
        var je = de[_e], O = de[_e + 1];
        for (B = $e = 0; B < je.length && !ke && je[B]; )
          if (ke = je[B++].exec(Y))
            for (Ne = 0; Ne < O.length; Ne++)
              M = ke[++$e], typeof (K = O[Ne]) === l && K.length > 0 ? K.length === 2 ? typeof K[1] == d ? this[K[0]] = K[1].call(this, M) : this[K[0]] = K[1] : K.length === 3 ? typeof K[1] !== d || K[1].exec && K[1].test ? this[K[0]] = M ? M.replace(K[1], K[2]) : a : this[K[0]] = M ? K[1].call(this, M, K[2]) : a : K.length === 4 && (this[K[0]] = M ? K[3].call(this, M.replace(K[1], K[2])) : a) : this[K] = M || a;
        _e += 2;
      }
    }, Oe = function(Y, de) {
      for (var B in de)
        if (typeof de[B] === l && de[B].length > 0) {
          for (var $e = 0; $e < de[B].length; $e++)
            if (on(de[B][$e], Y))
              return B === "?" ? a : B;
        } else if (on(de[B], Y))
          return B === "?" ? a : B;
      return Y;
    }, Qe = { ME: "4.90", "NT 3.11": "NT3.51", "NT 4.0": "NT4.0", 2e3: "NT 5.0", XP: ["NT 5.1", "NT 5.2"], Vista: "NT 6.0", 7: "NT 6.1", 8: "NT 6.2", 8.1: "NT 6.3", 10: ["NT 6.4", "NT 10.0"], RT: "ARM" }, Pn = { browser: [[/\b(?:crmo|crios)\/([\w\.]+)/i], [h, [y, "Chrome"]], [/edg(?:e|ios|a)?\/([\w\.]+)/i], [h, [y, "Edge"]], [/(opera mini)\/([-\w\.]+)/i, /(opera [mobiletab]{3,6})\b.+version\/([-\w\.]+)/i, /(opera)(?:.+version\/|[\/ ]+)([\w\.]+)/i], [y, h], [/opios[\/ ]+([\w\.]+)/i], [h, [y, U + " Mini"]], [/\bop(?:rg)?x\/([\w\.]+)/i], [h, [y, U + " GX"]], [/\bopr\/([\w\.]+)/i], [h, [y, U]], [/\bb[ai]*d(?:uhd|[ub]*[aekoprswx]{5,6})[\/ ]?([\w\.]+)/i], [h, [y, "Baidu"]], [/(kindle)\/([\w\.]+)/i, /(lunascape|maxthon|netfront|jasmine|blazer)[\/ ]?([\w\.]*)/i, /(avant|iemobile|slim)\s?(?:browser)?[\/ ]?([\w\.]*)/i, /(?:ms|\()(ie) ([\w\.]+)/i, /(flock|rockmelt|midori|epiphany|silk|skyfire|bolt|iron|vivaldi|iridium|phantomjs|bowser|quark|qupzilla|falkon|rekonq|puffin|brave|whale(?!.+naver)|qqbrowserlite|qq|duckduckgo)\/([-\w\.]+)/i, /(heytap|ovi)browser\/([\d\.]+)/i, /(weibo)__([\d\.]+)/i], [y, h], [/\bddg\/([\w\.]+)/i], [h, [y, "DuckDuckGo"]], [/(?:\buc? ?browser|(?:juc.+)ucweb)[\/ ]?([\w\.]+)/i], [h, [y, "UC" + x]], [/microm.+\bqbcore\/([\w\.]+)/i, /\bqbcore\/([\w\.]+).+microm/i, /micromessenger\/([\w\.]+)/i], [h, [y, "WeChat"]], [/konqueror\/([\w\.]+)/i], [h, [y, "Konqueror"]], [/trident.+rv[: ]([\w\.]{1,9})\b.+like gecko/i], [h, [y, "IE"]], [/ya(?:search)?browser\/([\w\.]+)/i], [h, [y, "Yandex"]], [/slbrowser\/([\w\.]+)/i], [h, [y, "Smart Lenovo " + x]], [/(avast|avg)\/([\w\.]+)/i], [[y, /(.+)/, "$1 Secure " + x], h], [/\bfocus\/([\w\.]+)/i], [h, [y, q + " Focus"]], [/\bopt\/([\w\.]+)/i], [h, [y, U + " Touch"]], [/coc_coc\w+\/([\w\.]+)/i], [h, [y, "Coc Coc"]], [/dolfin\/([\w\.]+)/i], [h, [y, "Dolphin"]], [/coast\/([\w\.]+)/i], [h, [y, U + " Coast"]], [/miuibrowser\/([\w\.]+)/i], [h, [y, "MIUI " + x]], [/fxios\/([-\w\.]+)/i], [h, [y, q]], [/\bqihu|(qi?ho?o?|360)browser/i], [[y, "360 " + x]], [/(oculus|sailfish|huawei|vivo)browser\/([\w\.]+)/i], [[y, /(.+)/, "$1 " + x], h], [/samsungbrowser\/([\w\.]+)/i], [h, [y, j + " Internet"]], [/(comodo_dragon)\/([\w\.]+)/i], [[y, /_/g, " "], h], [/metasr[\/ ]?([\d\.]+)/i], [h, [y, "Sogou Explorer"]], [/(sogou)mo\w+\/([\d\.]+)/i], [[y, "Sogou Mobile"], h], [/(electron)\/([\w\.]+) safari/i, /(tesla)(?: qtcarbrowser|\/(20\d\d\.[-\w\.]+))/i, /m?(qqbrowser|2345Explorer)[\/ ]?([\w\.]+)/i], [y, h], [/(lbbrowser)/i, /\[(linkedin)app\]/i], [y], [/((?:fban\/fbios|fb_iab\/fb4a)(?!.+fbav)|;fbav\/([\w\.]+);)/i], [[y, re], h], [/(Klarna)\/([\w\.]+)/i, /(kakao(?:talk|story))[\/ ]([\w\.]+)/i, /(naver)\(.*?(\d+\.[\w\.]+).*\)/i, /safari (line)\/([\w\.]+)/i, /\b(line)\/([\w\.]+)\/iab/i, /(alipay)client\/([\w\.]+)/i, /(twitter)(?:and| f.+e\/([\w\.]+))/i, /(chromium|instagram|snapchat)[\/ ]([-\w\.]+)/i], [y, h], [/\bgsa\/([\w\.]+) .*safari\//i], [h, [y, "GSA"]], [/musical_ly(?:.+app_?version\/|_)([\w\.]+)/i], [h, [y, "TikTok"]], [/headlesschrome(?:\/([\w\.]+)| )/i], [h, [y, F + " Headless"]], [/ wv\).+(chrome)\/([\w\.]+)/i], [[y, F + " WebView"], h], [/droid.+ version\/([\w\.]+)\b.+(?:mobile safari|safari)/i], [h, [y, "Android " + x]], [/(chrome|omniweb|arora|[tizenoka]{5} ?browser)\/v?([\w\.]+)/i], [y, h], [/version\/([\w\.\,]+) .*mobile\/\w+ (safari)/i], [h, [y, "Mobile Safari"]], [/version\/([\w(\.|\,)]+) .*(mobile ?safari|safari)/i], [h, y], [/webkit.+?(mobile ?safari|safari)(\/[\w\.]+)/i], [y, [h, Oe, { "1.0": "/8", 1.2: "/1", 1.3: "/3", "2.0": "/412", "2.0.2": "/416", "2.0.3": "/417", "2.0.4": "/419", "?": "/" }]], [/(webkit|khtml)\/([\w\.]+)/i], [y, h], [/(navigator|netscape\d?)\/([-\w\.]+)/i], [[y, "Netscape"], h], [/mobile vr; rv:([\w\.]+)\).+firefox/i], [h, [y, q + " Reality"]], [/ekiohf.+(flow)\/([\w\.]+)/i, /(swiftfox)/i, /(icedragon|iceweasel|camino|chimera|fennec|maemo browser|minimo|conkeror|klar)[\/ ]?([\w\.\+]+)/i, /(seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([-\w\.]+)$/i, /(firefox)\/([\w\.]+)/i, /(mozilla)\/([\w\.]+) .+rv\:.+gecko\/\d+/i, /(polaris|lynx|dillo|icab|doris|amaya|w3m|netsurf|sleipnir|obigo|mosaic|(?:go|ice|up)[\. ]?browser)[-\/ ]?v?([\w\.]+)/i, /(links) \(([\w\.]+)/i, /panasonic;(viera)/i], [y, h], [/(cobalt)\/([\w\.]+)/i], [y, [h, /master.|lts./, ""]]], cpu: [[/(?:(amd|x(?:(?:86|64)[-_])?|wow|win)64)[;\)]/i], [[c, "amd64"]], [/(ia32(?=;))/i], [[c, z]], [/((?:i[346]|x)86)[;\)]/i], [[c, "ia32"]], [/\b(aarch64|arm(v?8e?l?|_?64))\b/i], [[c, "arm64"]], [/\b(arm(?:v[67])?ht?n?[fl]p?)\b/i], [[c, "armhf"]], [/windows (ce|mobile); ppc;/i], [[c, "arm"]], [/((?:ppc|powerpc)(?:64)?)(?: mac|;|\))/i], [[c, /ower/, "", z]], [/(sun4\w)[;\)]/i], [[c, "sparc"]], [/((?:avr32|ia64(?=;))|68k(?=\))|\barm(?=v(?:[1-7]|[5-7]1)l?|;|eabi)|(?=atmel )avr|(?:irix|mips|sparc)(?:64)?\b|pa-risc)/i], [[c, z]]], device: [[/\b(sch-i[89]0\d|shw-m380s|sm-[ptx]\w{2,4}|gt-[pn]\d{2,4}|sgh-t8[56]9|nexus 10)/i], [_, [g, j], [u, $]], [/\b((?:s[cgp]h|gt|sm)-\w+|sc[g-]?[\d]+a?|galaxy nexus)/i, /samsung[- ]([-\w]+)/i, /sec-(sgh\w+)/i], [_, [g, j], [u, m]], [/(?:\/|\()(ip(?:hone|od)[\w, ]*)(?:\/|;)/i], [_, [g, A], [u, m]], [/\((ipad);[-\w\),; ]+apple/i, /applecoremedia\/[\w\.]+ \((ipad)/i, /\b(ipad)\d\d?,\d\d?[;\]].+ios/i], [_, [g, A], [u, $]], [/(macintosh);/i], [_, [g, A]], [/\b(sh-?[altvz]?\d\d[a-ekm]?)/i], [_, [g, Q], [u, m]], [/\b((?:ag[rs][23]?|bah2?|sht?|btv)-a?[lw]\d{2})\b(?!.+d\/s)/i], [_, [g, se], [u, $]], [/(?:huawei|honor)([-\w ]+)[;\)]/i, /\b(nexus 6p|\w{2,4}e?-[atu]?[ln][\dx][012359c][adn]?)\b(?!.+d\/s)/i], [_, [g, se], [u, m]], [/\b(poco[\w ]+|m2\d{3}j\d\d[a-z]{2})(?: bui|\))/i, /\b; (\w+) build\/hm\1/i, /\b(hm[-_ ]?note?[_ ]?(?:\d\w)?) bui/i, /\b(redmi[\-_ ]?(?:note|k)?[\w_ ]+)(?: bui|\))/i, /oid[^\)]+; (m?[12][0-389][01]\w{3,6}[c-y])( bui|; wv|\))/i, /\b(mi[-_ ]?(?:a\d|one|one[_ ]plus|note lte|max|cc)?[_ ]?(?:\d?\w?)[_ ]?(?:plus|se|lite)?)(?: bui|\))/i], [[_, /_/g, " "], [g, ae], [u, m]], [/oid[^\)]+; (2\d{4}(283|rpbf)[cgl])( bui|\))/i, /\b(mi[-_ ]?(?:pad)(?:[\w_ ]+))(?: bui|\))/i], [[_, /_/g, " "], [g, ae], [u, $]], [/; (\w+) bui.+ oppo/i, /\b(cph[12]\d{3}|p(?:af|c[al]|d\w|e[ar])[mt]\d0|x9007|a101op)\b/i], [_, [g, "OPPO"], [u, m]], [/\b(opd2\d{3}a?) bui/i], [_, [g, "OPPO"], [u, $]], [/vivo (\w+)(?: bui|\))/i, /\b(v[12]\d{3}\w?[at])(?: bui|;)/i], [_, [g, "Vivo"], [u, m]], [/\b(rmx[1-3]\d{3})(?: bui|;|\))/i], [_, [g, "Realme"], [u, m]], [/\b(milestone|droid(?:[2-4x]| (?:bionic|x2|pro|razr))?:?( 4g)?)\b[\w ]+build\//i, /\bmot(?:orola)?[- ](\w*)/i, /((?:moto[\w\(\) ]+|xt\d{3,4}|nexus 6)(?= bui|\)))/i], [_, [g, S], [u, m]], [/\b(mz60\d|xoom[2 ]{0,2}) build\//i], [_, [g, S], [u, $]], [/((?=lg)?[vl]k\-?\d{3}) bui| 3\.[-\w; ]{10}lg?-([06cv9]{3,4})/i], [_, [g, Te], [u, $]], [/(lm(?:-?f100[nv]?|-[\w\.]+)(?= bui|\))|nexus [45])/i, /\blg[-e;\/ ]+((?!browser|netcast|android tv)\w+)/i, /\blg-?([\d\w]+) bui/i], [_, [g, Te], [u, m]], [/(ideatab[-\w ]+)/i, /lenovo ?(s[56]000[-\w]+|tab(?:[\w ]+)|yt[-\d\w]{6}|tb[-\d\w]{6})/i], [_, [g, "Lenovo"], [u, $]], [/(?:maemo|nokia).*(n900|lumia \d+)/i, /nokia[-_ ]?([-\w\.]*)/i], [[_, /_/g, " "], [g, "Nokia"], [u, m]], [/(pixel c)\b/i], [_, [g, he], [u, $]], [/droid.+; (pixel[\daxl ]{0,6})(?: bui|\))/i], [_, [g, he], [u, m]], [/droid.+ (a?\d[0-2]{2}so|[c-g]\d{4}|so[-gl]\w+|xq-a\w[4-7][12])(?= bui|\).+chrome\/(?![1-6]{0,1}\d\.))/i], [_, [g, te], [u, m]], [/sony tablet [ps]/i, /\b(?:sony)?sgp\w+(?: bui|\))/i], [[_, "Xperia Tablet"], [g, te], [u, $]], [/ (kb2005|in20[12]5|be20[12][59])\b/i, /(?:one)?(?:plus)? (a\d0\d\d)(?: b|\))/i], [_, [g, "OnePlus"], [u, m]], [/(alexa)webm/i, /(kf[a-z]{2}wi|aeo[c-r]{2})( bui|\))/i, /(kf[a-z]+)( bui|\)).+silk\//i], [_, [g, w], [u, $]], [/((?:sd|kf)[0349hijorstuw]+)( bui|\)).+silk\//i], [[_, /(.+)/g, "Fire Phone $1"], [g, w], [u, m]], [/(playbook);[-\w\),; ]+(rim)/i], [_, g, [u, $]], [/\b((?:bb[a-f]|st[hv])100-\d)/i, /\(bb10; (\w+)/i], [_, [g, E], [u, m]], [/(?:\b|asus_)(transfo[prime ]{4,10} \w+|eeepc|slider \w+|nexus 7|padfone|p00[cj])/i], [_, [g, I], [u, $]], [/ (z[bes]6[027][012][km][ls]|zenfone \d\w?)\b/i], [_, [g, I], [u, m]], [/(nexus 9)/i], [_, [g, "HTC"], [u, $]], [/(htc)[-;_ ]{1,2}([\w ]+(?=\)| bui)|\w+)/i, /(zte)[- ]([\w ]+?)(?: bui|\/|\))/i, /(alcatel|geeksphone|nexian|panasonic(?!(?:;|\.))|sony(?!-bra))[-_ ]?([-\w]*)/i], [g, [_, /_/g, " "], [u, m]], [/droid.+; ([ab][1-7]-?[0178a]\d\d?)/i], [_, [g, "Acer"], [u, $]], [/droid.+; (m[1-5] note) bui/i, /\bmz-([-\w]{2,})/i], [_, [g, "Meizu"], [u, m]], [/; ((?:power )?armor(?:[\w ]{0,8}))(?: bui|\))/i], [_, [g, "Ulefone"], [u, m]], [/(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus|dell|meizu|motorola|polytron|infinix|tecno)[-_ ]?([-\w]*)/i, /(hp) ([\w ]+\w)/i, /(asus)-?(\w+)/i, /(microsoft); (lumia[\w ]+)/i, /(lenovo)[-_ ]?([-\w]+)/i, /(jolla)/i, /(oppo) ?([\w ]+) bui/i], [g, _, [u, m]], [/(kobo)\s(ereader|touch)/i, /(archos) (gamepad2?)/i, /(hp).+(touchpad(?!.+tablet)|tablet)/i, /(kindle)\/([\w\.]+)/i, /(nook)[\w ]+build\/(\w+)/i, /(dell) (strea[kpr\d ]*[\dko])/i, /(le[- ]+pan)[- ]+(\w{1,9}) bui/i, /(trinity)[- ]*(t\d{3}) bui/i, /(gigaset)[- ]+(q\w{1,9}) bui/i, /(vodafone) ([\w ]+)(?:\)| bui)/i], [g, _, [u, $]], [/(surface duo)/i], [_, [g, b], [u, $]], [/droid [\d\.]+; (fp\du?)(?: b|\))/i], [_, [g, "Fairphone"], [u, m]], [/(u304aa)/i], [_, [g, "AT&T"], [u, m]], [/\bsie-(\w*)/i], [_, [g, "Siemens"], [u, m]], [/\b(rct\w+) b/i], [_, [g, "RCA"], [u, $]], [/\b(venue[\d ]{2,7}) b/i], [_, [g, "Dell"], [u, $]], [/\b(q(?:mv|ta)\w+) b/i], [_, [g, "Verizon"], [u, $]], [/\b(?:barnes[& ]+noble |bn[rt])([\w\+ ]*) b/i], [_, [g, "Barnes & Noble"], [u, $]], [/\b(tm\d{3}\w+) b/i], [_, [g, "NuVision"], [u, $]], [/\b(k88) b/i], [_, [g, "ZTE"], [u, $]], [/\b(nx\d{3}j) b/i], [_, [g, "ZTE"], [u, m]], [/\b(gen\d{3}) b.+49h/i], [_, [g, "Swiss"], [u, m]], [/\b(zur\d{3}) b/i], [_, [g, "Swiss"], [u, $]], [/\b((zeki)?tb.*\b) b/i], [_, [g, "Zeki"], [u, $]], [/\b([yr]\d{2}) b/i, /\b(dragon[- ]+touch |dt)(\w{5}) b/i], [[g, "Dragon Touch"], _, [u, $]], [/\b(ns-?\w{0,9}) b/i], [_, [g, "Insignia"], [u, $]], [/\b((nxa|next)-?\w{0,9}) b/i], [_, [g, "NextBook"], [u, $]], [/\b(xtreme\_)?(v(1[045]|2[015]|[3469]0|7[05])) b/i], [[g, "Voice"], _, [u, m]], [/\b(lvtel\-)?(v1[12]) b/i], [[g, "LvTel"], _, [u, m]], [/\b(ph-1) /i], [_, [g, "Essential"], [u, m]], [/\b(v(100md|700na|7011|917g).*\b) b/i], [_, [g, "Envizen"], [u, $]], [/\b(trio[-\w\. ]+) b/i], [_, [g, "MachSpeed"], [u, $]], [/\btu_(1491) b/i], [_, [g, "Rotor"], [u, $]], [/(shield[\w ]+) b/i], [_, [g, "Nvidia"], [u, $]], [/(sprint) (\w+)/i], [g, _, [u, m]], [/(kin\.[onetw]{3})/i], [[_, /\./g, " "], [g, b], [u, m]], [/droid.+; (cc6666?|et5[16]|mc[239][23]x?|vc8[03]x?)\)/i], [_, [g, ee], [u, $]], [/droid.+; (ec30|ps20|tc[2-8]\d[kx])\)/i], [_, [g, ee], [u, m]], [/smart-tv.+(samsung)/i], [g, [u, v]], [/hbbtv.+maple;(\d+)/i], [[_, /^/, "SmartTV"], [g, j], [u, v]], [/(nux; netcast.+smarttv|lg (netcast\.tv-201\d|android tv))/i], [[g, Te], [u, v]], [/(apple) ?tv/i], [g, [_, A + " TV"], [u, v]], [/crkey/i], [[_, F + "cast"], [g, he], [u, v]], [/droid.+aft(\w+)( bui|\))/i], [_, [g, w], [u, v]], [/\(dtv[\);].+(aquos)/i, /(aquos-tv[\w ]+)\)/i], [_, [g, Q], [u, v]], [/(bravia[\w ]+)( bui|\))/i], [_, [g, te], [u, v]], [/(mitv-\w{5}) bui/i], [_, [g, ae], [u, v]], [/Hbbtv.*(technisat) (.*);/i], [g, _, [u, v]], [/\b(roku)[\dx]*[\)\/]((?:dvp-)?[\d\.]*)/i, /hbbtv\/\d+\.\d+\.\d+ +\([\w\+ ]*; *([\w\d][^;]*);([^;]*)/i], [[g, ye], [_, ye], [u, v]], [/\b(android tv|smart[- ]?tv|opera tv|tv; rv:)\b/i], [[u, v]], [/(ouya)/i, /(nintendo) ([wids3utch]+)/i], [g, _, [u, i]], [/droid.+; (shield) bui/i], [_, [g, "Nvidia"], [u, i]], [/(playstation [345portablevi]+)/i], [_, [g, te], [u, i]], [/\b(xbox(?: one)?(?!; xbox))[\); ]/i], [_, [g, b], [u, i]], [/((pebble))app/i], [g, _, [u, N]], [/(watch)(?: ?os[,\/]|\d,\d\/)[\d\.]+/i], [_, [g, A], [u, N]], [/droid.+; (glass) \d/i], [_, [g, he], [u, N]], [/droid.+; (wt63?0{2,3})\)/i], [_, [g, ee], [u, N]], [/(quest( \d| pro)?)/i], [_, [g, re], [u, N]], [/(tesla)(?: qtcarbrowser|\/[-\w\.]+)/i], [g, [u, C]], [/(aeobc)\b/i], [_, [g, w], [u, C]], [/droid .+?; ([^;]+?)(?: bui|; wv\)|\) applew).+? mobile safari/i], [_, [u, m]], [/droid .+?; ([^;]+?)(?: bui|\) applew).+?(?! mobile) safari/i], [_, [u, $]], [/\b((tablet|tab)[;\/]|focus\/\d(?!.+mobile))/i], [[u, $]], [/(phone|mobile(?:[;\/]| [ \w\/\.]*safari)|pda(?=.+windows ce))/i], [[u, m]], [/(android[-\w\. ]{0,9});.+buil/i], [_, [g, "Generic"]]], engine: [[/windows.+ edge\/([\w\.]+)/i], [h, [y, "EdgeHTML"]], [/webkit\/537\.36.+chrome\/(?!27)([\w\.]+)/i], [h, [y, "Blink"]], [/(presto)\/([\w\.]+)/i, /(webkit|trident|netfront|netsurf|amaya|lynx|w3m|goanna)\/([\w\.]+)/i, /ekioh(flow)\/([\w\.]+)/i, /(khtml|tasman|links)[\/ ]\(?([\w\.]+)/i, /(icab)[\/ ]([23]\.[\d\.]+)/i, /\b(libweb)/i], [y, h], [/rv\:([\w\.]{1,9})\b.+(gecko)/i], [h, y]], os: [[/microsoft (windows) (vista|xp)/i], [y, h], [/(windows (?:phone(?: os)?|mobile))[\/ ]?([\d\.\w ]*)/i], [y, [h, Oe, Qe]], [/windows nt 6\.2; (arm)/i, /windows[\/ ]?([ntce\d\. ]+\w)(?!.+xbox)/i, /(?:win(?=3|9|n)|win 9x )([nt\d\.]+)/i], [[h, Oe, Qe], [y, "Windows"]], [/ip[honead]{2,4}\b(?:.*os ([\w]+) like mac|; opera)/i, /(?:ios;fbsv\/|iphone.+ios[\/ ])([\d\.]+)/i, /cfnetwork\/.+darwin/i], [[h, /_/g, "."], [y, "iOS"]], [/(mac os x) ?([\w\. ]*)/i, /(macintosh|mac_powerpc\b)(?!.+haiku)/i], [[y, qe], [h, /_/g, "."]], [/droid ([\w\.]+)\b.+(android[- ]x86|harmonyos)/i], [h, y], [/(android|webos|qnx|bada|rim tablet os|maemo|meego|sailfish)[-\/ ]?([\w\.]*)/i, /(blackberry)\w*\/([\w\.]*)/i, /(tizen|kaios)[\/ ]([\w\.]+)/i, /\((series40);/i], [y, h], [/\(bb(10);/i], [h, [y, E]], [/(?:symbian ?os|symbos|s60(?=;)|series60)[-\/ ]?([\w\.]*)/i], [h, [y, "Symbian"]], [/mozilla\/[\d\.]+ \((?:mobile|tablet|tv|mobile; [\w ]+); rv:.+ gecko\/([\w\.]+)/i], [h, [y, q + " OS"]], [/web0s;.+rt(tv)/i, /\b(?:hp)?wos(?:browser)?\/([\w\.]+)/i], [h, [y, "webOS"]], [/watch(?: ?os[,\/]|\d,\d\/)([\d\.]+)/i], [h, [y, "watchOS"]], [/crkey\/([\d\.]+)/i], [h, [y, F + "cast"]], [/(cros) [\w]+(?:\)| ([\w\.]+)\b)/i], [[y, J], h], [/panasonic;(viera)/i, /(netrange)mmh/i, /(nettv)\/(\d+\.[\w\.]+)/i, /(nintendo|playstation) ([wids345portablevuch]+)/i, /(xbox); +xbox ([^\);]+)/i, /\b(joli|palm)\b ?(?:os)?\/?([\w\.]*)/i, /(mint)[\/\(\) ]?(\w*)/i, /(mageia|vectorlinux)[; ]/i, /([kxln]?ubuntu|debian|suse|opensuse|gentoo|arch(?= linux)|slackware|fedora|mandriva|centos|pclinuxos|red ?hat|zenwalk|linpus|raspbian|plan 9|minix|risc os|contiki|deepin|manjaro|elementary os|sabayon|linspire)(?: gnu\/linux)?(?: enterprise)?(?:[- ]linux)?(?:-gnu)?[-\/ ]?(?!chrom|package)([-\w\.]*)/i, /(hurd|linux) ?([\w\.]*)/i, /(gnu) ?([\w\.]*)/i, /\b([-frentopcghs]{0,5}bsd|dragonfly)[\/ ]?(?!amd|[ix346]{1,2}86)([\w\.]*)/i, /(haiku) (\w+)/i], [y, h], [/(sunos) ?([\w\.\d]*)/i], [[y, "Solaris"], h], [/((?:open)?solaris)[-\/ ]?([\w\.]*)/i, /(aix) ((\d)(?=\.|\)| )[\w\.])*/i, /\b(beos|os\/2|amigaos|morphos|openvms|fuchsia|hp-ux|serenityos)/i, /(unix) ?([\w\.]*)/i], [y, h]] }, ve = function(Y, de) {
      if (typeof Y === l && (de = Y, Y = a), !(this instanceof ve))
        return new ve(Y, de).getResult();
      var B = typeof o !== s && o.navigator ? o.navigator : a, $e = Y || (B && B.userAgent ? B.userAgent : ""), Ne = B && B.userAgentData ? B.userAgentData : a, K = de ? function(M, _e) {
        var je = {};
        for (var O in M)
          _e[O] && _e[O].length % 2 == 0 ? je[O] = _e[O].concat(M[O]) : je[O] = M[O];
        return je;
      }(Pn, de) : Pn, ke = B && B.userAgent == $e;
      return this.getBrowser = function() {
        var M, _e = {};
        return _e[y] = a, _e[h] = a, pe.call(_e, $e, K.browser), _e[p] = typeof (M = _e[h]) === f ? M.replace(/[^\d\.]/g, "").split(".")[0] : a, ke && B && B.brave && typeof B.brave.isBrave == d && (_e[y] = "Brave"), _e;
      }, this.getCPU = function() {
        var M = {};
        return M[c] = a, pe.call(M, $e, K.cpu), M;
      }, this.getDevice = function() {
        var M = {};
        return M[g] = a, M[_] = a, M[u] = a, pe.call(M, $e, K.device), ke && !M[u] && Ne && Ne.mobile && (M[u] = m), ke && M[_] == "Macintosh" && B && typeof B.standalone !== s && B.maxTouchPoints && B.maxTouchPoints > 2 && (M[_] = "iPad", M[u] = $), M;
      }, this.getEngine = function() {
        var M = {};
        return M[y] = a, M[h] = a, pe.call(M, $e, K.engine), M;
      }, this.getOS = function() {
        var M = {};
        return M[y] = a, M[h] = a, pe.call(M, $e, K.os), ke && !M[y] && Ne && Ne.platform && Ne.platform != "Unknown" && (M[y] = Ne.platform.replace(/chrome os/i, J).replace(/macos/i, qe)), M;
      }, this.getResult = function() {
        return { ua: this.getUA(), browser: this.getBrowser(), engine: this.getEngine(), os: this.getOS(), device: this.getDevice(), cpu: this.getCPU() };
      }, this.getUA = function() {
        return $e;
      }, this.setUA = function(M) {
        return $e = typeof M === f && M.length > 500 ? ye(M, 500) : M, this;
      }, this.setUA($e), this;
    };
    ve.VERSION = "1.0.38", ve.BROWSER = Be([y, h, p]), ve.CPU = Be([c]), ve.DEVICE = Be([_, g, u, i, m, v, $, N, C]), ve.ENGINE = ve.OS = Be([y, h]), typeof e !== s ? (n.exports && (e = n.exports = ve), e.UAParser = ve) : t.amdO ? (r = (function() {
      return ve;
    }).call(e, t, e, n)) === a || (n.exports = r) : typeof o !== s && (o.UAParser = ve);
    var We = typeof o !== s && (o.jQuery || o.Zepto);
    if (We && !We.ua) {
      var sn = new ve();
      We.ua = sn.getResult(), We.ua.get = function() {
        return sn.getUA();
      }, We.ua.set = function(Y) {
        sn.setUA(Y);
        var de = sn.getResult();
        for (var B in de)
          We.ua[B] = de[B];
      };
    }
  })(typeof window == "object" ? window : this);
} }, Er = {};
function oe(n) {
  var e = Er[n];
  if (e !== void 0)
    return e.exports;
  var t = Er[n] = { exports: {} };
  return R3[n].call(t.exports, t, t.exports, oe), t.exports;
}
oe.amdO = {}, oe.d = (n, e) => {
  for (var t in e)
    oe.o(e, t) && !oe.o(n, t) && Object.defineProperty(n, t, { enumerable: !0, get: e[t] });
}, oe.o = (n, e) => Object.prototype.hasOwnProperty.call(n, e);
var T = {};
(() => {
  oe.d(T, { k3: () => $.k, pP: () => d.p, hx: () => l.h, eC: () => p.eC, _Y: () => h._Y, mQ: () => h.mQ, _N: () => y._N, By: () => h.By, DL: () => y.DL, GV: () => e.G, hT: () => y.hT, c_: () => u.c, $b: () => g.$b, Vy: () => g.Vy, XG: () => f.X, i8: () => A, R0: () => N.R0, j7: () => N.j7, Hn: () => m, rE: () => c.r, Sr: () => t.S, w4: () => r.w, $y: () => w, _3: () => i, Hj: () => o.H, qk: () => C.qk, Zc: () => p.Zc, BK: () => p.BK, _K: () => p.Hn, mg: () => v.m, l1: () => s.l, R2: () => C.R2, U1: () => C.U1, Zu: () => a.Z, S3: () => p.S3, Q: () => p.Q, ir: () => _.i, Nq: () => p.Nq, mw: () => p.mw, Bd: () => p.Bd, UP: () => p.UP, xM: () => C.xM, un: () => p.un, gr: () => C.gr, IX: () => p.IX, Fr: () => p.Fr, KW: () => p.KW, C6: () => p.C6, a9: () => p.a9, cH: () => C.cH, JO: () => C.JO, wh: () => p.wh, zg: () => C.zg, F8: () => N.F8, $l: () => N.$l, Nk: () => N.Nk, RQ: () => p.RQ, pM: () => p.pM, uo: () => p.uo, m: () => p.m, _w: () => g._w, n2: () => g.n2, de: () => g.de, W3: () => g.W3, D7: () => n.D7, SX: () => n.SX, yy: () => n.yy, Fh: () => y.Fh, JT: () => C.JT });
  var n = oe(977), e = oe(196), t = oe(401), r = oe(276), o = oe(884), a = oe(856), d = oe(516), s = oe(396), l = oe(348), f = oe(362), p = oe(109), _ = oe(496), y = oe(890), u = oe(584), g = oe(152), h = oe(70), c = oe(988);
  class i {
    constructor() {
    }
    static findFirstMatchingUrlStringSearchParamIgnoreError(E, x, F) {
      try {
        const q = new URL(E);
        return i.findFirstMatchingUrlSearchParam(q, x, F);
      } catch {
        return;
      }
    }
    static findFirstMatchingUrlStringSearchParam(E, x, F) {
      const q = new URL(E);
      return i.findFirstMatchingUrlSearchParam(q, x, F);
    }
    static findFirstMatchingUrlSearchParam(E, x, F) {
      for (const q of x) {
        const he = E.searchParams.get(q);
        if (he !== null && (F || he !== ""))
          return he;
      }
    }
    static navigateToPageWithUrlString(E) {
      let x = !1;
      if (p.eC.isWechatMiniProgramWebView()) {
        const F = window.wx;
        F !== void 0 && F.miniProgram && F.miniProgram.navigateTo && (E.method === "replace" ? F.miniProgram.redirectTo({ url: E.url }) : F.miniProgram.navigateTo({ url: E.url }), x = !0);
      }
      x || (E.method === "replace" ? window.location.replace(E.url) : window.location.href = E.url);
    }
    static safeNavigateToPageWithUrlString(E) {
      E.safeUrlValidator.isSafeUrlString(E.url) ? i.navigateToPageWithUrlString({ url: E.url, method: E.method }) : E.safeUrl && i.navigateToPageWithUrlString({ url: E.safeUrl, method: E.method });
    }
    static parseToURLStringIgnoreError(E) {
      try {
        return i.parseToURLString(E);
      } catch {
        return;
      }
    }
    static parseToURLString(E) {
      return typeof E == "string" ? new URL(E).href : E instanceof URL ? E.href : void 0;
    }
    static parseToURLIgnoreError(E) {
      try {
        return i.parseToURL(E);
      } catch {
        return null;
      }
    }
    static parseToURL(E) {
      return typeof E == "string" ? new URL(E) : E instanceof URL ? E : null;
    }
  }
  class m {
    constructor(E) {
      this._allowHosts = E;
    }
    isSafeUrl(E) {
      for (const x of this._allowHosts)
        if (E.host === x || E.host.endsWith(`.${x}`))
          return !0;
      return !1;
    }
    isSafeUrlString(E) {
      try {
        const x = new URL(E);
        return this.isSafeUrl(x);
      } catch {
        return !1;
      }
    }
  }
  var $ = oe(954), v = oe(782), N = oe(590), C = oe(372);
  class w {
    constructor() {
    }
    static getStringValueIgnoreError(E) {
      return typeof E == "string" ? E : void 0;
    }
    static getBooleanValueIgnoreError(E) {
      return typeof E == "boolean" ? E : void 0;
    }
    static getNumberValueIgnoreError(E) {
      return typeof E == "number" ? E : void 0;
    }
  }
  const A = "8.1.0";
})();
T.k3;
T.pP;
T.hx;
T.eC;
T._Y;
T.mQ;
T._N;
var Gn = T.By;
T.DL;
T.GV;
T.hT;
T.c_;
T.$b;
T.Vy;
T.XG;
T.i8;
T.R0;
T.j7;
T.Hn;
T.rE;
T.Sr;
T.w4;
T.$y;
T._3;
T.Hj;
T.qk;
T.Zc;
T.BK;
T._K;
T.mg;
T.l1;
T.R2;
T.U1;
T.Zu;
T.S3;
T.Q;
T.ir;
T.Nq;
T.mw;
T.Bd;
T.UP;
T.xM;
T.un;
T.gr;
T.IX;
T.Fr;
T.KW;
T.C6;
T.a9;
T.cH;
T.JO;
T.wh;
T.zg;
T.F8;
T.$l;
T.Nk;
T.RQ;
T.pM;
T.uo;
T.m;
T._w;
T.n2;
T.de;
T.W3;
T.D7;
T.SX;
T.yy;
T.Fh;
T.JT;
const P3 = "web_yunpan_login", L3 = {
  web_login_page_click(n) {
  },
  web_login_request(n) {
  },
  web_email_login_page_click(n) {
  },
  web_email_register_page_click(n) {
  },
  web_email_login_page_show(n) {
  },
  web_email_register_page_show(n) {
  },
  qrcode_page_show(n) {
  },
  qrcode_page_click(n) {
  },
  web_phone_login_code_sending_result(n) {
  },
  web_login_fail(n) {
  },
  web_login_success(n) {
  }
}, V = new Proxy(L3, {
  get: (n, e) => (t) => {
    var r;
    return (
      // @ts-ignore
      (r = window.stat) == null ? void 0 : r.call(window, P3, e, t)
    );
  }
}), x3 = { class: "qr-code-box" }, M3 = { class: "code-container" }, D3 = ["src"], F3 = {
  key: 1,
  class: "cover"
}, U3 = {
  key: 0,
  class: "loading-pane"
}, G3 = {
  key: 1,
  class: "error-pane"
}, B3 = { class: "refresh-box" }, j3 = {
  key: 2,
  class: "success-pane"
}, H3 = { class: "describe-text" }, V3 = /* @__PURE__ */ le({
  __name: "QRCodeLogin",
  props: {
    client: {},
    authInfo: {}
  },
  emits: ["command"],
  setup(n, { emit: e }) {
    const t = me.global.t, r = n, o = e, a = ne(
      "loading"
      /* LOADING */
    ), d = ne(""), s = ne(""), l = async () => {
      try {
        V.qrcode_page_click({ button: "refresh" }), a.value = "loading";
        const p = r.client;
        p.stopDeviceAuthorization(), p.on(
          Qt.DEVICE_AUTHORIZATION,
          (u, g) => {
            var c;
            Array.isArray(g == null ? void 0 : g.details) && // eslint-disable-next-line
            g.details.length > 0 && (s.value = (c = g.details.pop()) == null ? void 0 : c.message), !s.value && (g != null && g.error_description) && (s.value = g == null ? void 0 : g.error_description);
            const h = g == null ? void 0 : g.error;
            if (h === Gn.AUTHORIZATION_PENDING) {
              let i = "WAITING_CONNECT";
              g != null && g.details && g.details.length > 0 && g.details[0].state && (i = g.details[0].state, V.web_login_fail({
                login_type: "qrcode",
                error: g,
                errorcode: s.value,
                emphasize_mode: X()
              })), i === "WAITING_CONSENT" && (a.value = "scan_success", V.web_login_request({
                login_type: "qrcode",
                emphasize_mode: X()
              }));
            }
            [Gn.EXPIRED_TOKEN, Gn.ACCESS_DENIED].includes(h) && (a.value = "error");
          }
        );
        const _ = await p.startDeviceAuthorization({
          scope: "user"
        });
        a.value = "scanning";
        const y = await I3(_.url);
        d.value = y || d.value;
      } catch (p) {
        s.value = t("vJvlwMy1A7SGoS1JggM9"), a.value = "error", console.warn("get qr code error", p);
      }
    }, f = ne(!1);
    return $n(() => l()), r.client.on(Qt.LOGIN_SUCCESS, () => {
      f.value = !0, o("command", { type: D.GOTO_ROUTER_BACK }), V.web_login_success({
        login_type: "qrcode",
        emphasize_mode: X()
      });
    }), Rt(() => {
      f.value && (l(), f.value = !1);
    }), (p, _) => (P(), L("div", x3, [
      k("div", M3, [
        d.value ? (P(), L("img", {
          key: 0,
          draggable: "false",
          src: d.value,
          class: "qr-code",
          alt: "qr-code"
        }, null, 8, D3)) : ge("", !0),
        a.value !== "scanning" ? (P(), L("div", F3, [
          a.value === "loading" ? (P(), L("div", U3, _[0] || (_[0] = [
            k("div", { class: "icon-loading" }, null, -1)
          ]))) : ge("", !0),
          a.value == "error" ? (P(), L("div", G3, [
            k("div", null, G(s.value), 1),
            k("div", B3, [
              k("span", null, G(R(t)("2Grb84h1MnUjxpxr7IQi")), 1),
              k("span", {
                class: "refresh-text-button",
                role: "button",
                onClick: l
              }, G(R(t)("6MhbexHdGc37PjQ7Tp15")), 1)
            ])
          ])) : ge("", !0),
          a.value == "scan_success" ? (P(), L("div", j3, [
            _[1] || (_[1] = k("div", { class: "icon-success" }, null, -1)),
            k("div", null, G(R(t)("gJaP_0qRfiU9zNb2Hs2y")), 1),
            k("div", null, G(R(t)("as230x12lSDF02LSD1dw")), 1)
          ])) : ge("", !0)
        ])) : ge("", !0)
      ]),
      k("div", H3, G(R(t)("mOAooQeZeCWt2a0swZlQ9")), 1)
    ]));
  }
}), z3 = /* @__PURE__ */ ue(V3, [["__scopeId", "data-v-6d0a51b3"]]), K3 = { class: "agreement" }, q3 = { class: "agreement-content" }, Q3 = ["href"], W3 = ["href"], Z3 = /* @__PURE__ */ le({
  __name: "Agreement",
  setup(n) {
    const e = me.global.t;
    return (t, r) => (P(), L("div", K3, [
      k("div", q3, [
        Fe(G(R(e)("guAsn6e2xbK3Raw9gokY")), 1),
        r[0] || (r[0] = k("br", null, null, -1)),
        k("a", {
          href: `${R(Qn)()}/policy/user-agreement`,
          target: "_blank",
          class: "agreement-content__link"
        }, G(R(e)("tWlnmAbJ1f4Tv3Iuoht8")), 9, Q3),
        Fe(" " + G(R(e)("lyNVvA9ZvxGiyb7W_8Mz0")) + " ", 1),
        k("a", {
          href: `${R(Qn)()}/policy/privacy-policy`,
          target: "_blank",
          class: "agreement-content__link"
        }, G(R(e)("i7t4qmC3l0Qrx1f3Vhhh4")), 9, W3)
      ])
    ]));
  }
}), J3 = /* @__PURE__ */ ue(Z3, [["__scopeId", "data-v-13192857"]]), Y3 = { class: "login-footer" }, X3 = {
  key: 0,
  class: "footer-operator"
}, e4 = ["onClick"], n4 = {
  key: 1,
  class: "footer-info"
}, t4 = /* @__PURE__ */ le({
  __name: "LoginFooter",
  props: {
    showAgreement: { type: Boolean, default: !0 },
    quickOperations: {}
  },
  emits: ["command"],
  setup(n, { emit: e }) {
    const t = n, r = e, o = be(
      () => xo.filter((a) => t.quickOperations.includes(a.type))
    );
    return (a, d) => (P(), L("div", Y3, [
      o.value.length > 0 ? (P(), L("div", X3, [
        (P(!0), L(Ue, null, Tn(o.value, (s, l) => (P(), L("div", {
          key: s.action + l,
          class: "quick-operation",
          role: "button",
          onClick: (f) => r("command", { type: s.action })
        }, [
          k("div", {
            class: Ie(s.iconClass)
          }, null, 2)
        ], 8, e4))), 128))
      ])) : ge("", !0),
      a.showAgreement ? (P(), L("div", n4, [
        W(J3)
      ])) : ge("", !0)
    ]));
  }
}), r4 = /* @__PURE__ */ ue(t4, [["__scopeId", "data-v-a8444cfa"]]), o4 = {
  key: 0,
  class: "loading-mask"
}, d4 = /* @__PURE__ */ le({
  __name: "Loading",
  props: {
    isLoading: { type: Boolean, default: !1 }
  },
  setup(n) {
    const e = n;
    return (t, r) => e.isLoading ? (P(), L("div", o4, r[0] || (r[0] = [
      k("div", { class: "loading-back" }, null, -1),
      k("div", { class: "loading-main" }, null, -1)
    ]))) : ge("", !0);
  }
}), a4 = /* @__PURE__ */ ue(d4, [["__scopeId", "data-v-7953caaf"]]), i4 = "data:image/png;base64,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", s4 = {
  key: 0,
  class: "open-cover"
}, c4 = { class: "content-box" }, l4 = { class: "content-box__item" }, u4 = {
  key: 0,
  class: "content-box__item"
}, h4 = { key: 0 }, g4 = {
  key: 1,
  class: "content-box__item"
}, f4 = { key: 0 }, m4 = { class: "content-box__item" }, p4 = /* @__PURE__ */ le({
  __name: "OpenCover",
  setup(n, { expose: e }) {
    const t = me.global.t, r = ne(!1), o = be(() => me.global.locale.value);
    e({
      show: () => r.value = !0,
      hide: () => r.value = !1
    });
    const s = (l) => {
      var p;
      ((p = l.target) == null ? void 0 : p.classList.contains(
        "open-cover"
      )) && (r.value = !1), l.stopPropagation();
    };
    return $n(() => document.addEventListener("click", s)), Eo(
      () => document.removeEventListener("click", s)
    ), (l, f) => r.value ? (P(), L("div", s4, [
      f[5] || (f[5] = k("img", {
        src: i4,
        class: "arrowhead-image",
        alt: "arrowhead-image"
      }, null, -1)),
      k("div", c4, [
        k("div", l4, [
          f[0] || (f[0] = k("i", { class: "icon-index" }, "1", -1)),
          k("span", null, G(R(t)("kkv6uGohTOyATz9IDzOdr")), 1)
        ]),
        R(wl)() ? (P(), L("div", u4, [
          f[1] || (f[1] = k("i", { class: "icon-index" }, "2", -1)),
          k("span", null, G(R(t)("eYnpkZMyeXCFgjyMfaTh")), 1),
          f[2] || (f[2] = k("i", { class: "icon icon-safari" }, null, -1)),
          o.value !== "ko" ? (P(), L("span", h4, '"')) : ge("", !0)
        ])) : (P(), L("div", g4, [
          f[3] || (f[3] = k("i", { class: "icon-index" }, "2", -1)),
          k("span", null, G(R(t)("fFdV8SvrG9_5ZuRy5GVd")), 1),
          o.value !== "ko" ? (P(), L("span", f4, '"')) : ge("", !0)
        ])),
        k("div", m4, [
          f[4] || (f[4] = k("i", { class: "icon-index" }, "3", -1)),
          k("span", null, G(R(t)("jxXRc1FxLoCdUtSsyzOf")), 1)
        ])
      ])
    ])) : ge("", !0);
  }
}), $4 = /* @__PURE__ */ ue(p4, [["__scopeId", "data-v-841fe623"]]);
function we(n, e, t, r) {
  if (t === "a" && !r)
    throw new TypeError("Private accessor was defined without a getter");
  if (typeof e == "function" ? n !== e || !r : !e.has(n))
    throw new TypeError("Cannot read private member from an object whose class did not declare it");
  return t === "m" ? r : t === "a" ? r.call(n) : r ? r.value : e.get(n);
}
function Mn(n, e, t, r, o) {
  if (typeof e == "function" ? n !== e || !0 : !e.has(n))
    throw new TypeError("Cannot write private member to an object whose class did not declare it");
  return e.set(n, t), t;
}
var Bn, Nn, Me, Tt, Cn, ho, go;
class _4 {
  constructor(e, t, r) {
    Bn.add(this), Nn.set(this, void 0), Me.set(this, ""), Tt.set(this, {}), Cn.set(this, []), Mn(this, Nn, e), Mn(this, Me, t), Mn(this, Tt, r || {}), window.addEventListener("message", (o) => {
      try {
        ((typeof we(this, Me, "f") == "string" ? o.origin === we(this, Me, "f") : we(this, Me, "f").includes(o.origin)) || we(this, Me, "f") === "*") && we(this, Cn, "f").forEach((a) => {
          const d = we(this, Bn, "m", go).call(this, o.data);
          d && a(d);
        });
      } catch (a) {
        console.error("process received message error: ", a);
      }
    });
  }
  addListener(e) {
    we(this, Cn, "f").push(e);
  }
  clearListeners() {
    Mn(this, Cn, []);
  }
  postMessage(e) {
    try {
      (typeof we(this, Me, "f") == "string" ? [we(this, Me, "f")] : we(this, Me, "f")).forEach((t) => {
        we(this, Nn, "f").postMessage(we(this, Bn, "m", ho).call(this, e), t);
      });
    } catch (t) {
      console.error(`[post message to ${we(this, Nn, "f")} error: ]`, t);
    }
  }
}
Nn = /* @__PURE__ */ new WeakMap(), Me = /* @__PURE__ */ new WeakMap(), Tt = /* @__PURE__ */ new WeakMap(), Cn = /* @__PURE__ */ new WeakMap(), Bn = /* @__PURE__ */ new WeakSet(), ho = function({ type: n, data: e }) {
  try {
    let t = { type: n, data: e, _PikPak_Application: !0 };
    return typeof e == "object" && e != null && (t = Object.assign(Object.assign({}, t), { data: JSON.stringify(e) })), JSON.stringify(t);
  } catch (t) {
    return console.error("[serialize data error: ]", t), JSON.stringify({ type: "", data: "" });
  }
}, go = function(n) {
  const e = { type: "", data: {} };
  try {
    if (!/_PikPak_Application/i.test(n))
      return;
    if (!n || typeof n != "string")
      return e;
    const t = JSON.parse(n);
    if (typeof t.data == "string" && /^{.+}$/i.test(t.data))
      try {
        t.data = JSON.parse(t.data);
      } catch {
        console.warn("parse message.data error.");
      }
    return delete t._PikPak_Application, t;
  } catch (t) {
    return console.error("[deserialize data error: ]", t), e;
  }
};
const y4 = "data:image/png;base64,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", v4 = "data:image/png;base64,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", N4 = /* @__PURE__ */ le({
  __name: "Button",
  emits: ["click"],
  setup(n, { emit: e }) {
    const t = e;
    return (r, o) => (P(), L("div", {
      class: "primary-button",
      onClick: o[0] || (o[0] = (a) => t("click"))
    }, [
      Re(r.$slots, "default", {}, void 0, !0)
    ]));
  }
}), fo = /* @__PURE__ */ ue(N4, [["__scopeId", "data-v-88588336"]]), C4 = { class: "auth-dialog" }, b4 = {
  key: 0,
  src: y4,
  alt: "auth-logo",
  class: "auth-logo"
}, w4 = {
  key: 1,
  src: v4,
  alt: "auth-logo",
  class: "auth-logo"
}, E4 = { class: "auth-describe" }, A4 = { class: "auth-describe__title" }, O4 = { class: "auth-describe__subtitle" }, S4 = { class: "auth-box" }, T4 = /* @__PURE__ */ le({
  __name: "PcOauthDialog",
  props: {
    authKind: {},
    cancelHandler: { type: Function }
  },
  setup(n) {
    const e = n;
    return (t, r) => (P(), L("div", C4, [
      t.authKind === "Google" ? (P(), L("img", b4)) : ge("", !0),
      t.authKind === "Facebook" ? (P(), L("img", w4)) : ge("", !0),
      k("div", E4, [
        k("div", A4, G(R(ln)("i0qzQnQhDvQTuSYzEvHd")()), 1),
        k("div", O4, G(R(ln)("yyHu3EkYTxXy2aMczGocn")()), 1)
      ]),
      k("div", S4, [
        W(fo, {
          onClick: r[0] || (r[0] = () => {
            var o;
            return (o = e.cancelHandler) == null ? void 0 : o.call(e);
          })
        }, {
          default: fe(() => [
            Fe(G(R(ln)("bbyavRuUbj025YpODbm1S")()), 1)
          ]),
          _: 1
        })
      ])
    ]));
  }
}), k4 = /* @__PURE__ */ ue(T4, [["__scopeId", "data-v-6246db29"]]), I4 = { class: "timeout-dialog" }, R4 = { class: "timeout-describe" }, P4 = { class: "timeout-describe__title" }, L4 = { class: "timeout-describe__subtitle" }, x4 = { class: "timeout-box" }, M4 = /* @__PURE__ */ le({
  __name: "TimeoutDialog",
  props: {
    continueHandler: { type: Function }
  },
  setup(n) {
    const e = n;
    return (t, r) => (P(), L("div", I4, [
      k("div", R4, [
        k("div", P4, G(R(ln)("vkN9TkHnIgJlFrVsw7bq")()), 1),
        k("div", L4, G(R(ln)("juspWzUyy57Ij3Oxe5Hyb")()), 1)
      ]),
      k("div", x4, [
        W(fo, {
          onClick: r[0] || (r[0] = () => {
            var o;
            return (o = e.continueHandler) == null ? void 0 : o.call(e);
          })
        }, {
          default: fe(() => [
            Fe(G(R(ln)("rKg0YrFdCcho96B04NnK")()), 1)
          ]),
          _: 1
        })
      ])
    ]));
  }
}), D4 = /* @__PURE__ */ ue(M4, [["__scopeId", "data-v-67d80a4d"]]);
let jn, Dn, wn = !1, kt = null;
const ht = () => {
  wn && (document.body.removeChild(jn), wn = !1, kt && clearTimeout(kt));
}, F4 = (n) => {
  if (wn)
    return { close: ht };
  const e = () => {
    const r = () => {
      window.login_component_waiting_auth = !1, n == null || n.cancelHandler();
    };
    window.login_component_hide_dialog = r;
    const o = W(k4, { ...n, cancelHandler: r });
    jn = document.createElement("div"), Kt(o, jn), document.body.appendChild(jn), wn = !0;
    const a = 5 * 60 * 1e3;
    kt = setTimeout(() => wn && t(), a), window.login_component_waiting_auth = !0;
  }, t = () => {
    ht();
    const r = () => document.body.removeChild(Dn), o = W(D4, { continueHandler: r });
    window.login_component_hide_dialog = r, Dn = document.createElement("div"), Kt(o, Dn), document.body.appendChild(Dn), window.login_component_waiting_auth = !1;
  };
  return e(), { close: ht };
}, U4 = new _4(window.top, "*"), mo = Ir.map((n) => [
  // 正式环境
  `https://${n}`,
  `https://${n}/auth`,
  `https://${n}/drive/login`,
  `https://${n}/drive/payment`,
  // 测试环境
  `https://dev.${n}`,
  `https://dev.${n}/auth`,
  `https://dev.${n}/drive/login`,
  `https://dev.${n}/drive/payment`
]).flat();
mo.push("https://local.mypikpak.com/auth");
const G4 = () => {
  try {
    const n = window.location.origin + window.location.pathname;
    return mo.includes(n);
  } catch (n) {
    return console.error("[isAuthorizedPath: ] ", n), !1;
  }
}, B4 = async (n, e) => {
  var r, o, a, d;
  if (!G4()) {
    const s = window.encodeURIComponent(window.location.href);
    V.web_login_success({
      login_type: e,
      emphasize_mode: X()
    });
    const f = `${Qn()}/auth?origin=${encodeURIComponent(
      s
    )}&type=${e}&init=1`, p = new URLSearchParams(window.location.search);
    if (/plugin/i.test(p.get("env") || ""))
      window.open(
        f,
        "_blank",
        "width=800, height=640, toolbar=no, menubar=no, location=no, status=no, help=no, center=yes, scrollbars=yes, resizable=yes, minmizebutton=yes, maxmizebutton=yes"
      );
    else if (/(pc|mac)/i.test(p.get("env") || ""))
      try {
        (d = (a = (o = (r = window.require) == null ? void 0 : r.call(window, "electron")) == null ? void 0 : o.shell) == null ? void 0 : a.openExternal) == null || d.call(a, f);
        const { close: _ } = F4({
          authKind: e === "google" ? "Google" : "Facebook",
          cancelHandler: () => _(),
          continueHandler: () => {
            var y, u, g, h;
            (h = (g = (u = (y = window.require) == null ? void 0 : y.call(window, "electron")) == null ? void 0 : u.shell) == null ? void 0 : g.openExternal) == null || h.call(g, f);
          }
        });
      } catch (_) {
        console.error("try to use electron method open link error: ", _), window.open(
          f,
          "_blank",
          "width=800, height=640, toolbar=no, menubar=no, location=no, status=no, help=no, center=yes, scrollbars=yes, resizable=yes, minmizebutton=yes, maxmizebutton=yes"
        );
      }
    else
      window !== window.parent ? U4.postMessage({
        type: "pp-iframe-request-o-auth",
        data: { oAuthLink: f }
      }) : window.location.href = f;
    return;
  }
  const t = n.getInjectedConfig();
  if (e === "google")
    try {
      return await n.signInWithProvider({
        providerType: "google",
        providerId: t.googleProviderId || "google.com",
        redirectURI: location.href.split("?")[0]
      }), V.web_login_success({
        login_type: "google",
        emphasize_mode: X()
      }), "";
    } catch (s) {
      console.warn("handle oAuth sign in error: ", s);
      const l = en(s) || n.getTextByError(s);
      return V.web_login_fail({
        login_type: "google",
        error: s.error,
        errorcode: l,
        emphasize_mode: X()
      }), l;
    }
  if (e === "facebook")
    try {
      return V.web_login_success({
        login_type: "facebook",
        emphasize_mode: X()
      }), await n.signInWithProvider({
        providerType: "facebook",
        providerId: t.facebookProviderId || "facebook.v2.com",
        redirectURI: location.href.split("?")[0]
      }), "";
    } catch (s) {
      console.warn("handle oAuth sign in error: ", s);
      const l = en(s) || n.getTextByError(s);
      return V.web_login_fail({
        login_type: "facebook",
        error: s.error,
        errorcode: l,
        emphasize_mode: X()
      }), l;
    }
};
class j4 {
  constructor(e, t) {
    _n(this, "client");
    _n(this, "tracker", V);
    // 获取短信验证码返回的结果
    _n(this, "phoneVerificationResponseData", {});
    // 获取邮箱验证码返回的结果
    _n(this, "emailVerificationResponseData", {});
    this.tracker = t || V, this.client = e;
  }
  // 三方登录
  async handleOAuth(e) {
    return B4(this.client, e);
  }
  // 发送手机验证码
  async sendPhoneVerifyCode(e) {
    try {
      const t = await this.client.getVerification({
        getVerificationRequest: {
          phone_number: e,
          target: "ANY",
          usage: Wt.SIGN_IN,
          locale: me.global.locale.value
        },
        checkPhoneNumber: !0
      });
      return this.phoneVerificationResponseData = {
        verification_id: "",
        is_user: !1,
        ...t
      }, this.tracker.web_phone_login_code_sending_result({
        result: "success",
        error: "",
        errorcode: ""
      }), "";
    } catch (t) {
      console.warn("send verify code error: ", t);
      const r = en(t) || this.client.getTextByError(t);
      return this.tracker.web_phone_login_code_sending_result({
        result: "fail",
        error: t.error,
        errorcode: r
      }), r;
    }
  }
  // 手机验证码登录, 如果未注册, 自动注册并登录
  async signInByVerifyCode(e, t, r) {
    var o;
    try {
      const a = await this.client.verify({
        verification_id: (o = this.phoneVerificationResponseData) == null ? void 0 : o.verification_id,
        verification_code: t
      });
      return await this.client.signInOrSignUpByVerification({
        getVerificationResponse: this.phoneVerificationResponseData,
        verifyResponse: a,
        username: e,
        noCallingCodePhoneNumber: r,
        verification_code: t
      }), this.tracker.web_login_success({
        login_type: "phone",
        emphasize_mode: X()
      }), "";
    } catch (a) {
      console.warn("sign in by verify code error: ", a);
      const d = en(a) || this.client.getTextByError(a);
      return this.tracker.web_login_fail({
        login_type: "phone",
        error: a.error,
        errorcode: d,
        emphasize_mode: X()
      }), d;
    }
  }
  // 使用手机号&密码登录
  async signInByPassword(e, t) {
    try {
      const r = {
        signInRequest: {
          username: e,
          password: t
        }
      };
      return r.signInRequest.username = e, r.checkPassword = !0, await this.client.signIn(r), "";
    } catch (r) {
      return console.warn("sign in by password error: ", r), en(r) || this.client.getTextByError(r);
    }
  }
  // 邮箱账号登录
  async signInByEmail(e, t) {
    try {
      const r = {
        signInRequest: {
          username: e,
          password: t
        }
      };
      r.signInRequest.username = e, r.checkPassword = !0;
      const o = await this.client.signIn(r);
      return console.info("login result: ", o), this.tracker.web_login_success({
        login_type: "email",
        emphasize_mode: X()
      }), "";
    } catch (r) {
      console.warn("sign in by email error: ", r);
      const o = en(r) || this.client.getTextByError(r);
      return this.tracker.web_login_fail({
        login_type: "email",
        error: r.error,
        errorcode: o,
        emphasize_mode: X()
      }), o;
    }
  }
  // 发送邮箱验证码
  async sendEmailVerifyCode(e) {
    try {
      const t = await this.client.getVerification({
        getVerificationRequest: {
          email: e,
          target: "ANY",
          usage: Wt.REGISTER,
          locale: me.global.locale.value
        },
        checkEmail: !0
      });
      return this.emailVerificationResponseData = {
        verification_id: "",
        is_user: !1,
        ...t
      }, "";
    } catch (t) {
      return console.warn("send verify code error: ", t), en(t) || this.client.getTextByError(t);
    }
  }
  // 使用邮箱账号注册
  async signUpByEmail(e, t, r) {
    var o;
    try {
      const a = await this.client.verify({
        verification_id: (o = this.emailVerificationResponseData) == null ? void 0 : o.verification_id,
        verification_code: r
      }), d = {
        signUpRequest: {
          email: e,
          verification_code: r,
          verification_token: a.verification_token,
          password: t
        },
        noCallingCodePhoneNumber: void 0,
        checkEmail: !0,
        checkVerificationCode: !0,
        checkPassword: !0,
        comfirmPassword: t
      };
      return await this.client.signUp(d), this.tracker.web_login_success({
        login_type: "register",
        emphasize_mode: X()
      }), "";
    } catch (a) {
      console.warn("sign up by email error: ", a);
      const d = en(a) || this.client.getTextByError(a);
      return this.tracker.web_login_fail({
        login_type: "register",
        error: a.error,
        errorcode: d,
        emphasize_mode: X()
      }), d;
    }
  }
  // 使用authCode登录
  async signInByAuthCode(e) {
    try {
      return await this.client.signInByCode(e), "";
    } catch (t) {
      return console.warn("sign in by auth code error: ", t), me.global.t("3cSGnE4amksZ8nYggFqYh");
    }
  }
}
const H4 = () => {
  const n = (e) => {
    var o;
    const t = e.data;
    if (!t.type || !/^review/.test(t.type))
      return;
    let r;
    t.type === "review-get-parent-env" ? r = window.env : t.type === "review-get-parent-width" && (r = window.innerWidth), (o = e.source) == null || o.postMessage(
      { type: `${t.type}:response`, data: r },
      // @ts-ignore
      e.origin
    );
  };
  $n(() => {
    window.addEventListener("message", n);
  }), Or(() => {
    window.removeEventListener("message", n);
  });
}, Ee = me.global.t;
let gt;
const V4 = () => (gt || (gt = /* @__PURE__ */ new Map([
  [
    "OAuthLogin",
    {
      title: () => Ee("xNuOXxnZbXmpgKbAqfKGz"),
      quickOperations: Al() ? [He.QUICK_PHONE, He.QUICK_EMAIL] : [
        He.QUICK_PHONE,
        He.QUICK_EMAIL,
        He.QUICK_QRCODE
      ]
    }
  ],
  [
    "EmailLogin",
    {
      title: () => Ee("1ZpdIhCgVugfCbRIp6oj"),
      quickOperations: [],
      subtitle: [
        {
          text: () => Ee("hA5VzRxKiolLxIDSOzu")
        },
        {
          text: () => Ee("cFufuxQyNg0q1a1dVWgD1"),
          action: { type: D.GOTO_EMAIL_REGISTER }
        }
      ]
    }
  ],
  [
    "EmailRegister",
    {
      title: () => Ee("ufUkrBGbv4Xt457vFOa4D"),
      quickOperations: [],
      subtitle: [
        {
          text: () => Ee("inpUrHefXWalKjs9ufoT")
        },
        {
          text: () => Ee("gyJwCCpTd35n7xsGpxnE"),
          action: { type: D.GOTO_EMAIL_LOGIN }
        }
      ],
      showAgreement: !1
    }
  ],
  [
    "PhoneLogin",
    {
      title: () => Ee("zcOSHAfjmkBuxiFzogJx"),
      quickOperations: [
        He.QUICK_GOOGLE,
        He.QUICK_FACEBOOK,
        He.QUICK_EMAIL
      ],
      subtitle: [
        {
          text: () => Ee("bGh4Ajs0J5MafoKrPkJy"),
          action: { type: D.GOTO_PASSWORD_LOGIN }
        }
      ]
    }
  ],
  [
    "PasswordLogin",
    {
      title: () => Ee("zcOSHAfjmkBuxiFzogJx"),
      quickOperations: [],
      subtitle: [
        {
          text: () => Ee("nWs2QjRZeS8UwDtTggyJ"),
          action: { type: D.GOTO_PHONE_LOGIN }
        }
      ]
    }
  ],
  [
    "QRCodeLogin",
    {
      title: () => Ee("aJ1drF3Sll9NPkTU0Ro6"),
      quickOperations: []
    }
  ],
  [
    "AuthLogin",
    {
      title: () => Ee("xNuOXxnZbXmpgKbAqfKGz"),
      quickOperations: []
    }
  ]
])), gt), z4 = (n = 2) => (
  // eslint-disable-next-line
  new Promise(async (e) => {
    var d;
    let t;
    for (let s = 0; s < n && (t = document.querySelector("#__PIKPAK_EXTENSION__"), !t); s++)
      await new Promise((l) => setTimeout(l, 500));
    const r = ((d = t == null ? void 0 : t.textContent) == null ? void 0 : d.split(".")) || [];
    if ((r == null ? void 0 : r.length) < 3) {
      e(!1);
      return;
    }
    const a = [1, 5, 2].every(
      (s, l) => s <= Number(r[l] || "0")
    );
    if (!a) {
      e(!1);
      return;
    }
    return e(a);
  })
), K4 = async (n, e) => new Promise((t) => {
  try {
    if (typeof chrome > "u") {
      t(void 0);
      return;
    }
    z4().then((r) => {
      r ? chrome.runtime.sendMessage(n, e, t) : t(void 0);
    });
  } catch (r) {
    t(void 0), console.warn("community with extension failed!", r == null ? void 0 : r.message);
  }
}), q4 = "ohpgjiplhigpfcioaeakjfjnkbgjpgbl", Q4 = "jkmnnedinolbhjcibbfpdlkmmibkcbgf", W4 = async (n) => {
  const e = /edg/i.test(window.navigator.userAgent) ? Q4 : q4;
  return await K4(e, {
    type: kr.GET_AUTH_LOGIN_INFO,
    data: { clientId: n }
  });
}, Z4 = async (n) => {
  try {
    const e = new Array(10).fill(0).map((t, r) => {
      const a = `http://127.0.0.1:${19998 + r}/auth-info?client-id=${n}`;
      return new Promise((d) => {
        setTimeout(() => d(void 0), 1e3), fetch(a).then((s) => {
          s.json().then(d).catch(() => d(void 0));
        }).catch(() => d(void 0));
      });
    });
    return (await Promise.all(e)).filter(
      (t) => !!t
    )[0];
  } catch {
    return {};
  }
}, Ar = async (n) => {
  const e = { success: !1 };
  try {
    const t = await W4(n);
    if (t != null && t.success)
      return t;
    const r = await Z4(n);
    return r != null && r.success ? r : e;
  } catch (t) {
    return console.warn("get auth info error: ", t), e;
  }
}, J4 = () => new Promise((n, e) => {
  if (window.google) {
    e(!1);
    return;
  }
  const t = document.createElement("script");
  t.src = "https://accounts.google.com/gsi/client", t.async = !0, t.onload = () => {
    n(!0);
  }, document.head.appendChild(t);
}), po = (n, e) => new Promise((t) => {
  J4().then(() => {
    function r(o) {
      t((o == null ? void 0 : o.credential) || "");
    }
    window == null || window.google.accounts.id.initialize({
      client_id: n,
      callback: r,
      context: "signin",
      itp_support: !0
    }), e().then(Y4);
  });
}), Y4 = () => {
  try {
    $o(), window == null || window.google.accounts.id.prompt((n) => {
      n.isDismissedMoment() && console.warn(
        `Google One Tap Dismissed, Reason: ${n.getDismissedReason()}`
      );
    });
  } catch (n) {
    console.error(n);
  }
}, $o = () => {
  try {
    window.google.accounts.id.cancel();
  } catch (n) {
    console.error(n);
  }
}, mu = async (n) => {
  try {
    if (qr() || !n.showInMobile && document.body.offsetWidth < 768)
      return;
    const { googleClientID: e, clientID: t, apiOrigins: r, loginUI: o } = n;
    if (await o.login.isLoginStateValid())
      return;
    po(e, async () => !await o.login.isLoginStateValid()).then(async (d) => {
      const s = await _o({
        clientID: t,
        apiOrigins: r,
        providerId: "google.com",
        providerIdToken: d
      }), l = await yo({
        clientID: t,
        apiOrigins: r,
        providerToken: s
      });
      await o.login.oAuth2Client.setCredentials(l), o.login.emit(Tr.LOGIN_SUCCESS);
    });
  } catch (e) {
    console.warn(e);
  }
}, _o = async ({
  clientID: n,
  providerId: e,
  providerIdToken: t,
  apiOrigins: r
}) => {
  try {
    const o = r[0], a = `${o.endsWith("/") ? o.slice(0, -1) : o}/v1/auth/provider/token`, s = await (await fetch(a, {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        client_id: n,
        provider_id: e,
        provider_id_token: t
      })
    })).json();
    return (s == null ? void 0 : s.provider_token) || "";
  } catch (o) {
    return console.warn("get provider token error: ", o), "";
  }
}, yo = async ({
  clientID: n,
  providerToken: e,
  apiOrigins: t
}) => {
  try {
    const r = t[0], o = `${r.endsWith("/") ? r.slice(0, -1) : r}/v1/auth/signin/with/provider`;
    return await (await fetch(o, {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        client_id: n,
        provider_token: e
      })
    })).json();
  } catch (r) {
    console.warn("get credentials error: ", r);
  }
}, X4 = {
  action: "javascript:;",
  class: "pp-login-container"
}, eu = { class: "container-content" }, nu = { class: "error-message" }, tu = { class: "o-auth-error-message" }, ru = { class: "error-message" }, ou = /* @__PURE__ */ le({
  __name: "Container",
  props: {
    loginComponentProps: {},
    oAuthErrorText: {}
  },
  setup(n, { expose: e }) {
    const r = n.loginComponentProps, o = me.global.t, a = V4();
    H4();
    const d = ne(""), s = ne(""), l = ne(""), f = {
      AuthLogin: Xo,
      OAuthLogin: is,
      EmailLogin: fs,
      EmailRegister: Tl,
      PhoneLogin: Gl,
      PasswordLogin: Hl,
      QRCodeLogin: z3
    }, p = {
      AuthLogin: "auth",
      OAuthLogin: "oauth",
      EmailLogin: "email",
      EmailRegister: "register",
      PhoneLogin: "phone",
      PasswordLogin: "password-login",
      QRCodeLogin: "qrcode"
    }, _ = Cl(), y = ne(_);
    hn(
      y,
      () => {
        ie.emphasizeMode = p[y.value] || "oauth";
      },
      {
        immediate: !0
      }
    ), ie.history.push("OAuthLogin");
    const u = be(
      () => a.get(y.value)
    ), g = ne(!1), h = ne(), c = an({
      username: "",
      email: "",
      phone: "",
      authCode: "",
      avatar: ""
    }), i = async () => {
      try {
        if (qr() || await r.login.isLoginStateValid())
          return;
        const { clientID: C, apiOrigins: w, googleClientID: A, showGoogleInMobile: I } = r.getInjectedConfig(), E = await Ar(C);
        Object.assign(c, E), E.success ? v({ type: D.GOTO_AUTH_LOGIN }) : (document.body.offsetWidth >= 768 || I) && po(A, async () => g.value ? !1 : !await r.login.isLoginStateValid()).then(async (x) => {
          g.value = !0;
          const F = await _o({
            clientID: C,
            apiOrigins: w,
            providerId: "google.com",
            providerIdToken: x
          }), q = await yo({
            clientID: C,
            apiOrigins: w,
            providerToken: F
          });
          await r.login.oAuth2Client.setCredentials(
            q
          ), r.login.emit(Tr.LOGIN_SUCCESS), g.value = !1;
        });
      } catch (N) {
        console.warn(N);
      }
    }, m = ne(), $ = new j4(r);
    async function v(N) {
      if (d.value = "", !g.value)
        try {
          [
            D.HANDLE_LOGIN_BY_AUTH_CODE,
            D.HANDLE_LOGIN_BY_EMAIL,
            D.HANDLE_LOGIN_BY_PASSWORD,
            D.HANDLE_LOGIN_BY_PHONE_NUMBER,
            D.HANDLE_OAUTH_FROM_GOOGLE,
            D.HANDLE_OAUTH_FROM_FACEBOOK
          ].includes(N.type) && $o(), await Lo(N.type).with(D.SET_X_BASE_ERROR_TEXT, () => {
            const { message: C } = N;
            d.value = C || "";
          }).with(D.CLEAR_X_BASE_ERROR_TEXT, () => {
            d.value = "";
          }).with(D.SET_OAUTH_ERROR_MESSAGE, () => {
            const { message: C } = N;
            s.value = C || "";
          }).with(D.GOTO_ROUTER_BACK, () => {
            ie.history.length > 1 && (ie.history.pop(), y.value = ie.history[ie.history.length - 1]);
          }).with(D.GOTO_OAUTH_LOGIN, () => {
            ie.history.push("OAuthLogin"), y.value = "OAuthLogin";
          }).with(D.GOTO_AUTH_LOGIN, () => {
            ie.history.push("AuthLogin"), y.value = "AuthLogin";
          }).with(D.GOTO_PHONE_LOGIN, () => {
            ie.history.push("PhoneLogin"), y.value = "PhoneLogin", V.web_login_page_click({
              button: "SMS_code",
              emphasize_mode: X()
            });
          }).with(D.GOTO_PASSWORD_LOGIN, () => {
            ie.history.push("PasswordLogin"), y.value = "PasswordLogin", V.web_login_page_click({
              button: "password",
              emphasize_mode: X()
            });
          }).with(D.GOTO_EMAIL_LOGIN, () => {
            y.value != "EmailRegister" ? V.web_login_page_click({
              button: "email",
              emphasize_mode: X()
            }) : V.web_login_page_click({
              button: "email"
            }), V.web_email_login_page_show({}), ie.history.push("EmailLogin"), y.value = "EmailLogin";
          }).with(D.GOTO_QR_CODE_LOGIN, () => {
            V.qrcode_page_show({}), V.web_login_page_click({
              button: "qrcode",
              emphasize_mode: X()
            }), ie.history.push("QRCodeLogin"), y.value = "QRCodeLogin";
          }).with(D.GOTO_EMAIL_REGISTER, () => {
            V.web_email_register_page_show({}), V.web_email_login_page_click({ button: "register" }), ie.history.push("EmailRegister"), y.value = "EmailRegister";
          }).with(D.GOTO_FORGET_PASSWORD, () => {
            y.value === "EmailLogin" ? V.web_email_login_page_click({ button: "forgot_password" }) : V.web_login_page_click({
              button: "forgot_password",
              emphasize_mode: N.data
            });
            const C = document.createElement("a");
            C.target = "_blank";
            const w = Qn();
            C.href = `${w}/drive/forget-password?type=${N.data || "phone"}`, C.click();
          }).with(D.HANDLE_SEND_PHONE_MESSAGE, async () => {
            g.value = !0;
            const { phoneNumber: C } = N, w = m.value;
            V.web_login_page_click({
              button: "send_code",
              emphasize_mode: X()
            });
            const A = await $.sendPhoneVerifyCode(C);
            A || w.startCountDown(), d.value = A;
          }).with(D.HANDLE_SEND_EMAIL_MESSAGE, async () => {
            g.value = !0;
            const { email: C } = N.registerInfo, w = m.value;
            V.web_email_register_page_click({
              button: "send_code"
            });
            const A = await $.sendEmailVerifyCode(C);
            A || w.startCountDown(), d.value = A;
          }).with(D.HANDLE_LOGIN_BY_PHONE_NUMBER, async () => {
            g.value = !0;
            const { phoneCode: C, phoneNumber: w, verificationCode: A } = N.loginInfo;
            V.web_login_page_click({
              button: "login",
              emphasize_mode: X()
            }), V.web_login_request({
              login_type: "phone",
              emphasize_mode: X()
            });
            const I = Kr(C, w), E = await $.signInByVerifyCode(
              I,
              A,
              w
            );
            d.value = E;
          }).with(D.HANDLE_LOGIN_BY_PASSWORD, async () => {
            g.value = !0;
            const { phoneCode: C, phoneNumber: w, password: A } = N.loginInfo;
            V.web_login_request({
              login_type: "phone",
              emphasize_mode: X()
            }), V.web_login_page_click({
              button: "login",
              emphasize_mode: X()
            });
            const I = `${C}${w}`, E = await $.signInByPassword(
              I,
              A
            );
            d.value = E, V[E ? "web_login_fail" : "web_login_success"]({
              login_type: "phone_password",
              emphasize_mode: X()
            });
          }).with(D.HANDLE_LOGIN_BY_EMAIL, async () => {
            g.value = !0;
            const { loginInfo: C } = N;
            V.web_email_login_page_click({
              button: "login"
            }), V.web_login_request({
              login_type: "email",
              emphasize_mode: X()
            });
            const w = await $.signInByEmail(
              C.email,
              C.password
            );
            d.value = w;
          }).with(D.HANDLE_REGISTER_BY_EMAIL, async () => {
            g.value = !0;
            const { registerInfo: C } = N, { email: w, verificationCode: A, password: I, confirmPassword: E } = C;
            d.value = I !== E ? o("b4Myg4xCv2PdFdp4T7Yf9") : "", V.web_email_register_page_click({
              button: "register"
            }), V.web_login_request({
              login_type: "register",
              emphasize_mode: X()
            });
            const x = await $.signUpByEmail(
              w,
              E,
              A
            );
            d.value = x;
          }).with(D.HANDLE_LOGIN_BY_AUTH_CODE, async () => {
            var E, x;
            g.value = !0, l.value = "";
            const C = (E = r.getInjectedConfig()) == null ? void 0 : E.clientID, w = await Ar(C), A = (w == null ? void 0 : w.authCode) || ((x = N.loginInfo) == null ? void 0 : x.authCode) || "", I = await $.signInByAuthCode(A);
            l.value = I;
          }).with(D.HANDLE_OAUTH_FROM_GOOGLE, async () => {
            var w;
            if (bl()) {
              (w = h.value) == null || w.show();
              return;
            }
            V.web_login_page_click({
              button: "google",
              emphasize_mode: X()
            }), V.web_login_request({
              login_type: "google",
              emphasize_mode: X()
            });
            const C = await $.handleOAuth("google");
            s.value = C;
          }).with(D.HANDLE_OAUTH_FROM_FACEBOOK, async () => {
            V.web_login_page_click({
              button: "facebook",
              emphasize_mode: X()
            }), V.web_login_request({
              login_type: "facebook",
              emphasize_mode: X()
            });
            const C = await $.handleOAuth("facebook");
            s.value = C;
          }).exhaustive();
        } catch (C) {
          console.warn("handle command error: ", C);
        } finally {
          g.value = !1;
        }
    }
    return e({
      startGoogleOneTapLogin: i
    }), (N, C) => {
      var w, A, I, E;
      return P(), L(Ue, null, [
        k("form", X4, [
          W(Bo, {
            title: (w = u.value) == null ? void 0 : w.title,
            subtitle: (A = u.value) == null ? void 0 : A.subtitle,
            onCommand: v
          }, null, 8, ["title", "subtitle"]),
          k("div", eu, [
            (P(), qt(Ao, null, [
              (P(), qt(Oo(f[y.value]), {
                client: R(r),
                "auth-info": c,
                ref_key: "loginComponentRef",
                ref: m,
                onCommand: v
              }, {
                "x-base-error": fe(() => [
                  k("span", nu, G(d.value), 1)
                ]),
                "o-auth-error": fe(() => [
                  k("span", tu, G(s.value), 1)
                ]),
                "auth-login-error": fe(() => [
                  k("span", ru, G(l.value), 1)
                ]),
                _: 1
              }, 40, ["client", "auth-info"]))
            ], 1024))
          ]),
          W(r4, {
            "quick-operations": ((I = u.value) == null ? void 0 : I.quickOperations) || [],
            "show-agreement": (E = u.value) == null ? void 0 : E.showAgreement,
            onCommand: v
          }, null, 8, ["quick-operations", "show-agreement"])
        ]),
        W(a4, { isLoading: g.value }, null, 8, ["isLoading"]),
        W($4, {
          ref_key: "openCoverRef",
          ref: h
        }, null, 512)
      ], 64);
    };
  }
}), du = /* @__PURE__ */ ue(ou, [["__scopeId", "data-v-b485fb0b"]]), au = { class: "pp-login-panel" }, iu = /* @__PURE__ */ le({
  __name: "WebLoginUiComponent",
  props: {
    loginUIComponentDelegate: {},
    localRunningConfig: {}
  },
  setup(n) {
    const e = n, t = e.loginUIComponentDelegate, r = ne(""), o = ne(), a = () => t;
    let d = ne("");
    const s = async () => {
      var _, y, u, g;
      const f = a(), p = await f.loginUIInitResult;
      if (p != null && p.needContinueProviderSignIn) {
        const h = await f.login.continueProviderSignIn(), c = ((_ = h.grantProviderTokenResponse) == null ? void 0 : _.provider_token) || "";
        if (console.log("provider token: ", c), h.error) {
          if (h.error.error === Gn.FAILED_PRECONDITION) {
            console.error(
              "providerSignInStateResponse is:",
              h
            ), d.value = f.getTextByError(
              h.error
            ), r.value = ((y = h.error) == null ? void 0 : y.error_description) || "";
            const i = /google/.test(
              JSON.stringify(h.error)
            );
            (g = window == null ? void 0 : window.stat) == null || g.call(window, "web_yunpan_login", "web_login_fail", {
              login_type: i ? "google" : "facebook",
              error: h.error.error,
              errorcode: (u = h.error) == null ? void 0 : u.error_description
            });
          }
          d.value = f.getTextByError(
            h.error
          );
        }
      }
      o == null || o.value.startGoogleOneTapLogin();
    };
    $n(() => s());
    const l = () => {
      const f = a();
      return {
        login: f.login,
        uiRunningConfig: f.uiRunningConfig,
        localRunningConfig: e.localRunningConfig,
        getProviders: f.getProviders.bind(
          f
        ),
        signIn: (p) => f.signIn(p, async () => Promise.resolve()),
        getVerification: f.getVerification.bind(
          f
        ),
        verify: f.verify.bind(f),
        signInOrSignUpByVerification: f.signInOrSignUpByVerification.bind(
          f
        ),
        signInWithProvider: f.signInWithProvider.bind(
          f
        ),
        getTextByError: f.getTextByError.bind(
          f
        ),
        signUp: f.signUp.bind(f),
        startDeviceAuthorization: f.startDeviceAuthorization.bind(
          f
        ),
        stopDeviceAuthorization: f.stopDeviceAuthorization.bind(
          f
        ),
        on: f.on.bind(f),
        getInjectedConfig: f.login.getInjectedConfig.bind(f.login),
        signInByCode(p) {
          return f.login._grantToken({
            code: p,
            grant_type: "authorization_code"
          });
        }
      };
    };
    return (f, p) => (P(), L("div", au, [
      W(du, {
        ref_key: "containerRef",
        ref: o,
        oAuthErrorText: r.value,
        loginComponentProps: l()
      }, null, 8, ["oAuthErrorText", "loginComponentProps"]),
      p[0] || (p[0] = k("div", { id: "shield-app" }, null, -1))
    ]));
  }
}), It = /* @__PURE__ */ ue(iu, [["__scopeId", "data-v-1beb05cb"]]);
It.install = (n) => {
  n.component("WebLoginUiComponent", It);
};
let Jn = {
  webOrigins: []
};
async function Ht(n, e) {
  if (!e) {
    try {
      const r = await n.loginUIInitResult;
      r != null && r.needContinueProviderSignIn && await n.login.continueProviderSignIn();
    } catch (r) {
      console.warn("continue provider sign in error: ", r);
    }
    return;
  }
  const t = So(It, {
    loginUIComponentDelegate: n,
    localRunningConfig: Jn
  });
  t.use(me), t.mount(e);
}
const su = (n) => {
  me.global.locale.value = n;
};
Ht.callbackHandler = () => su;
Ht.getCurrentLoginPane = () => ie.emphasizeMode || "oauth";
Ht.setLocalRunningConfig = (n) => {
  Jn = {
    ...Jn,
    ...n
  };
};
export {
  Ht as createLoginUIComponentFunction,
  mu as startGoogleOneTapLogin
};
